webpackJsonp([1],{

/***/ 0:
/*!******************!*\
  !*** multi main ***!
  \******************/
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(/*! /var/lib/docker/volumes/wordpress_wordpress/_data/wp-content/plugins/futusign/public/screen/src/index.jsx */289);
	module.exports = __webpack_require__(/*! source-map */660);


/***/ },

/***/ 28:
/*!**************************************!*\
  !*** ./~/css-loader/lib/css-base.js ***!
  \**************************************/
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },

/***/ 155:
/*!***************************!*\
  !*** ./~/firebase/app.js ***!
  \***************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {/*! @license Firebase v3.9.0
	Build: rev-cc77c9e
	Terms: https://firebase.google.com/terms/ */
	
	var firebase=function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=11)}([function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var r=void 0;if(void 0!==e)r=e;else if("undefined"!=typeof self)r=self;else try{r=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var i=r.Promise||n(8);t.local={Promise:i,GoogPromise:i}}).call(t,n(1))},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(5),i=(0,r.createFirebaseNamespace)();t.default=i,e.exports=t.default},function(e,t,n){"use strict";function r(e){return i(void 0,e)}function i(e,t){if(!(t instanceof Object))return t;switch(t.constructor){case Date:return new Date(t.getTime());case Object:void 0===e&&(e={});break;case Array:e=[];break;default:return t}for(var n in t)t.hasOwnProperty(n)&&(e[n]=i(e[n],t[n]));return e}function o(e,t,n){e[t]=n}Object.defineProperty(t,"__esModule",{value:!0}),t.deepCopy=r,t.deepExtend=i,t.patchProperty=o},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e){var t=a;return a=e,t}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.patchCapture=i;var a=Error.captureStackTrace,c=function e(t,n){if(r(this,e),this.code=t,this.message=n,a)a(this,s.prototype.create);else{var i=Error.apply(this,arguments);this.name="FirebaseError",Object.defineProperty(this,"stack",{get:function(){return i.stack}})}};c.prototype=Object.create(Error.prototype),c.prototype.constructor=c,c.prototype.name="FirebaseError";var s=t.ErrorFactory=function(){function e(t,n,i){r(this,e),this.service=t,this.serviceName=n,this.errors=i,this.pattern=/\{\$([^}]+)}/g}return o(e,[{key:"create",value:function(e,t){void 0===t&&(t={});var n=this.errors[e],r=this.service+"/"+e,i=void 0;i=void 0===n?"Error":n.replace(this.pattern,function(e,n){var r=t[n];return void 0!==r?r.toString():"<"+n+"?>"}),i=this.serviceName+": "+i+" ("+r+").";var o=new c(r,i);for(var a in t)t.hasOwnProperty(a)&&"_"!==a.slice(-1)&&(o[a]=t[a]);return o}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){function e(e){e=e||d;var t=r[e];return void 0===t&&o("no-app",{name:e}),t}function t(e,t){Object.keys(a).forEach(function(r){var i=n(e,r);null!==i&&h[i]&&h[i](t,e)})}function n(e,t){if("serverAuth"===t)return null;var n=t,r=e.options;return"auth"===t&&(r.serviceAccount||r.credential)&&(n="serverAuth","serverAuth"in a||o("sa-not-supported")),n}var r={},a={},h={},v={__esModule:!0,initializeApp:function(e,n){void 0===n?n=d:"string"==typeof n&&""!==n||o("bad-app-name",{name:n+""}),void 0!==r[n]&&o("duplicate-app",{name:n});var i=new p(e,n,v);return r[n]=i,t(i,"create"),void 0!=i.INTERNAL&&void 0!=i.INTERNAL.getToken||(0,c.deepExtend)(i,{INTERNAL:{getUid:function(){return null},getToken:function(){return l.resolve(null)},addAuthTokenListener:function(){},removeAuthTokenListener:function(){}}}),i},app:e,apps:null,Promise:l,SDK_VERSION:"3.9.0",INTERNAL:{registerService:function(t,n,r,i,s){a[t]&&o("duplicate-service",{name:t}),a[t]=s?n:function(e,t){return n(e,t,d)},i&&(h[t]=i);var u=void 0;return u=function(n){return void 0===n&&(n=e()),"function"!=typeof n[t]&&o("invalid-app-argument",{name:t}),n[t]()},void 0!==r&&(0,c.deepExtend)(u,r),v[t]=u,u},createFirebaseNamespace:i,extendNamespace:function(e){(0,c.deepExtend)(v,e)},createSubscribe:s.createSubscribe,ErrorFactory:u.ErrorFactory,removeApp:function(e){t(r[e],"delete"),delete r[e]},factories:a,useAsService:n,Promise:f.local.GoogPromise,deepExtend:c.deepExtend}};return(0,c.patchProperty)(v,"default",v),Object.defineProperty(v,"apps",{get:function(){return Object.keys(r).map(function(e){return r[e]})}}),(0,c.patchProperty)(e,"App",p),v}function o(e,t){throw v.create(e,t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.createFirebaseNamespace=i;var c=n(3),s=n(6),u=n(4),f=n(0),l=f.local.Promise,d="[DEFAULT]",p=function(){function e(t,n,i){var o=this;r(this,e),this.firebase_=i,this.isDeleted_=!1,this.services_={},this.name_=n,this.options_=(0,c.deepCopy)(t);var a="credential"in this.options_,s="serviceAccount"in this.options_;if(a||s){var u=s?"serviceAccount":"credential";"undefined"!=typeof console&&console.log("The '"+u+"' property specified in the first argument to initializeApp() is deprecated and will be removed in the next major version. You should instead use the 'firebase-admin' package. See https://firebase.google.com/docs/admin/setup for details on how to get started.")}Object.keys(i.INTERNAL.factories).forEach(function(e){var t=i.INTERNAL.useAsService(o,e);if(null!==t){var n=o.getService.bind(o,t);(0,c.patchProperty)(o,e,n)}})}return a(e,[{key:"delete",value:function(){var e=this;return new l(function(t){e.checkDestroyed_(),t()}).then(function(){e.firebase_.INTERNAL.removeApp(e.name_);var t=[];return Object.keys(e.services_).forEach(function(n){Object.keys(e.services_[n]).forEach(function(r){t.push(e.services_[n][r])})}),l.all(t.map(function(e){return e.INTERNAL.delete()}))}).then(function(){e.isDeleted_=!0,e.services_={}})}},{key:"getService",value:function(e,t){this.checkDestroyed_(),void 0===this.services_[e]&&(this.services_[e]={});var n=t||d;if(void 0===this.services_[e][n]){var r=this.firebase_.INTERNAL.factories[e](this,this.extendApp.bind(this),t);return this.services_[e][n]=r,r}return this.services_[e][n]}},{key:"extendApp",value:function(e){(0,c.deepExtend)(this,e)}},{key:"checkDestroyed_",value:function(){this.isDeleted_&&o("app-deleted",{name:this.name_})}},{key:"name",get:function(){return this.checkDestroyed_(),this.name_}},{key:"options",get:function(){return this.checkDestroyed_(),this.options_}}]),e}();p.prototype.name&&p.prototype.options||p.prototype.delete||console.log("dc");var h={"no-app":"No Firebase App '{$name}' has been created - call Firebase App.initializeApp()","bad-app-name":"Illegal App name: '{$name}","duplicate-app":"Firebase App named '{$name}' already exists","app-deleted":"Firebase App named '{$name}' already deleted","duplicate-service":"Firebase service named '{$name}' already registered","sa-not-supported":"Initializing the Firebase SDK with a service account is only allowed in a Node.js environment. On client devices, you should instead initialize the SDK with an api key and auth domain","invalid-app-argument":"firebase.{$name}() takes either no argument or a Firebase App instance."},v=new u.ErrorFactory("app","Firebase",h)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){var n=new d(e,t);return n.subscribe.bind(n)}function o(e,t){return function(){for(var n=arguments.length,r=Array(n),i=0;i<n;i++)r[i]=arguments[i];l.resolve(!0).then(function(){e.apply(void 0,r)}).catch(function(e){t&&t(e)})}}function a(e,t){if("object"!==(void 0===e?"undefined":s(e))||null===e)return!1;var n=!0,r=!1,i=void 0;try{for(var o,a=t[Symbol.iterator]();!(n=(o=a.next()).done);n=!0){var c=o.value;if(c in e&&"function"==typeof e[c])return!0}}catch(e){r=!0,i=e}finally{try{!n&&a.return&&a.return()}finally{if(r)throw i}}return!1}function c(){}Object.defineProperty(t,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.createSubscribe=i,t.async=o;var f=n(0),l=f.local.Promise,d=function(){function e(t,n){var i=this;r(this,e),this.observers=[],this.unsubscribes=[],this.observerCount=0,this.task=l.resolve(),this.finalized=!1,this.onNoObservers=n,this.task.then(function(){t(i)}).catch(function(e){i.error(e)})}return u(e,[{key:"next",value:function(e){this.forEachObserver(function(t){t.next(e)})}},{key:"error",value:function(e){this.forEachObserver(function(t){t.error(e)}),this.close(e)}},{key:"complete",value:function(){this.forEachObserver(function(e){e.complete()}),this.close()}},{key:"subscribe",value:function(e,t,n){var r=this,i=void 0;if(void 0===e&&void 0===t&&void 0===n)throw new Error("Missing Observer.");i=a(e,["next","error","complete"])?e:{next:e,error:t,complete:n},void 0===i.next&&(i.next=c),void 0===i.error&&(i.error=c),void 0===i.complete&&(i.complete=c);var o=this.unsubscribeOne.bind(this,this.observers.length);return this.finalized&&this.task.then(function(){try{r.finalError?i.error(r.finalError):i.complete()}catch(e){}}),this.observers.push(i),o}},{key:"unsubscribeOne",value:function(e){void 0!==this.observers&&void 0!==this.observers[e]&&(delete this.observers[e],this.observerCount-=1,0===this.observerCount&&void 0!==this.onNoObservers&&this.onNoObservers(this))}},{key:"forEachObserver",value:function(e){if(!this.finalized)for(var t=0;t<this.observers.length;t++)this.sendOne(t,e)}},{key:"sendOne",value:function(e,t){var n=this;this.task.then(function(){if(void 0!==n.observers&&void 0!==n.observers[e])try{t(n.observers[e])}catch(e){"undefined"!=typeof console&&console.error&&console.error(e)}})}},{key:"close",value:function(e){var t=this;this.finalized||(this.finalized=!0,void 0!==e&&(this.finalError=e),this.task.then(function(){t.observers=void 0,t.onNoObservers=void 0}))}}]),e}()},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function i(e){if(f===setTimeout)return setTimeout(e,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(e,0);try{return f(e,0)}catch(t){try{return f.call(null,e,0)}catch(t){return f.call(this,e,0)}}}function o(e){if(l===clearTimeout)return clearTimeout(e);if((l===r||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(e);try{return l(e)}catch(t){try{return l.call(null,e)}catch(t){return l.call(this,e)}}}function a(){v&&p&&(v=!1,p.length?h=p.concat(h):m=-1,h.length&&c())}function c(){if(!v){var e=i(a);v=!0;for(var t=h.length;t;){for(p=h,h=[];++m<t;)p&&p[m].run();m=-1,t=h.length}p=null,v=!1,o(e)}}function s(e,t){this.fun=e,this.array=t}function u(){}var f,l,d=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(e){f=n}try{l="function"==typeof clearTimeout?clearTimeout:r}catch(e){l=r}}();var p,h=[],v=!1,m=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new s(e,t)),1!==h.length||v||i(c)},s.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=u,d.addListener=u,d.once=u,d.off=u,d.removeListener=u,d.removeAllListeners=u,d.emit=u,d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){(function(t){!function(n){function r(){}function i(e,t){return function(){e.apply(t,arguments)}}function o(e){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],l(e,this)}function a(e,t){for(;3===e._state;)e=e._value;if(0===e._state)return void e._deferreds.push(t);e._handled=!0,o._immediateFn(function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null===n)return void(1===e._state?c:s)(t.promise,e._value);var r;try{r=n(e._value)}catch(e){return void s(t.promise,e)}c(t.promise,r)})}function c(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var n=t.then;if(t instanceof o)return e._state=3,e._value=t,void u(e);if("function"==typeof n)return void l(i(n,t),e)}e._state=1,e._value=t,u(e)}catch(t){s(e,t)}}function s(e,t){e._state=2,e._value=t,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var t=0,n=e._deferreds.length;t<n;t++)a(e,e._deferreds[t]);e._deferreds=null}function f(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}function l(e,t){var n=!1;try{e(function(e){n||(n=!0,c(t,e))},function(e){n||(n=!0,s(t,e))})}catch(e){if(n)return;n=!0,s(t,e)}}var d=setTimeout;o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){var n=new this.constructor(r);return a(this,new f(e,t,n)),n},o.all=function(e){var t=Array.prototype.slice.call(e);return new o(function(e,n){function r(o,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void c.call(a,function(e){r(o,e)},n)}t[o]=a,0==--i&&e(t)}catch(e){n(e)}}if(0===t.length)return e([]);for(var i=t.length,o=0;o<t.length;o++)r(o,t[o])})},o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o(function(t){t(e)})},o.reject=function(e){return new o(function(t,n){n(e)})},o.race=function(e){return new o(function(t,n){for(var r=0,i=e.length;r<i;r++)e[r].then(t,n)})},o._immediateFn="function"==typeof t&&function(e){t(e)}||function(e){d(e,0)},o._unhandledRejectionFn=function(e){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)},o._setImmediateFn=function(e){o._immediateFn=e},o._setUnhandledRejectionFn=function(e){o._unhandledRejectionFn=e},void 0!==e&&e.exports?e.exports=o:n.Promise||(n.Promise=o)}(this)}).call(t,n(10).setImmediate)},function(e,t,n){(function(e,t){!function(e,n){"use strict";function r(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),n=0;n<t.length;n++)t[n]=arguments[n+1];var r={callback:e,args:t};return u[s]=r,c(s),s++}function i(e){delete u[e]}function o(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}function a(e){if(f)setTimeout(a,0,e);else{var t=u[e];if(t){f=!0;try{o(t)}finally{i(e),f=!1}}}}if(!e.setImmediate){var c,s=1,u={},f=!1,l=e.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(e);d=d&&d.setTimeout?d:e,"[object process]"==={}.toString.call(e.process)?function(){c=function(e){t.nextTick(function(){a(e)})}}():function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?function(){var t="setImmediate$"+Math.random()+"$",n=function(n){n.source===e&&"string"==typeof n.data&&0===n.data.indexOf(t)&&a(+n.data.slice(t.length))};e.addEventListener?e.addEventListener("message",n,!1):e.attachEvent("onmessage",n),c=function(n){e.postMessage(t+n,"*")}}():e.MessageChannel?function(){var e=new MessageChannel;e.port1.onmessage=function(e){a(e.data)},c=function(t){e.port2.postMessage(t)}}():l&&"onreadystatechange"in l.createElement("script")?function(){var e=l.documentElement;c=function(t){var n=l.createElement("script");n.onreadystatechange=function(){a(t),n.onreadystatechange=null,e.removeChild(n),n=null},e.appendChild(n)}}():function(){c=function(e){setTimeout(a,0,e)}}(),d.setImmediate=r,d.clearImmediate=i}}("undefined"==typeof self?void 0===e?this:e:self)}).call(t,n(1),n(7))},function(e,t,n){function r(e,t){this._id=e,this._clearFn=t}var i=Function.prototype.apply;t.setTimeout=function(){return new r(i.call(setTimeout,window,arguments),clearTimeout)},t.setInterval=function(){return new r(i.call(setInterval,window,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(window,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout(function(){e._onTimeout&&e._onTimeout()},t))},n(9),t.setImmediate=setImmediate,t.clearImmediate=clearImmediate},function(e,t,n){e.exports=n(2)}]);module.exports=firebase;
	//# sourceMappingURL=app.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../timers-browserify/main.js */ 269).setImmediate, __webpack_require__(/*! ./../timers-browserify/main.js */ 269).clearImmediate))

/***/ },

/***/ 496:
/*!****************************!*\
  !*** ./~/firebase/auth.js ***!
  \****************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
	Build: rev-cc77c9e
	Terms: https://firebase.google.com/terms/ */
	
	var firebase = __webpack_require__(/*! ./app */ 155);
	(function(){
	(function(){var h,aa=aa||{},l=this,ba=function(){},ca=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&
	!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},da=function(a){return null===a},ea=function(a){return"array"==ca(a)},fa=function(a){var b=ca(a);return"array"==b||"object"==b&&"number"==typeof a.length},m=function(a){return"string"==typeof a},ga=function(a){return"number"==typeof a},p=function(a){return"function"==ca(a)},ha=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b},ia=function(a,
	b,c){return a.call.apply(a.bind,arguments)},ja=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}},q=function(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ia:ja;return q.apply(null,arguments)},ka=function(a,b){var c=Array.prototype.slice.call(arguments,
	1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}},la=Date.now||function(){return+new Date},r=function(a,b){function c(){}c.prototype=b.prototype;a.xd=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Tf=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};var t=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,t);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};r(t,Error);t.prototype.name="CustomError";var ma=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")},na=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},oa=/&/g,pa=/</g,qa=/>/g,ra=/"/g,sa=/'/g,ta=/\x00/g,ua=/[\x00&<>"']/,u=function(a,b){return-1!=a.indexOf(b)},va=function(a,b){return a<b?-1:a>b?1:0};var wa=function(a,b){b.unshift(a);t.call(this,ma.apply(null,b));b.shift()};r(wa,t);wa.prototype.name="AssertionError";
	var xa=function(a,b,c,d){var e="Assertion failed";if(c)var e=e+(": "+c),f=d;else a&&(e+=": "+a,f=b);throw new wa(""+e,f||[]);},v=function(a,b,c){a||xa("",null,b,Array.prototype.slice.call(arguments,2))},ya=function(a,b){throw new wa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));},za=function(a,b,c){ga(a)||xa("Expected number but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,2));return a},Aa=function(a,b,c){m(a)||xa("Expected string but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,
	2))},Ba=function(a,b,c){p(a)||xa("Expected function but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,2))};var Ca=Array.prototype.indexOf?function(a,b,c){v(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(m(a))return m(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){v(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},Da=function(a,b){for(var c=m(a)?
	a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)},Ea=Array.prototype.map?function(a,b,c){v(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=m(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Fa=Array.prototype.some?function(a,b,c){v(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1},
	Ha=function(a){var b;a:{b=Ga;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:m(a)?a.charAt(b):a[b]},Ia=function(a,b){return 0<=Ca(a,b)},Ka=function(a,b){b=Ca(a,b);var c;(c=0<=b)&&Ja(a,b);return c},Ja=function(a,b){v(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length},La=function(a,b){var c=0;Da(a,function(d,e){b.call(void 0,d,e,a)&&Ja(a,e)&&c++})},Ma=function(a){return Array.prototype.concat.apply([],arguments)},
	Na=function(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Oa=function(a){return Ea(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var Pa;a:{var Qa=l.navigator;if(Qa){var Ra=Qa.userAgent;if(Ra){Pa=Ra;break a}}Pa=""}var x=function(a){return u(Pa,a)};var Sa=function(a,b){for(var c in a)b.call(void 0,a[c],c,a)},Ta=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b},Ua=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b},Va=function(a){for(var b in a)return!1;return!0},Wa=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0},Xa=function(a){var b={},c;for(c in a)b[c]=a[c];return b},Ya="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
	Za=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Ya.length;f++)c=Ya[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};var $a=function(a){$a[" "](a);return a};$a[" "]=ba;var bb=function(a,b){var c=ab;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var cb=x("Opera"),y=x("Trident")||x("MSIE"),eb=x("Edge"),fb=eb||y,gb=x("Gecko")&&!(u(Pa.toLowerCase(),"webkit")&&!x("Edge"))&&!(x("Trident")||x("MSIE"))&&!x("Edge"),hb=u(Pa.toLowerCase(),"webkit")&&!x("Edge"),ib=function(){var a=l.document;return a?a.documentMode:void 0},jb;
	a:{var kb="",lb=function(){var a=Pa;if(gb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(eb)return/Edge\/([\d\.]+)/.exec(a);if(y)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(hb)return/WebKit\/(\S+)/.exec(a);if(cb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();lb&&(kb=lb?lb[1]:"");if(y){var mb=ib();if(null!=mb&&mb>parseFloat(kb)){jb=String(mb);break a}}jb=kb}
	var nb=jb,ab={},z=function(a){return bb(a,function(){for(var b=0,c=na(String(nb)).split("."),d=na(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",k=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==g[0].length&&0==k[0].length)break;b=va(0==g[1].length?0:parseInt(g[1],10),0==k[1].length?0:parseInt(k[1],10))||va(0==g[2].length,0==k[2].length)||va(g[2],k[2]);g=g[3];k=k[3]}while(0==b)}return 0<=b})},ob;var pb=l.document;
	ob=pb&&y?ib()||("CSS1Compat"==pb.compatMode?parseInt(nb,10):5):void 0;var qb=null,rb=null,tb=function(a){var b="";sb(a,function(a){b+=String.fromCharCode(a)});return b},sb=function(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=rb[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}ub();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),k=c(64);if(64===k&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=k&&b(g<<6&192|k))}},ub=function(){if(!qb){qb={};rb={};for(var a=0;65>a;a++)qb[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),
	rb[qb[a]]=a,62<=a&&(rb["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};var vb=function(){this.Da=-1};var yb=function(a,b){this.Da=64;this.ec=l.Uint8Array?new Uint8Array(this.Da):Array(this.Da);this.Fc=this.hb=0;this.h=[];this.lf=a;this.Wd=b;this.Mf=l.Int32Array?new Int32Array(64):Array(64);void 0!==wb||(wb=l.Int32Array?new Int32Array(xb):xb);this.reset()},wb;r(yb,vb);for(var zb=[],Ab=0;63>Ab;Ab++)zb[Ab]=0;var Bb=Ma(128,zb);yb.prototype.reset=function(){this.Fc=this.hb=0;this.h=l.Int32Array?new Int32Array(this.Wd):Na(this.Wd)};
	var Cb=function(a){var b=a.ec;v(b.length==a.Da);for(var c=a.Mf,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){var e=c[b-15]|0,d=c[b-2]|0,f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}for(var d=a.h[0]|0,e=a.h[1]|0,k=a.h[2]|0,n=a.h[3]|0,C=a.h[4]|0,db=a.h[5]|0,Pb=a.h[6]|0,f=a.h[7]|0,b=0;64>b;b++)var Ah=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&k^e&k)|0,g=C&db^~C&Pb,f=f+((C>>>6|
	C<<26)^(C>>>11|C<<21)^(C>>>25|C<<7))|0,g=g+(wb[b]|0)|0,g=f+(g+(c[b]|0)|0)|0,f=Pb,Pb=db,db=C,C=n+g|0,n=k,k=e,e=d,d=g+Ah|0;a.h[0]=a.h[0]+d|0;a.h[1]=a.h[1]+e|0;a.h[2]=a.h[2]+k|0;a.h[3]=a.h[3]+n|0;a.h[4]=a.h[4]+C|0;a.h[5]=a.h[5]+db|0;a.h[6]=a.h[6]+Pb|0;a.h[7]=a.h[7]+f|0};
	yb.prototype.update=function(a,b){void 0===b&&(b=a.length);var c=0,d=this.hb;if(m(a))for(;c<b;)this.ec[d++]=a.charCodeAt(c++),d==this.Da&&(Cb(this),d=0);else if(fa(a))for(;c<b;){var e=a[c++];if(!("number"==typeof e&&0<=e&&255>=e&&e==(e|0)))throw Error("message must be a byte array");this.ec[d++]=e;d==this.Da&&(Cb(this),d=0)}else throw Error("message must be string or array");this.hb=d;this.Fc+=b};
	yb.prototype.digest=function(){var a=[],b=8*this.Fc;56>this.hb?this.update(Bb,56-this.hb):this.update(Bb,this.Da-(this.hb-56));for(var c=63;56<=c;c--)this.ec[c]=b&255,b/=256;Cb(this);for(c=b=0;c<this.lf;c++)for(var d=24;0<=d;d-=8)a[b++]=this.h[c]>>d&255;return a};
	var xb=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var Eb=function(){yb.call(this,8,Db)};r(Eb,yb);var Db=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];var Fb=function(){this.Ga=this.Ga;this.tc=this.tc};Fb.prototype.Ga=!1;Fb.prototype.isDisposed=function(){return this.Ga};Fb.prototype.cb=function(){if(this.tc)for(;this.tc.length;)this.tc.shift()()};var Gb=!y||9<=Number(ob),Hb=y&&!z("9");!hb||z("528");gb&&z("1.9b")||y&&z("8")||cb&&z("9.5")||hb&&z("528");gb&&!z("8")||y&&z("9");var Ib=function(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.nb=!1;this.ee=!0};Ib.prototype.preventDefault=function(){this.defaultPrevented=!0;this.ee=!1};var Jb=function(a,b){Ib.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.eb=this.state=null;a&&this.init(a,b)};r(Jb,Ib);
	Jb.prototype.init=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;if(b=a.relatedTarget){if(gb){var e;a:{try{$a(b.nodeName);e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.offsetX=hb||void 0!==a.offsetX?a.offsetX:a.layerX,this.offsetY=hb||void 0!==a.offsetY?a.offsetY:a.layerY,this.clientX=void 0!==a.clientX?a.clientX:
	a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.state=a.state;this.eb=
	a;a.defaultPrevented&&this.preventDefault()};Jb.prototype.preventDefault=function(){Jb.xd.preventDefault.call(this);var a=this.eb;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Hb)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Jb.prototype.Pe=function(){return this.eb};var Kb="closure_listenable_"+(1E6*Math.random()|0),Lb=0;var Mb=function(a,b,c,d,e){this.listener=a;this.xc=null;this.src=b;this.type=c;this.capture=!!d;this.kc=e;this.key=++Lb;this.rb=this.dc=!1},Nb=function(a){a.rb=!0;a.listener=null;a.xc=null;a.src=null;a.kc=null};var Ob=function(a){this.src=a;this.G={};this.$b=0};Ob.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.G[f];a||(a=this.G[f]=[],this.$b++);var g=Qb(a,b,d,e);-1<g?(b=a[g],c||(b.dc=!1)):(b=new Mb(b,this.src,f,!!d,e),b.dc=c,a.push(b));return b};Ob.prototype.remove=function(a,b,c,d){a=a.toString();if(!(a in this.G))return!1;var e=this.G[a];b=Qb(e,b,c,d);return-1<b?(Nb(e[b]),Ja(e,b),0==e.length&&(delete this.G[a],this.$b--),!0):!1};
	var Rb=function(a,b){var c=b.type;c in a.G&&Ka(a.G[c],b)&&(Nb(b),0==a.G[c].length&&(delete a.G[c],a.$b--))};Ob.prototype.Uc=function(a,b,c,d){a=this.G[a.toString()];var e=-1;a&&(e=Qb(a,b,c,d));return-1<e?a[e]:null};var Qb=function(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.rb&&f.listener==b&&f.capture==!!c&&f.kc==d)return e}return-1};var Sb="closure_lm_"+(1E6*Math.random()|0),Tb={},Ub=0,Vb=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)Vb(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?a.listen(b,c,d,e):Xb(a,b,c,!1,d,e)},Xb=function(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=!!e,k=Yb(a);k||(a[Sb]=k=new Ob(a));c=k.add(b,c,d,e,f);if(!c.xc){d=Zb();c.xc=d;d.src=a;d.listener=c;if(a.addEventListener)a.addEventListener(b.toString(),d,g);else if(a.attachEvent)a.attachEvent($b(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");
	Ub++}},Zb=function(){var a=ac,b=Gb?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b},bc=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)bc(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?cc(a,b,c,d,e):Xb(a,b,c,!0,d,e)},dc=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)dc(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?a.fa.remove(String(b),c,d,e):a&&(a=Yb(a))&&(b=a.Uc(b,c,!!d,e))&&ec(b)},ec=function(a){if(!ga(a)&&a&&!a.rb){var b=a.src;if(b&&
	b[Kb])Rb(b.fa,a);else{var c=a.type,d=a.xc;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent&&b.detachEvent($b(c),d);Ub--;(c=Yb(b))?(Rb(c,a),0==c.$b&&(c.src=null,b[Sb]=null)):Nb(a)}}},$b=function(a){return a in Tb?Tb[a]:Tb[a]="on"+a},gc=function(a,b,c,d){var e=!0;if(a=Yb(a))if(b=a.G[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.rb&&(f=fc(f,d),e=e&&!1!==f)}return e},fc=function(a,b){var c=a.listener,d=a.kc||a.src;a.dc&&ec(a);return c.call(d,
	b)},ac=function(a,b){if(a.rb)return!0;if(!Gb){if(!b)a:{b=["window","event"];for(var c=l,d;d=b.shift();)if(null!=c[d])c=c[d];else{b=null;break a}b=c}d=b;b=new Jb(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.currentTarget;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;!b.nb&&0<=e;e--){b.currentTarget=d[e];var f=gc(d[e],a,!0,b),c=c&&f}for(e=0;!b.nb&&e<d.length;e++)b.currentTarget=
	d[e],f=gc(d[e],a,!1,b),c=c&&f}return c}return fc(a,new Jb(b,this))},Yb=function(a){a=a[Sb];return a instanceof Ob?a:null},hc="__closure_events_fn_"+(1E9*Math.random()>>>0),Wb=function(a){v(a,"Listener can not be null.");if(p(a))return a;v(a.handleEvent,"An object listener must have handleEvent method.");a[hc]||(a[hc]=function(b){return a.handleEvent(b)});return a[hc]};var ic=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;var kc=function(){this.Cc="";this.we=jc};kc.prototype.Eb=!0;kc.prototype.Bb=function(){return this.Cc};kc.prototype.toString=function(){return"Const{"+this.Cc+"}"};var lc=function(a){if(a instanceof kc&&a.constructor===kc&&a.we===jc)return a.Cc;ya("expected object of type Const, got '"+a+"'");return"type_error:Const"},jc={},mc=function(a){var b=new kc;b.Cc=a;return b};mc("");var oc=function(){this.wc="";this.xe=nc};oc.prototype.Eb=!0;oc.prototype.Bb=function(){return this.wc};oc.prototype.toString=function(){return"TrustedResourceUrl{"+this.wc+"}"};var nc={};var qc=function(){this.pa="";this.ve=pc};qc.prototype.Eb=!0;qc.prototype.Bb=function(){return this.pa};qc.prototype.toString=function(){return"SafeUrl{"+this.pa+"}"};
	var rc=function(a){if(a instanceof qc&&a.constructor===qc&&a.ve===pc)return a.pa;ya("expected object of type SafeUrl, got '"+a+"' of type "+ca(a));return"type_error:SafeUrl"},sc=/^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i,uc=function(a){if(a instanceof qc)return a;a=a.Eb?a.Bb():String(a);sc.test(a)||(a="about:invalid#zClosurez");return tc(a)},pc={},tc=function(a){var b=new qc;b.pa=a;return b};tc("about:blank");var xc=function(a){var b=[];vc(new wc,a,b);return b.join("")},wc=function(){this.yc=void 0},vc=function(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(ea(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),e=d[f],vc(a,a.yc?a.yc.call(d,String(f),e):e,c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");f="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(e=b[d],"function"!=typeof e&&(c.push(f),
	yc(d,c),c.push(":"),vc(a,a.yc?a.yc.call(b,d,e):e,c),f=","));c.push("}");return}}switch(typeof b){case "string":yc(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}},zc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ac=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g,
	yc=function(a,b){b.push('"',a.replace(Ac,function(a){var b=zc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),zc[a]=b);return b}),'"')};var Bc=function(){};Bc.prototype.Dd=null;var Cc=function(a){return a.Dd||(a.Dd=a.$c())};var Dc,Ec=function(){};r(Ec,Bc);Ec.prototype.fc=function(){var a=Fc(this);return a?new ActiveXObject(a):new XMLHttpRequest};Ec.prototype.$c=function(){var a={};Fc(this)&&(a[0]=!0,a[1]=!0);return a};
	var Fc=function(a){if(!a.Vd&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.Vd=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.Vd};Dc=new Ec;var Gc=function(){};r(Gc,Bc);Gc.prototype.fc=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Hc;throw Error("Unsupported browser");};Gc.prototype.$c=function(){return{}};
	var Hc=function(){this.ua=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.ua.onload=q(this.Re,this);this.ua.onerror=q(this.Sd,this);this.ua.onprogress=q(this.Se,this);this.ua.ontimeout=q(this.Te,this)};h=Hc.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.ua.open(a,b)};
	h.send=function(a){if(a)if("string"==typeof a)this.ua.send(a);else throw Error("Only string data is supported");else this.ua.send()};h.abort=function(){this.ua.abort()};h.setRequestHeader=function(){};h.Re=function(){this.status=200;this.responseText=this.ua.responseText;Ic(this,4)};h.Sd=function(){this.status=500;this.responseText="";Ic(this,4)};h.Te=function(){this.Sd()};h.Se=function(){this.status=200;Ic(this,1)};var Ic=function(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()};var Jc=function(a,b,c){this.ef=c;this.Fe=a;this.wf=b;this.sc=0;this.lc=null};Jc.prototype.get=function(){var a;0<this.sc?(this.sc--,a=this.lc,this.lc=a.next,a.next=null):a=this.Fe();return a};Jc.prototype.put=function(a){this.wf(a);this.sc<this.ef&&(this.sc++,a.next=this.lc,this.lc=a)};var Kc=function(a){l.setTimeout(function(){throw a;},0)},Lc,Mc=function(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!x("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host,
	a=q(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!x("Trident")&&!x("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.Gd;c.Gd=null;a()}};return function(a){d.next={Gd:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?
	function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){l.setTimeout(a,0)}};var Nc=function(){this.Jc=this.Za=null},Pc=new Jc(function(){return new Oc},function(a){a.reset()},100);Nc.prototype.add=function(a,b){var c=Pc.get();c.set(a,b);this.Jc?this.Jc.next=c:(v(!this.Za),this.Za=c);this.Jc=c};Nc.prototype.remove=function(){var a=null;this.Za&&(a=this.Za,this.Za=this.Za.next,this.Za||(this.Jc=null),a.next=null);return a};var Oc=function(){this.next=this.scope=this.Tc=null};Oc.prototype.set=function(a,b){this.Tc=a;this.scope=b;this.next=null};
	Oc.prototype.reset=function(){this.next=this.scope=this.Tc=null};var Uc=function(a,b){Qc||Rc();Sc||(Qc(),Sc=!0);Tc.add(a,b)},Qc,Rc=function(){if(-1!=String(l.Promise).indexOf("[native code]")){var a=l.Promise.resolve(void 0);Qc=function(){a.then(Vc)}}else Qc=function(){var a=Vc;!p(l.setImmediate)||l.Window&&l.Window.prototype&&!x("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(Lc||(Lc=Mc()),Lc(a)):l.setImmediate(a)}},Sc=!1,Tc=new Nc,Vc=function(){for(var a;a=Tc.remove();){try{a.Tc.call(a.scope)}catch(b){Kc(b)}Pc.put(a)}Sc=!1};!gb&&!y||y&&9<=Number(ob)||gb&&z("1.9.1");y&&z("9");var Xc=function(){this.pa="";this.ue=Wc};Xc.prototype.Eb=!0;Xc.prototype.Bb=function(){return this.pa};Xc.prototype.toString=function(){return"SafeHtml{"+this.pa+"}"};var Yc=function(a){if(a instanceof Xc&&a.constructor===Xc&&a.ue===Wc)return a.pa;ya("expected object of type SafeHtml, got '"+a+"' of type "+ca(a));return"type_error:SafeHtml"},Wc={};Xc.prototype.$e=function(a){this.pa=a;return this};var $c=function(a,b){Sa(b,function(b,d){b&&b.Eb&&(b=b.Bb());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Zc.hasOwnProperty(d)?a.setAttribute(Zc[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})},Zc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};var ad=function(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0},bd=function(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};var A=function(a,b){this.N=0;this.ra=void 0;this.bb=this.na=this.s=null;this.jc=this.Sc=!1;if(a!=ba)try{var c=this;a.call(b,function(a){cd(c,2,a)},function(a){if(!(a instanceof dd))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}cd(c,3,a)})}catch(d){cd(this,3,d)}},ed=function(){this.next=this.context=this.jb=this.Oa=this.child=null;this.xb=!1};ed.prototype.reset=function(){this.context=this.jb=this.Oa=this.child=null;this.xb=!1};
	var fd=new Jc(function(){return new ed},function(a){a.reset()},100),gd=function(a,b,c){var d=fd.get();d.Oa=a;d.jb=b;d.context=c;return d},B=function(a){if(a instanceof A)return a;var b=new A(ba);cd(b,2,a);return b},D=function(a){return new A(function(b,c){c(a)})},id=function(a,b,c){hd(a,b,c,null)||Uc(ka(b,a))},jd=function(a){return new A(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Ne:!0,value:f}:{Ne:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],id(g,ka(e,f,!0),
	ka(e,f,!1));else b(d)})};A.prototype.then=function(a,b,c){null!=a&&Ba(a,"opt_onFulfilled should be a function.");null!=b&&Ba(b,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return kd(this,p(a)?a:null,p(b)?b:null,c)};ad(A);var md=function(a,b){b=gd(b,b,void 0);b.xb=!0;ld(a,b);return a};A.prototype.f=function(a,b){return kd(this,null,a,b)};A.prototype.cancel=function(a){0==this.N&&Uc(function(){var b=new dd(a);nd(this,b)},this)};
	var nd=function(a,b){if(0==a.N)if(a.s){var c=a.s;if(c.na){for(var d=0,e=null,f=null,g=c.na;g&&(g.xb||(d++,g.child==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(0==c.N&&1==d?nd(c,b):(f?(d=f,v(c.na),v(null!=d),d.next==c.bb&&(c.bb=d),d.next=d.next.next):od(c),pd(c,e,3,b)))}a.s=null}else cd(a,3,b)},ld=function(a,b){a.na||2!=a.N&&3!=a.N||qd(a);v(null!=b.Oa);a.bb?a.bb.next=b:a.na=b;a.bb=b},kd=function(a,b,c,d){var e=gd(null,null,null);e.child=new A(function(a,g){e.Oa=b?function(c){try{var e=b.call(d,c);a(e)}catch(C){g(C)}}:
	a;e.jb=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof dd?g(b):a(e)}catch(C){g(C)}}:g});e.child.s=a;ld(a,e);return e.child};A.prototype.Jf=function(a){v(1==this.N);this.N=0;cd(this,2,a)};A.prototype.Kf=function(a){v(1==this.N);this.N=0;cd(this,3,a)};
	var cd=function(a,b,c){0==a.N&&(a===c&&(b=3,c=new TypeError("Promise cannot resolve to itself")),a.N=1,hd(c,a.Jf,a.Kf,a)||(a.ra=c,a.N=b,a.s=null,qd(a),3!=b||c instanceof dd||rd(a,c)))},hd=function(a,b,c,d){if(a instanceof A)return null!=b&&Ba(b,"opt_onFulfilled should be a function."),null!=c&&Ba(c,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"),ld(a,gd(b||ba,c||null,d)),!0;if(bd(a))return a.then(b,c,d),!0;if(ha(a))try{var e=a.then;if(p(e))return sd(a,
	e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1},sd=function(a,b,c,d,e){var f=!1,g=function(a){f||(f=!0,c.call(e,a))},k=function(a){f||(f=!0,d.call(e,a))};try{b.call(a,g,k)}catch(n){k(n)}},qd=function(a){a.Sc||(a.Sc=!0,Uc(a.Je,a))},od=function(a){var b=null;a.na&&(b=a.na,a.na=b.next,b.next=null);a.na||(a.bb=null);null!=b&&v(null!=b.Oa);return b};A.prototype.Je=function(){for(var a;a=od(this);)pd(this,a,this.N,this.ra);this.Sc=!1};
	var pd=function(a,b,c,d){if(3==c&&b.jb&&!b.xb)for(;a&&a.jc;a=a.s)a.jc=!1;if(b.child)b.child.s=null,td(b,c,d);else try{b.xb?b.Oa.call(b.context):td(b,c,d)}catch(e){ud.call(null,e)}fd.put(b)},td=function(a,b,c){2==b?a.Oa.call(a.context,c):a.jb&&a.jb.call(a.context,c)},rd=function(a,b){a.jc=!0;Uc(function(){a.jc&&ud.call(null,b)})},ud=Kc,dd=function(a){t.call(this,a)};r(dd,t);dd.prototype.name="cancel";
	var vd=function(a,b){this.zc=[];this.$d=a;this.Jd=b||null;this.Cb=this.fb=!1;this.ra=void 0;this.ud=this.Cd=this.Nc=!1;this.Gc=0;this.s=null;this.Oc=0};vd.prototype.cancel=function(a){if(this.fb)this.ra instanceof vd&&this.ra.cancel();else{if(this.s){var b=this.s;delete this.s;a?b.cancel(a):(b.Oc--,0>=b.Oc&&b.cancel())}this.$d?this.$d.call(this.Jd,this):this.ud=!0;this.fb||wd(this,new xd)}};vd.prototype.Hd=function(a,b){this.Nc=!1;yd(this,a,b)};
	var yd=function(a,b,c){a.fb=!0;a.ra=c;a.Cb=!b;zd(a)},Bd=function(a){if(a.fb){if(!a.ud)throw new Ad;a.ud=!1}};vd.prototype.callback=function(a){Bd(this);Cd(a);yd(this,!0,a)};
	var wd=function(a,b){Bd(a);Cd(b);yd(a,!1,b)},Cd=function(a){v(!(a instanceof vd),"An execution sequence may not be initiated with a blocking Deferred.")},Gd=function(a){var b=Dd("https://apis.google.com/js/client.js?onload="+Ed);Fd(b,null,a,void 0)},Fd=function(a,b,c,d){v(!a.Cd,"Blocking Deferreds can not be re-used");a.zc.push([b,c,d]);a.fb&&zd(a)};vd.prototype.then=function(a,b,c){var d,e,f=new A(function(a,b){d=a;e=b});Fd(this,d,function(a){a instanceof xd?f.cancel():e(a)});return f.then(a,b,c)};
	ad(vd);
	var Hd=function(a){return Fa(a.zc,function(a){return p(a[1])})},zd=function(a){if(a.Gc&&a.fb&&Hd(a)){var b=a.Gc,c=Id[b];c&&(l.clearTimeout(c.Db),delete Id[b]);a.Gc=0}a.s&&(a.s.Oc--,delete a.s);for(var b=a.ra,d=c=!1;a.zc.length&&!a.Nc;){var e=a.zc.shift(),f=e[0],g=e[1],e=e[2];if(f=a.Cb?g:f)try{var k=f.call(e||a.Jd,b);void 0!==k&&(a.Cb=a.Cb&&(k==b||k instanceof Error),a.ra=b=k);if(bd(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.Nc=!0}catch(n){b=n,a.Cb=!0,Hd(a)||(c=!0)}}a.ra=b;d&&
	(k=q(a.Hd,a,!0),d=q(a.Hd,a,!1),b instanceof vd?(Fd(b,k,d),b.Cd=!0):b.then(k,d));c&&(b=new Jd(b),Id[b.Db]=b,a.Gc=b.Db)},Ad=function(){t.call(this)};r(Ad,t);Ad.prototype.message="Deferred has already fired";Ad.prototype.name="AlreadyCalledError";var xd=function(){t.call(this)};r(xd,t);xd.prototype.message="Deferred was canceled";xd.prototype.name="CanceledError";var Jd=function(a){this.Db=l.setTimeout(q(this.If,this),0);this.P=a};
	Jd.prototype.If=function(){v(Id[this.Db],"Cannot throw an error that is not scheduled.");delete Id[this.Db];throw this.P;};var Id={};var Dd=function(a){var b=new oc;b.wc=a;return Kd(b)},Kd=function(a){var b={},c=b.document||document,d;a instanceof oc&&a.constructor===oc&&a.xe===nc?d=a.wc:(ya("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ca(a)),d="type_error:TrustedResourceUrl");var e=document.createElement("SCRIPT");a={fe:e,Zb:void 0};var f=new vd(Ld,a),g=null,k=null!=b.timeout?b.timeout:5E3;0<k&&(g=window.setTimeout(function(){Md(e,!0);wd(f,new Nd(1,"Timeout reached for loading script "+d))},k),a.Zb=g);e.onload=
	e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Md(e,b.Uf||!1,g),f.callback(null))};e.onerror=function(){Md(e,!0,g);wd(f,new Nd(0,"Error while loading script "+d))};a=b.attributes||{};Za(a,{type:"text/javascript",charset:"UTF-8",src:d});$c(e,a);Od(c).appendChild(e);return f},Od=function(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement},Ld=function(){if(this&&this.fe){var a=this.fe;a&&"SCRIPT"==a.tagName&&
	Md(a,!0,this.Zb)}},Md=function(a,b,c){null!=c&&l.clearTimeout(c);a.onload=ba;a.onerror=ba;a.onreadystatechange=ba;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)},Nd=function(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);t.call(this,c);this.code=a};r(Nd,t);var Pd="StopIteration"in l?l.StopIteration:{message:"StopIteration",stack:""},Qd=function(){};Qd.prototype.next=function(){throw Pd;};Qd.prototype.ye=function(){return this};var Rd=function(a,b){this.ga={};this.w=[];this.wb=this.o=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.addAll(a)};Rd.prototype.Z=function(){Sd(this);for(var a=[],b=0;b<this.w.length;b++)a.push(this.ga[this.w[b]]);return a};Rd.prototype.oa=function(){Sd(this);return this.w.concat()};Rd.prototype.yb=function(a){return Td(this.ga,a)};
	Rd.prototype.remove=function(a){return Td(this.ga,a)?(delete this.ga[a],this.o--,this.wb++,this.w.length>2*this.o&&Sd(this),!0):!1};var Sd=function(a){if(a.o!=a.w.length){for(var b=0,c=0;b<a.w.length;){var d=a.w[b];Td(a.ga,d)&&(a.w[c++]=d);b++}a.w.length=c}if(a.o!=a.w.length){for(var e={},c=b=0;b<a.w.length;)d=a.w[b],Td(e,d)||(a.w[c++]=d,e[d]=1),b++;a.w.length=c}};h=Rd.prototype;h.get=function(a,b){return Td(this.ga,a)?this.ga[a]:b};
	h.set=function(a,b){Td(this.ga,a)||(this.o++,this.w.push(a),this.wb++);this.ga[a]=b};h.addAll=function(a){var b;a instanceof Rd?(b=a.oa(),a=a.Z()):(b=Ua(a),a=Ta(a));for(var c=0;c<b.length;c++)this.set(b[c],a[c])};h.forEach=function(a,b){for(var c=this.oa(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};h.clone=function(){return new Rd(this)};
	h.ye=function(a){Sd(this);var b=0,c=this.wb,d=this,e=new Qd;e.next=function(){if(c!=d.wb)throw Error("The map has changed since the iterator was created");if(b>=d.w.length)throw Pd;var e=d.w[b++];return a?e:d.ga[e]};return e};var Td=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Ud=function(a){if(a.Z&&"function"==typeof a.Z)return a.Z();if(m(a))return a.split("");if(fa(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ta(a)},Vd=function(a){if(a.oa&&"function"==typeof a.oa)return a.oa();if(!a.Z||"function"!=typeof a.Z){if(fa(a)||m(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return Ua(a)}},Wd=function(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(fa(a)||m(a))w(a,b,void 0);else for(var c=Vd(a),d=Ud(a),e=
	d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};var Xd=function(a,b,c,d,e){this.reset(a,b,c,d,e)};Xd.prototype.Md=null;var Yd=0;Xd.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Yd++;d||la();this.Ib=a;this.hf=b;delete this.Md};Xd.prototype.ie=function(a){this.Ib=a};var Zd=function(a){this.jf=a;this.Td=this.Pc=this.Ib=this.s=null},$d=function(a,b){this.name=a;this.value=b};$d.prototype.toString=function(){return this.name};var ae=new $d("SEVERE",1E3),be=new $d("CONFIG",700),ce=new $d("FINE",500);Zd.prototype.getParent=function(){return this.s};Zd.prototype.ie=function(a){this.Ib=a};var de=function(a){if(a.Ib)return a.Ib;if(a.s)return de(a.s);ya("Root logger has no level set.");return null};
	Zd.prototype.log=function(a,b,c){if(a.value>=de(this).value)for(p(b)&&(b=b()),a=new Xd(a,String(b),this.jf),c&&(a.Md=c),c="log:"+a.hf,l.console&&(l.console.timeStamp?l.console.timeStamp(c):l.console.markTimeline&&l.console.markTimeline(c)),l.msWriteProfilerMark&&l.msWriteProfilerMark(c),c=this;c;){var d=c,e=a;if(d.Td)for(var f=0;b=d.Td[f];f++)b(e);c=c.getParent()}};
	var ee={},fe=null,ge=function(a){fe||(fe=new Zd(""),ee[""]=fe,fe.ie(be));var b;if(!(b=ee[a])){b=new Zd(a);var c=a.lastIndexOf("."),d=a.substr(c+1),c=ge(a.substr(0,c));c.Pc||(c.Pc={});c.Pc[d]=b;b.s=c;ee[a]=b}return b};var he=function(){Fb.call(this);this.fa=new Ob(this);this.ze=this;this.hd=null};r(he,Fb);he.prototype[Kb]=!0;h=he.prototype;h.addEventListener=function(a,b,c,d){Vb(this,a,b,c,d)};h.removeEventListener=function(a,b,c,d){dc(this,a,b,c,d)};
	h.dispatchEvent=function(a){ie(this);var b,c=this.hd;if(c){b=[];for(var d=1;c;c=c.hd)b.push(c),v(1E3>++d,"infinite loop")}c=this.ze;d=a.type||a;if(m(a))a=new Ib(a,c);else if(a instanceof Ib)a.target=a.target||c;else{var e=a;a=new Ib(d,c);Za(a,e)}var e=!0,f;if(b)for(var g=b.length-1;!a.nb&&0<=g;g--)f=a.currentTarget=b[g],e=je(f,d,!0,a)&&e;a.nb||(f=a.currentTarget=c,e=je(f,d,!0,a)&&e,a.nb||(e=je(f,d,!1,a)&&e));if(b)for(g=0;!a.nb&&g<b.length;g++)f=a.currentTarget=b[g],e=je(f,d,!1,a)&&e;return e};
	h.cb=function(){he.xd.cb.call(this);if(this.fa){var a=this.fa,b=0,c;for(c in a.G){for(var d=a.G[c],e=0;e<d.length;e++)++b,Nb(d[e]);delete a.G[c];a.$b--}}this.hd=null};h.listen=function(a,b,c,d){ie(this);return this.fa.add(String(a),b,!1,c,d)};
	var cc=function(a,b,c,d,e){a.fa.add(String(b),c,!0,d,e)},je=function(a,b,c,d){b=a.fa.G[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.rb&&g.capture==c){var k=g.listener,n=g.kc||g.src;g.dc&&Rb(a.fa,g);e=!1!==k.call(n,d)&&e}}return e&&0!=d.ee};he.prototype.Uc=function(a,b,c,d){return this.fa.Uc(String(a),b,c,d)};var ie=function(a){v(a.fa,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?")};var E=function(a,b){a&&a.log(ce,b,void 0)};var ke=function(a,b,c){if(p(a))c&&(a=q(a,c));else if(a&&"function"==typeof a.handleEvent)a=q(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)},le=function(a){var b=null;return(new A(function(c,d){b=ke(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).f(function(a){l.clearTimeout(b);throw a;})};var me=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/,ne=function(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e,f=null;0<=d?(e=a[c].substring(0,d),f=a[c].substring(d+1)):e=a[c];b(e,f?decodeURIComponent(f.replace(/\+/g," ")):"")}}};var F=function(a){he.call(this);this.headers=new Rd;this.Lc=a||null;this.va=!1;this.Kc=this.b=null;this.Hb=this.Zd=this.qc="";this.Ka=this.Yc=this.oc=this.Rc=!1;this.sb=0;this.Ec=null;this.de="";this.Hc=this.sf=this.te=!1};r(F,he);var oe=F.prototype,pe=ge("goog.net.XhrIo");oe.U=pe;var qe=/^https?$/i,re=["POST","PUT"];
	F.prototype.send=function(a,b,c,d){if(this.b)throw Error("[goog.net.XhrIo] Object is active with another request="+this.qc+"; newUri="+a);b=b?b.toUpperCase():"GET";this.qc=a;this.Hb="";this.Zd=b;this.Rc=!1;this.va=!0;this.b=this.Lc?this.Lc.fc():Dc.fc();this.Kc=this.Lc?Cc(this.Lc):Cc(Dc);this.b.onreadystatechange=q(this.be,this);this.sf&&"onprogress"in this.b&&(this.b.onprogress=q(function(a){this.ae(a,!0)},this),this.b.upload&&(this.b.upload.onprogress=q(this.ae,this)));try{E(this.U,se(this,"Opening Xhr")),
	this.Yc=!0,this.b.open(b,String(a),!0),this.Yc=!1}catch(f){E(this.U,se(this,"Error opening Xhr: "+f.message));this.P(5,f);return}a=c||"";var e=this.headers.clone();d&&Wd(d,function(a,b){e.set(b,a)});d=Ha(e.oa());c=l.FormData&&a instanceof l.FormData;!Ia(re,b)||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.b.setRequestHeader(b,a)},this);this.de&&(this.b.responseType=this.de);"withCredentials"in this.b&&this.b.withCredentials!==this.te&&(this.b.withCredentials=
	this.te);try{te(this),0<this.sb&&(this.Hc=ue(this.b),E(this.U,se(this,"Will abort after "+this.sb+"ms if incomplete, xhr2 "+this.Hc)),this.Hc?(this.b.timeout=this.sb,this.b.ontimeout=q(this.Zb,this)):this.Ec=ke(this.Zb,this.sb,this)),E(this.U,se(this,"Sending request")),this.oc=!0,this.b.send(a),this.oc=!1}catch(f){E(this.U,se(this,"Send error: "+f.message)),this.P(5,f)}};var ue=function(a){return y&&z(9)&&ga(a.timeout)&&void 0!==a.ontimeout},Ga=function(a){return"content-type"==a.toLowerCase()};
	F.prototype.Zb=function(){"undefined"!=typeof aa&&this.b&&(this.Hb="Timed out after "+this.sb+"ms, aborting",E(this.U,se(this,this.Hb)),this.dispatchEvent("timeout"),this.abort(8))};F.prototype.P=function(a,b){this.va=!1;this.b&&(this.Ka=!0,this.b.abort(),this.Ka=!1);this.Hb=b;ve(this);we(this)};var ve=function(a){a.Rc||(a.Rc=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))};
	F.prototype.abort=function(){this.b&&this.va&&(E(this.U,se(this,"Aborting")),this.va=!1,this.Ka=!0,this.b.abort(),this.Ka=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),we(this))};F.prototype.cb=function(){this.b&&(this.va&&(this.va=!1,this.Ka=!0,this.b.abort(),this.Ka=!1),we(this,!0));F.xd.cb.call(this)};F.prototype.be=function(){this.isDisposed()||(this.Yc||this.oc||this.Ka?xe(this):this.nf())};F.prototype.nf=function(){xe(this)};
	var xe=function(a){if(a.va&&"undefined"!=typeof aa)if(a.Kc[1]&&4==ye(a)&&2==ze(a))E(a.U,se(a,"Local request error detected and ignored"));else if(a.oc&&4==ye(a))ke(a.be,0,a);else if(a.dispatchEvent("readystatechange"),4==ye(a)){E(a.U,se(a,"Request complete"));a.va=!1;try{var b=ze(a),c;a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.qc).match(me)[1]||null;if(!f&&l.self&&l.self.location)var g=l.self.location.protocol,
	f=g.substr(0,g.length-1);e=!qe.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{var k;try{k=2<ye(a)?a.b.statusText:""}catch(n){E(a.U,"Can not get status: "+n.message),k=""}a.Hb=k+" ["+ze(a)+"]";ve(a)}}finally{we(a)}}};F.prototype.ae=function(a,b){v("progress"===a.type,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(Ae(a,"progress"));this.dispatchEvent(Ae(a,b?"downloadprogress":"uploadprogress"))};
	var Ae=function(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}},we=function(a,b){if(a.b){te(a);var c=a.b,d=a.Kc[0]?ba:null;a.b=null;a.Kc=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.U)&&a.log(ae,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}},te=function(a){a.b&&a.Hc&&(a.b.ontimeout=null);ga(a.Ec)&&(l.clearTimeout(a.Ec),a.Ec=null)},ye=function(a){return a.b?a.b.readyState:0},ze=function(a){try{return 2<ye(a)?
	a.b.status:-1}catch(b){return-1}},Be=function(a){try{return a.b?a.b.responseText:""}catch(b){return E(a.U,"Can not get responseText: "+b.message),""}},se=function(a,b){return b+" ["+a.Zd+" "+a.qc+" "+ze(a)+"]"};var G=function(a,b){this.ea=this.Xa=this.ha="";this.lb=null;this.Ja=this.xa="";this.S=this.df=!1;var c;a instanceof G?(this.S=void 0!==b?b:a.S,Ce(this,a.ha),c=a.Xa,H(this),this.Xa=c,De(this,a.ea),Ee(this,a.lb),Fe(this,a.xa),Ge(this,a.W.clone()),a=a.Ja,H(this),this.Ja=a):a&&(c=String(a).match(me))?(this.S=!!b,Ce(this,c[1]||"",!0),a=c[2]||"",H(this),this.Xa=He(a),De(this,c[3]||"",!0),Ee(this,c[4]),Fe(this,c[5]||"",!0),Ge(this,c[6]||"",!0),a=c[7]||"",H(this),this.Ja=He(a)):(this.S=!!b,this.W=new I(null,
	0,this.S))};G.prototype.toString=function(){var a=[],b=this.ha;b&&a.push(Ie(b,Je,!0),":");var c=this.ea;if(c||"file"==b)a.push("//"),(b=this.Xa)&&a.push(Ie(b,Je,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.lb,null!=c&&a.push(":",String(c));if(c=this.xa)this.ea&&"/"!=c.charAt(0)&&a.push("/"),a.push(Ie(c,"/"==c.charAt(0)?Ke:Le,!0));(c=this.W.toString())&&a.push("?",c);(c=this.Ja)&&a.push("#",Ie(c,Me));return a.join("")};
	G.prototype.resolve=function(a){var b=this.clone(),c=!!a.ha;c?Ce(b,a.ha):c=!!a.Xa;if(c){var d=a.Xa;H(b);b.Xa=d}else c=!!a.ea;c?De(b,a.ea):c=null!=a.lb;d=a.xa;if(c)Ee(b,a.lb);else if(c=!!a.xa){if("/"!=d.charAt(0))if(this.ea&&!this.xa)d="/"+d;else{var e=b.xa.lastIndexOf("/");-1!=e&&(d=b.xa.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(u(e,"./")||u(e,"/.")){for(var d=0==e.lastIndexOf("/",0),e=e.split("/"),f=[],g=0;g<e.length;){var k=e[g++];"."==k?d&&g==e.length&&f.push(""):".."==k?((1<f.length||
	1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(k),d=!0)}d=f.join("/")}else d=e}c?Fe(b,d):c=""!==a.W.toString();c?Ge(b,a.W.clone()):c=!!a.Ja;c&&(a=a.Ja,H(b),b.Ja=a);return b};G.prototype.clone=function(){return new G(this)};
	var Ce=function(a,b,c){H(a);a.ha=c?He(b,!0):b;a.ha&&(a.ha=a.ha.replace(/:$/,""))},De=function(a,b,c){H(a);a.ea=c?He(b,!0):b},Ee=function(a,b){H(a);if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.lb=b}else a.lb=null},Fe=function(a,b,c){H(a);a.xa=c?He(b,!0):b},Ge=function(a,b,c){H(a);b instanceof I?(a.W=b,a.W.td(a.S)):(c||(b=Ie(b,Ne)),a.W=new I(b,0,a.S))},J=function(a,b,c){H(a);a.W.set(b,c)},Oe=function(a,b){return a.W.get(b)};
	G.prototype.removeParameter=function(a){H(this);this.W.remove(a);return this};var H=function(a){if(a.df)throw Error("Tried to modify a read-only Uri");};G.prototype.td=function(a){this.S=a;this.W&&this.W.td(a);return this};
	var Pe=function(a){return a instanceof G?a.clone():new G(a,void 0)},Qe=function(a,b){var c=new G(null,void 0);Ce(c,"https");a&&De(c,a);b&&Fe(c,b);return c},He=function(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""},Ie=function(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Re),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null},Re=function(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)},Je=/[#\/\?@]/g,Le=/[\#\?:]/g,Ke=/[\#\?]/g,Ne=/[\#\?@]/g,
	Me=/#/g,I=function(a,b,c){this.o=this.l=null;this.O=a||null;this.S=!!c},Se=function(a){a.l||(a.l=new Rd,a.o=0,a.O&&ne(a.O,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))},Ue=function(a){var b=Vd(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new I(null,0,void 0);a=Ud(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];ea(f)?Te(c,e,f):c.add(e,f)}return c};h=I.prototype;
	h.add=function(a,b){Se(this);this.O=null;a=this.R(a);var c=this.l.get(a);c||this.l.set(a,c=[]);c.push(b);this.o=za(this.o)+1;return this};h.remove=function(a){Se(this);a=this.R(a);return this.l.yb(a)?(this.O=null,this.o=za(this.o)-this.l.get(a).length,this.l.remove(a)):!1};h.yb=function(a){Se(this);a=this.R(a);return this.l.yb(a)};h.oa=function(){Se(this);for(var a=this.l.Z(),b=this.l.oa(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
	h.Z=function(a){Se(this);var b=[];if(m(a))this.yb(a)&&(b=Ma(b,this.l.get(this.R(a))));else{a=this.l.Z();for(var c=0;c<a.length;c++)b=Ma(b,a[c])}return b};h.set=function(a,b){Se(this);this.O=null;a=this.R(a);this.yb(a)&&(this.o=za(this.o)-this.l.get(a).length);this.l.set(a,[b]);this.o=za(this.o)+1;return this};h.get=function(a,b){a=a?this.Z(a):[];return 0<a.length?String(a[0]):b};var Te=function(a,b,c){a.remove(b);0<c.length&&(a.O=null,a.l.set(a.R(b),Na(c)),a.o=za(a.o)+c.length)};
	I.prototype.toString=function(){if(this.O)return this.O;if(!this.l)return"";for(var a=[],b=this.l.oa(),c=0;c<b.length;c++)for(var d=b[c],e=encodeURIComponent(String(d)),d=this.Z(d),f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}return this.O=a.join("&")};I.prototype.clone=function(){var a=new I;a.O=this.O;this.l&&(a.l=this.l.clone(),a.o=this.o);return a};I.prototype.R=function(a){a=String(a);this.S&&(a=a.toLowerCase());return a};
	I.prototype.td=function(a){a&&!this.S&&(Se(this),this.O=null,this.l.forEach(function(a,c){var b=c.toLowerCase();c!=b&&(this.remove(c),Te(this,b,a))},this));this.S=a};var Ve=function(){var a=K();return y&&!!ob&&11==ob||/Edge\/\d+/.test(a)},We=function(){return l.window&&l.window.location.href||""},Xe=function(a,b){b=b||l.window;var c="about:blank";a&&(c=rc(uc(a)));b.location.href=c},Ye=function(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):ea(a[d])?Wa(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<Ye(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c},$e=function(){var a;
	a=K();a="Chrome"!=Ze(a)?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!y||!ob||9<ob},af=function(a){a=(a||K()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1},bf=function(a){a=a||l.window;try{a.close()}catch(b){}},cf=function(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-
	b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=K().toLowerCase();d&&(b.target=d,u(c,"crios/")&&(b.target="_blank"));"Firefox"==Ze(K())&&(a=a||"http://localhost",b.scrollbars=!0);var g;c=a||"about:blank";(d=b)||(d={});a=window;b=c instanceof qc?c:uc("undefined"!=typeof c.href?c.href:String(c));c=d.target||c.target;e=[];for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;
	default:e.push(g+"="+(d[g]?1:0))}g=e.join(",");(x("iPhone")&&!x("iPod")&&!x("iPad")||x("iPad")||x("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),"undefined"!=typeof HTMLAnchorElement&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&(e=g&&(g instanceof HTMLAnchorElement||!(g instanceof Location||g instanceof Element)),f=ha(g)?g.constructor.displayName||g.constructor.name||Object.prototype.toString.call(g):void 0===g?"undefined":null===g?"null":
	typeof g,v(e,"Argument is not a HTMLAnchorElement (or a non-Element mock); got: %s",f)),b=b instanceof qc?b:uc(b),g.href=rc(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel","noreferrer"),d=document.createEvent("MouseEvent"),d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),d=rc(b),g&&(fb&&u(d,";")&&(d="'"+d.replace(/'/g,"%27")+"'"),g.opener=null,a=mc("b/12014412, meta tag with sanitized URL"),ua.test(d)&&(-1!=d.indexOf("&")&&(d=d.replace(oa,
	"&amp;")),-1!=d.indexOf("<")&&(d=d.replace(pa,"&lt;")),-1!=d.indexOf(">")&&(d=d.replace(qa,"&gt;")),-1!=d.indexOf('"')&&(d=d.replace(ra,"&quot;")),-1!=d.indexOf("'")&&(d=d.replace(sa,"&#39;")),-1!=d.indexOf("\x00")&&(d=d.replace(ta,"&#0;"))),d='<META HTTP-EQUIV="refresh" content="0; url='+d+'">',Aa(lc(a),"must provide justification"),v(!/^[\s\xa0]*$/.test(lc(a)),"must provide non-empty justification"),g.document.write(Yc((new Xc).$e(d))),g.document.close())):g=a.open(rc(b),c,g);if(g)try{g.focus()}catch(k){}return g},
	df=function(a){return new A(function(b){var c=function(){le(2E3).then(function(){if(!a||a.closed)b();else return c()})};return c()})},ef=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,ff=function(){var a=null;return(new A(function(b){"complete"==l.document.readyState?b():(a=function(){b()},bc(window,"load",a))})).f(function(b){dc(window,"load",a);throw b;})},hf=function(){return gf(void 0)?ff().then(function(){return new A(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},
	1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):D(Error("Cordova must run in an Android or iOS file scheme."))},gf=function(a){a=a||K();return!("file:"!==jf()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))},kf=function(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}},L=function(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":"Browser"},lf=function(){var a=L();return"ReactNative"===
	a||"Node"===a},Ze=function(a){var b=a.toLowerCase();if(u(b,"opera/")||u(b,"opr/")||u(b,"opios/"))return"Opera";if(u(b,"iemobile"))return"IEMobile";if(u(b,"msie")||u(b,"trident/"))return"IE";if(u(b,"edge/"))return"Edge";if(u(b,"firefox/"))return"Firefox";if(u(b,"silk/"))return"Silk";if(u(b,"blackberry"))return"Blackberry";if(u(b,"webos"))return"Webos";if(!u(b,"safari/")||u(b,"chrome/")||u(b,"crios/")||u(b,"android"))if(!u(b,"chrome/")&&!u(b,"crios/")||u(b,"edge/")){if(u(b,"android"))return"Android";
	if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&2==a.length)return a[1]}else return"Chrome";else return"Safari";return"Other"},mf=function(a){var b=L();return("Browser"===b?Ze(K()):b)+"/JsCore/"+a},K=function(){return l.navigator&&l.navigator.userAgent||""},M=function(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b},pf=function(){var a;if(a=(nf()||"chrome-extension:"===jf()||gf())&&!lf())a:{try{var b=l.localStorage,c=
	of();if(b){b.setItem(c,"1");b.removeItem(c);a=Ve()?!!l.indexedDB:!0;break a}}catch(d){}a=!1}return a},nf=function(){return"http:"===jf()||"https:"===jf()},jf=function(){return l.location&&l.location.protocol||null},qf=function(a){a=a||K();return af(a)||"Firefox"==Ze(a)?!1:!0},rf=function(a){return"undefined"===typeof a?null:xc(a)},sf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b},tf=function(a){if(null!==a)return JSON.parse(a)},of=function(a){return a?
	a:""+Math.floor(1E9*Math.random()).toString()},uf=function(a){a=a||K();return"Safari"==Ze(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0},vf=function(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null},wf=function(){return l.navigator&&"boolean"===typeof l.navigator.onLine?l.navigator.onLine:!0},xf=function(a,b,c,d){if(a>b)throw Error("Short delay should be less than long delay!");
	this.Ff=a;this.gf=b;a=c||K();d=d||L();this.cf=af(a)||"ReactNative"===d};xf.prototype.get=function(){return this.cf?this.gf:this.Ff};
	var yf=function(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0},zf=function(){var a=l.document,b=null;return yf()||!a?B():(new A(function(c){b=function(){yf()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).f(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})};var Af={},Bf=function(a){Af[a]||(Af[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Cf;try{var Df={};Object.defineProperty(Df,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Df,"abcd",{configurable:!0,enumerable:!0,value:2});Cf=2==Df.abcd}catch(a){Cf=!1}
	var N=function(a,b,c){Cf?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c},Ef=function(a,b){Cf?Object.defineProperty(a,"provider",{configurable:!0,enumerable:!0,get:function(){Bf("firebase.auth.AuthCredential.provider is deprecated. Please use the providerId field instead.");return b}}):a.provider=b},Ff=function(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&N(a,c,b[c])},Gf=function(a){var b={};Ff(b,a);return b},Hf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=
	a[c]);return b},If=function(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0},Jf=function(a){var b=a;if("object"==typeof a&&null!=a){var b="length"in a?[]:{},c;for(c in a)N(b,c,Jf(a[c]))}return b};var Kf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Lf=["client_id","response_type","scope","redirect_uri","state"],Mf={Pf:{Mb:500,Lb:600,providerId:"facebook.com",qd:Lf},Qf:{Mb:500,Lb:620,providerId:"github.com",qd:Lf},Rf:{Mb:515,Lb:680,providerId:"google.com",qd:Lf},Sf:{Mb:485,Lb:705,providerId:"twitter.com",qd:Kf}},Nf=function(a){for(var b in Mf)if(Mf[b].providerId==a)return Mf[b];return null};var O=function(a,b){this.code="auth/"+a;this.message=b||Of[a]||""};r(O,Error);O.prototype.C=function(){return{code:this.code,message:this.message}};O.prototype.toJSON=function(){return this.C()};
	var Pf=function(a){var b=a&&a.code;return b?new O(b.substring(5),a.message):null},Of={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"",
	"code-expired":"","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
	"email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.",
	"invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.",
	"invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
	"invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-identifier-number":"","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
	"invalid-verification-id":"","missing-iframe-start":"An internal error has occurred.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"","missing-verification-code":"","missing-identifier-number":"","missing-verification-id":"","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
	"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
	"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",timeout:"The operation has timed out.",
	"user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.",
	"user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};var P=function(a,b,c,d,e){this.da=a;this.J=b||null;this.tb=c||null;this.sd=d||null;this.P=e||null;if(this.tb||this.P){if(this.tb&&this.P)throw new O("invalid-auth-event");if(this.tb&&!this.sd)throw new O("invalid-auth-event");}else throw new O("invalid-auth-event");};P.prototype.ic=function(){return this.sd};P.prototype.getError=function(){return this.P};P.prototype.C=function(){return{type:this.da,eventId:this.J,urlResponse:this.tb,sessionId:this.sd,error:this.P&&this.P.C()}};
	var Qf=function(a){a=a||{};return a.type?new P(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&Pf(a.error)):null};var Rf=function(a){var b="unauthorized-domain",c=void 0,d=Pe(a);a=d.ea;d=d.ha;"chrome-extension"==d?c=ma("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=ma("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b=
	"operation-not-supported-in-this-environment";O.call(this,b,c)};r(Rf,O);var Sf=function(a){this.ff=a.sub;la();this.gc=a.email||null};var Tf=function(a,b){return a.then(function(a){if(a.idToken){var c;a:{var e=a.idToken.split(".");if(3==e.length){for(var e=e[1],f=(4-e.length%4)%4,g=0;g<f;g++)e+=".";try{var k=JSON.parse(tb(e));if(k.sub&&k.iss&&k.aud&&k.exp){c=new Sf(k);break a}}catch(n){}}c=null}if(!c||b!=c.ff)throw new O("user-mismatch");return a}throw new O("user-mismatch");}).f(function(a){throw a&&a.code&&"auth/user-not-found"==a.code?new O("user-mismatch"):a;})},Uf=function(a,b){if(b.idToken||b.accessToken)b.idToken&&N(this,
	"idToken",b.idToken),b.accessToken&&N(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)N(this,"accessToken",b.oauthToken),N(this,"secret",b.oauthTokenSecret);else throw new O("internal-error","failed to construct a credential");Ef(this,a);N(this,"providerId",a)};Uf.prototype.Ab=function(a){return Vf(a,Wf(this))};Uf.prototype.cd=function(a,b){var c=Wf(this);c.idToken=b;return Xf(a,c)};Uf.prototype.ed=function(a,b){var c=Wf(this);return Tf(Yf(a,c),b)};
	var Wf=function(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:Ue(b).toString(),requestUri:"http://localhost"}};Uf.prototype.C=function(){var a={providerId:this.providerId};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};
	var Zf=function(a,b){this.vf=b||[];Ff(this,{providerId:a,isOAuthProvider:!0});this.Id={}};Zf.prototype.setCustomParameters=function(a){this.Id=Xa(a);return this};var Q=function(a){Zf.call(this,a,Lf);this.rd=[]};r(Q,Zf);Q.prototype.addScope=function(a){Ia(this.rd,a)||this.rd.push(a);return this};Q.prototype.Rd=function(){return Na(this.rd)};
	Q.prototype.credential=function(a,b){if(!a&&!b)throw new O("argument-error","credential failed: must provide the ID token and/or the access token.");return new Uf(this.providerId,{idToken:a||null,accessToken:b||null})};var $f=function(){Q.call(this,"facebook.com")};r($f,Q);N($f,"PROVIDER_ID","facebook.com");
	var ag=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;ha(a)&&(b=a.accessToken);return(new $f).credential(null,b)},bg=function(){Q.call(this,"github.com")};r(bg,Q);N(bg,"PROVIDER_ID","github.com");
	var cg=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;ha(a)&&(b=a.accessToken);return(new bg).credential(null,b)},dg=function(){Q.call(this,"google.com");this.addScope("profile")};r(dg,Q);N(dg,"PROVIDER_ID","google.com");var eg=function(a,b){var c=a;ha(a)&&(c=a.idToken,b=a.accessToken);return(new dg).credential(c,b)},fg=function(){Zf.call(this,"twitter.com",Kf)};r(fg,Zf);N(fg,"PROVIDER_ID","twitter.com");
	var gg=function(a,b){var c=a;ha(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new O("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Uf("twitter.com",c)},hg=function(a,b){this.gc=a;this.jd=b;Ef(this,"password");N(this,"providerId","password")};hg.prototype.Ab=function(a){return R(a,ig,{email:this.gc,password:this.jd})};hg.prototype.cd=function(a,b){return R(a,jg,{idToken:b,email:this.gc,password:this.jd})};
	hg.prototype.ed=function(a,b){return Tf(this.Ab(a),b)};hg.prototype.C=function(){return{email:this.gc,password:this.jd}};var kg=function(){Ff(this,{providerId:"password",isOAuthProvider:!1})};Ff(kg,{PROVIDER_ID:"password"});var lg=function(a){if(!(a.Bd&&a.Ad||a.Yb&&a.ya))throw new O("internal-error");this.I=a;N(this,"providerId","identifier")};lg.prototype.Ab=function(a){return a.se(mg(this))};lg.prototype.cd=function(a,b){var c=mg(this);c.idToken=b;return R(a,ng,c)};
	lg.prototype.ed=function(a,b){var c=mg(this);c.operation="REAUTH";a=R(a,og,c);return Tf(a,b)};lg.prototype.C=function(){var a={providerId:"identifier"};this.I.Bd&&(a.verificationId=this.I.Bd);this.I.Ad&&(a.verificationCode=this.I.Ad);this.I.Yb&&(a.temporaryProof=this.I.Yb);this.I.ya&&(a.identifierNumber=this.I.ya);return a};
	var mg=function(a){return a.I.Yb&&a.I.ya?{temporaryProof:a.I.Yb,identifierNumber:a.I.ya}:{sessionInfo:a.I.Bd,code:a.I.Ad}},pg=function(a){try{this.Ce=a||firebase.auth()}catch(b){throw new O("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.identifierAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}Ff(this,{providerId:"identifier",isOAuthProvider:!1})};
	pg.prototype.se=function(a,b){var c=this.Ce.g;return B(b.verify()).then(function(d){if(!m(d))throw new O("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return R(c,qg,{identifierNumber:a,recaptchaToken:d});default:throw new O("argument-error",'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};Ff(pg,{PROVIDER_ID:"identifier"});
	var rg=function(a){if(a.temporaryProof&&a.identifierNumber)return new lg({Yb:a.temporaryProof,ya:a.identifierNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return eg(a,c);case "facebook.com":return ag(c);case "github.com":return cg(c);case "twitter.com":return gg(c,d);default:return(new Q(b)).credential(a,c)}}catch(e){return null}},sg=function(a){if(!a.isOAuthProvider)throw new O("invalid-oauth-provider");
	};var tg=function(a,b,c){O.call(this,a,c);a=b||{};a.email&&N(this,"email",a.email);a.ya&&N(this,"identifierNumber",a.ya);a.credential&&N(this,"credential",a.credential)};r(tg,O);tg.prototype.C=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.identifierNumber&&(a.identifierNumber=this.identifierNumber);var b=this.credential&&this.credential.C();b&&Za(a,b);return a};tg.prototype.toJSON=function(){return this.C()};
	var ug=function(a){if(a.code){var b=a.code||"";0==b.indexOf("auth/")&&(b=b.substring(5));var c={credential:rg(a)};if(a.email)c.email=a.email;else if(a.identifierNumber)c.ya=a.identifierNumber;else return new O(b,a.message||void 0);return new tg(b,c,a.message)}return null};var vg=function(a){this.Of=a};r(vg,Bc);vg.prototype.fc=function(){return new this.Of};vg.prototype.$c=function(){return{}};
	var S=function(a,b,c){var d;d="Node"==L();d=l.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new O("internal-error","The XMLHttpRequest compatibility library was not found.");this.j=a;a=b||{};this.Bf=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.Cf=a.secureTokenTimeout||wg;this.ge=Xa(a.secureTokenHeaders||xg);this.Le=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.Me=a.firebaseTimeout||
	yg;this.Pd=Xa(a.firebaseHeaders||zg);c&&(this.Pd["X-Client-Version"]=c,this.ge["X-Client-Version"]=c);this.Ee=new Gc;this.Nf=new vg(d)},Ag,wg=new xf(3E4,6E4),xg={"Content-Type":"application/x-www-form-urlencoded"},yg=new xf(3E4,6E4),zg={"Content-Type":"application/json"},Cg=function(a,b,c,d,e,f,g){wf()?($e()?a=q(a.Ef,a):(Ag||(Ag=new A(function(a,b){Bg(a,b)})),a=q(a.Df,a)),a(b,c,d,e,f,g)):c&&c(null)};
	S.prototype.Ef=function(a,b,c,d,e,f){var g="Node"==L(),k=lf()?g?new F(this.Nf):new F:new F(this.Ee),n;f&&(k.sb=Math.max(0,f),n=setTimeout(function(){k.dispatchEvent("timeout")},f));k.listen("complete",function(){n&&clearTimeout(n);var a=null;try{a=JSON.parse(Be(this))||null}catch(db){a=null}b&&b(a)});cc(k,"ready",function(){n&&clearTimeout(n);this.Ga||(this.Ga=!0,this.cb())});cc(k,"timeout",function(){n&&clearTimeout(n);this.Ga||(this.Ga=!0,this.cb());b&&b(null)});k.send(a,c,d,e)};
	var Ed="__fcb"+Math.floor(1E6*Math.random()).toString(),Bg=function(a,b){((window.gapi||{}).client||{}).request?a():(l[Ed]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))},Gd(function(){b(Error("CORS_UNSUPPORTED"))}))};
	S.prototype.Df=function(a,b,c,d,e){var f=this;Ag.then(function(){window.gapi.client.setApiKey(f.j);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).f(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
	var Eg=function(a,b){return new A(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Cg(a,a.Bf+"?key="+encodeURIComponent(a.j),function(a){a?a.error?d(Dg(a)):a.access_token&&a.refresh_token?c(a):d(new O("internal-error")):d(new O("network-request-failed"))},"POST",Ue(b).toString(),a.ge,a.Cf.get()):d(new O("internal-error"))})},Fg=function(a,b,c,d,e,f){var g=Pe(a.Le+b);J(g,"key",a.j);f&&J(g,"cb",la().toString());var k="GET"==c;if(k)for(var n in d)d.hasOwnProperty(n)&&
	J(g,n,d[n]);return new A(function(b,f){Cg(a,g.toString(),function(a){a?a.error?f(Dg(a,e||{})):b(a):f(new O("network-request-failed"))},c,k?void 0:xc(sf(d)),a.Pd,a.Me.get())})},Gg=function(a){if(!ic.test(a.email))throw new O("invalid-email");},Hg=function(a){"email"in a&&Gg(a)},Jg=function(a,b){return R(a,Ig,{identifier:b,continueUri:nf()?We():"http://localhost"}).then(function(a){return a.allProviders||[]})},Lg=function(a){return R(a,Kg,{}).then(function(a){return a.authorizedDomains||[]})},Mg=function(a){if(!a.idToken)throw new O("internal-error");
	},Ng=function(a){if(a.identifierNumber||a.temporaryProof){if(!a.identifierNumber||!a.temporaryProof)throw new O("internal-error");}else{if(!a.sessionInfo)throw new O("missing-verification-id");if(!a.code)throw new O("missing-verification-code");}};S.prototype.signInAnonymously=function(){return R(this,Og,{})};S.prototype.updateEmail=function(a,b){return R(this,Pg,{idToken:a,email:b})};S.prototype.updatePassword=function(a,b){return R(this,jg,{idToken:a,password:b})};var Qg={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};
	S.prototype.updateProfile=function(a,b){var c={idToken:a},d=[];Sa(Qg,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return R(this,Pg,c)};S.prototype.sendPasswordResetEmail=function(a){return R(this,Rg,{requestType:"PASSWORD_RESET",email:a})};S.prototype.sendEmailVerification=function(a){return R(this,Sg,{requestType:"VERIFY_EMAIL",idToken:a})};S.prototype.se=function(a){return R(this,Tg,a)};
	var Vg=function(a,b,c){return R(a,Ug,{idToken:b,deleteProvider:c})},Wg=function(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new O("internal-error");},Xg=function(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=ug(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=ug(a)):"EMAIL_EXISTS"==a.errorMessage&&(a.code="email-already-in-use",b=ug(a));if(b)throw b;if(!a.idToken)throw new O("internal-error");},Vf=function(a,
	b){b.returnIdpCredential=!0;return R(a,Yg,b)},Xf=function(a,b){b.returnIdpCredential=!0;return R(a,Zg,b)},Yf=function(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return R(a,$g,b)},ah=function(a){if(!a.oobCode)throw new O("invalid-action-code");};S.prototype.confirmPasswordReset=function(a,b){return R(this,bh,{oobCode:a,newPassword:b})};S.prototype.checkActionCode=function(a){return R(this,ch,{oobCode:a})};S.prototype.applyActionCode=function(a){return R(this,dh,{oobCode:a})};
	var dh={endpoint:"setAccountInfo",A:ah,Wa:"email"},ch={endpoint:"resetPassword",A:ah,Y:function(a){if(!a.email||!a.requestType)throw new O("internal-error");}},eh={endpoint:"signupNewUser",A:function(a){Gg(a);if(!a.password)throw new O("weak-password");},Y:Mg,sa:!0},Ig={endpoint:"createAuthUri"},fh={endpoint:"deleteAccount",Ua:["idToken"]},Ug={endpoint:"setAccountInfo",Ua:["idToken","deleteProvider"],A:function(a){if(!ea(a.deleteProvider))throw new O("internal-error");}},gh={endpoint:"getAccountInfo"},
	Sg={endpoint:"getOobConfirmationCode",Ua:["idToken","requestType"],A:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new O("internal-error");},Wa:"email"},Rg={endpoint:"getOobConfirmationCode",Ua:["requestType"],A:function(a){if("PASSWORD_RESET"!=a.requestType)throw new O("internal-error");Gg(a)},Wa:"email"},Kg={De:!0,endpoint:"getProjectConfig",We:"GET"},bh={endpoint:"resetPassword",A:ah,Wa:"email"},qg={endpoint:"sendVerificationCode",Ua:["identifierNumber","recaptchaToken"],Wa:"sessionInfo"},Pg={endpoint:"setAccountInfo",
	Ua:["idToken"],A:Hg,sa:!0},jg={endpoint:"setAccountInfo",Ua:["idToken"],A:function(a){Hg(a);if(!a.password)throw new O("weak-password");},Y:Mg,sa:!0},Og={endpoint:"signupNewUser",Y:Mg,sa:!0},Yg={endpoint:"verifyAssertion",A:Wg,Y:Xg,sa:!0},$g={endpoint:"verifyAssertion",A:Wg,Y:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new O("user-not-found");if(!a.idToken)throw new O("internal-error");},sa:!0},Zg={endpoint:"verifyAssertion",A:function(a){Wg(a);if(!a.idToken)throw new O("internal-error");
	},Y:Xg,sa:!0},hh={endpoint:"verifyCustomToken",A:function(a){if(!a.token)throw new O("invalid-custom-token");},Y:Mg,sa:!0},ig={endpoint:"verifyPassword",A:function(a){Gg(a);if(!a.password)throw new O("wrong-password");},Y:Mg,sa:!0},Tg={endpoint:"verifyidentifierNumber",A:Ng,Y:Mg},ng={endpoint:"verifyidentifierNumber",A:function(a){if(!a.idToken)throw new O("internal-error");Ng(a)},Y:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",ug(a);Mg(a)}},og={Ge:{USER_NOT_FOUND:"user-not-found"},
	endpoint:"verifyidentifierNumber",A:Ng,Y:Mg},R=function(a,b,c){if(!If(c,b.Ua))return D(new O("internal-error"));var d=b.We||"POST",e;return B(c).then(b.A).then(function(){b.sa&&(c.returnSecureToken=!0);return Fg(a,b.endpoint,d,c,b.Ge,b.De||!1)}).then(function(a){return e=a}).then(b.Y).then(function(){if(!b.Wa)return e;if(!(b.Wa in e))throw new O("internal-error");return e[b.Wa]})},Dg=function(a,b){var c;c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};
	if(c=d[c]?new O(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",
	FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",
	CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_identifier_NUMBER:"invalid-identifier-number",INVALID_SESSION_INFO:"invalid-verification-id",
	INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_identifier_NUMBER:"missing-identifier-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired"};Za(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new O(d[e],b);!b&&a&&(b=rf(a));return new O("internal-error",b)};var ih=function(a){this.V=a};ih.prototype.value=function(){return this.V};ih.prototype.je=function(a){this.V.style=a;return this};var jh=function(a){this.V=a||{}};jh.prototype.value=function(){return this.V};jh.prototype.je=function(a){this.V.style=a;return this};var lh=function(a){this.Lf=a;this.nc=null;this.gd=kh(this)},mh=function(a){var b=new jh;b.V.where=document.body;b.V.url=a.Lf;b.V.messageHandlersFilter=M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER");b.V.attributes=b.V.attributes||{};(new ih(b.V.attributes)).je({position:"absolute",top:"-100px",width:"1px",height:"1px"});b.V.dontclear=!0;return b},kh=function(a){return nh().then(function(){return new A(function(b,c){M("gapi.iframes.getContext")().open(mh(a).value(),function(d){a.nc=d;a.nc.restyle({setHideOnLeave:!1});
	var e=setTimeout(function(){c(Error("Network Error"))},oh.get()),f=function(){clearTimeout(e);b()};d.ping(f).then(f,function(){c(Error("Network Error"))})})})})};lh.prototype.sendMessage=function(a){var b=this;return this.gd.then(function(){return new A(function(c){b.nc.send(a.type,a,c,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})};
	var ph=function(a,b){a.gd.then(function(){a.nc.register("authEvent",b,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})},qh=new xf(3E4,6E4),oh=new xf(5E3,15E3),nh=function(){return new A(function(a,b){if(wf()){var c=function(){vf();M("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){vf();b(Error("Network Error"))},timeout:qh.get()})};if(M("gapi.iframes.Iframe"))a();else if(M("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){M("gapi.load")?
	c():b(Error("Network Error"))};B(Dd("https://apis.google.com/js/api.js?onload="+d)).f(function(){b(Error("Network Error"))})}}else b(Error("Network Error"))})};var rh=function(a,b,c){this.v=a;this.j=b;this.D=c;this.Ya=null;this.ac=Qe(this.v,"/__/auth/iframe");J(this.ac,"apiKey",this.j);J(this.ac,"appName",this.D)};rh.prototype.setVersion=function(a){this.Ya=a;return this};rh.prototype.toString=function(){this.Ya?J(this.ac,"v",this.Ya):this.ac.removeParameter("v");return this.ac.toString()};var sh=function(a,b,c,d,e){this.v=a;this.j=b;this.D=c;this.Be=d;this.Ya=this.J=this.pd=null;this.Pb=e};sh.prototype.setVersion=function(a){this.Ya=a;return this};
	sh.prototype.toString=function(){var a=Qe(this.v,"/__/auth/handler");J(a,"apiKey",this.j);J(a,"appName",this.D);J(a,"authType",this.Be);if(this.Pb.isOAuthProvider){J(a,"providerId",this.Pb.providerId);var b=this.Pb,c=sf(b.Id),d;for(d in c)c[d]=c[d].toString();b=b.vf;c=Xa(c);for(d=0;d<b.length;d++){var e=b[d];e in c&&delete c[e]}Va(c)||J(a,"customParameters",rf(c))}"function"===typeof this.Pb.Rd&&(b=this.Pb.Rd(),b.length&&J(a,"scopes",b.join(",")));this.pd?J(a,"redirectUrl",this.pd):a.removeParameter("redirectUrl");
	this.J?J(a,"eventId",this.J):a.removeParameter("eventId");this.Ya?J(a,"v",this.Ya):a.removeParameter("v");if(this.bc)for(var f in this.bc)this.bc.hasOwnProperty(f)&&!Oe(a,f)&&J(a,f,this.bc[f]);return a.toString()};
	var th=function(a,b,c,d){this.v=a;this.j=b;this.D=c;this.Oe=(this.Ea=d||null)?mf(this.Ea):null;d=this.Ea;this.Xe=(new rh(a,b,c)).setVersion(d).toString();this.ma=[];this.g=new S(b,null,this.Oe);this.pc=this.wa=null},uh=function(a){var b=We();return Lg(a).then(function(a){a:{for(var c=Pe(b),e=c.ha,c=c.ea,f=0;f<a.length;f++){var g;var k=a[f];g=c;var n=e;0==k.indexOf("chrome-extension://")?g=Pe(k).ea==g&&"chrome-extension"==n:"http"!=n&&"https"!=n?g=!1:ef.test(k)?g=g==k:(k=k.split(".").join("\\."),g=
	(new RegExp("^(.+\\."+k+"|"+k+")$","i")).test(g));if(g){a=!0;break a}}a=!1}if(!a)throw new Rf(We());})};h=th.prototype;h.Gb=function(){if(this.pc)return this.pc;var a=this;return this.pc=ff().then(function(){a.mc=new lh(a.Xe);vh(a)})};h.Vb=function(a,b,c){var d=new O("popup-closed-by-user"),e=new O("web-storage-unsupported"),f=this,g=!1;return this.La().then(function(){wh(f).then(function(c){c||(a&&bf(a),b(e),g=!0)})}).f(function(){}).then(function(){if(!g)return df(a)}).then(function(){if(!g)return le(c).then(function(){b(d)})})};
	h.ke=function(){var a=K();return!qf(a)&&!uf(a)};h.Ud=function(){return!1};h.Nb=function(a,b,c,d,e,f,g){if(!a)return D(new O("popup-blocked"));if(g&&!qf())return this.La().f(function(b){bf(a);e(b)}),d(),B();this.wa||(this.wa=uh(this.g));var k=this;return this.wa.then(function(){var b=k.La().f(function(b){bf(a);e(b);throw b;});d();return b}).then(function(){sg(c);if(!g){var d=xh(k.v,k.j,k.D,b,c,null,f,k.Ea);Xe(d,a)}}).f(function(a){"auth/network-request-failed"==a.code&&(k.wa=null);throw a;})};
	h.Ob=function(a,b,c){this.wa||(this.wa=uh(this.g));var d=this;return this.wa.then(function(){sg(b);var e=xh(d.v,d.j,d.D,a,b,We(),c,d.Ea);Xe(e)})};h.La=function(){var a=this;return this.Gb().then(function(){return a.mc.gd}).f(function(){a.wa=null;throw new O("network-request-failed");})};h.ne=function(){return!0};
	var xh=function(a,b,c,d,e,f,g,k,n){a=new sh(a,b,c,d,e);a.pd=f;a.J=g;f=a.setVersion(k);f.bc=Xa(n||null);return f.toString()},vh=function(a){if(!a.mc)throw Error("IfcHandler must be initialized!");ph(a.mc,function(b){var c={};if(b&&b.authEvent){var d=!1;b=Qf(b.authEvent);for(c=0;c<a.ma.length;c++)d=a.ma[c](b)||d;c={};c.status=d?"ACK":"ERROR";return B(c)}c.status="ERROR";return B(c)})},wh=function(a){var b={type:"webStorageSupport"};return a.Gb().then(function(){return a.mc.sendMessage(b)}).then(function(a){if(a&&
	a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})};th.prototype.$a=function(a){this.ma.push(a)};th.prototype.Tb=function(a){La(this.ma,function(b){return b==a})};var yh=function(a){this.B=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.B)throw new O("internal-error","The React Native compatibility library was not found.");};h=yh.prototype;h.get=function(a){return B(this.B.getItem(a)).then(function(a){return a&&tf(a)})};h.set=function(a,b){return B(this.B.setItem(a,rf(b)))};h.remove=function(a){return B(this.B.removeItem(a))};h.ab=function(){};h.Ta=function(){};var zh=function(){this.B={}};h=zh.prototype;h.get=function(a){return B(this.B[a])};h.set=function(a,b){this.B[a]=b;return B()};h.remove=function(a){delete this.B[a];return B()};h.ab=function(){};h.Ta=function(){};var Ch=function(){if(!Bh()){if("Node"==L())throw new O("internal-error","The LocalStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.B=l.localStorage||firebase.INTERNAL.node.localStorage},Bh=function(){var a="Node"==L(),a=l.localStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=Ch.prototype;
	h.get=function(a){var b=this;return B().then(function(){var c=b.B.getItem(a);return tf(c)})};h.set=function(a,b){var c=this;return B().then(function(){var d=rf(b);null===d?c.remove(a):c.B.setItem(a,d)})};h.remove=function(a){var b=this;return B().then(function(){b.B.removeItem(a)})};h.ab=function(a){l.window&&Vb(l.window,"storage",a)};h.Ta=function(a){l.window&&dc(l.window,"storage",a)};var Dh=function(){this.B={}};h=Dh.prototype;h.get=function(){return B(null)};h.set=function(){return B()};h.remove=function(){return B()};h.ab=function(){};h.Ta=function(){};var Fh=function(){if(!Eh()){if("Node"==L())throw new O("internal-error","The SessionStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.B=l.sessionStorage||firebase.INTERNAL.node.sessionStorage},Eh=function(){var a="Node"==L(),a=l.sessionStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=Fh.prototype;
	h.get=function(a){var b=this;return B().then(function(){var c=b.B.getItem(a);return tf(c)})};h.set=function(a,b){var c=this;return B().then(function(){var d=rf(b);null===d?c.remove(a):c.B.setItem(a,d)})};h.remove=function(a){var b=this;return B().then(function(){b.B.removeItem(a)})};h.ab=function(){};h.Ta=function(){};var Gh=function(a,b,c,d,e,f){if(!window.indexedDB)throw new O("web-storage-unsupported");this.He=a;this.fd=b;this.Qc=c;this.re=d;this.wb=e;this.$={};this.Wb=[];this.Jb=0;this.Ye=f||l.indexedDB},Hh,Ih=function(a){return new A(function(b,c){var d=a.Ye.open(a.He,a.wb);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.fd,{keyPath:a.Qc})}catch(f){c(f)}};d.onsuccess=function(a){b(a.target.result)}})},Jh=function(a){a.Xd||(a.Xd=
	Ih(a));return a.Xd},Kh=function(a,b){return b.objectStore(a.fd)},Lh=function(a,b,c){return b.transaction([a.fd],c?"readwrite":"readonly")},Mh=function(a){return new A(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})};h=Gh.prototype;
	h.set=function(a,b){var c=!1,d,e=this;return md(Jh(this).then(function(b){d=b;b=Kh(e,Lh(e,d,!0));return Mh(b.get(a))}).then(function(f){var g=Kh(e,Lh(e,d,!0));if(f)return f.value=b,Mh(g.put(f));e.Jb++;c=!0;f={};f[e.Qc]=a;f[e.re]=b;return Mh(g.add(f))}).then(function(){e.$[a]=b}),function(){c&&e.Jb--})};h.get=function(a){var b=this;return Jh(this).then(function(c){return Mh(Kh(b,Lh(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
	h.remove=function(a){var b=!1,c=this;return md(Jh(this).then(function(d){b=!0;c.Jb++;return Mh(Kh(c,Lh(c,d,!0))["delete"](a))}).then(function(){delete c.$[a]}),function(){b&&c.Jb--})};
	h.Hf=function(){var a=this;return Jh(this).then(function(b){var c=Kh(a,Lh(a,b,!1));return c.getAll?Mh(c.getAll()):new A(function(a,b){var d=[],e=c.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.Jb){for(d=0;d<b.length;d++)c[b[d][a.Qc]]=b[d][a.re];d=Ye(a.$,c);a.$=c}return d})};h.ab=function(a){0==this.Wb.length&&this.vd();this.Wb.push(a)};
	h.Ta=function(a){La(this.Wb,function(b){return b==a});0==this.Wb.length&&this.Bc()};h.vd=function(){var a=this;this.Bc();var b=function(){a.kd=le(800).then(q(a.Hf,a)).then(function(b){0<b.length&&w(a.Wb,function(a){a(b)})}).then(b).f(function(a){"STOP_EVENT"!=a.message&&b()});return a.kd};b()};h.Bc=function(){this.kd&&this.kd.cancel("STOP_EVENT")};var Qh=function(){this.Ld={Browser:Nh,Node:Oh,ReactNative:Ph}[L()]},Rh,Nh={M:Ch,yd:Fh},Oh={M:Ch,yd:Fh},Ph={M:yh,yd:Dh};var Sh=function(a){var b={},c=a.email,d=a.newEmail;a=a.requestType;if(!c||!a)throw Error("Invalid provider user info!");b.fromEmail=d||null;b.email=c;N(this,"operation",a);N(this,"data",Jf(b))};var Th=function(a,b,c,d,e,f){this.pf=a;this.xf=b;this.Qe=c;this.rc=d;this.zd=e;this.yf=!!f;this.kb=null;this.Ma=this.rc;if(this.zd<this.rc)throw Error("Proactive refresh lower bound greater than upper bound!");};Th.prototype.start=function(){this.Ma=this.rc;Uh(this,!0)};
	var Vh=function(a,b){if(b)return a.Ma=a.rc,a.Qe();b=a.Ma;a.Ma*=2;a.Ma>a.zd&&(a.Ma=a.zd);return b},Uh=function(a,b){a.stop();a.kb=le(Vh(a,b)).then(function(){return a.yf?B():zf()}).then(function(){return a.pf()}).then(function(){Uh(a,!0)}).f(function(b){a.xf(b)&&Uh(a,!1)})};Th.prototype.stop=function(){this.kb&&(this.kb.cancel(),this.kb=null)};var ai=function(a){var b={};b["facebook.com"]=Wh;b["google.com"]=Xh;b["github.com"]=Yh;b["twitter.com"]=Zh;var c=a&&a.providerId;return c?b[c]?new b[c](a):new $h(a):null},$h=function(a){var b=tf(a.rawUserInfo||"{}");a=a.providerId;if(!a)throw Error("Invalid additional user info!");N(this,"profile",Jf(b||{}));N(this,"providerId",a)},Wh=function(a){$h.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider id!");};r(Wh,$h);
	var Yh=function(a){$h.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",this.profile&&this.profile.login||null)};r(Yh,$h);var Xh=function(a){$h.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider id!");};r(Xh,$h);var Zh=function(a){$h.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",a.screenName||null)};r(Zh,$h);var bi=function(a,b,c,d){this.kf=a;this.he=b;this.zf=c;this.Ub=d;this.T={};Rh||(Rh=new Qh);a=Rh;try{var e;Ve()?(Hh||(Hh=new Gh("firebaseLocalStorageDb","firebaseLocalStorage","fbase_key","value",1)),e=Hh):e=new a.Ld.M;this.Qa=e}catch(f){this.Qa=new zh,this.Ub=!0}try{this.Dc=new a.Ld.yd}catch(f){this.Dc=new zh}this.wd=q(this.le,this);this.$={}},ci,di=function(){ci||(ci=new bi("firebase",":",!uf(K())&&kf()?!0:!1,qf()));return ci};h=bi.prototype;
	h.R=function(a,b){return this.kf+this.he+a.name+(b?this.he+b:"")};h.get=function(a,b){return(a.M?this.Qa:this.Dc).get(this.R(a,b))};h.remove=function(a,b){b=this.R(a,b);a.M&&!this.Ub&&(this.$[b]=null);return(a.M?this.Qa:this.Dc).remove(b)};h.set=function(a,b,c){var d=this.R(a,c),e=this,f=a.M?this.Qa:this.Dc;return f.set(d,b).then(function(){return f.get(d)}).then(function(b){a.M&&!this.Ub&&(e.$[d]=b)})};
	h.addListener=function(a,b,c){a=this.R(a,b);this.Ub||(this.$[a]=l.localStorage.getItem(a));Va(this.T)&&this.vd();this.T[a]||(this.T[a]=[]);this.T[a].push(c)};h.removeListener=function(a,b,c){a=this.R(a,b);this.T[a]&&(La(this.T[a],function(a){return a==c}),0==this.T[a].length&&delete this.T[a]);Va(this.T)&&this.Bc()};h.vd=function(){this.Qa.ab(this.wd);this.Ub||Ve()||ei(this)};
	var ei=function(a){fi(a);a.dd=setInterval(function(){for(var b in a.T){var c=l.localStorage.getItem(b),d=a.$[b];c!=d&&(a.$[b]=c,c=new Jb({type:"storage",key:b,target:window,oldValue:d,newValue:c,rf:!0}),a.le(c))}},1E3)},fi=function(a){a.dd&&(clearInterval(a.dd),a.dd=null)};bi.prototype.Bc=function(){this.Qa.Ta(this.wd);fi(this)};
	bi.prototype.le=function(a){if(a&&a.Pe){var b=a.eb.key;"undefined"!==typeof a.eb.rf?this.Qa.Ta(this.wd):fi(this);if(this.zf){var c=l.localStorage.getItem(b);a=a.eb.newValue;a!=c&&(a?l.localStorage.setItem(b,a):a||l.localStorage.removeItem(b))}this.$[b]=l.localStorage.getItem(b);this.Ed(b)}else w(a,q(this.Ed,this))};bi.prototype.Ed=function(a){this.T[a]&&w(this.T[a],function(a){a()})};var gi=function(a,b){this.u=a;this.i=b||di()},hi={name:"authEvent",M:!0},ii=function(a){return a.i.get(hi,a.u).then(function(a){return Qf(a)})};gi.prototype.$a=function(a){this.i.addListener(hi,this.u,a)};gi.prototype.Tb=function(a){this.i.removeListener(hi,this.u,a)};var ji=function(a){this.i=a||di()},ki={name:"sessionId",M:!1};ji.prototype.ic=function(a){return this.i.get(ki,a)};var li=function(a,b,c,d,e,f){this.v=a;this.j=b;this.D=c;this.Ea=d||null;this.me=b+":"+c;this.Af=new ji;this.Qd=new gi(this.me);this.Zc=null;this.ma=[];this.bf=e||500;this.tf=f||2E3;this.Fb=this.uc=null},mi=function(a){return new O("invalid-cordova-configuration",a)};
	li.prototype.La=function(){return this.ad?this.ad:this.ad=hf().then(function(){if("function"!==typeof M("universalLinks.subscribe",l))throw mi("cordova-universal-links-plugin is not installed");if("undefined"===typeof M("BuildInfo.packageName",l))throw mi("cordova-plugin-buildinfo is not installed");if("function"!==typeof M("cordova.plugins.browsertab.openUrl",l))throw mi("cordova-plugin-browsertab is not installed");if("function"!==typeof M("cordova.InAppBrowser.open",l))throw mi("cordova-plugin-inappbrowser is not installed");
	},function(){throw new O("cordova-not-ready");})};var ni=function(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")},oi=function(a){var b=new Eb;b.update(a);return Oa(b.digest())};h=li.prototype;h.Vb=function(a,b){b(new O("operation-not-supported-in-this-environment"));return B()};h.Nb=function(){return D(new O("operation-not-supported-in-this-environment"))};h.ne=function(){return!1};h.ke=function(){return!0};
	h.Ud=function(){return!0};
	h.Ob=function(a,b,c){if(this.uc)return D(new O("redirect-operation-pending"));var d=this,e=l.document,f=null,g=null,k=null,n=null;return this.uc=md(B().then(function(){sg(b);return pi(d)}).then(function(){return qi(d,a,b,c)}).then(function(){return(new A(function(a,b){g=function(){var b=M("cordova.plugins.browsertab.close",l);a();"function"===typeof b&&b();d.Fb&&"function"===typeof d.Fb.close&&(d.Fb.close(),d.Fb=null);return!1};d.$a(g);k=function(){f||(f=le(d.tf).then(function(){b(new O("redirect-cancelled-by-user"))}))};n=
	function(){yf()&&k()};e.addEventListener("resume",k,!1);K().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).f(function(a){return ri(d).then(function(){throw a;})})}),function(){k&&e.removeEventListener("resume",k,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.Tb(g);d.uc=null})};
	var qi=function(a,b,c,d){var e=ni(),f=new P(b,d,null,e,new O("no-auth-event")),g=M("BuildInfo.packageName",l);if("string"!==typeof g)throw new O("invalid-cordova-configuration");var k=M("BuildInfo.displayName",l),n={};if(K().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(K().toLowerCase().match(/android/))n.apn=g;else return D(new O("operation-not-supported-in-this-environment"));k&&(n.appDisplayName=k);e=oi(e);n.sessionId=e;var C=xh(a.v,a.j,a.D,b,c,null,d,a.Ea,n);return a.La().then(function(){var b=
	a.me;return a.Af.i.set(hi,f.C(),b)}).then(function(){var b=M("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof b)throw new O("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=M("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof c)throw new O("invalid-cordova-configuration");c(C)}else{c=M("cordova.InAppBrowser.open",l);if("function"!==typeof c)throw new O("invalid-cordova-configuration");b=c;var d;d=K();d=!(!d.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!d.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
	a.Fb=b(C,d?"_blank":"_system","location=yes")}})})},si=function(a,b){for(var c=0;c<a.ma.length;c++)try{a.ma[c](b)}catch(d){}},pi=function(a){a.Zc||(a.Zc=a.La().then(function(){return new A(function(b){var c=function(d){b(d);a.Tb(c);return!1};a.$a(c);ti(a)})}));return a.Zc},ri=function(a){var b=null;return ii(a.Qd).then(function(c){b=c;c=a.Qd;return c.i.remove(hi,c.u)}).then(function(){return b})},ti=function(a){var b=M("universalLinks.subscribe",l);if("function"!==typeof b)throw new O("invalid-cordova-configuration");
	var c=new P("unknown",null,null,null,new O("no-auth-event")),d=!1,e=le(a.bf).then(function(){return ri(a).then(function(){d||si(a,c)})}),f=function(b){d=!0;e&&e.cancel();ri(a).then(function(d){var e=c;if(d&&b&&b.url){var e=null,f;f=b.url;var g=Pe(f),k=Oe(g,"link"),n=Oe(Pe(k),"link"),g=Oe(g,"deep_link_id");f=Oe(Pe(g),"link")||g||n||k||f;-1!=f.indexOf("/__/auth/callback")&&(e=Pe(f),e=tf(Oe(e,"firebaseError")||null),e=(e="object"===typeof e?Pf(e):null)?new P(d.da,d.J,null,null,e):new P(d.da,d.J,f,d.ic()));
	e=e||c}si(a,e)})},g=l.handleOpenURL;l.handleOpenURL=function(a){0==a.indexOf(M("BuildInfo.packageName",l)+"://")&&f({url:a});if("function"===typeof g)try{g(a)}catch(n){console.error(n)}};b(null,f)};li.prototype.$a=function(a){this.ma.push(a);pi(this).f(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new P("unknown",null,null,null,new O("no-auth-event")),a(b))})};li.prototype.Tb=function(a){La(this.ma,function(b){return b==a})};var ui=function(a){this.u=a;this.i=di()},vi={name:"pendingRedirect",M:!1},wi=function(a){return a.i.set(vi,"pending",a.u)},xi=function(a){return a.i.remove(vi,a.u)},yi=function(a){return a.i.get(vi,a.u).then(function(a){return"pending"==a})};var T=function(a,b,c){this.v=a;this.j=b;this.D=c;this.Xb=[];this.ib=!1;this.Mc=q(this.Wc,this);this.Ra=new zi(this);this.ld=new Ai(this);this.Kb=new ui(this.j+":"+this.D);this.Aa={};this.Aa.unknown=this.Ra;this.Aa.signInViaRedirect=this.Ra;this.Aa.linkViaRedirect=this.Ra;this.Aa.reauthViaRedirect=this.Ra;this.Aa.signInViaPopup=this.ld;this.Aa.linkViaPopup=this.ld;this.Aa.reauthViaPopup=this.ld;this.K=Bi(this.v,this.j,this.D)},Bi=function(a,b,c){var d=firebase.SDK_VERSION||null;return gf()?new li(a,
	b,c,d):new th(a,b,c,d)};T.prototype.reset=function(){this.ib=!1;this.K.Tb(this.Mc);this.K=Bi(this.v,this.j,this.D)};T.prototype.Gb=function(){var a=this;this.ib||(this.ib=!0,this.K.$a(this.Mc));var b=this.K;return this.K.La().f(function(c){a.K==b&&a.reset();throw c;})};var Ei=function(a){a.K.ke()&&a.Gb().f(function(b){var c=new P("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));Ci(b)&&a.Wc(c)});a.K.Ud()||Di(a.Ra)};
	T.prototype.subscribe=function(a){Ia(this.Xb,a)||this.Xb.push(a);if(!this.ib){var b=this;yi(this.Kb).then(function(a){a?xi(b.Kb).then(function(){b.Gb().f(function(a){var c=new P("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));Ci(a)&&b.Wc(c)})}):Ei(b)}).f(function(){Ei(b)})}};T.prototype.unsubscribe=function(a){La(this.Xb,function(b){return b==a})};
	T.prototype.Wc=function(a){if(!a)throw new O("invalid-auth-event");for(var b=!1,c=0;c<this.Xb.length;c++){var d=this.Xb[c];if(d.Fd(a.da,a.J)){(b=this.Aa[a.da])&&b.ce(a,d);b=!0;break}}Di(this.Ra);return b};var Fi=new xf(2E3,1E4),Gi=new xf(3E4,6E4);T.prototype.getRedirectResult=function(){return this.Ra.getRedirectResult()};T.prototype.Nb=function(a,b,c,d,e){var f=this;return this.K.Nb(a,b,c,function(){f.ib||(f.ib=!0,f.K.$a(f.Mc))},function(){f.reset()},d,e)};
	var Ci=function(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1};T.prototype.Ob=function(a,b,c){var d=this,e;return wi(this.Kb).then(function(){return d.K.Ob(a,b,c).f(function(a){if(Ci(a))throw new O("operation-not-supported-in-this-environment");e=a;return xi(d.Kb).then(function(){throw e;})}).then(function(){return d.K.ne()?new A(function(){}):xi(d.Kb).then(function(){return d.getRedirectResult()}).then(function(){}).f(function(){})})})};
	T.prototype.Vb=function(a,b,c,d){return this.K.Vb(c,function(c){a.Va(b,null,c,d)},Fi.get())};var Hi={},Ii=function(a,b,c){var d=b+":"+c;Hi[d]||(Hi[d]=new T(a,b,c));return Hi[d]},zi=function(a){this.i=a;this.qb=null;this.Rb=[];this.Qb=[];this.ob=null;this.od=!1};zi.prototype.reset=function(){this.qb=null;this.ob&&(this.ob.cancel(),this.ob=null)};
	zi.prototype.ce=function(a,b){if(!a)return D(new O("invalid-auth-event"));this.reset();this.od=!0;var c=a.da,d=a.J,e=a.getError()&&"auth/web-storage-unsupported"==a.getError().code,f=a.getError()&&"auth/operation-not-supported-in-this-environment"==a.getError().code;"unknown"!=c||e||f?a=a.P?this.md(a,b):b.zb(c,d)?this.nd(a,b):D(new O("invalid-auth-event")):(Ji(this,!1,null,null),a=B());return a};var Di=function(a){a.od||(a.od=!0,Ji(a,!1,null,null))};
	zi.prototype.md=function(a){Ji(this,!0,null,a.getError());return B()};zi.prototype.nd=function(a,b){var c=this;b=b.zb(a.da,a.J);var d=a.tb,e=a.ic(),f=!!a.da.match(/Redirect$/);return b(d,e).then(function(a){Ji(c,f,a,null)}).f(function(a){Ji(c,f,null,a)})};
	var Ki=function(a,b){a.qb=function(){return D(b)};if(a.Qb.length)for(var c=0;c<a.Qb.length;c++)a.Qb[c](b)},Li=function(a,b){a.qb=function(){return B(b)};if(a.Rb.length)for(var c=0;c<a.Rb.length;c++)a.Rb[c](b)},Ji=function(a,b,c,d){b?d?Ki(a,d):Li(a,c):Li(a,{user:null});a.Rb=[];a.Qb=[]};zi.prototype.getRedirectResult=function(){var a=this;return new A(function(b,c){a.qb?a.qb().then(b,c):(a.Rb.push(b),a.Qb.push(c),Mi(a))})};
	var Mi=function(a){var b=new O("timeout");a.ob&&a.ob.cancel();a.ob=le(Gi.get()).then(function(){a.qb||Ji(a,!0,null,b)})},Ai=function(a){this.i=a};Ai.prototype.ce=function(a,b){if(!a)return D(new O("invalid-auth-event"));var c=a.da,d=a.J;return a.P?this.md(a,b):b.zb(c,d)?this.nd(a,b):D(new O("invalid-auth-event"))};Ai.prototype.md=function(a,b){b.Va(a.da,null,a.getError(),a.J);return B()};
	Ai.prototype.nd=function(a,b){var c=a.J,d=a.da,e=b.zb(d,c),f=a.tb;a=a.ic();return e(f,a).then(function(a){b.Va(d,a,null,c)}).f(function(a){b.Va(d,null,a,c)})};var Ni=function(a){this.g=a;this.Ba=this.X=null;this.Ha=0};Ni.prototype.C=function(){return{apiKey:this.g.j,refreshToken:this.X,accessToken:this.Ba,expirationTime:this.Ha}};
	var Pi=function(a,b){var c=b.idToken,d=b.refreshToken;b=Oi(b.expiresIn);a.Ba=c;a.Ha=b;a.X=d},Oi=function(a){return la()+1E3*parseInt(a,10)},Qi=function(a,b){return Eg(a.g,b).then(function(b){a.Ba=b.access_token;a.Ha=Oi(b.expires_in);a.X=b.refresh_token;return{accessToken:a.Ba,expirationTime:a.Ha,refreshToken:a.X}}).f(function(b){"auth/user-token-expired"==b.code&&(a.X=null);throw b;})};
	Ni.prototype.getToken=function(a){a=!!a;return this.Ba&&!this.X?D(new O("user-token-expired")):a||!this.Ba||la()>this.Ha-3E4?this.X?Qi(this,{grant_type:"refresh_token",refresh_token:this.X}):B(null):B({accessToken:this.Ba,expirationTime:this.Ha,refreshToken:this.X})};var Ri=function(a,b,c,d,e){Ff(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,providerId:b})},Si=function(a,b){Ib.call(this,a);for(var c in b)this[c]=b[c]};r(Si,Ib);
	var U=function(a,b,c){this.ba=[];this.j=a.apiKey;this.D=a.appName;this.v=a.authDomain||null;a=firebase.SDK_VERSION?mf(firebase.SDK_VERSION):null;this.g=new S(this.j,null,a);this.ia=new Ni(this.g);Ti(this,b.idToken);Pi(this.ia,b);N(this,"refreshToken",this.ia.X);Ui(this,c||{});he.call(this);this.vc=!1;this.v&&pf()&&(this.m=Ii(this.v,this.j,this.D));this.Ac=[];this.ka=null;this.mb=Vi(this);this.vb=q(this.Xc,this)};r(U,he);U.prototype.Xc=function(){this.mb.kb&&(this.mb.stop(),this.mb.start())};
	var Vi=function(a){return new Th(function(){return a.getToken(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.ia.Ha-la()-3E5;return 0<b?b:0},3E4,96E4,!1)},Wi=function(a){a.Kd||a.mb.kb||(a.mb.start(),dc(a,"tokenChanged",a.vb),Vb(a,"tokenChanged",a.vb))},Xi=function(a){dc(a,"tokenChanged",a.vb);a.mb.stop()},Ti=function(a,b){a.Yd=b;N(a,"_lat",b)},Yi=function(a,b){La(a.Ac,function(a){return a==b})},Zi=function(a){for(var b=[],c=0;c<a.Ac.length;c++)b.push(a.Ac[c](a));
	return jd(b).then(function(){return a})},$i=function(a){a.m&&!a.vc&&(a.vc=!0,a.m.subscribe(a))},Ui=function(a,b){Ff(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,identifierNumber:b.identifierNumber||null,isAnonymous:b.isAnonymous||!1,providerData:[]})};N(U.prototype,"providerId","firebase");
	var aj=function(){},bj=function(a){return B().then(function(){if(a.Kd)throw new O("app-deleted");})},cj=function(a){return Ea(a.providerData,function(a){return a.providerId})},ej=function(a,b){b&&(dj(a,b.providerId),a.providerData.push(b))},dj=function(a,b){La(a.providerData,function(a){return a.providerId==b})},fj=function(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&N(a,b,c)};
	U.prototype.copy=function(a){var b=this;b!=a&&(Ff(this,{uid:a.uid,displayName:a.displayName,photoURL:a.photoURL,email:a.email,emailVerified:a.emailVerified,identifierNumber:a.identifierNumber,isAnonymous:a.isAnonymous,providerData:[]}),w(a.providerData,function(a){ej(b,a)}),this.ia=a.ia,N(this,"refreshToken",this.ia.X))};U.prototype.reload=function(){var a=this;return this.c(bj(this).then(function(){return gj(a).then(function(){return Zi(a)}).then(aj)}))};
	var gj=function(a){return a.getToken().then(function(b){var c=a.isAnonymous;return hj(a,b).then(function(){c||fj(a,"isAnonymous",!1);return b})})};U.prototype.getToken=function(a){var b=this;return this.c(bj(this).then(function(){return b.ia.getToken(a)}).then(function(a){if(!a)throw new O("internal-error");a.accessToken!=b.Yd&&(Ti(b,a.accessToken),b.Na());fj(b,"refreshToken",a.refreshToken);return a.accessToken}))};
	var ij=function(a,b){b.idToken&&a.Yd!=b.idToken&&(Pi(a.ia,b),a.Na(),Ti(a,b.idToken),fj(a,"refreshToken",a.ia.X))};U.prototype.Na=function(){this.dispatchEvent(new Si("tokenChanged"))};var hj=function(a,b){return R(a.g,gh,{idToken:b}).then(q(a.qf,a))};
	U.prototype.qf=function(a){a=a.users;if(!a||!a.length)throw new O("internal-error");a=a[0];Ui(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,identifierNumber:a.identifierNumber});for(var b=jj(a),c=0;c<b.length;c++)ej(this,b[c]);fj(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
	var jj=function(a){return(a=a.providerUserInfo)&&a.length?Ea(a,function(a){return new Ri(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl)}):[]},lj=function(a,b){var c=null;return a.c(b.ed(a.g,a.uid).then(function(b){ij(a,b);c=kj(a,b,"reauthenticate");a.ka=null;return a.reload()}).then(function(){return c}),!0)};U.prototype.reauthenticate=function(a){Bf("firebase.User.prototype.reauthenticate is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.reauthenticateWithCredential(a)};
	U.prototype.reauthenticateWithCredential=function(a){return lj(this,a).then(function(){})};var mj=function(a,b){return gj(a).then(function(){if(Ia(cj(a),b))return Zi(a).then(function(){throw new O("provider-already-linked");})})},oj=function(a,b){var c=null;return a.c(mj(a,b.providerId).then(function(){return a.getToken()}).then(function(c){return b.cd(a.g,c)}).then(function(b){c=kj(a,b,"link");return nj(a,b)}).then(function(){return c}))};
	U.prototype.link=function(a){Bf("firebase.User.prototype.link is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.linkWithCredential(a)};U.prototype.linkWithCredential=function(a){return oj(this,a).then(function(a){return a.user})};var kj=function(a,b,c){var d=rg(b);b=ai(b);return Gf({user:a,credential:d,additionalUserInfo:b,operationType:c})},nj=function(a,b){ij(a,b);return a.reload().then(function(){return a})};h=U.prototype;
	h.updateEmail=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.g.updateEmail(c,a)}).then(function(a){ij(b,a);return b.reload()}))};h.updatePassword=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.g.updatePassword(c,a)}).then(function(a){ij(b,a);return b.reload()}))};
	h.updateProfile=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return bj(this);var b=this;return this.c(this.getToken().then(function(c){return b.g.updateProfile(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){ij(b,a);fj(b,"displayName",a.displayName||null);fj(b,"photoURL",a.photoUrl||null);return Zi(b)}).then(aj))};
	h.unlink=function(a){var b=this;return this.c(gj(this).then(function(c){return Ia(cj(b),a)?Vg(b.g,c,[a]).then(function(a){var c={};w(a.providerUserInfo||[],function(a){c[a.providerId]=!0});w(cj(b),function(a){c[a]||dj(b,a)});return Zi(b)}):Zi(b).then(function(){throw new O("no-such-provider");})}))};
	h["delete"]=function(){var a=this;return this.c(this.getToken().then(function(b){return R(a.g,fh,{idToken:b})}).then(function(){a.dispatchEvent(new Si("userDeleted"))})).then(function(){for(var b=0;b<a.ba.length;b++)a.ba[b].cancel("app-deleted");a.ba=[];a.Kd=!0;Xi(a);N(a,"refreshToken",null);a.m&&a.m.unsubscribe(a)})};
	h.Fd=function(a,b){return"linkViaPopup"==a&&(this.ca||null)==b&&this.aa||"reauthViaPopup"==a&&(this.ca||null)==b&&this.aa||"linkViaRedirect"==a&&(this.za||null)==b||"reauthViaRedirect"==a&&(this.za||null)==b?!0:!1};h.Va=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.ca||null)||(c&&this.Pa?this.Pa(c):b&&!c&&this.aa&&this.aa(b),this.F&&(this.F.cancel(),this.F=null),delete this.aa,delete this.Pa)};
	h.zb=function(a,b){return"linkViaPopup"==a&&b==(this.ca||null)?q(this.Nd,this):"reauthViaPopup"==a&&b==(this.ca||null)?q(this.Od,this):"linkViaRedirect"==a&&(this.za||null)==b?q(this.Nd,this):"reauthViaRedirect"==a&&(this.za||null)==b?q(this.Od,this):null};h.hc=function(){return of(this.uid+":::")};var qj=function(a,b){return pj(a,"linkViaPopup",b,function(){return mj(a,b.providerId).then(function(){return Zi(a)})},!1)};
	U.prototype.linkWithPopup=function(a){return qj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};var rj=function(a,b){return pj(a,"reauthViaPopup",b,function(){return B()},!0)};U.prototype.reauthenticateWithPopup=function(a){return rj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};
	var pj=function(a,b,c,d,e){if(!pf())return D(new O("operation-not-supported-in-this-environment"));if(a.ka&&!e)return D(a.ka);var f=Nf(c.providerId),g=a.hc(),k=null;(!qf()||kf())&&a.v&&c.isOAuthProvider&&(k=xh(a.v,a.j,a.D,b,c,null,g,firebase.SDK_VERSION||null));var n=cf(k,f&&f.Mb,f&&f.Lb);d=d().then(function(){sj(a);if(!e)return a.getToken().then(function(){})}).then(function(){return a.m.Nb(n,b,c,g,!!k)}).then(function(){return new A(function(c,d){a.Va(b,null,new O("cancelled-popup-request"),a.ca||
	null);a.aa=c;a.Pa=d;a.ca=g;a.F=a.m.Vb(a,b,n,g)})}).then(function(a){n&&bf(n);return a}).f(function(a){n&&bf(n);throw a;});return a.c(d,e)};U.prototype.linkWithRedirect=function(a){var b=this;return tj(this,"linkViaRedirect",a,function(){return mj(b,a.providerId)},!1)};U.prototype.reauthenticateWithRedirect=function(a){return tj(this,"reauthViaRedirect",a,function(){return B()},!0)};
	var tj=function(a,b,c,d,e){if(!pf())return D(new O("operation-not-supported-in-this-environment"));if(a.ka&&!e)return D(a.ka);var f=null,g=a.hc();d=d().then(function(){sj(a);if(!e)return a.getToken().then(function(){})}).then(function(){a.za=g;return Zi(a)}).then(function(b){a.Sa&&(b=a.Sa,b=b.i.set(uj,a.C(),b.u));return b}).then(function(){return a.m.Ob(b,c,g)}).f(function(b){f=b;if(a.Sa)return vj(a.Sa);throw f;}).then(function(){if(f)throw f;});return a.c(d,e)},sj=function(a){if(!a.m||!a.vc){if(a.m&&
	!a.vc)throw new O("internal-error");throw new O("auth-domain-config-required");}};U.prototype.Nd=function(a,b){var c=this;this.F&&(this.F.cancel(),this.F=null);var d=null,e=this.getToken().then(function(d){return Xf(c.g,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=kj(c,a,"link");return nj(c,a)}).then(function(){return d});return this.c(e)};
	U.prototype.Od=function(a,b){var c=this;this.F&&(this.F.cancel(),this.F=null);var d=null,e=B().then(function(){return Tf(Yf(c.g,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=kj(c,a,"reauthenticate");ij(c,a);c.ka=null;return c.reload()}).then(function(){return d});return this.c(e,!0)};U.prototype.sendEmailVerification=function(){var a=this;return this.c(this.getToken().then(function(b){return a.g.sendEmailVerification(b)}).then(function(b){if(a.email!=b)return a.reload()}).then(function(){}))};
	U.prototype.c=function(a,b){var c=this,d=wj(this,a,b);this.ba.push(d);md(d,function(){Ka(c.ba,d)});return d};var wj=function(a,b,c){return a.ka&&!c?(b.cancel(),D(a.ka)):b.f(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.ka||a.dispatchEvent(new Si("userInvalidated")),a.ka=b);throw b;})};U.prototype.toJSON=function(){return this.C()};
	U.prototype.C=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,identifierNumber:this.identifierNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.j,appName:this.D,authDomain:this.v,stsTokenManager:this.ia.C(),redirectEventId:this.za||null};w(this.providerData,function(b){a.providerData.push(Hf(b))});return a};
	var xj=function(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c.idToken=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-la())/1E3;else return null;var d=new U(b,c,a);a.providerData&&w(a.providerData,function(a){a&&ej(d,Gf(a))});a.redirectEventId&&(d.za=a.redirectEventId);return d},
	yj=function(a,b,c){var d=new U(a,b);c&&(d.Sa=c);return d.reload().then(function(){return d})};var zj=function(a){this.u=a;this.i=di()},uj={name:"redirectUser",M:!1},vj=function(a){return a.i.remove(uj,a.u)},Aj=function(a,b){return a.i.get(uj,a.u).then(function(a){a&&b&&(a.authDomain=b);return xj(a||{})})};var Bj=function(a){this.u=a;this.i=di()},Cj={name:"authUser",M:!0},Dj=function(a,b){return a.i.set(Cj,b.C(),a.u)},Ej=function(a){return a.i.remove(Cj,a.u)},Fj=function(a,b){return a.i.get(Cj,a.u).then(function(a){a&&b&&(a.authDomain=b);return xj(a||{})})};var W=function(a){this.Fa=!1;N(this,"app",a);if(V(this).options&&V(this).options.apiKey)a=firebase.SDK_VERSION?mf(firebase.SDK_VERSION):null,this.g=new S(V(this).options&&V(this).options.apiKey,null,a);else throw new O("invalid-api-key");this.ba=[];this.Ca=[];this.ub=[];this.mf=firebase.INTERNAL.createSubscribe(q(this.Ze,this));this.Ic=void 0;firebase.INTERNAL.createSubscribe(q(this.af,this));Gj(this,null);this.ta=new Bj(V(this).options.apiKey+":"+V(this).name);this.pb=new zj(V(this).options.apiKey+
	":"+V(this).name);this.cc=this.c(Hj(this));this.qa=this.c(Ij(this));this.bd=!1;this.Vc=q(this.Gf,this);this.qe=q(this.gb,this);this.vb=q(this.Xc,this);this.oe=q(this.Ue,this);this.pe=q(this.Ve,this);Jj(this);this.INTERNAL={};this.INTERNAL["delete"]=q(this["delete"],this);this.Ia=0};W.prototype.toJSON=function(){return{apiKey:V(this).options.apiKey,authDomain:V(this).options.authDomain,appName:V(this).name,currentUser:X(this)&&X(this).C()}};
	var Kj=function(a){return a.Ie||D(new O("auth-domain-config-required"))},Jj=function(a){var b=V(a).options.authDomain,c=V(a).options.apiKey;b&&pf()&&(a.Ie=a.cc.then(function(){if(!a.Fa)return a.m=Ii(b,c,V(a).name),a.m.subscribe(a),X(a)&&$i(X(a)),a.Sb&&($i(a.Sb),a.Sb=null),a.m}))};h=W.prototype;h.Fd=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.ca==b&&!!this.aa;default:return!1}};
	h.Va=function(a,b,c,d){"signInViaPopup"==a&&this.ca==d&&(c&&this.Pa?this.Pa(c):b&&!c&&this.aa&&this.aa(b),this.F&&(this.F.cancel(),this.F=null),delete this.aa,delete this.Pa)};h.zb=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.ca==b&&this.aa?q(this.Ke,this):null};
	h.Ke=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.F&&(this.F.cancel(),this.F=null);var d=null,e=null,f=Vf(c.g,a).then(function(a){d=rg(a);e=ai(a);return a});a=c.cc.then(function(){return f}).then(function(a){return Lj(c,a)}).then(function(){return Gf({user:X(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return this.c(a)};h.hc=function(){return of()};
	var Mj=function(a,b){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var c=Nf(b.providerId),d=a.hc(),e=null;(!qf()||kf())&&V(a).options.authDomain&&b.isOAuthProvider&&(e=xh(V(a).options.authDomain,V(a).options.apiKey,V(a).name,"signInViaPopup",b,null,d,firebase.SDK_VERSION||null));var f=cf(e,c&&c.Mb,c&&c.Lb),c=Kj(a).then(function(a){return a.Nb(f,"signInViaPopup",b,d,!!e)}).then(function(){return new A(function(b,c){a.Va("signInViaPopup",null,new O("cancelled-popup-request"),
	a.ca);a.aa=b;a.Pa=c;a.ca=d;a.F=a.m.Vb(a,"signInViaPopup",f,d)})}).then(function(a){f&&bf(f);return a}).f(function(a){f&&bf(f);throw a;});return a.c(c)};W.prototype.signInWithPopup=function(a){return Mj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};W.prototype.getRedirectResult=function(){return Nj(this).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};
	W.prototype.signInWithRedirect=function(a){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var b=this,c=Kj(this).then(function(){return b.m.Ob("signInViaRedirect",a)});return this.c(c)};
	var Nj=function(a){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var b=Kj(a).then(function(){return a.m.getRedirectResult()});return a.c(b)},Lj=function(a,b){var c={};c.apiKey=V(a).options.apiKey;c.authDomain=V(a).options.authDomain;c.appName=V(a).name;return a.cc.then(function(){return yj(c,b,a.pb)}).then(function(b){if(X(a)&&b.uid==X(a).uid)return X(a).copy(b),a.gb(b);Gj(a,b);$i(b);return a.gb(b)}).then(function(){a.Na()})},Gj=function(a,b){X(a)&&(Yi(X(a),a.qe),dc(X(a),
	"tokenChanged",a.vb),dc(X(a),"userDeleted",a.oe),dc(X(a),"userInvalidated",a.pe),Xi(X(a)));b&&(b.Ac.push(a.qe),Vb(b,"tokenChanged",a.vb),Vb(b,"userDeleted",a.oe),Vb(b,"userInvalidated",a.pe),0<a.Ia&&Wi(b));N(a,"currentUser",b)};W.prototype.signOut=function(){var a=this,b=this.qa.then(function(){if(!X(a))return B();Gj(a,null);return Ej(a.ta).then(function(){a.Na()})});return this.c(b)};
	var Oj=function(a){var b=Aj(a.pb,V(a).options.authDomain).then(function(b){if(a.Sb=b)b.Sa=a.pb;return vj(a.pb)});return a.c(b)},Hj=function(a){var b=V(a).options.authDomain,c=Oj(a).then(function(){return Fj(a.ta,b)}).then(function(b){return b?(b.Sa=a.pb,a.Sb&&(a.Sb.za||null)==(b.za||null)?b:b.reload().then(function(){return Dj(a.ta,b).then(function(){return b})}).f(function(c){return"auth/network-request-failed"==c.code?b:Ej(a.ta)})):null}).then(function(b){Gj(a,b||null)});return a.c(c)},Ij=function(a){return a.cc.then(function(){return a.getRedirectResult()}).f(function(){}).then(function(){if(!a.Fa)return a.Vc()}).f(function(){}).then(function(){if(!a.Fa){a.bd=
	!0;var b=a.ta;b.i.addListener(Cj,b.u,a.Vc)}})};h=W.prototype;h.Gf=function(){var a=this;return Fj(this.ta,V(this).options.authDomain).then(function(b){if(!a.Fa){var c;if(c=X(a)&&b){c=X(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return X(a).copy(b),X(a).getToken();if(X(a)||b)Gj(a,b),b&&($i(b),b.Sa=a.pb),a.m&&a.m.subscribe(a),a.Na()}})};h.gb=function(a){return Dj(this.ta,a)};h.Xc=function(){this.Na();this.gb(X(this))};h.Ue=function(){this.signOut()};
	h.Ve=function(){this.signOut()};var Pj=function(a,b){var c=null,d=null;return a.c(b.then(function(b){c=rg(b);d=ai(b);return Lj(a,b)}).then(function(){return Gf({user:X(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))};h=W.prototype;h.Ze=function(a){var b=this;this.addAuthTokenListener(function(){a.next(X(b))})};h.af=function(a){var b=this;Qj(this,function(){a.next(X(b))})};
	h.onAuthStateChanged=function(a,b,c){var d=this;this.bd&&firebase.Promise.resolve().then(function(){p(a)?a(X(d)):p(a.next)&&a.next(X(d))});return this.mf(a,b,c)};h.getToken=function(a){var b=this,c=this.qa.then(function(){return X(b)?X(b).getToken(a).then(function(a){return{accessToken:a}}):null});return this.c(c)};h.signInWithCustomToken=function(a){var b=this;return this.qa.then(function(){return Pj(b,R(b.g,hh,{token:a}))}).then(function(a){a=a.user;fj(a,"isAnonymous",!1);return b.gb(a)}).then(function(){return X(b)})};
	h.signInWithEmailAndPassword=function(a,b){var c=this;return this.qa.then(function(){return Pj(c,R(c.g,ig,{email:a,password:b}))}).then(function(a){return a.user})};h.createUserWithEmailAndPassword=function(a,b){var c=this;return this.qa.then(function(){return Pj(c,R(c.g,eh,{email:a,password:b}))}).then(function(a){return a.user})};h.signInWithCredential=function(a){return Rj(this,a).then(function(a){return a.user})};var Rj=function(a,b){return a.qa.then(function(){return Pj(a,b.Ab(a.g))})};
	W.prototype.signInAnonymously=function(){var a=X(this),b=this;return a&&a.isAnonymous?B(a):this.qa.then(function(){return Pj(b,b.g.signInAnonymously())}).then(function(a){a=a.user;fj(a,"isAnonymous",!0);return b.gb(a)}).then(function(){return X(b)})};var V=function(a){return a.app},X=function(a){return a.currentUser};W.prototype.getUid=function(){return X(this)&&X(this).uid||null};var Sj=function(a){return X(a)&&X(a)._lat||null};h=W.prototype;
	h.Na=function(){if(this.bd){for(var a=0;a<this.Ca.length;a++)if(this.Ca[a])this.Ca[a](Sj(this));if(this.Ic!==this.getUid()&&this.ub.length)for(this.Ic=this.getUid(),a=0;a<this.ub.length;a++)if(this.ub[a])this.ub[a](Sj(this))}};h.Ae=function(a){this.addAuthTokenListener(a);this.Ia++;0<this.Ia&&X(this)&&Wi(X(this))};h.uf=function(a){var b=this;w(this.Ca,function(c){c==a&&b.Ia--});0>this.Ia&&(this.Ia=0);0==this.Ia&&X(this)&&Xi(X(this));this.removeAuthTokenListener(a)};
	h.addAuthTokenListener=function(a){var b=this;this.Ca.push(a);this.c(this.qa.then(function(){b.Fa||Ia(b.Ca,a)&&a(Sj(b))}))};h.removeAuthTokenListener=function(a){La(this.Ca,function(b){return b==a})};var Qj=function(a,b){a.ub.push(b);a.c(a.qa.then(function(){!a.Fa&&Ia(a.ub,b)&&a.Ic!==a.getUid()&&(a.Ic=a.getUid(),b(Sj(a)))}))};h=W.prototype;
	h["delete"]=function(){this.Fa=!0;for(var a=0;a<this.ba.length;a++)this.ba[a].cancel("app-deleted");this.ba=[];this.ta&&(a=this.ta,a.i.removeListener(Cj,a.u,this.Vc));this.m&&this.m.unsubscribe(this);return firebase.Promise.resolve()};h.c=function(a){var b=this;this.ba.push(a);md(a,function(){Ka(b.ba,a)});return a};h.fetchProvidersForEmail=function(a){return this.c(Jg(this.g,a))};h.verifyPasswordResetCode=function(a){return this.checkActionCode(a).then(function(a){return a.data.email})};
	h.confirmPasswordReset=function(a,b){return this.c(this.g.confirmPasswordReset(a,b).then(function(){}))};h.checkActionCode=function(a){return this.c(this.g.checkActionCode(a).then(function(a){return new Sh(a)}))};h.applyActionCode=function(a){return this.c(this.g.applyActionCode(a).then(function(){}))};h.sendPasswordResetEmail=function(a){return this.c(this.g.sendPasswordResetEmail(a).then(function(){}))};var Tj="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" "),Y=function(a,b){return{name:a||"",ja:"a valid string",optional:!!b,la:m}},Z=function(a){return{name:a||"",ja:"a valid object",optional:!1,la:ha}},Uj=function(a,b){return{name:a||"",ja:"a function",optional:!!b,la:p}},Vj=function(){return{name:"",ja:"null",optional:!1,la:da}},Wj=function(){return{name:"credential",ja:"a valid credential",optional:!1,la:function(a){return a?!!a.Ab:!1}}},Xj=function(){return{name:"authProvider",
	ja:"a valid Auth provider",optional:!1,la:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}},Yj=function(a,b,c,d){return{name:c||"",ja:a.ja+" or "+b.ja,optional:!!d,la:function(c){return a.la(c)||b.la(c)}}};var ak=function(a,b){for(var c in b){var d=b[c].name;a[d]=Zj(d,a[c],b[c].a)}},bk=function(a,b,c,d){a[b]=Zj(b,c,d)},Zj=function(a,b,c){if(!c)return b;var d=ck(a);a=function(){var a=Array.prototype.slice.call(arguments),e;a:{e=Array.prototype.slice.call(a);var k;k=0;for(var n=!1,C=0;C<c.length;C++)if(c[C].optional)n=!0;else{if(n)throw new O("internal-error","Argument validator encountered a required argument after an optional argument.");k++}n=c.length;if(e.length<k||n<e.length)e="Expected "+(k==n?
	1==k?"1 argument":k+" arguments":k+"-"+n+" arguments")+" but got "+e.length+".";else{for(k=0;k<e.length;k++)if(n=c[k].optional&&void 0===e[k],!c[k].la(e[k])&&!n){e=c[k];if(0>k||k>=Tj.length)throw new O("internal-error","Argument validator received an unsupported number of arguments.");e=Tj[k]+" argument "+(e.name?'"'+e.name+'" ':"")+"must be "+e.ja+".";break a}e=null}}if(e)throw new O("argument-error",d+" failed: "+e);return b.apply(this,a)};for(var e in b)a[e]=b[e];for(e in b.prototype)a.prototype[e]=
	b.prototype[e];return a},ck=function(a){a=a.split(".");return a[a.length-1]};ak(W.prototype,{applyActionCode:{name:"applyActionCode",a:[Y("code")]},checkActionCode:{name:"checkActionCode",a:[Y("code")]},confirmPasswordReset:{name:"confirmPasswordReset",a:[Y("code"),Y("newPassword")]},createUserWithEmailAndPassword:{name:"createUserWithEmailAndPassword",a:[Y("email"),Y("password")]},fetchProvidersForEmail:{name:"fetchProvidersForEmail",a:[Y("email")]},getRedirectResult:{name:"getRedirectResult",a:[]},onAuthStateChanged:{name:"onAuthStateChanged",a:[Yj(Z(),Uj(),"nextOrObserver"),
	Uj("opt_error",!0),Uj("opt_completed",!0)]},sendPasswordResetEmail:{name:"sendPasswordResetEmail",a:[Y("email")]},signInAnonymously:{name:"signInAnonymously",a:[]},signInWithCredential:{name:"signInWithCredential",a:[Wj()]},signInWithCustomToken:{name:"signInWithCustomToken",a:[Y("token")]},signInWithEmailAndPassword:{name:"signInWithEmailAndPassword",a:[Y("email"),Y("password")]},signInWithPopup:{name:"signInWithPopup",a:[Xj()]},signInWithRedirect:{name:"signInWithRedirect",a:[Xj()]},signOut:{name:"signOut",
	a:[]},toJSON:{name:"toJSON",a:[Y(null,!0)]},verifyPasswordResetCode:{name:"verifyPasswordResetCode",a:[Y("code")]}});
	ak(U.prototype,{"delete":{name:"delete",a:[]},getToken:{name:"getToken",a:[{name:"opt_forceRefresh",ja:"a boolean",optional:!0,la:function(a){return"boolean"==typeof a}}]},link:{name:"link",a:[Wj()]},linkWithCredential:{name:"linkWithCredential",a:[Wj()]},linkWithPopup:{name:"linkWithPopup",a:[Xj()]},linkWithRedirect:{name:"linkWithRedirect",a:[Xj()]},reauthenticate:{name:"reauthenticate",a:[Wj()]},reauthenticateWithCredential:{name:"reauthenticateWithCredential",a:[Wj()]},reauthenticateWithPopup:{name:"reauthenticateWithPopup",
	a:[Xj()]},reauthenticateWithRedirect:{name:"reauthenticateWithRedirect",a:[Xj()]},reload:{name:"reload",a:[]},sendEmailVerification:{name:"sendEmailVerification",a:[]},toJSON:{name:"toJSON",a:[Y(null,!0)]},unlink:{name:"unlink",a:[Y("provider")]},updateEmail:{name:"updateEmail",a:[Y("email")]},updatePassword:{name:"updatePassword",a:[Y("password")]},updateProfile:{name:"updateProfile",a:[Z("profile")]}});ak(A.prototype,{f:{name:"catch"},then:{name:"then"}});
	bk(kg,"credential",function(a,b){return new hg(a,b)},[Y("email"),Y("password")]);ak($f.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk($f,"credential",ag,[Yj(Y(),Z(),"token")]);ak(bg.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(bg,"credential",cg,[Yj(Y(),Z(),"token")]);
	ak(dg.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(dg,"credential",eg,[Yj(Y(),Yj(Z(),Vj()),"idToken"),Yj(Y(),Vj(),"accessToken",!0)]);ak(fg.prototype,{setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(fg,"credential",gg,[Yj(Y(),Z(),"token"),Y("secret",!0)]);ak(O.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});ak(tg.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});
	ak(Rf.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:W,Error:O};bk(a,"EmailAuthProvider",kg,[]);bk(a,"FacebookAuthProvider",$f,[]);bk(a,"GithubAuthProvider",bg,[]);bk(a,"GoogleAuthProvider",dg,[]);bk(a,"TwitterAuthProvider",fg,[]);firebase.INTERNAL.registerService("auth",function(a,c){a=new W(a);c({INTERNAL:{getUid:q(a.getUid,a),getToken:q(a.getToken,a),addAuthTokenListener:q(a.Ae,a),removeAuthTokenListener:q(a.uf,a)}});return a},a,function(a,
	c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:U})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).call(this);
	}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
	module.exports = firebase.auth;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 497:
/*!********************************!*\
  !*** ./~/firebase/database.js ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
	Build: rev-cc77c9e
	Terms: https://firebase.google.com/terms/
	
	---
	
	typedarray.js
	Copyright (c) 2010, Linden Research, Inc.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE. */
	
	var firebase = __webpack_require__(/*! ./app */ 155);
	(function(){
	(function() {var g,aa=this;function n(a){return void 0!==a}function ba(){}function ca(a){a.Vb=function(){return a.Ye?a.Ye:a.Ye=new a}}
	function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return"array"==da(a)}function fa(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function p(a){return"string"==typeof a}function ga(a){return"number"==typeof a}function ha(a){return"function"==da(a)}function ia(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}function ja(a,b,c){return a.call.apply(a.bind,arguments)}
	function ka(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function q(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ja:ka;return q.apply(null,arguments)}
	function la(a,b){function c(){}c.prototype=b.prototype;a.wg=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.sg=function(a,c,f){for(var h=Array(arguments.length-2),k=2;k<arguments.length;k++)h[k-2]=arguments[k];return b.prototype[c].apply(a,h)}};function ma(a){a=String(a);if(/^\s*$/.test(a)?0:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,"")))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function na(){this.Fd=void 0}
	function oa(a,b,c){switch(typeof b){case "string":pa(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?b:"null");break;case "boolean":c.push(b);break;case "undefined":c.push("null");break;case "object":if(null==b){c.push("null");break}if(ea(b)){var d=b.length;c.push("[");for(var e="",f=0;f<d;f++)c.push(e),e=b[f],oa(a,a.Fd?a.Fd.call(b,String(f),e):e,c),e=",";c.push("]");break}c.push("{");d="";for(f in b)Object.prototype.hasOwnProperty.call(b,f)&&(e=b[f],"function"!=typeof e&&(c.push(d),pa(f,c),
	c.push(":"),oa(a,a.Fd?a.Fd.call(b,f,e):e,c),d=","));c.push("}");break;case "function":break;default:throw Error("Unknown type: "+typeof b);}}var qa={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},ra=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
	function pa(a,b){b.push('"',a.replace(ra,function(a){if(a in qa)return qa[a];var b=a.charCodeAt(0),e="\\u";16>b?e+="000":256>b?e+="00":4096>b&&(e+="0");return qa[a]=e+b.toString(16)}),'"')};function sa(){this.Wa=-1};function ta(){this.Wa=-1;this.Wa=64;this.M=[];this.Wd=[];this.Af=[];this.zd=[];this.zd[0]=128;for(var a=1;a<this.Wa;++a)this.zd[a]=0;this.Pd=this.$b=0;this.reset()}la(ta,sa);ta.prototype.reset=function(){this.M[0]=1732584193;this.M[1]=4023233417;this.M[2]=2562383102;this.M[3]=271733878;this.M[4]=3285377520;this.Pd=this.$b=0};
	function ua(a,b,c){c||(c=0);var d=a.Af;if(p(b))for(var e=0;16>e;e++)d[e]=b.charCodeAt(c)<<24|b.charCodeAt(c+1)<<16|b.charCodeAt(c+2)<<8|b.charCodeAt(c+3),c+=4;else for(e=0;16>e;e++)d[e]=b[c]<<24|b[c+1]<<16|b[c+2]<<8|b[c+3],c+=4;for(e=16;80>e;e++){var f=d[e-3]^d[e-8]^d[e-14]^d[e-16];d[e]=(f<<1|f>>>31)&4294967295}b=a.M[0];c=a.M[1];for(var h=a.M[2],k=a.M[3],m=a.M[4],l,e=0;80>e;e++)40>e?20>e?(f=k^c&(h^k),l=1518500249):(f=c^h^k,l=1859775393):60>e?(f=c&h|k&(c|h),l=2400959708):(f=c^h^k,l=3395469782),f=(b<<
	5|b>>>27)+f+m+l+d[e]&4294967295,m=k,k=h,h=(c<<30|c>>>2)&4294967295,c=b,b=f;a.M[0]=a.M[0]+b&4294967295;a.M[1]=a.M[1]+c&4294967295;a.M[2]=a.M[2]+h&4294967295;a.M[3]=a.M[3]+k&4294967295;a.M[4]=a.M[4]+m&4294967295}
	ta.prototype.update=function(a,b){if(null!=a){n(b)||(b=a.length);for(var c=b-this.Wa,d=0,e=this.Wd,f=this.$b;d<b;){if(0==f)for(;d<=c;)ua(this,a,d),d+=this.Wa;if(p(a))for(;d<b;){if(e[f]=a.charCodeAt(d),++f,++d,f==this.Wa){ua(this,e);f=0;break}}else for(;d<b;)if(e[f]=a[d],++f,++d,f==this.Wa){ua(this,e);f=0;break}}this.$b=f;this.Pd+=b}};var r;a:{var va=aa.navigator;if(va){var wa=va.userAgent;if(wa){r=wa;break a}}r=""};var t=Array.prototype,xa=t.indexOf?function(a,b,c){return t.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(p(a))return p(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ya=t.forEach?function(a,b,c){t.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},za=t.filter?function(a,b,c){return t.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,h=p(a)?
	a.split(""):a,k=0;k<d;k++)if(k in h){var m=h[k];b.call(c,m,k,a)&&(e[f++]=m)}return e},Aa=t.map?function(a,b,c){return t.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=p(a)?a.split(""):a,h=0;h<d;h++)h in f&&(e[h]=b.call(c,f[h],h,a));return e},Ba=t.reduce?function(a,b,c,d){for(var e=[],f=1,h=arguments.length;f<h;f++)e.push(arguments[f]);d&&(e[0]=q(b,d));return t.reduce.apply(a,e)}:function(a,b,c,d){var e=c;ya(a,function(c,h){e=b.call(d,e,c,h,a)});return e},Ca=t.every?function(a,b,
	c){return t.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};function Da(a,b){var c=Ea(a,b,void 0);return 0>c?null:p(a)?a.charAt(c):a[c]}function Ea(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}function Fa(a,b){var c=xa(a,b);0<=c&&t.splice.call(a,c,1)}function Ga(a,b,c){return 2>=arguments.length?t.slice.call(a,b):t.slice.call(a,b,c)}
	function Ha(a,b){a.sort(b||Ia)}function Ia(a,b){return a>b?1:a<b?-1:0};function v(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Ja(a,b){var c={},d;for(d in a)c[d]=b.call(void 0,a[d],d,a);return c}function Ka(a,b){for(var c in a)if(!b.call(void 0,a[c],c,a))return!1;return!0}function La(a){var b=0,c;for(c in a)b++;return b}function Ma(a){for(var b in a)return b}function Na(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Oa(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Pa(a,b){for(var c in a)if(a[c]==b)return!0;return!1}
	function Qa(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d}function Ra(a,b){var c=Qa(a,b,void 0);return c&&a[c]}function Sa(a){for(var b in a)return!1;return!0}function Ta(a){var b={},c;for(c in a)b[c]=a[c];return b};var Ua=-1!=r.indexOf("Opera")||-1!=r.indexOf("OPR"),Va=-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE"),Wa=-1!=r.indexOf("Gecko")&&-1==r.toLowerCase().indexOf("webkit")&&!(-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE")),Xa=-1!=r.toLowerCase().indexOf("webkit");
	(function(){var a="",b;if(Ua&&aa.opera)return a=aa.opera.version,ha(a)?a():a;Wa?b=/rv\:([^\);]+)(\)|;)/:Va?b=/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/:Xa&&(b=/WebKit\/(\S+)/);b&&(a=(a=b.exec(r))?a[1]:"");return Va&&(b=(b=aa.document)?b.documentMode:void 0,b>parseFloat(a))?String(b):a})();var Ya=null,Za=null,$a=null;function ab(a,b){if(!fa(a))throw Error("encodeByteArray takes an array as a parameter");bb();for(var c=b?Za:Ya,d=[],e=0;e<a.length;e+=3){var f=a[e],h=e+1<a.length,k=h?a[e+1]:0,m=e+2<a.length,l=m?a[e+2]:0,u=f>>2,f=(f&3)<<4|k>>4,k=(k&15)<<2|l>>6,l=l&63;m||(l=64,h||(k=64));d.push(c[u],c[f],c[k],c[l])}return d.join("")}
	function bb(){if(!Ya){Ya={};Za={};$a={};for(var a=0;65>a;a++)Ya[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Za[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a),$a[Za[a]]=a,62<=a&&($a["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a)]=a)}};function cb(a,b){if(!a)throw db(b);}function db(a){return Error("Firebase Database ("+firebase.SDK_VERSION+") INTERNAL ASSERT FAILED: "+a)};function eb(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function w(a,b){if(Object.prototype.hasOwnProperty.call(a,b))return a[b]}function fb(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])};function gb(a){var b=[];fb(a,function(a,d){ea(d)?ya(d,function(d){b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))}):b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))});return b.length?"&"+b.join("&"):""};var hb=firebase.Promise;function ib(){var a=this;this.reject=this.resolve=null;this.ra=new hb(function(b,c){a.resolve=b;a.reject=c})}function jb(a,b){return function(c,d){c?a.reject(c):a.resolve(d);ha(b)&&(kb(a.ra),1===b.length?b(c):b(c,d))}}function kb(a){a.then(void 0,ba)};function lb(a){return"undefined"!==typeof JSON&&n(JSON.parse)?JSON.parse(a):ma(a)}function x(a){if("undefined"!==typeof JSON&&n(JSON.stringify))a=JSON.stringify(a);else{var b=[];oa(new na,a,b);a=b.join("")}return a};function mb(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);55296<=e&&56319>=e&&(e-=55296,d++,cb(d<a.length,"Surrogate pair missing trail surrogate."),e=65536+(e<<10)+(a.charCodeAt(d)-56320));128>e?b[c++]=e:(2048>e?b[c++]=e>>6|192:(65536>e?b[c++]=e>>12|224:(b[c++]=e>>18|240,b[c++]=e>>12&63|128),b[c++]=e>>6&63|128),b[c++]=e&63|128)}return b}function nb(a){for(var b=0,c=0;c<a.length;c++){var d=a.charCodeAt(c);128>d?b++:2048>d?b+=2:55296<=d&&56319>=d?(b+=4,c++):b+=3}return b};function y(a,b,c,d){var e;d<b?e="at least "+b:d>c&&(e=0===c?"none":"no more than "+c);if(e)throw Error(a+" failed: Was called with "+d+(1===d?" argument.":" arguments.")+" Expects "+e+".");}function A(a,b,c){var d="";switch(b){case 1:d=c?"first":"First";break;case 2:d=c?"second":"Second";break;case 3:d=c?"third":"Third";break;case 4:d=c?"fourth":"Fourth";break;default:throw Error("errorPrefix called with argumentNumber > 4.  Need to update it?");}return a=a+" failed: "+(d+" argument ")}
	function B(a,b,c,d){if((!d||n(c))&&!ha(c))throw Error(A(a,b,d)+"must be a valid function.");}function ob(a,b,c){if(n(c)&&(!ia(c)||null===c))throw Error(A(a,b,!0)+"must be a valid context object.");};function pb(){return"undefined"!==typeof window&&!!(window.cordova||window.phonegap||window.PhoneGap)&&/ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test("undefined"!==typeof navigator&&"string"===typeof navigator.userAgent?navigator.userAgent:"")};function C(a,b){this.name=a;this.R=b}function qb(a,b){return new C(a,b)};function rb(a,b){return sb(a.name,b.name)}function tb(a,b){return sb(a,b)};function ub(a){this.uc=a;this.Cd="firebase:"}g=ub.prototype;g.set=function(a,b){null==b?this.uc.removeItem(this.Cd+a):this.uc.setItem(this.Cd+a,x(b))};g.get=function(a){a=this.uc.getItem(this.Cd+a);return null==a?null:lb(a)};g.remove=function(a){this.uc.removeItem(this.Cd+a)};g.Ze=!1;g.toString=function(){return this.uc.toString()};function vb(){this.pc={}}vb.prototype.set=function(a,b){null==b?delete this.pc[a]:this.pc[a]=b};vb.prototype.get=function(a){return eb(this.pc,a)?this.pc[a]:null};vb.prototype.remove=function(a){delete this.pc[a]};vb.prototype.Ze=!0;function wb(a){try{if("undefined"!==typeof window&&"undefined"!==typeof window[a]){var b=window[a];b.setItem("firebase:sentinel","cache");b.removeItem("firebase:sentinel");return new ub(b)}}catch(c){}return new vb}var xb=wb("localStorage"),yb=wb("sessionStorage");function zb(a,b,c,d,e){this.host=a.toLowerCase();this.domain=this.host.substr(this.host.indexOf(".")+1);this.Sc=b;this.pe=c;this.qg=d;this.gf=e||"";this.$a=xb.get("host:"+a)||this.host}function Ab(a,b){b!==a.$a&&(a.$a=b,"s-"===a.$a.substr(0,2)&&xb.set("host:"+a.host,a.$a))}
	function Bb(a,b,c){D("string"===typeof b,"typeof type must == string");D("object"===typeof c,"typeof params must == object");if(b===Cb)b=(a.Sc?"wss://":"ws://")+a.$a+"/.ws?";else if(b===Db)b=(a.Sc?"https://":"http://")+a.$a+"/.lp?";else throw Error("Unknown connection type: "+b);a.host!==a.$a&&(c.ns=a.pe);var d=[];v(c,function(a,b){d.push(b+"="+a)});return b+d.join("&")}zb.prototype.toString=function(){var a=(this.Sc?"https://":"http://")+this.host;this.gf&&(a+="<"+this.gf+">");return a};function Eb(a,b){return a&&"object"===typeof a?(D(".sv"in a,"Unexpected leaf node or priority contents"),b[a[".sv"]]):a}function Fb(a,b){var c=new Gb;Hb(a,new E(""),function(a,e){Ib(c,a,Jb(e,b))});return c}function Jb(a,b){var c=a.C().H(),c=Eb(c,b),d;if(a.J()){var e=Eb(a.Ca(),b);return e!==a.Ca()||c!==a.C().H()?new Kb(e,G(c)):a}d=a;c!==a.C().H()&&(d=d.fa(new Kb(c)));a.O(H,function(a,c){var e=Jb(c,b);e!==c&&(d=d.T(a,e))});return d};var Lb=function(){var a=1;return function(){return a++}}(),D=cb,Mb=db;
	function Nb(a){try{var b;bb();for(var c=$a,d=[],e=0;e<a.length;){var f=c[a.charAt(e++)],h=e<a.length?c[a.charAt(e)]:0;++e;var k=e<a.length?c[a.charAt(e)]:64;++e;var m=e<a.length?c[a.charAt(e)]:64;++e;if(null==f||null==h||null==k||null==m)throw Error();d.push(f<<2|h>>4);64!=k&&(d.push(h<<4&240|k>>2),64!=m&&d.push(k<<6&192|m))}if(8192>d.length)b=String.fromCharCode.apply(null,d);else{a="";for(c=0;c<d.length;c+=8192)a+=String.fromCharCode.apply(null,Ga(d,c,c+8192));b=a}return b}catch(l){I("base64Decode failed: ",
	l)}return null}function Ob(a){var b=mb(a);a=new ta;a.update(b);var b=[],c=8*a.Pd;56>a.$b?a.update(a.zd,56-a.$b):a.update(a.zd,a.Wa-(a.$b-56));for(var d=a.Wa-1;56<=d;d--)a.Wd[d]=c&255,c/=256;ua(a,a.Wd);for(d=c=0;5>d;d++)for(var e=24;0<=e;e-=8)b[c]=a.M[d]>>e&255,++c;return ab(b)}function Pb(a){for(var b="",c=0;c<arguments.length;c++)b=fa(arguments[c])?b+Pb.apply(null,arguments[c]):"object"===typeof arguments[c]?b+x(arguments[c]):b+arguments[c],b+=" ";return b}var Qb=null,Rb=!0;
	function Sb(a,b){cb(!b||!0===a||!1===a,"Can't turn on custom loggers persistently.");!0===a?("undefined"!==typeof console&&("function"===typeof console.log?Qb=q(console.log,console):"object"===typeof console.log&&(Qb=function(a){console.log(a)})),b&&yb.set("logging_enabled",!0)):ha(a)?Qb=a:(Qb=null,yb.remove("logging_enabled"))}function I(a){!0===Rb&&(Rb=!1,null===Qb&&!0===yb.get("logging_enabled")&&Sb(!0));if(Qb){var b=Pb.apply(null,arguments);Qb(b)}}
	function Tb(a){return function(){I(a,arguments)}}function Ub(a){if("undefined"!==typeof console){var b="FIREBASE INTERNAL ERROR: "+Pb.apply(null,arguments);"undefined"!==typeof console.error?console.error(b):console.log(b)}}function Vb(a){var b=Pb.apply(null,arguments);throw Error("FIREBASE FATAL ERROR: "+b);}function J(a){if("undefined"!==typeof console){var b="FIREBASE WARNING: "+Pb.apply(null,arguments);"undefined"!==typeof console.warn?console.warn(b):console.log(b)}}
	function Wb(a){var b,c,d,e,f,h=a;f=c=a=b="";d=!0;e="https";if(p(h)){var k=h.indexOf("//");0<=k&&(e=h.substring(0,k-1),h=h.substring(k+2));k=h.indexOf("/");-1===k&&(k=h.length);b=h.substring(0,k);f="";h=h.substring(k).split("/");for(k=0;k<h.length;k++)if(0<h[k].length){var m=h[k];try{m=decodeURIComponent(m.replace(/\+/g," "))}catch(l){}f+="/"+m}h=b.split(".");3===h.length?(a=h[1],c=h[0].toLowerCase()):2===h.length&&(a=h[0]);k=b.indexOf(":");0<=k&&(d="https"===e||"wss"===e)}"firebase"===a&&Vb(b+" is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead");
	c&&"undefined"!=c||Vb("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");d||"undefined"!==typeof window&&window.location&&window.location.protocol&&-1!==window.location.protocol.indexOf("https:")&&J("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");return{jc:new zb(b,d,c,"ws"===e||"wss"===e),path:new E(f)}}function Xb(a){return ga(a)&&(a!=a||a==Number.POSITIVE_INFINITY||a==Number.NEGATIVE_INFINITY)}
	function Yb(a){if("complete"===document.readyState)a();else{var b=!1,c=function(){document.body?b||(b=!0,a()):setTimeout(c,Math.floor(10))};document.addEventListener?(document.addEventListener("DOMContentLoaded",c,!1),window.addEventListener("load",c,!1)):document.attachEvent&&(document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&c()}),window.attachEvent("onload",c))}}
	function sb(a,b){if(a===b)return 0;if("[MIN_NAME]"===a||"[MAX_NAME]"===b)return-1;if("[MIN_NAME]"===b||"[MAX_NAME]"===a)return 1;var c=Zb(a),d=Zb(b);return null!==c?null!==d?0==c-d?a.length-b.length:c-d:-1:null!==d?1:a<b?-1:1}function $b(a,b){if(b&&a in b)return b[a];throw Error("Missing required key ("+a+") in object: "+x(b));}
	function ac(a){if("object"!==typeof a||null===a)return x(a);var b=[],c;for(c in a)b.push(c);b.sort();c="{";for(var d=0;d<b.length;d++)0!==d&&(c+=","),c+=x(b[d]),c+=":",c+=ac(a[b[d]]);return c+"}"}function bc(a,b){if(a.length<=b)return[a];for(var c=[],d=0;d<a.length;d+=b)d+b>a?c.push(a.substring(d,a.length)):c.push(a.substring(d,d+b));return c}function cc(a,b){if(ea(a))for(var c=0;c<a.length;++c)b(c,a[c]);else v(a,b)}
	function dc(a){D(!Xb(a),"Invalid JSON number");var b,c,d,e;0===a?(d=c=0,b=-Infinity===1/a?1:0):(b=0>a,a=Math.abs(a),a>=Math.pow(2,-1022)?(d=Math.min(Math.floor(Math.log(a)/Math.LN2),1023),c=d+1023,d=Math.round(a*Math.pow(2,52-d)-Math.pow(2,52))):(c=0,d=Math.round(a/Math.pow(2,-1074))));e=[];for(a=52;a;--a)e.push(d%2?1:0),d=Math.floor(d/2);for(a=11;a;--a)e.push(c%2?1:0),c=Math.floor(c/2);e.push(b?1:0);e.reverse();b=e.join("");c="";for(a=0;64>a;a+=8)d=parseInt(b.substr(a,8),2).toString(16),1===d.length&&
	(d="0"+d),c+=d;return c.toLowerCase()}var ec=/^-?\d{1,10}$/;function Zb(a){return ec.test(a)&&(a=Number(a),-2147483648<=a&&2147483647>=a)?a:null}function fc(a){try{a()}catch(b){setTimeout(function(){J("Exception was thrown by user callback.",b.stack||"");throw b;},Math.floor(0))}}function gc(a,b,c){Object.defineProperty(a,b,{get:c})}function hc(a,b){var c=setTimeout(a,b);"object"===typeof c&&c.unref&&c.unref();return c};function ic(a){var b={},c={},d={},e="";try{var f=a.split("."),b=lb(Nb(f[0])||""),c=lb(Nb(f[1])||""),e=f[2],d=c.d||{};delete c.d}catch(h){}return{tg:b,Je:c,data:d,mg:e}}function jc(a){a=ic(a);var b=a.Je;return!!a.mg&&!!b&&"object"===typeof b&&b.hasOwnProperty("iat")}function kc(a){a=ic(a).Je;return"object"===typeof a&&!0===w(a,"admin")};function lc(){}var mc={};function nc(a){return q(a.compare,a)}lc.prototype.nd=function(a,b){return 0!==this.compare(new C("[MIN_NAME]",a),new C("[MIN_NAME]",b))};lc.prototype.Hc=function(){return oc};function pc(a){D(!a.e()&&".priority"!==K(a),"Can't create PathIndex with empty path or .priority key");this.bc=a}la(pc,lc);g=pc.prototype;g.xc=function(a){return!a.P(this.bc).e()};g.compare=function(a,b){var c=a.R.P(this.bc),d=b.R.P(this.bc),c=c.sc(d);return 0===c?sb(a.name,b.name):c};
	g.Ec=function(a,b){var c=G(a),c=L.F(this.bc,c);return new C(b,c)};g.Fc=function(){var a=L.F(this.bc,qc);return new C("[MAX_NAME]",a)};g.toString=function(){return this.bc.slice().join("/")};function rc(){}la(rc,lc);g=rc.prototype;g.compare=function(a,b){var c=a.R.C(),d=b.R.C(),c=c.sc(d);return 0===c?sb(a.name,b.name):c};g.xc=function(a){return!a.C().e()};g.nd=function(a,b){return!a.C().Z(b.C())};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",new Kb("[PRIORITY-POST]",qc))};
	g.Ec=function(a,b){var c=G(a);return new C(b,new Kb("[PRIORITY-POST]",c))};g.toString=function(){return".priority"};var H=new rc;function sc(){}la(sc,lc);g=sc.prototype;g.compare=function(a,b){return sb(a.name,b.name)};g.xc=function(){throw Mb("KeyIndex.isDefinedOn not expected to be called.");};g.nd=function(){return!1};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",L)};g.Ec=function(a){D(p(a),"KeyIndex indexValue must always be a string.");return new C(a,L)};g.toString=function(){return".key"};
	var tc=new sc;function uc(){}la(uc,lc);g=uc.prototype;g.compare=function(a,b){var c=a.R.sc(b.R);return 0===c?sb(a.name,b.name):c};g.xc=function(){return!0};g.nd=function(a,b){return!a.Z(b)};g.Hc=function(){return oc};g.Fc=function(){return vc};g.Ec=function(a,b){var c=G(a);return new C(b,c)};g.toString=function(){return".value"};var wc=new uc;function xc(a,b){this.od=a;this.cc=b}xc.prototype.get=function(a){var b=w(this.od,a);if(!b)throw Error("No index defined for "+a);return b===mc?null:b};function yc(a,b,c){var d=Ja(a.od,function(d,f){var h=w(a.cc,f);D(h,"Missing index implementation for "+f);if(d===mc){if(h.xc(b.R)){for(var k=[],m=c.Wb(qb),l=M(m);l;)l.name!=b.name&&k.push(l),l=M(m);k.push(b);return zc(k,nc(h))}return mc}h=c.get(b.name);k=d;h&&(k=k.remove(new C(b.name,h)));return k.Oa(b,b.R)});return new xc(d,a.cc)}
	function Ac(a,b,c){var d=Ja(a.od,function(a){if(a===mc)return a;var d=c.get(b.name);return d?a.remove(new C(b.name,d)):a});return new xc(d,a.cc)}var Bc=new xc({".priority":mc},{".priority":H});function Kb(a,b){this.B=a;D(n(this.B)&&null!==this.B,"LeafNode shouldn't be created with null/undefined value.");this.aa=b||L;Cc(this.aa);this.Db=null}var Dc=["object","boolean","number","string"];g=Kb.prototype;g.J=function(){return!0};g.C=function(){return this.aa};g.fa=function(a){return new Kb(this.B,a)};g.Q=function(a){return".priority"===a?this.aa:L};g.P=function(a){return a.e()?this:".priority"===K(a)?this.aa:L};g.Da=function(){return!1};g.Ve=function(){return null};
	g.T=function(a,b){return".priority"===a?this.fa(b):b.e()&&".priority"!==a?this:L.T(a,b).fa(this.aa)};g.F=function(a,b){var c=K(a);if(null===c)return b;if(b.e()&&".priority"!==c)return this;D(".priority"!==c||1===Ec(a),".priority must be the last token in a path");return this.T(c,L.F(N(a),b))};g.e=function(){return!1};g.Eb=function(){return 0};g.O=function(){return!1};g.H=function(a){return a&&!this.C().e()?{".value":this.Ca(),".priority":this.C().H()}:this.Ca()};
	g.hash=function(){if(null===this.Db){var a="";this.aa.e()||(a+="priority:"+Fc(this.aa.H())+":");var b=typeof this.B,a=a+(b+":"),a="number"===b?a+dc(this.B):a+this.B;this.Db=Ob(a)}return this.Db};g.Ca=function(){return this.B};g.sc=function(a){if(a===L)return 1;if(a instanceof O)return-1;D(a.J(),"Unknown node type");var b=typeof a.B,c=typeof this.B,d=xa(Dc,b),e=xa(Dc,c);D(0<=d,"Unknown leaf type: "+b);D(0<=e,"Unknown leaf type: "+c);return d===e?"object"===c?0:this.B<a.B?-1:this.B===a.B?0:1:e-d};
	g.nb=function(){return this};g.yc=function(){return!0};g.Z=function(a){return a===this?!0:a.J()?this.B===a.B&&this.aa.Z(a.aa):!1};g.toString=function(){return x(this.H(!0))};function Gc(){this.set={}}g=Gc.prototype;g.add=function(a,b){this.set[a]=null!==b?b:!0};g.contains=function(a){return eb(this.set,a)};g.get=function(a){return this.contains(a)?this.set[a]:void 0};g.remove=function(a){delete this.set[a]};g.clear=function(){this.set={}};g.e=function(){return Sa(this.set)};g.count=function(){return La(this.set)};function Hc(a,b){v(a.set,function(a,d){b(d,a)})}g.keys=function(){var a=[];v(this.set,function(b,c){a.push(c)});return a};function Ic(a){D(ea(a)&&0<a.length,"Requires a non-empty array");this.Bf=a;this.Dc={}}Ic.prototype.Ge=function(a,b){var c;c=this.Dc[a]||[];var d=c.length;if(0<d){for(var e=Array(d),f=0;f<d;f++)e[f]=c[f];c=e}else c=[];for(d=0;d<c.length;d++)c[d].Ie.apply(c[d].Ma,Array.prototype.slice.call(arguments,1))};Ic.prototype.gc=function(a,b,c){Jc(this,a);this.Dc[a]=this.Dc[a]||[];this.Dc[a].push({Ie:b,Ma:c});(a=this.Ue(a))&&b.apply(c,a)};
	Ic.prototype.Ic=function(a,b,c){Jc(this,a);a=this.Dc[a]||[];for(var d=0;d<a.length;d++)if(a[d].Ie===b&&(!c||c===a[d].Ma)){a.splice(d,1);break}};function Jc(a,b){D(Da(a.Bf,function(a){return a===b}),"Unknown event: "+b)};var Kc=function(){var a=0,b=[];return function(c){var d=c===a;a=c;for(var e=Array(8),f=7;0<=f;f--)e[f]="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(c%64),c=Math.floor(c/64);D(0===c,"Cannot push at time == 0");c=e.join("");if(d){for(f=11;0<=f&&63===b[f];f--)b[f]=0;b[f]++}else for(f=0;12>f;f++)b[f]=Math.floor(64*Math.random());for(f=0;12>f;f++)c+="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(b[f]);D(20===c.length,"nextPushId: Length should be 20.");
	return c}}();function Lc(){Ic.call(this,["online"]);this.hc=!0;if("undefined"!==typeof window&&"undefined"!==typeof window.addEventListener&&!pb()){var a=this;window.addEventListener("online",function(){a.hc||(a.hc=!0,a.Ge("online",!0))},!1);window.addEventListener("offline",function(){a.hc&&(a.hc=!1,a.Ge("online",!1))},!1)}}la(Lc,Ic);Lc.prototype.Ue=function(a){D("online"===a,"Unknown event type: "+a);return[this.hc]};ca(Lc);function Mc(){Ic.call(this,["visible"]);var a,b;"undefined"!==typeof document&&"undefined"!==typeof document.addEventListener&&("undefined"!==typeof document.hidden?(b="visibilitychange",a="hidden"):"undefined"!==typeof document.mozHidden?(b="mozvisibilitychange",a="mozHidden"):"undefined"!==typeof document.msHidden?(b="msvisibilitychange",a="msHidden"):"undefined"!==typeof document.webkitHidden&&(b="webkitvisibilitychange",a="webkitHidden"));this.Mb=!0;if(b){var c=this;document.addEventListener(b,
	function(){var b=!document[a];b!==c.Mb&&(c.Mb=b,c.Ge("visible",b))},!1)}}la(Mc,Ic);Mc.prototype.Ue=function(a){D("visible"===a,"Unknown event type: "+a);return[this.Mb]};ca(Mc);function E(a,b){if(1==arguments.length){this.o=a.split("/");for(var c=0,d=0;d<this.o.length;d++)0<this.o[d].length&&(this.o[c]=this.o[d],c++);this.o.length=c;this.Y=0}else this.o=a,this.Y=b}function P(a,b){var c=K(a);if(null===c)return b;if(c===K(b))return P(N(a),N(b));throw Error("INTERNAL ERROR: innerPath ("+b+") is not within outerPath ("+a+")");}
	function Nc(a,b){for(var c=a.slice(),d=b.slice(),e=0;e<c.length&&e<d.length;e++){var f=sb(c[e],d[e]);if(0!==f)return f}return c.length===d.length?0:c.length<d.length?-1:1}function K(a){return a.Y>=a.o.length?null:a.o[a.Y]}function Ec(a){return a.o.length-a.Y}function N(a){var b=a.Y;b<a.o.length&&b++;return new E(a.o,b)}function Oc(a){return a.Y<a.o.length?a.o[a.o.length-1]:null}g=E.prototype;
	g.toString=function(){for(var a="",b=this.Y;b<this.o.length;b++)""!==this.o[b]&&(a+="/"+this.o[b]);return a||"/"};g.slice=function(a){return this.o.slice(this.Y+(a||0))};g.parent=function(){if(this.Y>=this.o.length)return null;for(var a=[],b=this.Y;b<this.o.length-1;b++)a.push(this.o[b]);return new E(a,0)};
	g.n=function(a){for(var b=[],c=this.Y;c<this.o.length;c++)b.push(this.o[c]);if(a instanceof E)for(c=a.Y;c<a.o.length;c++)b.push(a.o[c]);else for(a=a.split("/"),c=0;c<a.length;c++)0<a[c].length&&b.push(a[c]);return new E(b,0)};g.e=function(){return this.Y>=this.o.length};g.Z=function(a){if(Ec(this)!==Ec(a))return!1;for(var b=this.Y,c=a.Y;b<=this.o.length;b++,c++)if(this.o[b]!==a.o[c])return!1;return!0};
	g.contains=function(a){var b=this.Y,c=a.Y;if(Ec(this)>Ec(a))return!1;for(;b<this.o.length;){if(this.o[b]!==a.o[c])return!1;++b;++c}return!0};var Q=new E("");function Pc(a,b){this.Qa=a.slice();this.Ha=Math.max(1,this.Qa.length);this.Qe=b;for(var c=0;c<this.Qa.length;c++)this.Ha+=nb(this.Qa[c]);Qc(this)}Pc.prototype.push=function(a){0<this.Qa.length&&(this.Ha+=1);this.Qa.push(a);this.Ha+=nb(a);Qc(this)};Pc.prototype.pop=function(){var a=this.Qa.pop();this.Ha-=nb(a);0<this.Qa.length&&--this.Ha};
	function Qc(a){if(768<a.Ha)throw Error(a.Qe+"has a key path longer than 768 bytes ("+a.Ha+").");if(32<a.Qa.length)throw Error(a.Qe+"path specified exceeds the maximum depth that can be written (32) or object contains a cycle "+Rc(a));}function Rc(a){return 0==a.Qa.length?"":"in property '"+a.Qa.join(".")+"'"};function Sc(){this.children={};this.bd=0;this.value=null}function Tc(a,b,c){this.ud=a?a:"";this.Pc=b?b:null;this.A=c?c:new Sc}function Uc(a,b){for(var c=b instanceof E?b:new E(b),d=a,e;null!==(e=K(c));)d=new Tc(e,d,w(d.A.children,e)||new Sc),c=N(c);return d}g=Tc.prototype;g.Ca=function(){return this.A.value};function Vc(a,b){D("undefined"!==typeof b,"Cannot set value to undefined");a.A.value=b;Wc(a)}g.clear=function(){this.A.value=null;this.A.children={};this.A.bd=0;Wc(this)};
	g.kd=function(){return 0<this.A.bd};g.e=function(){return null===this.Ca()&&!this.kd()};g.O=function(a){var b=this;v(this.A.children,function(c,d){a(new Tc(d,b,c))})};function Xc(a,b,c,d){c&&!d&&b(a);a.O(function(a){Xc(a,b,!0,d)});c&&d&&b(a)}function Yc(a,b){for(var c=a.parent();null!==c&&!b(c);)c=c.parent()}g.path=function(){return new E(null===this.Pc?this.ud:this.Pc.path()+"/"+this.ud)};g.name=function(){return this.ud};g.parent=function(){return this.Pc};
	function Wc(a){if(null!==a.Pc){var b=a.Pc,c=a.ud,d=a.e(),e=eb(b.A.children,c);d&&e?(delete b.A.children[c],b.A.bd--,Wc(b)):d||e||(b.A.children[c]=a.A,b.A.bd++,Wc(b))}};function Zc(a,b){this.La=a;this.ba=b?b:$c}g=Zc.prototype;g.Oa=function(a,b){return new Zc(this.La,this.ba.Oa(a,b,this.La).X(null,null,!1,null,null))};g.remove=function(a){return new Zc(this.La,this.ba.remove(a,this.La).X(null,null,!1,null,null))};g.get=function(a){for(var b,c=this.ba;!c.e();){b=this.La(a,c.key);if(0===b)return c.value;0>b?c=c.left:0<b&&(c=c.right)}return null};
	function ad(a,b){for(var c,d=a.ba,e=null;!d.e();){c=a.La(b,d.key);if(0===c){if(d.left.e())return e?e.key:null;for(d=d.left;!d.right.e();)d=d.right;return d.key}0>c?d=d.left:0<c&&(e=d,d=d.right)}throw Error("Attempted to find predecessor key for a nonexistent key.  What gives?");}g.e=function(){return this.ba.e()};g.count=function(){return this.ba.count()};g.Gc=function(){return this.ba.Gc()};g.ec=function(){return this.ba.ec()};g.ha=function(a){return this.ba.ha(a)};
	g.Wb=function(a){return new bd(this.ba,null,this.La,!1,a)};g.Xb=function(a,b){return new bd(this.ba,a,this.La,!1,b)};g.Zb=function(a,b){return new bd(this.ba,a,this.La,!0,b)};g.We=function(a){return new bd(this.ba,null,this.La,!0,a)};function bd(a,b,c,d,e){this.Hd=e||null;this.le=d;this.Pa=[];for(e=1;!a.e();)if(e=b?c(a.key,b):1,d&&(e*=-1),0>e)a=this.le?a.left:a.right;else if(0===e){this.Pa.push(a);break}else this.Pa.push(a),a=this.le?a.right:a.left}
	function M(a){if(0===a.Pa.length)return null;var b=a.Pa.pop(),c;c=a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value};if(a.le)for(b=b.left;!b.e();)a.Pa.push(b),b=b.right;else for(b=b.right;!b.e();)a.Pa.push(b),b=b.left;return c}function cd(a){if(0===a.Pa.length)return null;var b;b=a.Pa;b=b[b.length-1];return a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value}}function dd(a,b,c,d,e){this.key=a;this.value=b;this.color=null!=c?c:!0;this.left=null!=d?d:$c;this.right=null!=e?e:$c}g=dd.prototype;
	g.X=function(a,b,c,d,e){return new dd(null!=a?a:this.key,null!=b?b:this.value,null!=c?c:this.color,null!=d?d:this.left,null!=e?e:this.right)};g.count=function(){return this.left.count()+1+this.right.count()};g.e=function(){return!1};g.ha=function(a){return this.left.ha(a)||a(this.key,this.value)||this.right.ha(a)};function ed(a){return a.left.e()?a:ed(a.left)}g.Gc=function(){return ed(this).key};g.ec=function(){return this.right.e()?this.key:this.right.ec()};
	g.Oa=function(a,b,c){var d,e;e=this;d=c(a,e.key);e=0>d?e.X(null,null,null,e.left.Oa(a,b,c),null):0===d?e.X(null,b,null,null,null):e.X(null,null,null,null,e.right.Oa(a,b,c));return gd(e)};function hd(a){if(a.left.e())return $c;a.left.ea()||a.left.left.ea()||(a=id(a));a=a.X(null,null,null,hd(a.left),null);return gd(a)}
	g.remove=function(a,b){var c,d;c=this;if(0>b(a,c.key))c.left.e()||c.left.ea()||c.left.left.ea()||(c=id(c)),c=c.X(null,null,null,c.left.remove(a,b),null);else{c.left.ea()&&(c=jd(c));c.right.e()||c.right.ea()||c.right.left.ea()||(c=kd(c),c.left.left.ea()&&(c=jd(c),c=kd(c)));if(0===b(a,c.key)){if(c.right.e())return $c;d=ed(c.right);c=c.X(d.key,d.value,null,null,hd(c.right))}c=c.X(null,null,null,null,c.right.remove(a,b))}return gd(c)};g.ea=function(){return this.color};
	function gd(a){a.right.ea()&&!a.left.ea()&&(a=ld(a));a.left.ea()&&a.left.left.ea()&&(a=jd(a));a.left.ea()&&a.right.ea()&&(a=kd(a));return a}function id(a){a=kd(a);a.right.left.ea()&&(a=a.X(null,null,null,null,jd(a.right)),a=ld(a),a=kd(a));return a}function ld(a){return a.right.X(null,null,a.color,a.X(null,null,!0,null,a.right.left),null)}function jd(a){return a.left.X(null,null,a.color,null,a.X(null,null,!0,a.left.right,null))}
	function kd(a){return a.X(null,null,!a.color,a.left.X(null,null,!a.left.color,null,null),a.right.X(null,null,!a.right.color,null,null))}function md(){}g=md.prototype;g.X=function(){return this};g.Oa=function(a,b){return new dd(a,b,null)};g.remove=function(){return this};g.count=function(){return 0};g.e=function(){return!0};g.ha=function(){return!1};g.Gc=function(){return null};g.ec=function(){return null};g.ea=function(){return!1};var $c=new md;function O(a,b,c){this.k=a;(this.aa=b)&&Cc(this.aa);a.e()&&D(!this.aa||this.aa.e(),"An empty node cannot have a priority");this.yb=c;this.Db=null}g=O.prototype;g.J=function(){return!1};g.C=function(){return this.aa||L};g.fa=function(a){return this.k.e()?this:new O(this.k,a,this.yb)};g.Q=function(a){if(".priority"===a)return this.C();a=this.k.get(a);return null===a?L:a};g.P=function(a){var b=K(a);return null===b?this:this.Q(b).P(N(a))};g.Da=function(a){return null!==this.k.get(a)};
	g.T=function(a,b){D(b,"We should always be passing snapshot nodes");if(".priority"===a)return this.fa(b);var c=new C(a,b),d,e;b.e()?(d=this.k.remove(a),c=Ac(this.yb,c,this.k)):(d=this.k.Oa(a,b),c=yc(this.yb,c,this.k));e=d.e()?L:this.aa;return new O(d,e,c)};g.F=function(a,b){var c=K(a);if(null===c)return b;D(".priority"!==K(a)||1===Ec(a),".priority must be the last token in a path");var d=this.Q(c).F(N(a),b);return this.T(c,d)};g.e=function(){return this.k.e()};g.Eb=function(){return this.k.count()};
	var nd=/^(0|[1-9]\d*)$/;g=O.prototype;g.H=function(a){if(this.e())return null;var b={},c=0,d=0,e=!0;this.O(H,function(f,h){b[f]=h.H(a);c++;e&&nd.test(f)?d=Math.max(d,Number(f)):e=!1});if(!a&&e&&d<2*c){var f=[],h;for(h in b)f[h]=b[h];return f}a&&!this.C().e()&&(b[".priority"]=this.C().H());return b};g.hash=function(){if(null===this.Db){var a="";this.C().e()||(a+="priority:"+Fc(this.C().H())+":");this.O(H,function(b,c){var d=c.hash();""!==d&&(a+=":"+b+":"+d)});this.Db=""===a?"":Ob(a)}return this.Db};
	g.Ve=function(a,b,c){return(c=od(this,c))?(a=ad(c,new C(a,b)))?a.name:null:ad(this.k,a)};function pd(a,b){var c;c=(c=od(a,b))?(c=c.Gc())&&c.name:a.k.Gc();return c?new C(c,a.k.get(c)):null}function qd(a,b){var c;c=(c=od(a,b))?(c=c.ec())&&c.name:a.k.ec();return c?new C(c,a.k.get(c)):null}g.O=function(a,b){var c=od(this,a);return c?c.ha(function(a){return b(a.name,a.R)}):this.k.ha(b)};g.Wb=function(a){return this.Xb(a.Hc(),a)};
	g.Xb=function(a,b){var c=od(this,b);if(c)return c.Xb(a,function(a){return a});for(var c=this.k.Xb(a.name,qb),d=cd(c);null!=d&&0>b.compare(d,a);)M(c),d=cd(c);return c};g.We=function(a){return this.Zb(a.Fc(),a)};g.Zb=function(a,b){var c=od(this,b);if(c)return c.Zb(a,function(a){return a});for(var c=this.k.Zb(a.name,qb),d=cd(c);null!=d&&0<b.compare(d,a);)M(c),d=cd(c);return c};g.sc=function(a){return this.e()?a.e()?0:-1:a.J()||a.e()?1:a===qc?-1:0};
	g.nb=function(a){if(a===tc||Pa(this.yb.cc,a.toString()))return this;var b=this.yb,c=this.k;D(a!==tc,"KeyIndex always exists and isn't meant to be added to the IndexMap.");for(var d=[],e=!1,c=c.Wb(qb),f=M(c);f;)e=e||a.xc(f.R),d.push(f),f=M(c);d=e?zc(d,nc(a)):mc;e=a.toString();c=Ta(b.cc);c[e]=a;a=Ta(b.od);a[e]=d;return new O(this.k,this.aa,new xc(a,c))};g.yc=function(a){return a===tc||Pa(this.yb.cc,a.toString())};
	g.Z=function(a){if(a===this)return!0;if(a.J())return!1;if(this.C().Z(a.C())&&this.k.count()===a.k.count()){var b=this.Wb(H);a=a.Wb(H);for(var c=M(b),d=M(a);c&&d;){if(c.name!==d.name||!c.R.Z(d.R))return!1;c=M(b);d=M(a)}return null===c&&null===d}return!1};function od(a,b){return b===tc?null:a.yb.get(b.toString())}g.toString=function(){return x(this.H(!0))};function G(a,b){if(null===a)return L;var c=null;"object"===typeof a&&".priority"in a?c=a[".priority"]:"undefined"!==typeof b&&(c=b);D(null===c||"string"===typeof c||"number"===typeof c||"object"===typeof c&&".sv"in c,"Invalid priority type found: "+typeof c);"object"===typeof a&&".value"in a&&null!==a[".value"]&&(a=a[".value"]);if("object"!==typeof a||".sv"in a)return new Kb(a,G(c));if(a instanceof Array){var d=L,e=a;v(e,function(a,b){if(eb(e,b)&&"."!==b.substring(0,1)){var c=G(a);if(c.J()||!c.e())d=
	d.T(b,c)}});return d.fa(G(c))}var f=[],h=!1,k=a;fb(k,function(a){if("string"!==typeof a||"."!==a.substring(0,1)){var b=G(k[a]);b.e()||(h=h||!b.C().e(),f.push(new C(a,b)))}});if(0==f.length)return L;var m=zc(f,rb,function(a){return a.name},tb);if(h){var l=zc(f,nc(H));return new O(m,G(c),new xc({".priority":l},{".priority":H}))}return new O(m,G(c),Bc)}var rd=Math.log(2);
	function sd(a){this.count=parseInt(Math.log(a+1)/rd,10);this.Oe=this.count-1;this.Cf=a+1&parseInt(Array(this.count+1).join("1"),2)}function td(a){var b=!(a.Cf&1<<a.Oe);a.Oe--;return b}
	function zc(a,b,c,d){function e(b,d){var f=d-b;if(0==f)return null;if(1==f){var l=a[b],u=c?c(l):l;return new dd(u,l.R,!1,null,null)}var l=parseInt(f/2,10)+b,f=e(b,l),z=e(l+1,d),l=a[l],u=c?c(l):l;return new dd(u,l.R,!1,f,z)}a.sort(b);var f=function(b){function d(b,h){var k=u-b,z=u;u-=b;var z=e(k+1,z),k=a[k],F=c?c(k):k,z=new dd(F,k.R,h,null,z);f?f.left=z:l=z;f=z}for(var f=null,l=null,u=a.length,z=0;z<b.count;++z){var F=td(b),fd=Math.pow(2,b.count-(z+1));F?d(fd,!1):(d(fd,!1),d(fd,!0))}return l}(new sd(a.length));
	return null!==f?new Zc(d||b,f):new Zc(d||b)}function Fc(a){return"number"===typeof a?"number:"+dc(a):"string:"+a}function Cc(a){if(a.J()){var b=a.H();D("string"===typeof b||"number"===typeof b||"object"===typeof b&&eb(b,".sv"),"Priority must be a string or number.")}else D(a===qc||a.e(),"priority of unexpected type.");D(a===qc||a.C().e(),"Priority nodes can't have a priority of their own.")}var L=new O(new Zc(tb),null,Bc);function ud(){O.call(this,new Zc(tb),L,Bc)}la(ud,O);g=ud.prototype;
	g.sc=function(a){return a===this?0:1};g.Z=function(a){return a===this};g.C=function(){return this};g.Q=function(){return L};g.e=function(){return!1};var qc=new ud,oc=new C("[MIN_NAME]",L),vc=new C("[MAX_NAME]",qc);function vd(a,b){this.value=a;this.children=b||wd}var wd=new Zc(function(a,b){return a===b?0:a<b?-1:1});function xd(a){var b=R;v(a,function(a,d){b=b.set(new E(d),a)});return b}g=vd.prototype;g.e=function(){return null===this.value&&this.children.e()};function yd(a,b,c){if(null!=a.value&&c(a.value))return{path:Q,value:a.value};if(b.e())return null;var d=K(b);a=a.children.get(d);return null!==a?(b=yd(a,N(b),c),null!=b?{path:(new E(d)).n(b.path),value:b.value}:null):null}
	function zd(a,b){return yd(a,b,function(){return!0})}g.subtree=function(a){if(a.e())return this;var b=this.children.get(K(a));return null!==b?b.subtree(N(a)):R};g.set=function(a,b){if(a.e())return new vd(b,this.children);var c=K(a),d=(this.children.get(c)||R).set(N(a),b),c=this.children.Oa(c,d);return new vd(this.value,c)};
	g.remove=function(a){if(a.e())return this.children.e()?R:new vd(null,this.children);var b=K(a),c=this.children.get(b);return c?(a=c.remove(N(a)),b=a.e()?this.children.remove(b):this.children.Oa(b,a),null===this.value&&b.e()?R:new vd(this.value,b)):this};g.get=function(a){if(a.e())return this.value;var b=this.children.get(K(a));return b?b.get(N(a)):null};
	function Ad(a,b,c){if(b.e())return c;var d=K(b);b=Ad(a.children.get(d)||R,N(b),c);d=b.e()?a.children.remove(d):a.children.Oa(d,b);return new vd(a.value,d)}function Bd(a,b){return Cd(a,Q,b)}function Cd(a,b,c){var d={};a.children.ha(function(a,f){d[a]=Cd(f,b.n(a),c)});return c(b,a.value,d)}function Dd(a,b,c){return Ed(a,b,Q,c)}function Ed(a,b,c,d){var e=a.value?d(c,a.value):!1;if(e)return e;if(b.e())return null;e=K(b);return(a=a.children.get(e))?Ed(a,N(b),c.n(e),d):null}
	function Fd(a,b,c){Gd(a,b,Q,c)}function Gd(a,b,c,d){if(b.e())return a;a.value&&d(c,a.value);var e=K(b);return(a=a.children.get(e))?Gd(a,N(b),c.n(e),d):R}function Hd(a,b){Id(a,Q,b)}function Id(a,b,c){a.children.ha(function(a,e){Id(e,b.n(a),c)});a.value&&c(b,a.value)}function Jd(a,b){a.children.ha(function(a,d){d.value&&b(a,d.value)})}var R=new vd(null);vd.prototype.toString=function(){var a={};Hd(this,function(b,c){a[b.toString()]=c.toString()});return x(a)};var Kd=/[\[\].#$\/\u0000-\u001F\u007F]/,Ld=/[\[\].#$\u0000-\u001F\u007F]/;function Md(a){return p(a)&&0!==a.length&&!Kd.test(a)}function Nd(a){return null===a||p(a)||ga(a)&&!Xb(a)||ia(a)&&eb(a,".sv")}function Od(a,b,c,d){d&&!n(b)||Pd(A(a,1,d),b,c)}
	function Pd(a,b,c){c instanceof E&&(c=new Pc(c,a));if(!n(b))throw Error(a+"contains undefined "+Rc(c));if(ha(b))throw Error(a+"contains a function "+Rc(c)+" with contents: "+b.toString());if(Xb(b))throw Error(a+"contains "+b.toString()+" "+Rc(c));if(p(b)&&b.length>10485760/3&&10485760<nb(b))throw Error(a+"contains a string greater than 10485760 utf8 bytes "+Rc(c)+" ('"+b.substring(0,50)+"...')");if(ia(b)){var d=!1,e=!1;fb(b,function(b,h){if(".value"===b)d=!0;else if(".priority"!==b&&".sv"!==b&&(e=
	!0,!Md(b)))throw Error(a+" contains an invalid key ("+b+") "+Rc(c)+'.  Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');c.push(b);Pd(a,h,c);c.pop()});if(d&&e)throw Error(a+' contains ".value" child '+Rc(c)+" in addition to actual children.");}}
	function Qd(a,b){var c,d;for(c=0;c<b.length;c++){d=b[c];for(var e=d.slice(),f=0;f<e.length;f++)if((".priority"!==e[f]||f!==e.length-1)&&!Md(e[f]))throw Error(a+"contains an invalid key ("+e[f]+") in path "+d.toString()+'. Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');}b.sort(Nc);e=null;for(c=0;c<b.length;c++){d=b[c];if(null!==e&&e.contains(d))throw Error(a+"contains a path "+e.toString()+" that is ancestor of another path "+d.toString());e=d}}
	function Rd(a,b,c){var d=A(a,1,!1);if(!ia(b)||ea(b))throw Error(d+" must be an object containing the children to replace.");var e=[];fb(b,function(a,b){var k=new E(a);Pd(d,b,c.n(k));if(".priority"===Oc(k)&&!Nd(b))throw Error(d+"contains an invalid value for '"+k.toString()+"', which must be a valid Firebase priority (a string, finite number, server value, or null).");e.push(k)});Qd(d,e)}
	function Sd(a,b,c){if(Xb(c))throw Error(A(a,b,!1)+"is "+c.toString()+", but must be a valid Firebase priority (a string, finite number, server value, or null).");if(!Nd(c))throw Error(A(a,b,!1)+"must be a valid Firebase priority (a string, finite number, server value, or null).");}
	function Td(a,b,c){if(!c||n(b))switch(b){case "value":case "child_added":case "child_removed":case "child_changed":case "child_moved":break;default:throw Error(A(a,1,c)+'must be a valid event type: "value", "child_added", "child_removed", "child_changed", or "child_moved".');}}function Ud(a,b){if(n(b)&&!Md(b))throw Error(A(a,2,!0)+'was an invalid key: "'+b+'".  Firebase keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]").');}
	function Vd(a,b){if(!p(b)||0===b.length||Ld.test(b))throw Error(A(a,1,!1)+'was an invalid path: "'+b+'". Paths must be non-empty strings and can\'t contain ".", "#", "$", "[", or "]"');}function Wd(a,b){if(".info"===K(b))throw Error(a+" failed: Can't modify data under /.info/");}
	function Xd(a,b){var c=b.path.toString(),d;!(d=!p(b.jc.host)||0===b.jc.host.length||!Md(b.jc.pe))&&(d=0!==c.length)&&(c&&(c=c.replace(/^\/*\.info(\/|$)/,"/")),d=!(p(c)&&0!==c.length&&!Ld.test(c)));if(d)throw Error(A(a,1,!1)+'must be a valid firebase URL and the path can\'t contain ".", "#", "$", "[", or "]".');};function Gb(){this.k=this.B=null}Gb.prototype.find=function(a){if(null!=this.B)return this.B.P(a);if(a.e()||null==this.k)return null;var b=K(a);a=N(a);return this.k.contains(b)?this.k.get(b).find(a):null};function Ib(a,b,c){if(b.e())a.B=c,a.k=null;else if(null!==a.B)a.B=a.B.F(b,c);else{null==a.k&&(a.k=new Gc);var d=K(b);a.k.contains(d)||a.k.add(d,new Gb);a=a.k.get(d);b=N(b);Ib(a,b,c)}}
	function Yd(a,b){if(b.e())return a.B=null,a.k=null,!0;if(null!==a.B){if(a.B.J())return!1;var c=a.B;a.B=null;c.O(H,function(b,c){Ib(a,new E(b),c)});return Yd(a,b)}return null!==a.k?(c=K(b),b=N(b),a.k.contains(c)&&Yd(a.k.get(c),b)&&a.k.remove(c),a.k.e()?(a.k=null,!0):!1):!0}function Hb(a,b,c){null!==a.B?c(b,a.B):a.O(function(a,e){var f=new E(b.toString()+"/"+a);Hb(e,f,c)})}Gb.prototype.O=function(a){null!==this.k&&Hc(this.k,function(b,c){a(b,c)})};function Zd(a,b){this.type=$d;this.source=a;this.path=b}Zd.prototype.Mc=function(){return this.path.e()?new Zd(this.source,Q):new Zd(this.source,N(this.path))};Zd.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" listen_complete)"};function ae(a,b,c){this.type=be;this.source=a;this.path=b;this.children=c}ae.prototype.Mc=function(a){if(this.path.e())return a=this.children.subtree(new E(a)),a.e()?null:a.value?new ce(this.source,Q,a.value):new ae(this.source,Q,a);D(K(this.path)===a,"Can't get a merge for a child not on the path of the operation");return new ae(this.source,N(this.path),this.children)};ae.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" merge: "+this.children.toString()+")"};function de(a,b,c){this.type=ee;this.source=fe;this.path=a;this.Ob=b;this.Id=c}de.prototype.Mc=function(a){if(this.path.e()){if(null!=this.Ob.value)return D(this.Ob.children.e(),"affectedTree should not have overlapping affected paths."),this;a=this.Ob.subtree(new E(a));return new de(Q,a,this.Id)}D(K(this.path)===a,"operationForChild called for unrelated child.");return new de(N(this.path),this.Ob,this.Id)};
	de.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" ack write revert="+this.Id+" affectedTree="+this.Ob+")"};function ce(a,b,c){this.type=ge;this.source=a;this.path=b;this.Ga=c}ce.prototype.Mc=function(a){return this.path.e()?new ce(this.source,Q,this.Ga.Q(a)):new ce(this.source,N(this.path),this.Ga)};ce.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" overwrite: "+this.Ga.toString()+")"};var ge=0,be=1,ee=2,$d=3;function he(a,b,c,d){this.ee=a;this.Se=b;this.Hb=c;this.Ee=d;D(!d||b,"Tagged queries must be from server.")}var fe=new he(!0,!1,null,!1),ie=new he(!1,!0,null,!1);he.prototype.toString=function(){return this.ee?"user":this.Ee?"server(queryID="+this.Hb+")":"server"};function je(a,b,c){this.A=a;this.da=b;this.Sb=c}function ke(a){return a.da}function le(a){return a.Sb}function me(a,b){return b.e()?a.da&&!a.Sb:ne(a,K(b))}function ne(a,b){return a.da&&!a.Sb||a.A.Da(b)}je.prototype.j=function(){return this.A};function oe(a,b){this.N=a;this.Ld=b}function pe(a,b,c,d){return new oe(new je(b,c,d),a.Ld)}function qe(a){return a.N.da?a.N.j():null}oe.prototype.w=function(){return this.Ld};function re(a){return a.Ld.da?a.Ld.j():null};function se(){}se.prototype.Te=function(){return null};se.prototype.fe=function(){return null};var te=new se;function ue(a,b,c){this.xf=a;this.Ka=b;this.yd=c}ue.prototype.Te=function(a){var b=this.Ka.N;if(ne(b,a))return b.j().Q(a);b=null!=this.yd?new je(this.yd,!0,!1):this.Ka.w();return this.xf.qc(a,b)};ue.prototype.fe=function(a,b,c){var d=null!=this.yd?this.yd:re(this.Ka);a=this.xf.Xd(d,b,1,c,a);return 0===a.length?null:a[0]};function ve(a,b){this.Sd=a;this.Df=b}function we(a){this.U=a}
	we.prototype.eb=function(a,b,c,d){var e=new xe,f;if(b.type===ge)b.source.ee?c=ye(this,a,b.path,b.Ga,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w())&&!b.path.e(),c=ze(this,a,b.path,b.Ga,c,d,f,e));else if(b.type===be)b.source.ee?c=Ae(this,a,b.path,b.children,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w()),c=Be(this,a,b.path,b.children,c,d,f,e));else if(b.type===ee)if(b.Id)if(b=b.path,null!=c.lc(b))c=a;else{f=new ue(c,a,d);d=a.N.j();if(b.e()||".priority"===K(b))ke(a.w())?
	b=c.Aa(re(a)):(b=a.w().j(),D(b instanceof O,"serverChildren would be complete if leaf node"),b=c.rc(b)),b=this.U.ya(d,b,e);else{var h=K(b),k=c.qc(h,a.w());null==k&&ne(a.w(),h)&&(k=d.Q(h));b=null!=k?this.U.F(d,h,k,N(b),f,e):a.N.j().Da(h)?this.U.F(d,h,L,N(b),f,e):d;b.e()&&ke(a.w())&&(d=c.Aa(re(a)),d.J()&&(b=this.U.ya(b,d,e)))}d=ke(a.w())||null!=c.lc(Q);c=pe(a,b,d,this.U.Na())}else c=Ce(this,a,b.path,b.Ob,c,d,e);else if(b.type===$d)d=b.path,b=a.w(),f=b.j(),h=b.da||d.e(),c=De(this,new oe(a.N,new je(f,
	h,b.Sb)),d,c,te,e);else throw Mb("Unknown operation type: "+b.type);e=Na(e.fb);d=c;b=d.N;b.da&&(f=b.j().J()||b.j().e(),h=qe(a),(0<e.length||!a.N.da||f&&!b.j().Z(h)||!b.j().C().Z(h.C()))&&e.push(Ee(qe(d))));return new ve(c,e)};
	function De(a,b,c,d,e,f){var h=b.N;if(null!=d.lc(c))return b;var k;if(c.e())D(ke(b.w()),"If change path is empty, we must have complete server data"),le(b.w())?(e=re(b),d=d.rc(e instanceof O?e:L)):d=d.Aa(re(b)),f=a.U.ya(b.N.j(),d,f);else{var m=K(c);if(".priority"==m)D(1==Ec(c),"Can't have a priority with additional path components"),f=h.j(),k=b.w().j(),d=d.ad(c,f,k),f=null!=d?a.U.fa(f,d):h.j();else{var l=N(c);ne(h,m)?(k=b.w().j(),d=d.ad(c,h.j(),k),d=null!=d?h.j().Q(m).F(l,d):h.j().Q(m)):d=d.qc(m,
	b.w());f=null!=d?a.U.F(h.j(),m,d,l,e,f):h.j()}}return pe(b,f,h.da||c.e(),a.U.Na())}function ze(a,b,c,d,e,f,h,k){var m=b.w();h=h?a.U:a.U.Ub();if(c.e())d=h.ya(m.j(),d,null);else if(h.Na()&&!m.Sb)d=m.j().F(c,d),d=h.ya(m.j(),d,null);else{var l=K(c);if(!me(m,c)&&1<Ec(c))return b;var u=N(c);d=m.j().Q(l).F(u,d);d=".priority"==l?h.fa(m.j(),d):h.F(m.j(),l,d,u,te,null)}m=m.da||c.e();b=new oe(b.N,new je(d,m,h.Na()));return De(a,b,c,e,new ue(e,b,f),k)}
	function ye(a,b,c,d,e,f,h){var k=b.N;e=new ue(e,b,f);if(c.e())h=a.U.ya(b.N.j(),d,h),a=pe(b,h,!0,a.U.Na());else if(f=K(c),".priority"===f)h=a.U.fa(b.N.j(),d),a=pe(b,h,k.da,k.Sb);else{c=N(c);var m=k.j().Q(f);if(!c.e()){var l=e.Te(f);d=null!=l?".priority"===Oc(c)&&l.P(c.parent()).e()?l:l.F(c,d):L}m.Z(d)?a=b:(h=a.U.F(k.j(),f,d,c,e,h),a=pe(b,h,k.da,a.U.Na()))}return a}
	function Ae(a,b,c,d,e,f,h){var k=b;Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))&&(k=ye(a,k,u,l,e,f,h))});Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))||(k=ye(a,k,u,l,e,f,h))});return k}function Fe(a,b){Hd(b,function(b,d){a=a.F(b,d)});return a}
	function Be(a,b,c,d,e,f,h,k){if(b.w().j().e()&&!ke(b.w()))return b;var m=b;c=c.e()?d:Ad(R,c,d);var l=b.w().j();c.children.ha(function(c,d){if(l.Da(c)){var F=b.w().j().Q(c),F=Fe(F,d);m=ze(a,m,new E(c),F,e,f,h,k)}});c.children.ha(function(c,d){var F=!ne(b.w(),c)&&null==d.value;l.Da(c)||F||(F=b.w().j().Q(c),F=Fe(F,d),m=ze(a,m,new E(c),F,e,f,h,k))});return m}
	function Ce(a,b,c,d,e,f,h){if(null!=e.lc(c))return b;var k=le(b.w()),m=b.w();if(null!=d.value){if(c.e()&&m.da||me(m,c))return ze(a,b,c,m.j().P(c),e,f,k,h);if(c.e()){var l=R;m.j().O(tc,function(a,b){l=l.set(new E(a),b)});return Be(a,b,c,l,e,f,k,h)}return b}l=R;Hd(d,function(a){var b=c.n(a);me(m,b)&&(l=l.set(a,m.j().P(b)))});return Be(a,b,c,l,e,f,k,h)};function Ge(a){this.V=a;this.g=a.m.g}function He(a,b,c,d){var e=[],f=[];ya(b,function(b){b.type===Ie&&a.g.nd(b.qe,b.Ja)&&f.push(new S(Je,b.Ja,b.Xa))});Ke(a,e,Le,b,d,c);Ke(a,e,Me,b,d,c);Ke(a,e,Je,f,d,c);Ke(a,e,Ie,b,d,c);Ke(a,e,Ne,b,d,c);return e}function Ke(a,b,c,d,e,f){d=za(d,function(a){return a.type===c});Ha(d,q(a.Ff,a));ya(d,function(c){var d=Oe(a,c,f);ya(e,function(e){e.nf(c.type)&&b.push(e.createEvent(d,a.V))})})}
	function Oe(a,b,c){"value"!==b.type&&"child_removed"!==b.type&&(b.Dd=c.Ve(b.Xa,b.Ja,a.g));return b}Ge.prototype.Ff=function(a,b){if(null==a.Xa||null==b.Xa)throw Mb("Should only compare child_ events.");return this.g.compare(new C(a.Xa,a.Ja),new C(b.Xa,b.Ja))};function Pe(a,b){this.V=a;var c=a.m,d=new Qe(c.g),c=T(c)?new Qe(c.g):c.xa?new Re(c):new Se(c);this.hf=new we(c);var e=b.w(),f=b.N,h=d.ya(L,e.j(),null),k=c.ya(L,f.j(),null);this.Ka=new oe(new je(k,f.da,c.Na()),new je(h,e.da,d.Na()));this.Za=[];this.Jf=new Ge(a)}function Te(a){return a.V}g=Pe.prototype;g.w=function(){return this.Ka.w().j()};g.hb=function(a){var b=re(this.Ka);return b&&(T(this.V.m)||!a.e()&&!b.Q(K(a)).e())?b.P(a):null};g.e=function(){return 0===this.Za.length};g.Nb=function(a){this.Za.push(a)};
	g.kb=function(a,b){var c=[];if(b){D(null==a,"A cancel should cancel all event registrations.");var d=this.V.path;ya(this.Za,function(a){(a=a.Me(b,d))&&c.push(a)})}if(a){for(var e=[],f=0;f<this.Za.length;++f){var h=this.Za[f];if(!h.matches(a))e.push(h);else if(a.Xe()){e=e.concat(this.Za.slice(f+1));break}}this.Za=e}else this.Za=[];return c};
	g.eb=function(a,b,c){a.type===be&&null!==a.source.Hb&&(D(re(this.Ka),"We should always have a full cache before handling merges"),D(qe(this.Ka),"Missing event cache, even though we have a server cache"));var d=this.Ka;a=this.hf.eb(d,a,b,c);b=this.hf;c=a.Sd;D(c.N.j().yc(b.U.g),"Event snap not indexed");D(c.w().j().yc(b.U.g),"Server snap not indexed");D(ke(a.Sd.w())||!ke(d.w()),"Once a server snap is complete, it should never go back");this.Ka=a.Sd;return Ue(this,a.Df,a.Sd.N.j(),null)};
	function Ve(a,b){var c=a.Ka.N,d=[];c.j().J()||c.j().O(H,function(a,b){d.push(new S(Me,b,a))});c.da&&d.push(Ee(c.j()));return Ue(a,d,c.j(),b)}function Ue(a,b,c,d){return He(a.Jf,b,c,d?[d]:a.Za)};function We(a,b,c,d){this.ae=b;this.Md=c;this.Dd=d;this.hd=a}We.prototype.Yb=function(){var a=this.Md.wb();return"value"===this.hd?a.path:a.getParent().path};We.prototype.ge=function(){return this.hd};We.prototype.Tb=function(){return this.ae.Tb(this)};We.prototype.toString=function(){return this.Yb().toString()+":"+this.hd+":"+x(this.Md.be())};function Xe(a,b,c){this.ae=a;this.error=b;this.path=c}Xe.prototype.Yb=function(){return this.path};Xe.prototype.ge=function(){return"cancel"};
	Xe.prototype.Tb=function(){return this.ae.Tb(this)};Xe.prototype.toString=function(){return this.path.toString()+":cancel"};function Ye(){this.vb=[]}function Ze(a,b){for(var c=null,d=0;d<b.length;d++){var e=b[d],f=e.Yb();null===c||f.Z(c.Yb())||(a.vb.push(c),c=null);null===c&&(c=new $e(f));c.add(e)}c&&a.vb.push(c)}function af(a,b,c){Ze(a,c);bf(a,function(a){return a.Z(b)})}function cf(a,b,c){Ze(a,c);bf(a,function(a){return a.contains(b)||b.contains(a)})}
	function bf(a,b){for(var c=!0,d=0;d<a.vb.length;d++){var e=a.vb[d];if(e)if(e=e.Yb(),b(e)){for(var e=a.vb[d],f=0;f<e.jd.length;f++){var h=e.jd[f];if(null!==h){e.jd[f]=null;var k=h.Tb();Qb&&I("event: "+h.toString());fc(k)}}a.vb[d]=null}else c=!1}c&&(a.vb=[])}function $e(a){this.qa=a;this.jd=[]}$e.prototype.add=function(a){this.jd.push(a)};$e.prototype.Yb=function(){return this.qa};function Qe(a){this.g=a}g=Qe.prototype;g.F=function(a,b,c,d,e,f){D(a.yc(this.g),"A node must be indexed if only a child is updated");e=a.Q(b);if(e.P(d).Z(c.P(d))&&e.e()==c.e())return a;null!=f&&(c.e()?a.Da(b)?df(f,new S(Le,e,b)):D(a.J(),"A child remove without an old child only makes sense on a leaf node"):e.e()?df(f,new S(Me,c,b)):df(f,new S(Ie,c,b,e)));return a.J()&&c.e()?a:a.T(b,c).nb(this.g)};
	g.ya=function(a,b,c){null!=c&&(a.J()||a.O(H,function(a,e){b.Da(a)||df(c,new S(Le,e,a))}),b.J()||b.O(H,function(b,e){if(a.Da(b)){var f=a.Q(b);f.Z(e)||df(c,new S(Ie,e,b,f))}else df(c,new S(Me,e,b))}));return b.nb(this.g)};g.fa=function(a,b){return a.e()?L:a.fa(b)};g.Na=function(){return!1};g.Ub=function(){return this};function Se(a){this.he=new Qe(a.g);this.g=a.g;var b;a.ka?(b=ef(a),b=a.g.Ec(ff(a),b)):b=a.g.Hc();this.Uc=b;a.na?(b=gf(a),a=a.g.Ec(hf(a),b)):a=a.g.Fc();this.vc=a}g=Se.prototype;g.matches=function(a){return 0>=this.g.compare(this.Uc,a)&&0>=this.g.compare(a,this.vc)};g.F=function(a,b,c,d,e,f){this.matches(new C(b,c))||(c=L);return this.he.F(a,b,c,d,e,f)};
	g.ya=function(a,b,c){b.J()&&(b=L);var d=b.nb(this.g),d=d.fa(L),e=this;b.O(H,function(a,b){e.matches(new C(a,b))||(d=d.T(a,L))});return this.he.ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.he};function Re(a){this.sa=new Se(a);this.g=a.g;D(a.xa,"Only valid if limit has been set");this.oa=a.oa;this.Ib=!jf(a)}g=Re.prototype;g.F=function(a,b,c,d,e,f){this.sa.matches(new C(b,c))||(c=L);return a.Q(b).Z(c)?a:a.Eb()<this.oa?this.sa.Ub().F(a,b,c,d,e,f):kf(this,a,b,c,e,f)};
	g.ya=function(a,b,c){var d;if(b.J()||b.e())d=L.nb(this.g);else if(2*this.oa<b.Eb()&&b.yc(this.g)){d=L.nb(this.g);b=this.Ib?b.Zb(this.sa.vc,this.g):b.Xb(this.sa.Uc,this.g);for(var e=0;0<b.Pa.length&&e<this.oa;){var f=M(b),h;if(h=this.Ib?0>=this.g.compare(this.sa.Uc,f):0>=this.g.compare(f,this.sa.vc))d=d.T(f.name,f.R),e++;else break}}else{d=b.nb(this.g);d=d.fa(L);var k,m,l;if(this.Ib){b=d.We(this.g);k=this.sa.vc;m=this.sa.Uc;var u=nc(this.g);l=function(a,b){return u(b,a)}}else b=d.Wb(this.g),k=this.sa.Uc,
	m=this.sa.vc,l=nc(this.g);for(var e=0,z=!1;0<b.Pa.length;)f=M(b),!z&&0>=l(k,f)&&(z=!0),(h=z&&e<this.oa&&0>=l(f,m))?e++:d=d.T(f.name,L)}return this.sa.Ub().ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.sa.Ub()};
	function kf(a,b,c,d,e,f){var h;if(a.Ib){var k=nc(a.g);h=function(a,b){return k(b,a)}}else h=nc(a.g);D(b.Eb()==a.oa,"");var m=new C(c,d),l=a.Ib?pd(b,a.g):qd(b,a.g),u=a.sa.matches(m);if(b.Da(c)){for(var z=b.Q(c),l=e.fe(a.g,l,a.Ib);null!=l&&(l.name==c||b.Da(l.name));)l=e.fe(a.g,l,a.Ib);e=null==l?1:h(l,m);if(u&&!d.e()&&0<=e)return null!=f&&df(f,new S(Ie,d,c,z)),b.T(c,d);null!=f&&df(f,new S(Le,z,c));b=b.T(c,L);return null!=l&&a.sa.matches(l)?(null!=f&&df(f,new S(Me,l.R,l.name)),b.T(l.name,l.R)):b}return d.e()?
	b:u&&0<=h(l,m)?(null!=f&&(df(f,new S(Le,l.R,l.name)),df(f,new S(Me,d,c))),b.T(c,d).T(l.name,L)):b};function S(a,b,c,d){this.type=a;this.Ja=b;this.Xa=c;this.qe=d;this.Dd=void 0}function Ee(a){return new S(Ne,a)}var Me="child_added",Le="child_removed",Ie="child_changed",Je="child_moved",Ne="value";function xe(){this.fb={}}
	function df(a,b){var c=b.type,d=b.Xa;D(c==Me||c==Ie||c==Le,"Only child changes supported for tracking");D(".priority"!==d,"Only non-priority child changes can be tracked.");var e=w(a.fb,d);if(e){var f=e.type;if(c==Me&&f==Le)a.fb[d]=new S(Ie,b.Ja,d,e.Ja);else if(c==Le&&f==Me)delete a.fb[d];else if(c==Le&&f==Ie)a.fb[d]=new S(Le,e.qe,d);else if(c==Ie&&f==Me)a.fb[d]=new S(Me,b.Ja,d);else if(c==Ie&&f==Ie)a.fb[d]=new S(Ie,b.Ja,d,e.qe);else throw Mb("Illegal combination of changes: "+b+" occurred after "+
	e);}else a.fb[d]=b};function lf(){this.Rb=this.na=this.Kb=this.ka=this.xa=!1;this.oa=0;this.mb="";this.dc=null;this.zb="";this.ac=null;this.xb="";this.g=H}var mf=new lf;function jf(a){return""===a.mb?a.ka:"l"===a.mb}function ff(a){D(a.ka,"Only valid if start has been set");return a.dc}function ef(a){D(a.ka,"Only valid if start has been set");return a.Kb?a.zb:"[MIN_NAME]"}function hf(a){D(a.na,"Only valid if end has been set");return a.ac}
	function gf(a){D(a.na,"Only valid if end has been set");return a.Rb?a.xb:"[MAX_NAME]"}function nf(a){var b=new lf;b.xa=a.xa;b.oa=a.oa;b.ka=a.ka;b.dc=a.dc;b.Kb=a.Kb;b.zb=a.zb;b.na=a.na;b.ac=a.ac;b.Rb=a.Rb;b.xb=a.xb;b.g=a.g;b.mb=a.mb;return b}g=lf.prototype;g.ne=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="l";return b};g.oe=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="r";return b};g.Nd=function(a,b){var c=nf(this);c.ka=!0;n(a)||(a=null);c.dc=a;null!=b?(c.Kb=!0,c.zb=b):(c.Kb=!1,c.zb="");return c};
	g.gd=function(a,b){var c=nf(this);c.na=!0;n(a)||(a=null);c.ac=a;n(b)?(c.Rb=!0,c.xb=b):(c.vg=!1,c.xb="");return c};function of(a,b){var c=nf(a);c.g=b;return c}function pf(a){var b={};a.ka&&(b.sp=a.dc,a.Kb&&(b.sn=a.zb));a.na&&(b.ep=a.ac,a.Rb&&(b.en=a.xb));if(a.xa){b.l=a.oa;var c=a.mb;""===c&&(c=jf(a)?"l":"r");b.vf=c}a.g!==H&&(b.i=a.g.toString());return b}function T(a){return!(a.ka||a.na||a.xa)}function qf(a){return T(a)&&a.g==H}
	function rf(a){var b={};if(qf(a))return b;var c;a.g===H?c="$priority":a.g===wc?c="$value":a.g===tc?c="$key":(D(a.g instanceof pc,"Unrecognized index type!"),c=a.g.toString());b.orderBy=x(c);a.ka&&(b.startAt=x(a.dc),a.Kb&&(b.startAt+=","+x(a.zb)));a.na&&(b.endAt=x(a.ac),a.Rb&&(b.endAt+=","+x(a.xb)));a.xa&&(jf(a)?b.limitToFirst=a.oa:b.limitToLast=a.oa);return b}g.toString=function(){return x(pf(this))};function sf(a){this.W=a}var tf=new sf(new vd(null));function uf(a,b,c){if(b.e())return new sf(new vd(c));var d=zd(a.W,b);if(null!=d){var e=d.path,d=d.value;b=P(e,b);d=d.F(b,c);return new sf(a.W.set(e,d))}a=Ad(a.W,b,new vd(c));return new sf(a)}function vf(a,b,c){var d=a;fb(c,function(a,c){d=uf(d,b.n(a),c)});return d}sf.prototype.Ed=function(a){if(a.e())return tf;a=Ad(this.W,a,R);return new sf(a)};function wf(a,b){var c=zd(a.W,b);return null!=c?a.W.get(c.path).P(P(c.path,b)):null}
	function xf(a){var b=[],c=a.W.value;null!=c?c.J()||c.O(H,function(a,c){b.push(new C(a,c))}):a.W.children.ha(function(a,c){null!=c.value&&b.push(new C(a,c.value))});return b}function yf(a,b){if(b.e())return a;var c=wf(a,b);return null!=c?new sf(new vd(c)):new sf(a.W.subtree(b))}sf.prototype.e=function(){return this.W.e()};sf.prototype.apply=function(a){return zf(Q,this.W,a)};
	function zf(a,b,c){if(null!=b.value)return c.F(a,b.value);var d=null;b.children.ha(function(b,f){".priority"===b?(D(null!==f.value,"Priority writes must always be leaf nodes"),d=f.value):c=zf(a.n(b),f,c)});c.P(a).e()||null===d||(c=c.F(a.n(".priority"),d));return c};function Af(){this.Jd=L}Af.prototype.j=function(a){return this.Jd.P(a)};Af.prototype.toString=function(){return this.Jd.toString()};function Bf(a){this.oc=a}Bf.prototype.getToken=function(a){return this.oc.INTERNAL.getToken(a).then(null,function(a){return a&&"auth/token-not-initialized"===a.code?(I("Got auth/token-not-initialized error.  Treating as null token."),null):Promise.reject(a)})};function Cf(a,b){a.oc.INTERNAL.addAuthTokenListener(b)};function Df(){this.S=tf;this.la=[];this.Bc=-1}function Ef(a,b){for(var c=0;c<a.la.length;c++){var d=a.la[c];if(d.Zc===b)return d}return null}g=Df.prototype;
	g.Ed=function(a){var b=Ea(this.la,function(b){return b.Zc===a});D(0<=b,"removeWrite called with nonexistent writeId.");var c=this.la[b];this.la.splice(b,1);for(var d=c.visible,e=!1,f=this.la.length-1;d&&0<=f;){var h=this.la[f];h.visible&&(f>=b&&Ff(h,c.path)?d=!1:c.path.contains(h.path)&&(e=!0));f--}if(d){if(e)this.S=Gf(this.la,Hf,Q),this.Bc=0<this.la.length?this.la[this.la.length-1].Zc:-1;else if(c.Ga)this.S=this.S.Ed(c.path);else{var k=this;v(c.children,function(a,b){k.S=k.S.Ed(c.path.n(b))})}return!0}return!1};
	g.Aa=function(a,b,c,d){if(c||d){var e=yf(this.S,a);return!d&&e.e()?b:d||null!=b||null!=wf(e,Q)?(e=Gf(this.la,function(b){return(b.visible||d)&&(!c||!(0<=xa(c,b.Zc)))&&(b.path.contains(a)||a.contains(b.path))},a),b=b||L,e.apply(b)):null}e=wf(this.S,a);if(null!=e)return e;e=yf(this.S,a);return e.e()?b:null!=b||null!=wf(e,Q)?(b=b||L,e.apply(b)):null};
	g.rc=function(a,b){var c=L,d=wf(this.S,a);if(d)d.J()||d.O(H,function(a,b){c=c.T(a,b)});else if(b){var e=yf(this.S,a);b.O(H,function(a,b){var d=yf(e,new E(a)).apply(b);c=c.T(a,d)});ya(xf(e),function(a){c=c.T(a.name,a.R)})}else e=yf(this.S,a),ya(xf(e),function(a){c=c.T(a.name,a.R)});return c};g.ad=function(a,b,c,d){D(c||d,"Either existingEventSnap or existingServerSnap must exist");a=a.n(b);if(null!=wf(this.S,a))return null;a=yf(this.S,a);return a.e()?d.P(b):a.apply(d.P(b))};
	g.qc=function(a,b,c){a=a.n(b);var d=wf(this.S,a);return null!=d?d:ne(c,b)?yf(this.S,a).apply(c.j().Q(b)):null};g.lc=function(a){return wf(this.S,a)};g.Xd=function(a,b,c,d,e,f){var h;a=yf(this.S,a);h=wf(a,Q);if(null==h)if(null!=b)h=a.apply(b);else return[];h=h.nb(f);if(h.e()||h.J())return[];b=[];a=nc(f);e=e?h.Zb(c,f):h.Xb(c,f);for(f=M(e);f&&b.length<d;)0!==a(f,c)&&b.push(f),f=M(e);return b};
	function Ff(a,b){return a.Ga?a.path.contains(b):!!Qa(a.children,function(c,d){return a.path.n(d).contains(b)})}function Hf(a){return a.visible}
	function Gf(a,b,c){for(var d=tf,e=0;e<a.length;++e){var f=a[e];if(b(f)){var h=f.path;if(f.Ga)c.contains(h)?(h=P(c,h),d=uf(d,h,f.Ga)):h.contains(c)&&(h=P(h,c),d=uf(d,Q,f.Ga.P(h)));else if(f.children)if(c.contains(h))h=P(c,h),d=vf(d,h,f.children);else{if(h.contains(c))if(h=P(h,c),h.e())d=vf(d,Q,f.children);else if(f=w(f.children,K(h)))f=f.P(N(h)),d=uf(d,Q,f)}else throw Mb("WriteRecord should have .snap or .children");}}return d}function If(a,b){this.Lb=a;this.W=b}g=If.prototype;
	g.Aa=function(a,b,c){return this.W.Aa(this.Lb,a,b,c)};g.rc=function(a){return this.W.rc(this.Lb,a)};g.ad=function(a,b,c){return this.W.ad(this.Lb,a,b,c)};g.lc=function(a){return this.W.lc(this.Lb.n(a))};g.Xd=function(a,b,c,d,e){return this.W.Xd(this.Lb,a,b,c,d,e)};g.qc=function(a,b){return this.W.qc(this.Lb,a,b)};g.n=function(a){return new If(this.Lb.n(a),this.W)};function Jf(a,b){this.rf={};this.Vc=new Kf(a);this.va=b;var c=1E4+2E4*Math.random();hc(q(this.lf,this),Math.floor(c))}Jf.prototype.lf=function(){var a=this.Vc.get(),b={},c=!1,d;for(d in a)0<a[d]&&eb(this.rf,d)&&(b[d]=a[d],c=!0);c&&this.va.ye(b);hc(q(this.lf,this),Math.floor(6E5*Math.random()))};function Lf(){this.tc={}}function Mf(a,b,c){n(c)||(c=1);eb(a.tc,b)||(a.tc[b]=0);a.tc[b]+=c}Lf.prototype.get=function(){return Ta(this.tc)};function Kf(a){this.Ef=a;this.rd=null}Kf.prototype.get=function(){var a=this.Ef.get(),b=Ta(a);if(this.rd)for(var c in this.rd)b[c]-=this.rd[c];this.rd=a;return b};var Nf={},Of={};function Pf(a){a=a.toString();Nf[a]||(Nf[a]=new Lf);return Nf[a]}function Qf(a,b){var c=a.toString();Of[c]||(Of[c]=b());return Of[c]};function Rf(a,b,c){this.f=Tb("p:rest:");this.L=a;this.Gb=b;this.$c=c;this.$={}}function Sf(a,b){if(n(b))return"tag$"+b;D(qf(a.m),"should have a tag if it's not a default query.");return a.path.toString()}g=Rf.prototype;
	g.$e=function(a,b,c,d){var e=a.path.toString();this.f("Listen called for "+e+" "+a.ja());var f=Sf(a,c),h={};this.$[f]=h;a=rf(a.m);var k=this;Tf(this,e+".json",a,function(a,b){var u=b;404===a&&(a=u=null);null===a&&k.Gb(e,u,!1,c);w(k.$,f)===h&&d(a?401==a?"permission_denied":"rest_error:"+a:"ok",null)})};g.uf=function(a,b){var c=Sf(a,b);delete this.$[c]};g.kf=function(){};g.re=function(){};g.cf=function(){};g.xd=function(){};g.put=function(){};g.af=function(){};g.ye=function(){};
	function Tf(a,b,c,d){c=c||{};c.format="export";a.$c.getToken(!1).then(function(e){(e=e&&e.accessToken)&&(c.auth=e);var f=(a.L.Sc?"https://":"http://")+a.L.host+b+"?"+gb(c);a.f("Sending REST request for "+f);var h=new XMLHttpRequest;h.onreadystatechange=function(){if(d&&4===h.readyState){a.f("REST Response for "+f+" received. status:",h.status,"response:",h.responseText);var b=null;if(200<=h.status&&300>h.status){try{b=lb(h.responseText)}catch(c){J("Failed to parse JSON response for "+f+": "+h.responseText)}d(null,
	b)}else 401!==h.status&&404!==h.status&&J("Got unsuccessful REST response for "+f+" Status: "+h.status),d(h.status);d=null}};h.open("GET",f,!0);h.send()})};function Uf(a){this.te=a;this.Bd=[];this.Qb=0;this.Yd=-1;this.Fb=null}function Vf(a,b,c){a.Yd=b;a.Fb=c;a.Yd<a.Qb&&(a.Fb(),a.Fb=null)}function Wf(a,b,c){for(a.Bd[b]=c;a.Bd[a.Qb];){var d=a.Bd[a.Qb];delete a.Bd[a.Qb];for(var e=0;e<d.length;++e)if(d[e]){var f=a;fc(function(){f.te(d[e])})}if(a.Qb===a.Yd){a.Fb&&(clearTimeout(a.Fb),a.Fb(),a.Fb=null);break}a.Qb++}};var Cb="websocket",Db="long_polling";var Xf=null;"undefined"!==typeof MozWebSocket?Xf=MozWebSocket:"undefined"!==typeof WebSocket&&(Xf=WebSocket);function Yf(a,b,c,d){this.Zd=a;this.f=Tb(this.Zd);this.frames=this.zc=null;this.pb=this.qb=this.Fe=0;this.Va=Pf(b);a={v:"5"};"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");c&&(a.s=c);d&&(a.ls=d);this.Ke=Bb(b,Cb,a)}var Zf;
	Yf.prototype.open=function(a,b){this.ib=b;this.Xf=a;this.f("Websocket connecting to "+this.Ke);this.wc=!1;xb.set("previous_websocket_failure",!0);try{this.Ia=new Xf(this.Ke)}catch(c){this.f("Error instantiating WebSocket.");var d=c.message||c.data;d&&this.f(d);this.bb();return}var e=this;this.Ia.onopen=function(){e.f("Websocket connected.");e.wc=!0};this.Ia.onclose=function(){e.f("Websocket connection was disconnected.");e.Ia=null;e.bb()};this.Ia.onmessage=function(a){if(null!==e.Ia)if(a=a.data,e.pb+=
	a.length,Mf(e.Va,"bytes_received",a.length),$f(e),null!==e.frames)ag(e,a);else{a:{D(null===e.frames,"We already have a frame buffer");if(6>=a.length){var b=Number(a);if(!isNaN(b)){e.Fe=b;e.frames=[];a=null;break a}}e.Fe=1;e.frames=[]}null!==a&&ag(e,a)}};this.Ia.onerror=function(a){e.f("WebSocket error.  Closing connection.");(a=a.message||a.data)&&e.f(a);e.bb()}};Yf.prototype.start=function(){};
	Yf.isAvailable=function(){var a=!1;if("undefined"!==typeof navigator&&navigator.userAgent){var b=navigator.userAgent.match(/Android ([0-9]{0,}\.[0-9]{0,})/);b&&1<b.length&&4.4>parseFloat(b[1])&&(a=!0)}return!a&&null!==Xf&&!Zf};Yf.responsesRequiredToBeHealthy=2;Yf.healthyTimeout=3E4;g=Yf.prototype;g.sd=function(){xb.remove("previous_websocket_failure")};function ag(a,b){a.frames.push(b);if(a.frames.length==a.Fe){var c=a.frames.join("");a.frames=null;c=lb(c);a.Xf(c)}}
	g.send=function(a){$f(this);a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=bc(a,16384);1<a.length&&bg(this,String(a.length));for(var b=0;b<a.length;b++)bg(this,a[b])};g.Tc=function(){this.Ab=!0;this.zc&&(clearInterval(this.zc),this.zc=null);this.Ia&&(this.Ia.close(),this.Ia=null)};g.bb=function(){this.Ab||(this.f("WebSocket is closing itself"),this.Tc(),this.ib&&(this.ib(this.wc),this.ib=null))};g.close=function(){this.Ab||(this.f("WebSocket is being closed"),this.Tc())};
	function $f(a){clearInterval(a.zc);a.zc=setInterval(function(){a.Ia&&bg(a,"0");$f(a)},Math.floor(45E3))}function bg(a,b){try{a.Ia.send(b)}catch(c){a.f("Exception thrown from WebSocket.send():",c.message||c.data,"Closing connection."),setTimeout(q(a.bb,a),0)}};function cg(a,b,c,d){this.Zd=a;this.f=Tb(a);this.jc=b;this.pb=this.qb=0;this.Va=Pf(b);this.tf=c;this.wc=!1;this.Cb=d;this.Yc=function(a){return Bb(b,Db,a)}}var dg,eg;
	cg.prototype.open=function(a,b){this.Ne=0;this.ia=b;this.bf=new Uf(a);this.Ab=!1;var c=this;this.sb=setTimeout(function(){c.f("Timed out trying to connect.");c.bb();c.sb=null},Math.floor(3E4));Yb(function(){if(!c.Ab){c.Ta=new fg(function(a,b,d,k,m){gg(c,arguments);if(c.Ta)if(c.sb&&(clearTimeout(c.sb),c.sb=null),c.wc=!0,"start"==a)c.id=b,c.ff=d;else if("close"===a)b?(c.Ta.Kd=!1,Vf(c.bf,b,function(){c.bb()})):c.bb();else throw Error("Unrecognized command received: "+a);},function(a,b){gg(c,arguments);
	Wf(c.bf,a,b)},function(){c.bb()},c.Yc);var a={start:"t"};a.ser=Math.floor(1E8*Math.random());c.Ta.Qd&&(a.cb=c.Ta.Qd);a.v="5";c.tf&&(a.s=c.tf);c.Cb&&(a.ls=c.Cb);"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");a=c.Yc(a);c.f("Connecting via long-poll to "+a);hg(c.Ta,a,function(){})}})};
	cg.prototype.start=function(){var a=this.Ta,b=this.ff;a.Vf=this.id;a.Wf=b;for(a.Ud=!0;ig(a););a=this.id;b=this.ff;this.fc=document.createElement("iframe");var c={dframe:"t"};c.id=a;c.pw=b;this.fc.src=this.Yc(c);this.fc.style.display="none";document.body.appendChild(this.fc)};
	cg.isAvailable=function(){return dg||!eg&&"undefined"!==typeof document&&null!=document.createElement&&!("object"===typeof window&&window.chrome&&window.chrome.extension&&!/^chrome/.test(window.location.href))&&!("object"===typeof Windows&&"object"===typeof Windows.rg)&&!0};g=cg.prototype;g.sd=function(){};g.Tc=function(){this.Ab=!0;this.Ta&&(this.Ta.close(),this.Ta=null);this.fc&&(document.body.removeChild(this.fc),this.fc=null);this.sb&&(clearTimeout(this.sb),this.sb=null)};
	g.bb=function(){this.Ab||(this.f("Longpoll is closing itself"),this.Tc(),this.ia&&(this.ia(this.wc),this.ia=null))};g.close=function(){this.Ab||(this.f("Longpoll is being closed."),this.Tc())};g.send=function(a){a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=mb(a);a=ab(a,!0);a=bc(a,1840);for(var b=0;b<a.length;b++){var c=this.Ta;c.Qc.push({jg:this.Ne,pg:a.length,Pe:a[b]});c.Ud&&ig(c);this.Ne++}};function gg(a,b){var c=x(b).length;a.pb+=c;Mf(a.Va,"bytes_received",c)}
	function fg(a,b,c,d){this.Yc=d;this.ib=c;this.ve=new Gc;this.Qc=[];this.$d=Math.floor(1E8*Math.random());this.Kd=!0;this.Qd=Lb();window["pLPCommand"+this.Qd]=a;window["pRTLPCB"+this.Qd]=b;a=document.createElement("iframe");a.style.display="none";if(document.body){document.body.appendChild(a);try{a.contentWindow.document||I("No IE domain setting required")}catch(e){a.src="javascript:void((function(){document.open();document.domain='"+document.domain+"';document.close();})())"}}else throw"Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
	a.contentDocument?a.gb=a.contentDocument:a.contentWindow?a.gb=a.contentWindow.document:a.document&&(a.gb=a.document);this.Ea=a;a="";this.Ea.src&&"javascript:"===this.Ea.src.substr(0,11)&&(a='<script>document.domain="'+document.domain+'";\x3c/script>');a="<html><body>"+a+"</body></html>";try{this.Ea.gb.open(),this.Ea.gb.write(a),this.Ea.gb.close()}catch(f){I("frame writing exception"),f.stack&&I(f.stack),I(f)}}
	fg.prototype.close=function(){this.Ud=!1;if(this.Ea){this.Ea.gb.body.innerHTML="";var a=this;setTimeout(function(){null!==a.Ea&&(document.body.removeChild(a.Ea),a.Ea=null)},Math.floor(0))}var b=this.ib;b&&(this.ib=null,b())};
	function ig(a){if(a.Ud&&a.Kd&&a.ve.count()<(0<a.Qc.length?2:1)){a.$d++;var b={};b.id=a.Vf;b.pw=a.Wf;b.ser=a.$d;for(var b=a.Yc(b),c="",d=0;0<a.Qc.length;)if(1870>=a.Qc[0].Pe.length+30+c.length){var e=a.Qc.shift(),c=c+"&seg"+d+"="+e.jg+"&ts"+d+"="+e.pg+"&d"+d+"="+e.Pe;d++}else break;jg(a,b+c,a.$d);return!0}return!1}function jg(a,b,c){function d(){a.ve.remove(c);ig(a)}a.ve.add(c,1);var e=setTimeout(d,Math.floor(25E3));hg(a,b,function(){clearTimeout(e);d()})}
	function hg(a,b,c){setTimeout(function(){try{if(a.Kd){var d=a.Ea.gb.createElement("script");d.type="text/javascript";d.async=!0;d.src=b;d.onload=d.onreadystatechange=function(){var a=d.readyState;a&&"loaded"!==a&&"complete"!==a||(d.onload=d.onreadystatechange=null,d.parentNode&&d.parentNode.removeChild(d),c())};d.onerror=function(){I("Long-poll script failed to load: "+b);a.Kd=!1;a.close()};a.Ea.gb.body.appendChild(d)}}catch(e){}},Math.floor(1))};function kg(a){lg(this,a)}var mg=[cg,Yf];function lg(a,b){var c=Yf&&Yf.isAvailable(),d=c&&!(xb.Ze||!0===xb.get("previous_websocket_failure"));b.qg&&(c||J("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."),d=!0);if(d)a.Wc=[Yf];else{var e=a.Wc=[];cc(mg,function(a,b){b&&b.isAvailable()&&e.push(b)})}}function ng(a){if(0<a.Wc.length)return a.Wc[0];throw Error("No transports available");};function og(a,b,c,d,e,f,h){this.id=a;this.f=Tb("c:"+this.id+":");this.te=c;this.Lc=d;this.ia=e;this.se=f;this.L=b;this.Ad=[];this.Le=0;this.sf=new kg(b);this.Ua=0;this.Cb=h;this.f("Connection created");pg(this)}
	function pg(a){var b=ng(a.sf);a.I=new b("c:"+a.id+":"+a.Le++,a.L,void 0,a.Cb);a.xe=b.responsesRequiredToBeHealthy||0;var c=qg(a,a.I),d=rg(a,a.I);a.Xc=a.I;a.Rc=a.I;a.D=null;a.Bb=!1;setTimeout(function(){a.I&&a.I.open(c,d)},Math.floor(0));b=b.healthyTimeout||0;0<b&&(a.md=hc(function(){a.md=null;a.Bb||(a.I&&102400<a.I.pb?(a.f("Connection exceeded healthy timeout but has received "+a.I.pb+" bytes.  Marking connection healthy."),a.Bb=!0,a.I.sd()):a.I&&10240<a.I.qb?a.f("Connection exceeded healthy timeout but has sent "+
	a.I.qb+" bytes.  Leaving connection alive."):(a.f("Closing unhealthy connection after timeout."),a.close()))},Math.floor(b)))}function rg(a,b){return function(c){b===a.I?(a.I=null,c||0!==a.Ua?1===a.Ua&&a.f("Realtime connection lost."):(a.f("Realtime connection failed."),"s-"===a.L.$a.substr(0,2)&&(xb.remove("host:"+a.L.host),a.L.$a=a.L.host)),a.close()):b===a.D?(a.f("Secondary connection lost."),c=a.D,a.D=null,a.Xc!==c&&a.Rc!==c||a.close()):a.f("closing an old connection")}}
	function qg(a,b){return function(c){if(2!=a.Ua)if(b===a.Rc){var d=$b("t",c);c=$b("d",c);if("c"==d){if(d=$b("t",c),"d"in c)if(c=c.d,"h"===d){var d=c.ts,e=c.v,f=c.h;a.qf=c.s;Ab(a.L,f);0==a.Ua&&(a.I.start(),sg(a,a.I,d),"5"!==e&&J("Protocol version mismatch detected"),c=a.sf,(c=1<c.Wc.length?c.Wc[1]:null)&&tg(a,c))}else if("n"===d){a.f("recvd end transmission on primary");a.Rc=a.D;for(c=0;c<a.Ad.length;++c)a.wd(a.Ad[c]);a.Ad=[];ug(a)}else"s"===d?(a.f("Connection shutdown command received. Shutting down..."),
	a.se&&(a.se(c),a.se=null),a.ia=null,a.close()):"r"===d?(a.f("Reset packet received.  New host: "+c),Ab(a.L,c),1===a.Ua?a.close():(vg(a),pg(a))):"e"===d?Ub("Server Error: "+c):"o"===d?(a.f("got pong on primary."),wg(a),xg(a)):Ub("Unknown control packet command: "+d)}else"d"==d&&a.wd(c)}else if(b===a.D)if(d=$b("t",c),c=$b("d",c),"c"==d)"t"in c&&(c=c.t,"a"===c?yg(a):"r"===c?(a.f("Got a reset on secondary, closing it"),a.D.close(),a.Xc!==a.D&&a.Rc!==a.D||a.close()):"o"===c&&(a.f("got pong on secondary."),
	a.pf--,yg(a)));else if("d"==d)a.Ad.push(c);else throw Error("Unknown protocol layer: "+d);else a.f("message on old connection")}}og.prototype.ua=function(a){zg(this,{t:"d",d:a})};function ug(a){a.Xc===a.D&&a.Rc===a.D&&(a.f("cleaning up and promoting a connection: "+a.D.Zd),a.I=a.D,a.D=null)}
	function yg(a){0>=a.pf?(a.f("Secondary connection is healthy."),a.Bb=!0,a.D.sd(),a.D.start(),a.f("sending client ack on secondary"),a.D.send({t:"c",d:{t:"a",d:{}}}),a.f("Ending transmission on primary"),a.I.send({t:"c",d:{t:"n",d:{}}}),a.Xc=a.D,ug(a)):(a.f("sending ping on secondary."),a.D.send({t:"c",d:{t:"p",d:{}}}))}og.prototype.wd=function(a){wg(this);this.te(a)};function wg(a){a.Bb||(a.xe--,0>=a.xe&&(a.f("Primary connection is healthy."),a.Bb=!0,a.I.sd()))}
	function tg(a,b){a.D=new b("c:"+a.id+":"+a.Le++,a.L,a.qf);a.pf=b.responsesRequiredToBeHealthy||0;a.D.open(qg(a,a.D),rg(a,a.D));hc(function(){a.D&&(a.f("Timed out trying to upgrade."),a.D.close())},Math.floor(6E4))}function sg(a,b,c){a.f("Realtime connection established.");a.I=b;a.Ua=1;a.Lc&&(a.Lc(c,a.qf),a.Lc=null);0===a.xe?(a.f("Primary connection is healthy."),a.Bb=!0):hc(function(){xg(a)},Math.floor(5E3))}
	function xg(a){a.Bb||1!==a.Ua||(a.f("sending ping on primary."),zg(a,{t:"c",d:{t:"p",d:{}}}))}function zg(a,b){if(1!==a.Ua)throw"Connection is not connected";a.Xc.send(b)}og.prototype.close=function(){2!==this.Ua&&(this.f("Closing realtime connection."),this.Ua=2,vg(this),this.ia&&(this.ia(),this.ia=null))};function vg(a){a.f("Shutting down all connections");a.I&&(a.I.close(),a.I=null);a.D&&(a.D.close(),a.D=null);a.md&&(clearTimeout(a.md),a.md=null)};function Ag(a,b,c,d,e,f){this.id=Bg++;this.f=Tb("p:"+this.id+":");this.qd={};this.$={};this.pa=[];this.Oc=0;this.Kc=[];this.ma=!1;this.Sa=1E3;this.td=3E5;this.Gb=b;this.Jc=c;this.ue=d;this.L=a;this.ob=this.Fa=this.Cb=this.ze=null;this.$c=e;this.de=!1;this.ke=0;if(f)throw Error("Auth override specified in options, but not supported on non Node.js platforms");this.Vd=f;this.ub=null;this.Mb=!1;this.Gd={};this.ig=0;this.Re=!0;this.Ac=this.me=null;Cg(this,0);Mc.Vb().gc("visible",this.Zf,this);-1===a.host.indexOf("fblocal")&&
	Lc.Vb().gc("online",this.Yf,this)}var Bg=0,Dg=0;g=Ag.prototype;g.ua=function(a,b,c){var d=++this.ig;a={r:d,a:a,b:b};this.f(x(a));D(this.ma,"sendRequest call when we're not connected not allowed.");this.Fa.ua(a);c&&(this.Gd[d]=c)};
	g.$e=function(a,b,c,d){var e=a.ja(),f=a.path.toString();this.f("Listen called for "+f+" "+e);this.$[f]=this.$[f]||{};D(qf(a.m)||!T(a.m),"listen() called for non-default but complete query");D(!this.$[f][e],"listen() called twice for same path/queryId.");a={G:d,ld:b,eg:a,tag:c};this.$[f][e]=a;this.ma&&Eg(this,a)};
	function Eg(a,b){var c=b.eg,d=c.path.toString(),e=c.ja();a.f("Listen on "+d+" for "+e);var f={p:d};b.tag&&(f.q=pf(c.m),f.t=b.tag);f.h=b.ld();a.ua("q",f,function(f){var k=f.d,m=f.s;if(k&&"object"===typeof k&&eb(k,"w")){var l=w(k,"w");ea(l)&&0<=xa(l,"no_index")&&J("Using an unspecified index. Consider adding "+('".indexOn": "'+c.m.g.toString()+'"')+" at "+c.path.toString()+" to your security rules for better performance")}(a.$[d]&&a.$[d][e])===b&&(a.f("listen response",f),"ok"!==m&&Fg(a,d,e),b.G&&b.G(m,
	k))})}g.kf=function(a){this.ob=a;this.f("Auth token refreshed");this.ob?Gg(this):this.ma&&this.ua("unauth",{},function(){});if(a&&40===a.length||kc(a))this.f("Admin auth credential detected.  Reducing max reconnect time."),this.td=3E4};function Gg(a){if(a.ma&&a.ob){var b=a.ob,c=jc(b)?"auth":"gauth",d={cred:b};null===a.Vd?d.noauth=!0:"object"===typeof a.Vd&&(d.authvar=a.Vd);a.ua(c,d,function(c){var d=c.s;c=c.d||"error";a.ob===b&&("ok"===d?a.ke=0:Hg(a,d,c))})}}
	g.uf=function(a,b){var c=a.path.toString(),d=a.ja();this.f("Unlisten called for "+c+" "+d);D(qf(a.m)||!T(a.m),"unlisten() called for non-default but complete query");if(Fg(this,c,d)&&this.ma){var e=pf(a.m);this.f("Unlisten on "+c+" for "+d);c={p:c};b&&(c.q=e,c.t=b);this.ua("n",c)}};g.re=function(a,b,c){this.ma?Ig(this,"o",a,b,c):this.Kc.push({we:a,action:"o",data:b,G:c})};g.cf=function(a,b,c){this.ma?Ig(this,"om",a,b,c):this.Kc.push({we:a,action:"om",data:b,G:c})};
	g.xd=function(a,b){this.ma?Ig(this,"oc",a,null,b):this.Kc.push({we:a,action:"oc",data:null,G:b})};function Ig(a,b,c,d,e){c={p:c,d:d};a.f("onDisconnect "+b,c);a.ua(b,c,function(a){e&&setTimeout(function(){e(a.s,a.d)},Math.floor(0))})}g.put=function(a,b,c,d){Jg(this,"p",a,b,c,d)};g.af=function(a,b,c,d){Jg(this,"m",a,b,c,d)};function Jg(a,b,c,d,e,f){d={p:c,d:d};n(f)&&(d.h=f);a.pa.push({action:b,mf:d,G:e});a.Oc++;b=a.pa.length-1;a.ma?Kg(a,b):a.f("Buffering put: "+c)}
	function Kg(a,b){var c=a.pa[b].action,d=a.pa[b].mf,e=a.pa[b].G;a.pa[b].fg=a.ma;a.ua(c,d,function(d){a.f(c+" response",d);delete a.pa[b];a.Oc--;0===a.Oc&&(a.pa=[]);e&&e(d.s,d.d)})}g.ye=function(a){this.ma&&(a={c:a},this.f("reportStats",a),this.ua("s",a,function(a){"ok"!==a.s&&this.f("reportStats","Error sending stats: "+a.d)}))};
	g.wd=function(a){if("r"in a){this.f("from server: "+x(a));var b=a.r,c=this.Gd[b];c&&(delete this.Gd[b],c(a.b))}else{if("error"in a)throw"A server-side error has occurred: "+a.error;"a"in a&&(b=a.a,a=a.b,this.f("handleServerMessage",b,a),"d"===b?this.Gb(a.p,a.d,!1,a.t):"m"===b?this.Gb(a.p,a.d,!0,a.t):"c"===b?Lg(this,a.p,a.q):"ac"===b?Hg(this,a.s,a.d):"sd"===b?this.ze?this.ze(a):"msg"in a&&"undefined"!==typeof console&&console.log("FIREBASE: "+a.msg.replace("\n","\nFIREBASE: ")):Ub("Unrecognized action received from server: "+
	x(b)+"\nAre you using the latest client?"))}};g.Lc=function(a,b){this.f("connection ready");this.ma=!0;this.Ac=(new Date).getTime();this.ue({serverTimeOffset:a-(new Date).getTime()});this.Cb=b;if(this.Re){var c={};c["sdk.js."+firebase.SDK_VERSION.replace(/\./g,"-")]=1;pb()?c["framework.cordova"]=1:"object"===typeof navigator&&"ReactNative"===navigator.product&&(c["framework.reactnative"]=1);this.ye(c)}Mg(this);this.Re=!1;this.Jc(!0)};
	function Cg(a,b){D(!a.Fa,"Scheduling a connect when we're already connected/ing?");a.ub&&clearTimeout(a.ub);a.ub=setTimeout(function(){a.ub=null;Ng(a)},Math.floor(b))}g.Zf=function(a){a&&!this.Mb&&this.Sa===this.td&&(this.f("Window became visible.  Reducing delay."),this.Sa=1E3,this.Fa||Cg(this,0));this.Mb=a};g.Yf=function(a){a?(this.f("Browser went online."),this.Sa=1E3,this.Fa||Cg(this,0)):(this.f("Browser went offline.  Killing connection."),this.Fa&&this.Fa.close())};
	g.df=function(){this.f("data client disconnected");this.ma=!1;this.Fa=null;for(var a=0;a<this.pa.length;a++){var b=this.pa[a];b&&"h"in b.mf&&b.fg&&(b.G&&b.G("disconnect"),delete this.pa[a],this.Oc--)}0===this.Oc&&(this.pa=[]);this.Gd={};Og(this)&&(this.Mb?this.Ac&&(3E4<(new Date).getTime()-this.Ac&&(this.Sa=1E3),this.Ac=null):(this.f("Window isn't visible.  Delaying reconnect."),this.Sa=this.td,this.me=(new Date).getTime()),a=Math.max(0,this.Sa-((new Date).getTime()-this.me)),a*=Math.random(),this.f("Trying to reconnect in "+
	a+"ms"),Cg(this,a),this.Sa=Math.min(this.td,1.3*this.Sa));this.Jc(!1)};
	function Ng(a){if(Og(a)){a.f("Making a connection attempt");a.me=(new Date).getTime();a.Ac=null;var b=q(a.wd,a),c=q(a.Lc,a),d=q(a.df,a),e=a.id+":"+Dg++,f=a.Cb,h=!1,k=null,m=function(){k?k.close():(h=!0,d())};a.Fa={close:m,ua:function(a){D(k,"sendRequest call when we're not connected not allowed.");k.ua(a)}};var l=a.de;a.de=!1;a.$c.getToken(l).then(function(l){h?I("getToken() completed but was canceled"):(I("getToken() completed. Creating connection."),a.ob=l&&l.accessToken,k=new og(e,a.L,b,c,d,function(b){J(b+
	" ("+a.L.toString()+")");a.ab("server_kill")},f))}).then(null,function(b){a.f("Failed to get token: "+b);h||m()})}}g.ab=function(a){I("Interrupting connection for reason: "+a);this.qd[a]=!0;this.Fa?this.Fa.close():(this.ub&&(clearTimeout(this.ub),this.ub=null),this.ma&&this.df())};g.kc=function(a){I("Resuming connection for reason: "+a);delete this.qd[a];Sa(this.qd)&&(this.Sa=1E3,this.Fa||Cg(this,0))};
	function Lg(a,b,c){c=c?Aa(c,function(a){return ac(a)}).join("$"):"default";(a=Fg(a,b,c))&&a.G&&a.G("permission_denied")}function Fg(a,b,c){b=(new E(b)).toString();var d;n(a.$[b])?(d=a.$[b][c],delete a.$[b][c],0===La(a.$[b])&&delete a.$[b]):d=void 0;return d}
	function Hg(a,b,c){I("Auth token revoked: "+b+"/"+c);a.ob=null;a.de=!0;a.Fa.close();if("invalid_token"===b||"permission_denied"===b)a.ke++,3<=a.ke&&(a.Sa=3E4,a=a.$c,b='Provided authentication credentials for the app named "'+a.oc.name+'" are invalid. This usually indicates your app was not initialized correctly. ',b="credential"in a.oc.options?b+'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':"serviceAccount"in
	a.oc.options?b+'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':b+'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.',J(b))}
	function Mg(a){Gg(a);v(a.$,function(b){v(b,function(b){Eg(a,b)})});for(var b=0;b<a.pa.length;b++)a.pa[b]&&Kg(a,b);for(;a.Kc.length;)b=a.Kc.shift(),Ig(a,b.action,b.we,b.data,b.G)}function Og(a){var b;b=Lc.Vb().hc;return Sa(a.qd)&&b};function Pg(a){a instanceof Qg||Vb("Don't call new Database() directly - please use firebase.database().");this.ta=a;this.ba=new U(a,Q);this.INTERNAL=new Rg(this)}var Sg={TIMESTAMP:{".sv":"timestamp"}};g=Pg.prototype;g.app=null;g.jf=function(a){Tg(this,"ref");y("database.ref",0,1,arguments.length);return n(a)?this.ba.n(a):this.ba};
	g.gg=function(a){Tg(this,"database.refFromURL");y("database.refFromURL",1,1,arguments.length);var b=Wb(a);Xd("database.refFromURL",b);var c=b.jc;c.host!==this.ta.L.host&&Vb("database.refFromURL: Host name does not match the current database: (found "+c.host+" but expected "+this.ta.L.host+")");return this.jf(b.path.toString())};function Tg(a,b){null===a.ta&&Vb("Cannot call "+b+" on a deleted database.")}g.Pf=function(){y("database.goOffline",0,0,arguments.length);Tg(this,"goOffline");this.ta.ab()};
	g.Qf=function(){y("database.goOnline",0,0,arguments.length);Tg(this,"goOnline");this.ta.kc()};Object.defineProperty(Pg.prototype,"app",{get:function(){return this.ta.app}});function Rg(a){this.Ya=a}Rg.prototype.delete=function(){Tg(this.Ya,"delete");var a=Ug.Vb(),b=this.Ya.ta;w(a.lb,b.app.name)!==b&&Vb("Database "+b.app.name+" has already been deleted.");b.ab();delete a.lb[b.app.name];this.Ya.ta=null;this.Ya.ba=null;this.Ya=this.Ya.INTERNAL=null;return firebase.Promise.resolve()};
	Pg.prototype.ref=Pg.prototype.jf;Pg.prototype.refFromURL=Pg.prototype.gg;Pg.prototype.goOnline=Pg.prototype.Qf;Pg.prototype.goOffline=Pg.prototype.Pf;Rg.prototype["delete"]=Rg.prototype.delete;function V(a,b,c){this.A=a;this.V=b;this.g=c}V.prototype.H=function(){y("Firebase.DataSnapshot.val",0,0,arguments.length);return this.A.H()};V.prototype.val=V.prototype.H;V.prototype.be=function(){y("Firebase.DataSnapshot.exportVal",0,0,arguments.length);return this.A.H(!0)};V.prototype.exportVal=V.prototype.be;V.prototype.toJSON=function(){y("Firebase.DataSnapshot.toJSON",0,1,arguments.length);return this.be()};V.prototype.toJSON=V.prototype.toJSON;
	V.prototype.Lf=function(){y("Firebase.DataSnapshot.exists",0,0,arguments.length);return!this.A.e()};V.prototype.exists=V.prototype.Lf;V.prototype.n=function(a){y("Firebase.DataSnapshot.child",0,1,arguments.length);ga(a)&&(a=String(a));Vd("Firebase.DataSnapshot.child",a);var b=new E(a),c=this.V.n(b);return new V(this.A.P(b),c,H)};V.prototype.child=V.prototype.n;
	V.prototype.Da=function(a){y("Firebase.DataSnapshot.hasChild",1,1,arguments.length);Vd("Firebase.DataSnapshot.hasChild",a);var b=new E(a);return!this.A.P(b).e()};V.prototype.hasChild=V.prototype.Da;V.prototype.C=function(){y("Firebase.DataSnapshot.getPriority",0,0,arguments.length);return this.A.C().H()};V.prototype.getPriority=V.prototype.C;
	V.prototype.forEach=function(a){y("Firebase.DataSnapshot.forEach",1,1,arguments.length);B("Firebase.DataSnapshot.forEach",1,a,!1);if(this.A.J())return!1;var b=this;return!!this.A.O(this.g,function(c,d){return a(new V(d,b.V.n(c),H))})};V.prototype.forEach=V.prototype.forEach;V.prototype.kd=function(){y("Firebase.DataSnapshot.hasChildren",0,0,arguments.length);return this.A.J()?!1:!this.A.e()};V.prototype.hasChildren=V.prototype.kd;
	V.prototype.getKey=function(){y("Firebase.DataSnapshot.key",0,0,arguments.length);return this.V.getKey()};gc(V.prototype,"key",V.prototype.getKey);V.prototype.Eb=function(){y("Firebase.DataSnapshot.numChildren",0,0,arguments.length);return this.A.Eb()};V.prototype.numChildren=V.prototype.Eb;V.prototype.wb=function(){y("Firebase.DataSnapshot.ref",0,0,arguments.length);return this.V};gc(V.prototype,"ref",V.prototype.wb);function Vg(a,b,c){this.Pb=a;this.rb=b;this.tb=c||null}g=Vg.prototype;g.nf=function(a){return"value"===a};g.createEvent=function(a,b){var c=b.m.g;return new We("value",this,new V(a.Ja,b.wb(),c))};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.Pb;return function(){d.call(b,a.Md)}};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
	g.matches=function(a){return a instanceof Vg?a.Pb&&this.Pb?a.Pb===this.Pb&&a.tb===this.tb:!0:!1};g.Xe=function(){return null!==this.Pb};function Wg(a,b,c){this.ga=a;this.rb=b;this.tb=c}g=Wg.prototype;g.nf=function(a){a="children_added"===a?"child_added":a;return("children_removed"===a?"child_removed":a)in this.ga};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
	g.createEvent=function(a,b){D(null!=a.Xa,"Child events should have a childName.");var c=b.wb().n(a.Xa);return new We(a.type,this,new V(a.Ja,c,b.m.g),a.Dd)};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.ga[a.hd];return function(){d.call(b,a.Md,a.Dd)}};
	g.matches=function(a){if(a instanceof Wg){if(!this.ga||!a.ga)return!0;if(this.tb===a.tb){var b=La(a.ga);if(b===La(this.ga)){if(1===b){var b=Ma(a.ga),c=Ma(this.ga);return c===b&&(!a.ga[b]||!this.ga[c]||a.ga[b]===this.ga[c])}return Ka(this.ga,function(b,c){return a.ga[c]===b})}}}return!1};g.Xe=function(){return null!==this.ga};function Xg(){this.za={}}g=Xg.prototype;g.e=function(){return Sa(this.za)};g.eb=function(a,b,c){var d=a.source.Hb;if(null!==d)return d=w(this.za,d),D(null!=d,"SyncTree gave us an op for an invalid query."),d.eb(a,b,c);var e=[];v(this.za,function(d){e=e.concat(d.eb(a,b,c))});return e};g.Nb=function(a,b,c,d,e){var f=a.ja(),h=w(this.za,f);if(!h){var h=c.Aa(e?d:null),k=!1;h?k=!0:(h=d instanceof O?c.rc(d):L,k=!1);h=new Pe(a,new oe(new je(h,k,!1),new je(d,e,!1)));this.za[f]=h}h.Nb(b);return Ve(h,b)};
	g.kb=function(a,b,c){var d=a.ja(),e=[],f=[],h=null!=Yg(this);if("default"===d){var k=this;v(this.za,function(a,d){f=f.concat(a.kb(b,c));a.e()&&(delete k.za[d],T(a.V.m)||e.push(a.V))})}else{var m=w(this.za,d);m&&(f=f.concat(m.kb(b,c)),m.e()&&(delete this.za[d],T(m.V.m)||e.push(m.V)))}h&&null==Yg(this)&&e.push(new U(a.u,a.path));return{hg:e,Kf:f}};function Zg(a){return za(Na(a.za),function(a){return!T(a.V.m)})}g.hb=function(a){var b=null;v(this.za,function(c){b=b||c.hb(a)});return b};
	function $g(a,b){if(T(b.m))return Yg(a);var c=b.ja();return w(a.za,c)}function Yg(a){return Ra(a.za,function(a){return T(a.V.m)})||null};function ah(a){this.wa=R;this.jb=new Df;this.De={};this.ic={};this.Cc=a}function bh(a,b,c,d,e){var f=a.jb,h=e;D(d>f.Bc,"Stacking an older write on top of newer ones");n(h)||(h=!0);f.la.push({path:b,Ga:c,Zc:d,visible:h});h&&(f.S=uf(f.S,b,c));f.Bc=d;return e?ch(a,new ce(fe,b,c)):[]}function dh(a,b,c,d){var e=a.jb;D(d>e.Bc,"Stacking an older merge on top of newer ones");e.la.push({path:b,children:c,Zc:d,visible:!0});e.S=vf(e.S,b,c);e.Bc=d;c=xd(c);return ch(a,new ae(fe,b,c))}
	function eh(a,b,c){c=c||!1;var d=Ef(a.jb,b);if(a.jb.Ed(b)){var e=R;null!=d.Ga?e=e.set(Q,!0):fb(d.children,function(a,b){e=e.set(new E(a),b)});return ch(a,new de(d.path,e,c))}return[]}function fh(a,b,c){c=xd(c);return ch(a,new ae(ie,b,c))}function gh(a,b,c,d){d=hh(a,d);if(null!=d){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=new ce(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
	function kh(a,b,c,d){if(d=hh(a,d)){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=xd(c);c=new ae(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
	ah.prototype.Nb=function(a,b){var c=a.path,d=null,e=!1;Fd(this.wa,c,function(a,b){var f=P(a,c);d=d||b.hb(f);e=e||null!=Yg(b)});var f=this.wa.get(c);f?(e=e||null!=Yg(f),d=d||f.hb(Q)):(f=new Xg,this.wa=this.wa.set(c,f));var h;null!=d?h=!0:(h=!1,d=L,Jd(this.wa.subtree(c),function(a,b){var c=b.hb(Q);c&&(d=d.T(a,c))}));var k=null!=$g(f,a);if(!k&&!T(a.m)){var m=lh(a);D(!(m in this.ic),"View does not exist, but we have a tag");var l=mh++;this.ic[m]=l;this.De["_"+l]=m}h=f.Nb(a,b,new If(c,this.jb),d,h);k||
	e||(f=$g(f,a),h=h.concat(nh(this,a,f)));return h};
	ah.prototype.kb=function(a,b,c){var d=a.path,e=this.wa.get(d),f=[];if(e&&("default"===a.ja()||null!=$g(e,a))){f=e.kb(a,b,c);e.e()&&(this.wa=this.wa.remove(d));e=f.hg;f=f.Kf;b=-1!==Ea(e,function(a){return T(a.m)});var h=Dd(this.wa,d,function(a,b){return null!=Yg(b)});if(b&&!h&&(d=this.wa.subtree(d),!d.e()))for(var d=oh(d),k=0;k<d.length;++k){var m=d[k],l=m.V,m=ph(this,m);this.Cc.Ae(qh(l),rh(this,l),m.ld,m.G)}if(!h&&0<e.length&&!c)if(b)this.Cc.Od(qh(a),null);else{var u=this;ya(e,function(a){a.ja();
	var b=u.ic[lh(a)];u.Cc.Od(qh(a),b)})}sh(this,e)}return f};ah.prototype.Aa=function(a,b){var c=this.jb,d=Dd(this.wa,a,function(b,c){var d=P(b,a);if(d=c.hb(d))return d});return c.Aa(a,d,b,!0)};function oh(a){return Bd(a,function(a,c,d){if(c&&null!=Yg(c))return[Yg(c)];var e=[];c&&(e=Zg(c));v(d,function(a){e=e.concat(a)});return e})}function sh(a,b){for(var c=0;c<b.length;++c){var d=b[c];if(!T(d.m)){var d=lh(d),e=a.ic[d];delete a.ic[d];delete a.De["_"+e]}}}
	function qh(a){return T(a.m)&&!qf(a.m)?a.wb():a}function nh(a,b,c){var d=b.path,e=rh(a,b);c=ph(a,c);b=a.Cc.Ae(qh(b),e,c.ld,c.G);d=a.wa.subtree(d);if(e)D(null==Yg(d.value),"If we're adding a query, it shouldn't be shadowed");else for(e=Bd(d,function(a,b,c){if(!a.e()&&b&&null!=Yg(b))return[Te(Yg(b))];var d=[];b&&(d=d.concat(Aa(Zg(b),function(a){return a.V})));v(c,function(a){d=d.concat(a)});return d}),d=0;d<e.length;++d)c=e[d],a.Cc.Od(qh(c),rh(a,c));return b}
	function ph(a,b){var c=b.V,d=rh(a,c);return{ld:function(){return(b.w()||L).hash()},G:function(b){if("ok"===b){if(d){var f=c.path;if(b=hh(a,d)){var h=ih(b);b=h.path;h=h.Hb;f=P(b,f);f=new Zd(new he(!1,!0,h,!0),f);b=jh(a,b,f)}else b=[]}else b=ch(a,new Zd(ie,c.path));return b}f="Unknown Error";"too_big"===b?f="The data requested exceeds the maximum size that can be accessed with a single request.":"permission_denied"==b?f="Client doesn't have permission to access the desired data.":"unavailable"==b&&
	(f="The service is unavailable");f=Error(b+" at "+c.path.toString()+": "+f);f.code=b.toUpperCase();return a.kb(c,null,f)}}}function lh(a){return a.path.toString()+"$"+a.ja()}function ih(a){var b=a.indexOf("$");D(-1!==b&&b<a.length-1,"Bad queryKey.");return{Hb:a.substr(b+1),path:new E(a.substr(0,b))}}function hh(a,b){var c=a.De,d="_"+b;return d in c?c[d]:void 0}function rh(a,b){var c=lh(b);return w(a.ic,c)}var mh=1;
	function jh(a,b,c){var d=a.wa.get(b);D(d,"Missing sync point for query tag that we're tracking");return d.eb(c,new If(b,a.jb),null)}function ch(a,b){return th(a,b,a.wa,null,new If(Q,a.jb))}function th(a,b,c,d,e){if(b.path.e())return uh(a,b,c,d,e);var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[],k=K(b.path),m=b.Mc(k);if((c=c.children.get(k))&&m)var l=d?d.Q(k):null,k=e.n(k),h=h.concat(th(a,m,c,l,k));f&&(h=h.concat(f.eb(b,e,d)));return h}
	function uh(a,b,c,d,e){var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[];c.children.ha(function(c,f){var l=d?d.Q(c):null,u=e.n(c),z=b.Mc(c);z&&(h=h.concat(uh(a,z,f,l,u)))});f&&(h=h.concat(f.eb(b,e,d)));return h};function Qg(a,b,c){this.app=c;var d=new Bf(c);this.L=a;this.Va=Pf(a);this.Vc=null;this.ca=new Ye;this.vd=1;this.Ra=null;if(b||0<=("object"===typeof window&&window.navigator&&window.navigator.userAgent||"").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i))this.va=new Rf(this.L,q(this.Gb,this),d),setTimeout(q(this.Jc,this,!0),0);else{b=c.options.databaseAuthVariableOverride;if("undefined"!==da(b)&&null!==b){if("object"!==da(b))throw Error("Only objects are supported for option databaseAuthVariableOverride");
	try{x(b)}catch(e){throw Error("Invalid authOverride provided: "+e);}}this.va=this.Ra=new Ag(this.L,q(this.Gb,this),q(this.Jc,this),q(this.ue,this),d,b)}var f=this;Cf(d,function(a){f.va.kf(a)});this.og=Qf(a,q(function(){return new Jf(this.Va,this.va)},this));this.mc=new Tc;this.ie=new Af;this.pd=new ah({Ae:function(a,b,c,d){b=[];c=f.ie.j(a.path);c.e()||(b=ch(f.pd,new ce(ie,a.path,c)),setTimeout(function(){d("ok")},0));return b},Od:ba});vh(this,"connected",!1);this.ia=new Gb;this.Ya=new Pg(this);this.fd=
	0;this.je=null;this.K=new ah({Ae:function(a,b,c,d){f.va.$e(a,c,b,function(b,c){var e=d(b,c);cf(f.ca,a.path,e)});return[]},Od:function(a,b){f.va.uf(a,b)}})}g=Qg.prototype;g.toString=function(){return(this.L.Sc?"https://":"http://")+this.L.host};g.name=function(){return this.L.pe};function wh(a){a=a.ie.j(new E(".info/serverTimeOffset")).H()||0;return(new Date).getTime()+a}function xh(a){a=a={timestamp:wh(a)};a.timestamp=a.timestamp||(new Date).getTime();return a}
	g.Gb=function(a,b,c,d){this.fd++;var e=new E(a);b=this.je?this.je(a,b):b;a=[];d?c?(b=Ja(b,function(a){return G(a)}),a=kh(this.K,e,b,d)):(b=G(b),a=gh(this.K,e,b,d)):c?(d=Ja(b,function(a){return G(a)}),a=fh(this.K,e,d)):(d=G(b),a=ch(this.K,new ce(ie,e,d)));d=e;0<a.length&&(d=yh(this,e));cf(this.ca,d,a)};g.Jc=function(a){vh(this,"connected",a);!1===a&&zh(this)};g.ue=function(a){var b=this;cc(a,function(a,d){vh(b,d,a)})};
	function vh(a,b,c){b=new E("/.info/"+b);c=G(c);var d=a.ie;d.Jd=d.Jd.F(b,c);c=ch(a.pd,new ce(ie,b,c));cf(a.ca,b,c)}g.Jb=function(a,b,c,d){this.f("set",{path:a.toString(),value:b,ug:c});var e=xh(this);b=G(b,c);var e=Jb(b,e),f=this.vd++,e=bh(this.K,a,e,f,!0);Ze(this.ca,e);var h=this;this.va.put(a.toString(),b.H(!0),function(b,c){var e="ok"===b;e||J("set at "+a+" failed: "+b);e=eh(h.K,f,!e);cf(h.ca,a,e);Ah(d,b,c)});e=Bh(this,a);yh(this,e);cf(this.ca,e,[])};
	g.update=function(a,b,c){this.f("update",{path:a.toString(),value:b});var d=!0,e=xh(this),f={};v(b,function(a,b){d=!1;var c=G(a);f[b]=Jb(c,e)});if(d)I("update() called with empty data.  Don't do anything."),Ah(c,"ok");else{var h=this.vd++,k=dh(this.K,a,f,h);Ze(this.ca,k);var m=this;this.va.af(a.toString(),b,function(b,d){var e="ok"===b;e||J("update at "+a+" failed: "+b);var e=eh(m.K,h,!e),f=a;0<e.length&&(f=yh(m,a));cf(m.ca,f,e);Ah(c,b,d)});v(b,function(b,c){var d=Bh(m,a.n(c));yh(m,d)});cf(this.ca,
	a,[])}};function zh(a){a.f("onDisconnectEvents");var b=xh(a),c=[];Hb(Fb(a.ia,b),Q,function(b,e){c=c.concat(ch(a.K,new ce(ie,b,e)));var f=Bh(a,b);yh(a,f)});a.ia=new Gb;cf(a.ca,Q,c)}g.xd=function(a,b){var c=this;this.va.xd(a.toString(),function(d,e){"ok"===d&&Yd(c.ia,a);Ah(b,d,e)})};function Ch(a,b,c,d){var e=G(c);a.va.re(b.toString(),e.H(!0),function(c,h){"ok"===c&&Ib(a.ia,b,e);Ah(d,c,h)})}
	function Dh(a,b,c,d,e){var f=G(c,d);a.va.re(b.toString(),f.H(!0),function(c,d){"ok"===c&&Ib(a.ia,b,f);Ah(e,c,d)})}function Eh(a,b,c,d){var e=!0,f;for(f in c)e=!1;e?(I("onDisconnect().update() called with empty data.  Don't do anything."),Ah(d,"ok")):a.va.cf(b.toString(),c,function(e,f){if("ok"===e)for(var m in c){var l=G(c[m]);Ib(a.ia,b.n(m),l)}Ah(d,e,f)})}function Fh(a,b,c){c=".info"===K(b.path)?a.pd.Nb(b,c):a.K.Nb(b,c);af(a.ca,b.path,c)}g.ab=function(){this.Ra&&this.Ra.ab("repo_interrupt")};
	g.kc=function(){this.Ra&&this.Ra.kc("repo_interrupt")};g.Be=function(a){if("undefined"!==typeof console){a?(this.Vc||(this.Vc=new Kf(this.Va)),a=this.Vc.get()):a=this.Va.get();var b=Ba(Oa(a),function(a,b){return Math.max(b.length,a)},0),c;for(c in a){for(var d=a[c],e=c.length;e<b+2;e++)c+=" ";console.log(c+d)}}};g.Ce=function(a){Mf(this.Va,a);this.og.rf[a]=!0};g.f=function(a){var b="";this.Ra&&(b=this.Ra.id+":");I(b,arguments)};
	function Ah(a,b,c){a&&fc(function(){if("ok"==b)a(null);else{var d=(b||"error").toUpperCase(),e=d;c&&(e+=": "+c);e=Error(e);e.code=d;a(e)}})};function Gh(a,b,c,d,e){function f(){}a.f("transaction on "+b);var h=new U(a,b);h.gc("value",f);c={path:b,update:c,G:d,status:null,ef:Lb(),He:e,of:0,Rd:function(){h.Ic("value",f)},Td:null,Ba:null,cd:null,dd:null,ed:null};d=a.K.Aa(b,void 0)||L;c.cd=d;d=c.update(d.H());if(n(d)){Pd("transaction failed: Data returned ",d,c.path);c.status=1;e=Uc(a.mc,b);var k=e.Ca()||[];k.push(c);Vc(e,k);"object"===typeof d&&null!==d&&eb(d,".priority")?(k=w(d,".priority"),D(Nd(k),"Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.")):
	k=(a.K.Aa(b)||L).C().H();e=xh(a);d=G(d,k);e=Jb(d,e);c.dd=d;c.ed=e;c.Ba=a.vd++;c=bh(a.K,b,e,c.Ba,c.He);cf(a.ca,b,c);Hh(a)}else c.Rd(),c.dd=null,c.ed=null,c.G&&(a=new V(c.cd,new U(a,c.path),H),c.G(null,!1,a))}function Hh(a,b){var c=b||a.mc;b||Ih(a,c);if(null!==c.Ca()){var d=Jh(a,c);D(0<d.length,"Sending zero length transaction queue");Ca(d,function(a){return 1===a.status})&&Kh(a,c.path(),d)}else c.kd()&&c.O(function(b){Hh(a,b)})}
	function Kh(a,b,c){for(var d=Aa(c,function(a){return a.Ba}),e=a.K.Aa(b,d)||L,d=e,e=e.hash(),f=0;f<c.length;f++){var h=c[f];D(1===h.status,"tryToSendTransactionQueue_: items in queue should all be run.");h.status=2;h.of++;var k=P(b,h.path),d=d.F(k,h.dd)}d=d.H(!0);a.va.put(b.toString(),d,function(d){a.f("transaction put response",{path:b.toString(),status:d});var e=[];if("ok"===d){d=[];for(f=0;f<c.length;f++){c[f].status=3;e=e.concat(eh(a.K,c[f].Ba));if(c[f].G){var h=c[f].ed,k=new U(a,c[f].path);d.push(q(c[f].G,
	null,null,!0,new V(h,k,H)))}c[f].Rd()}Ih(a,Uc(a.mc,b));Hh(a);cf(a.ca,b,e);for(f=0;f<d.length;f++)fc(d[f])}else{if("datastale"===d)for(f=0;f<c.length;f++)c[f].status=4===c[f].status?5:1;else for(J("transaction at "+b.toString()+" failed: "+d),f=0;f<c.length;f++)c[f].status=5,c[f].Td=d;yh(a,b)}},e)}function yh(a,b){var c=Lh(a,b),d=c.path(),c=Jh(a,c);Mh(a,c,d);return d}
	function Mh(a,b,c){if(0!==b.length){for(var d=[],e=[],f=za(b,function(a){return 1===a.status}),f=Aa(f,function(a){return a.Ba}),h=0;h<b.length;h++){var k=b[h],m=P(c,k.path),l=!1,u;D(null!==m,"rerunTransactionsUnderNode_: relativePath should not be null.");if(5===k.status)l=!0,u=k.Td,e=e.concat(eh(a.K,k.Ba,!0));else if(1===k.status)if(25<=k.of)l=!0,u="maxretry",e=e.concat(eh(a.K,k.Ba,!0));else{var z=a.K.Aa(k.path,f)||L;k.cd=z;var F=b[h].update(z.H());n(F)?(Pd("transaction failed: Data returned ",F,
	k.path),m=G(F),"object"===typeof F&&null!=F&&eb(F,".priority")||(m=m.fa(z.C())),z=k.Ba,F=xh(a),F=Jb(m,F),k.dd=m,k.ed=F,k.Ba=a.vd++,Fa(f,z),e=e.concat(bh(a.K,k.path,F,k.Ba,k.He)),e=e.concat(eh(a.K,z,!0))):(l=!0,u="nodata",e=e.concat(eh(a.K,k.Ba,!0)))}cf(a.ca,c,e);e=[];l&&(b[h].status=3,setTimeout(b[h].Rd,Math.floor(0)),b[h].G&&("nodata"===u?(k=new U(a,b[h].path),d.push(q(b[h].G,null,null,!1,new V(b[h].cd,k,H)))):d.push(q(b[h].G,null,Error(u),!1,null))))}Ih(a,a.mc);for(h=0;h<d.length;h++)fc(d[h]);Hh(a)}}
	function Lh(a,b){for(var c,d=a.mc;null!==(c=K(b))&&null===d.Ca();)d=Uc(d,c),b=N(b);return d}function Jh(a,b){var c=[];Nh(a,b,c);c.sort(function(a,b){return a.ef-b.ef});return c}function Nh(a,b,c){var d=b.Ca();if(null!==d)for(var e=0;e<d.length;e++)c.push(d[e]);b.O(function(b){Nh(a,b,c)})}function Ih(a,b){var c=b.Ca();if(c){for(var d=0,e=0;e<c.length;e++)3!==c[e].status&&(c[d]=c[e],d++);c.length=d;Vc(b,0<c.length?c:null)}b.O(function(b){Ih(a,b)})}
	function Bh(a,b){var c=Lh(a,b).path(),d=Uc(a.mc,b);Yc(d,function(b){Oh(a,b)});Oh(a,d);Xc(d,function(b){Oh(a,b)});return c}
	function Oh(a,b){var c=b.Ca();if(null!==c){for(var d=[],e=[],f=-1,h=0;h<c.length;h++)4!==c[h].status&&(2===c[h].status?(D(f===h-1,"All SENT items should be at beginning of queue."),f=h,c[h].status=4,c[h].Td="set"):(D(1===c[h].status,"Unexpected transaction status in abort"),c[h].Rd(),e=e.concat(eh(a.K,c[h].Ba,!0)),c[h].G&&d.push(q(c[h].G,null,Error("set"),!1,null))));-1===f?Vc(b,null):c.length=f+1;cf(a.ca,b.path(),e);for(h=0;h<d.length;h++)fc(d[h])}};function Ug(){this.lb={};this.wf=!1}Ug.prototype.ab=function(){for(var a in this.lb)this.lb[a].ab()};Ug.prototype.kc=function(){for(var a in this.lb)this.lb[a].kc()};Ug.prototype.ce=function(a){this.wf=a};ca(Ug);Ug.prototype.interrupt=Ug.prototype.ab;Ug.prototype.resume=Ug.prototype.kc;var W={};W.nc=Ag;W.DataConnection=W.nc;Ag.prototype.ng=function(a,b){this.ua("q",{p:a},b)};W.nc.prototype.simpleListen=W.nc.prototype.ng;Ag.prototype.Hf=function(a,b){this.ua("echo",{d:a},b)};W.nc.prototype.echo=W.nc.prototype.Hf;Ag.prototype.interrupt=Ag.prototype.ab;W.zf=og;W.RealTimeConnection=W.zf;og.prototype.sendRequest=og.prototype.ua;og.prototype.close=og.prototype.close;
	W.Rf=function(a){var b=Ag.prototype.put;Ag.prototype.put=function(c,d,e,f){n(f)&&(f=a());b.call(this,c,d,e,f)};return function(){Ag.prototype.put=b}};W.hijackHash=W.Rf;W.yf=zb;W.ConnectionTarget=W.yf;W.ja=function(a){return a.ja()};W.queryIdentifier=W.ja;W.Uf=function(a){return a.u.Ra.$};W.listens=W.Uf;W.ce=function(a){Ug.Vb().ce(a)};W.forceRestClient=W.ce;W.Context=Ug;function Ph(a,b){this.committed=a;this.snapshot=b};function X(a,b,c,d){this.u=a;this.path=b;this.m=c;this.Nc=d}
	function Qh(a){var b=null,c=null;a.ka&&(b=ff(a));a.na&&(c=hf(a));if(a.g===tc){if(a.ka){if("[MIN_NAME]"!=ef(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==typeof b)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}if(a.na){if("[MAX_NAME]"!=gf(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==
	typeof c)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}}else if(a.g===H){if(null!=b&&!Nd(b)||null!=c&&!Nd(c))throw Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");}else if(D(a.g instanceof pc||a.g===wc,"unknown index type."),null!=b&&"object"===typeof b||null!=c&&"object"===typeof c)throw Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
	}function Rh(a){if(a.ka&&a.na&&a.xa&&(!a.xa||""===a.mb))throw Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");}function Sh(a,b){if(!0===a.Nc)throw Error(b+": You can't combine multiple orderBy calls.");}g=X.prototype;g.wb=function(){y("Query.ref",0,0,arguments.length);return new U(this.u,this.path)};
	g.gc=function(a,b,c,d){y("Query.on",2,4,arguments.length);Td("Query.on",a,!1);B("Query.on",2,b,!1);var e=Th("Query.on",c,d);if("value"===a)Fh(this.u,this,new Vg(b,e.cancel||null,e.Ma||null));else{var f={};f[a]=b;Fh(this.u,this,new Wg(f,e.cancel,e.Ma))}return b};
	g.Ic=function(a,b,c){y("Query.off",0,3,arguments.length);Td("Query.off",a,!0);B("Query.off",2,b,!0);ob("Query.off",3,c);var d=null,e=null;"value"===a?d=new Vg(b||null,null,c||null):a&&(b&&(e={},e[a]=b),d=new Wg(e,null,c||null));e=this.u;d=".info"===K(this.path)?e.pd.kb(this,d):e.K.kb(this,d);af(e.ca,this.path,d)};
	g.$f=function(a,b){function c(k){f&&(f=!1,e.Ic(a,c),b&&b.call(d.Ma,k),h.resolve(k))}y("Query.once",1,4,arguments.length);Td("Query.once",a,!1);B("Query.once",2,b,!0);var d=Th("Query.once",arguments[2],arguments[3]),e=this,f=!0,h=new ib;kb(h.ra);this.gc(a,c,function(b){e.Ic(a,c);d.cancel&&d.cancel.call(d.Ma,b);h.reject(b)});return h.ra};
	g.ne=function(a){y("Query.limitToFirst",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToFirst: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.ne(a),this.Nc)};
	g.oe=function(a){y("Query.limitToLast",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToLast: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.oe(a),this.Nc)};
	g.ag=function(a){y("Query.orderByChild",1,1,arguments.length);if("$key"===a)throw Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');if("$priority"===a)throw Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');if("$value"===a)throw Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');Vd("Query.orderByChild",a);Sh(this,"Query.orderByChild");var b=new E(a);if(b.e())throw Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
	b=new pc(b);b=of(this.m,b);Qh(b);return new X(this.u,this.path,b,!0)};g.bg=function(){y("Query.orderByKey",0,0,arguments.length);Sh(this,"Query.orderByKey");var a=of(this.m,tc);Qh(a);return new X(this.u,this.path,a,!0)};g.cg=function(){y("Query.orderByPriority",0,0,arguments.length);Sh(this,"Query.orderByPriority");var a=of(this.m,H);Qh(a);return new X(this.u,this.path,a,!0)};
	g.dg=function(){y("Query.orderByValue",0,0,arguments.length);Sh(this,"Query.orderByValue");var a=of(this.m,wc);Qh(a);return new X(this.u,this.path,a,!0)};g.Nd=function(a,b){y("Query.startAt",0,2,arguments.length);Od("Query.startAt",a,this.path,!0);Ud("Query.startAt",b);var c=this.m.Nd(a,b);Rh(c);Qh(c);if(this.m.ka)throw Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");n(a)||(b=a=null);return new X(this.u,this.path,c,this.Nc)};
	g.gd=function(a,b){y("Query.endAt",0,2,arguments.length);Od("Query.endAt",a,this.path,!0);Ud("Query.endAt",b);var c=this.m.gd(a,b);Rh(c);Qh(c);if(this.m.na)throw Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");return new X(this.u,this.path,c,this.Nc)};
	g.If=function(a,b){y("Query.equalTo",1,2,arguments.length);Od("Query.equalTo",a,this.path,!1);Ud("Query.equalTo",b);if(this.m.ka)throw Error("Query.equalTo: Starting point was already set (by another call to startAt or equalTo).");if(this.m.na)throw Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");return this.Nd(a,b).gd(a,b)};
	g.toString=function(){y("Query.toString",0,0,arguments.length);for(var a=this.path,b="",c=a.Y;c<a.o.length;c++)""!==a.o[c]&&(b+="/"+encodeURIComponent(String(a.o[c])));return this.u.toString()+(b||"/")};g.toJSON=function(){y("Query.toJSON",0,1,arguments.length);return this.toString()};g.ja=function(){var a=ac(pf(this.m));return"{}"===a?"default":a};
	g.isEqual=function(a){y("Query.isEqual",1,1,arguments.length);if(!(a instanceof X))throw Error("Query.isEqual failed: First argument must be an instance of firebase.database.Query.");var b=this.u===a.u,c=this.path.Z(a.path),d=this.ja()===a.ja();return b&&c&&d};
	function Th(a,b,c){var d={cancel:null,Ma:null};if(b&&c)d.cancel=b,B(a,3,d.cancel,!0),d.Ma=c,ob(a,4,d.Ma);else if(b)if("object"===typeof b&&null!==b)d.Ma=b;else if("function"===typeof b)d.cancel=b;else throw Error(A(a,3,!0)+" must either be a cancel callback or a context object.");return d}X.prototype.on=X.prototype.gc;X.prototype.off=X.prototype.Ic;X.prototype.once=X.prototype.$f;X.prototype.limitToFirst=X.prototype.ne;X.prototype.limitToLast=X.prototype.oe;X.prototype.orderByChild=X.prototype.ag;
	X.prototype.orderByKey=X.prototype.bg;X.prototype.orderByPriority=X.prototype.cg;X.prototype.orderByValue=X.prototype.dg;X.prototype.startAt=X.prototype.Nd;X.prototype.endAt=X.prototype.gd;X.prototype.equalTo=X.prototype.If;X.prototype.toString=X.prototype.toString;X.prototype.isEqual=X.prototype.isEqual;gc(X.prototype,"ref",X.prototype.wb);function Y(a,b){this.ta=a;this.qa=b}Y.prototype.cancel=function(a){y("Firebase.onDisconnect().cancel",0,1,arguments.length);B("Firebase.onDisconnect().cancel",1,a,!0);var b=new ib;this.ta.xd(this.qa,jb(b,a));return b.ra};Y.prototype.cancel=Y.prototype.cancel;Y.prototype.remove=function(a){y("Firebase.onDisconnect().remove",0,1,arguments.length);Wd("Firebase.onDisconnect().remove",this.qa);B("Firebase.onDisconnect().remove",1,a,!0);var b=new ib;Ch(this.ta,this.qa,null,jb(b,a));return b.ra};
	Y.prototype.remove=Y.prototype.remove;Y.prototype.set=function(a,b){y("Firebase.onDisconnect().set",1,2,arguments.length);Wd("Firebase.onDisconnect().set",this.qa);Od("Firebase.onDisconnect().set",a,this.qa,!1);B("Firebase.onDisconnect().set",2,b,!0);var c=new ib;Ch(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.set=Y.prototype.set;
	Y.prototype.Jb=function(a,b,c){y("Firebase.onDisconnect().setWithPriority",2,3,arguments.length);Wd("Firebase.onDisconnect().setWithPriority",this.qa);Od("Firebase.onDisconnect().setWithPriority",a,this.qa,!1);Sd("Firebase.onDisconnect().setWithPriority",2,b);B("Firebase.onDisconnect().setWithPriority",3,c,!0);var d=new ib;Dh(this.ta,this.qa,a,b,jb(d,c));return d.ra};Y.prototype.setWithPriority=Y.prototype.Jb;
	Y.prototype.update=function(a,b){y("Firebase.onDisconnect().update",1,2,arguments.length);Wd("Firebase.onDisconnect().update",this.qa);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.onDisconnect().update",a,this.qa);B("Firebase.onDisconnect().update",2,b,!0);
	c=new ib;Eh(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.update=Y.prototype.update;var Z={Mf:function(){dg=Zf=!0}};Z.forceLongPolling=Z.Mf;Z.Nf=function(){eg=!0};Z.forceWebSockets=Z.Nf;Z.Tf=function(){return Yf.isAvailable()};Z.isWebSocketsAvailable=Z.Tf;Z.lg=function(a,b){a.u.Ra.ze=b};Z.setSecurityDebugCallback=Z.lg;Z.Be=function(a,b){a.u.Be(b)};Z.stats=Z.Be;Z.Ce=function(a,b){a.u.Ce(b)};Z.statsIncrementCounter=Z.Ce;Z.fd=function(a){return a.u.fd};Z.dataUpdateCount=Z.fd;Z.Sf=function(a,b){a.u.je=b};Z.interceptServerData=Z.Sf;function U(a,b){if(!(a instanceof Qg))throw Error("new Firebase() no longer supported - use app.database().");X.call(this,a,b,mf,!1);this.then=void 0;this["catch"]=void 0}la(U,X);g=U.prototype;g.getKey=function(){y("Firebase.key",0,0,arguments.length);return this.path.e()?null:Oc(this.path)};
	g.n=function(a){y("Firebase.child",1,1,arguments.length);if(ga(a))a=String(a);else if(!(a instanceof E))if(null===K(this.path)){var b=a;b&&(b=b.replace(/^\/*\.info(\/|$)/,"/"));Vd("Firebase.child",b)}else Vd("Firebase.child",a);return new U(this.u,this.path.n(a))};g.getParent=function(){y("Firebase.parent",0,0,arguments.length);var a=this.path.parent();return null===a?null:new U(this.u,a)};
	g.Of=function(){y("Firebase.ref",0,0,arguments.length);for(var a=this;null!==a.getParent();)a=a.getParent();return a};g.Gf=function(){return this.u.Ya};g.set=function(a,b){y("Firebase.set",1,2,arguments.length);Wd("Firebase.set",this.path);Od("Firebase.set",a,this.path,!1);B("Firebase.set",2,b,!0);var c=new ib;this.u.Jb(this.path,a,null,jb(c,b));return c.ra};
	g.update=function(a,b){y("Firebase.update",1,2,arguments.length);Wd("Firebase.update",this.path);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.update",a,this.path);B("Firebase.update",2,b,!0);c=new ib;this.u.update(this.path,a,jb(c,b));return c.ra};
	g.Jb=function(a,b,c){y("Firebase.setWithPriority",2,3,arguments.length);Wd("Firebase.setWithPriority",this.path);Od("Firebase.setWithPriority",a,this.path,!1);Sd("Firebase.setWithPriority",2,b);B("Firebase.setWithPriority",3,c,!0);if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.setWithPriority failed: "+this.getKey()+" is a read-only object.";var d=new ib;this.u.Jb(this.path,a,b,jb(d,c));return d.ra};
	g.remove=function(a){y("Firebase.remove",0,1,arguments.length);Wd("Firebase.remove",this.path);B("Firebase.remove",1,a,!0);return this.set(null,a)};
	g.transaction=function(a,b,c){y("Firebase.transaction",1,3,arguments.length);Wd("Firebase.transaction",this.path);B("Firebase.transaction",1,a,!1);B("Firebase.transaction",2,b,!0);if(n(c)&&"boolean"!=typeof c)throw Error(A("Firebase.transaction",3,!0)+"must be a boolean.");if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.transaction failed: "+this.getKey()+" is a read-only object.";"undefined"===typeof c&&(c=!0);var d=new ib;ha(b)&&kb(d.ra);Gh(this.u,this.path,a,function(a,c,h){a?
	d.reject(a):d.resolve(new Ph(c,h));ha(b)&&b(a,c,h)},c);return d.ra};g.kg=function(a,b){y("Firebase.setPriority",1,2,arguments.length);Wd("Firebase.setPriority",this.path);Sd("Firebase.setPriority",1,a);B("Firebase.setPriority",2,b,!0);var c=new ib;this.u.Jb(this.path.n(".priority"),a,null,jb(c,b));return c.ra};
	g.push=function(a,b){y("Firebase.push",0,2,arguments.length);Wd("Firebase.push",this.path);Od("Firebase.push",a,this.path,!0);B("Firebase.push",2,b,!0);var c=wh(this.u),d=Kc(c),c=this.n(d),e=this.n(d),d=null!=a?c.set(a,b).then(function(){return e}):hb.resolve(e);c.then=q(d.then,d);c["catch"]=q(d.then,d,void 0);ha(b)&&kb(d);return c};g.ib=function(){Wd("Firebase.onDisconnect",this.path);return new Y(this.u,this.path)};U.prototype.child=U.prototype.n;U.prototype.set=U.prototype.set;
	U.prototype.update=U.prototype.update;U.prototype.setWithPriority=U.prototype.Jb;U.prototype.remove=U.prototype.remove;U.prototype.transaction=U.prototype.transaction;U.prototype.setPriority=U.prototype.kg;U.prototype.push=U.prototype.push;U.prototype.onDisconnect=U.prototype.ib;gc(U.prototype,"database",U.prototype.Gf);gc(U.prototype,"key",U.prototype.getKey);gc(U.prototype,"parent",U.prototype.getParent);gc(U.prototype,"root",U.prototype.Of);if("undefined"===typeof firebase)throw Error("Cannot install Firebase Database - be sure to load firebase-app.js first.");
	try{firebase.INTERNAL.registerService("database",function(a){var b=Ug.Vb(),c=a.options.databaseURL;n(c)||Vb("Can't determine Firebase Database URL.  Be sure to include databaseURL option when calling firebase.intializeApp().");var d=Wb(c),c=d.jc;Xd("Invalid Firebase Database URL",d);d.path.e()||Vb("Database URL must point to the root of a Firebase Database (not including a child path).");(d=w(b.lb,a.name))&&Vb("FIREBASE INTERNAL ERROR: Database initialized multiple times.");d=new Qg(c,b.wf,a);b.lb[a.name]=
	d;return d.Ya},{Reference:U,Query:X,Database:Pg,enableLogging:Sb,INTERNAL:Z,TEST_ACCESS:W,ServerValue:Sg})}catch(Uh){Vb("Failed to register the Firebase Database Service ("+Uh+")")};})();
	
	}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
	module.exports = firebase.database;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 653:
/*!****************************************!*\
  !*** ./~/setimmediate/setImmediate.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(/*! ./../process/browser.js */ 100)))

/***/ },

/***/ 266:
/*!***************************************!*\
  !*** ./~/source-map/lib/array-set.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(/*! ./util */ 84);
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * A data structure which is a combination of an array and a set. Adding a new
	 * member is O(1), testing for membership is O(1), and finding the index of an
	 * element is O(1). Removing elements from the set is not supported. Only
	 * strings are supported for membership.
	 */
	function ArraySet() {
	  this._array = [];
	  this._set = Object.create(null);
	}
	
	/**
	 * Static method for creating ArraySet instances from an existing array.
	 */
	ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
	  var set = new ArraySet();
	  for (var i = 0, len = aArray.length; i < len; i++) {
	    set.add(aArray[i], aAllowDuplicates);
	  }
	  return set;
	};
	
	/**
	 * Return how many unique items are in this ArraySet. If duplicates have been
	 * added, than those do not count towards the size.
	 *
	 * @returns Number
	 */
	ArraySet.prototype.size = function ArraySet_size() {
	  return Object.getOwnPropertyNames(this._set).length;
	};
	
	/**
	 * Add the given string to this set.
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
	  var sStr = util.toSetString(aStr);
	  var isDuplicate = has.call(this._set, sStr);
	  var idx = this._array.length;
	  if (!isDuplicate || aAllowDuplicates) {
	    this._array.push(aStr);
	  }
	  if (!isDuplicate) {
	    this._set[sStr] = idx;
	  }
	};
	
	/**
	 * Is the given string a member of this set?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.has = function ArraySet_has(aStr) {
	  var sStr = util.toSetString(aStr);
	  return has.call(this._set, sStr);
	};
	
	/**
	 * What is the index of the given string in the array?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
	  var sStr = util.toSetString(aStr);
	  if (has.call(this._set, sStr)) {
	    return this._set[sStr];
	  }
	  throw new Error('"' + aStr + '" is not in the set.');
	};
	
	/**
	 * What is the element at the given index?
	 *
	 * @param Number aIdx
	 */
	ArraySet.prototype.at = function ArraySet_at(aIdx) {
	  if (aIdx >= 0 && aIdx < this._array.length) {
	    return this._array[aIdx];
	  }
	  throw new Error('No element indexed by ' + aIdx);
	};
	
	/**
	 * Returns the array representation of this set (which has the proper indices
	 * indicated by indexOf). Note that this is a copy of the internal array used
	 * for storing the members so that no one can mess with internal state.
	 */
	ArraySet.prototype.toArray = function ArraySet_toArray() {
	  return this._array.slice();
	};
	
	exports.ArraySet = ArraySet;


/***/ },

/***/ 267:
/*!****************************************!*\
  !*** ./~/source-map/lib/base64-vlq.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 *
	 * Based on the Base 64 VLQ implementation in Closure Compiler:
	 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
	 *
	 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *  * Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *  * Neither the name of Google Inc. nor the names of its
	 *    contributors may be used to endorse or promote products derived
	 *    from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	var base64 = __webpack_require__(/*! ./base64 */ 654);
	
	// A single base 64 digit can contain 6 bits of data. For the base 64 variable
	// length quantities we use in the source map spec, the first bit is the sign,
	// the next four bits are the actual value, and the 6th bit is the
	// continuation bit. The continuation bit tells us whether there are more
	// digits in this value following this digit.
	//
	//   Continuation
	//   |    Sign
	//   |    |
	//   V    V
	//   101011
	
	var VLQ_BASE_SHIFT = 5;
	
	// binary: 100000
	var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	
	// binary: 011111
	var VLQ_BASE_MASK = VLQ_BASE - 1;
	
	// binary: 100000
	var VLQ_CONTINUATION_BIT = VLQ_BASE;
	
	/**
	 * Converts from a two-complement value to a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	 */
	function toVLQSigned(aValue) {
	  return aValue < 0
	    ? ((-aValue) << 1) + 1
	    : (aValue << 1) + 0;
	}
	
	/**
	 * Converts to a two-complement value from a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	 */
	function fromVLQSigned(aValue) {
	  var isNegative = (aValue & 1) === 1;
	  var shifted = aValue >> 1;
	  return isNegative
	    ? -shifted
	    : shifted;
	}
	
	/**
	 * Returns the base 64 VLQ encoded value.
	 */
	exports.encode = function base64VLQ_encode(aValue) {
	  var encoded = "";
	  var digit;
	
	  var vlq = toVLQSigned(aValue);
	
	  do {
	    digit = vlq & VLQ_BASE_MASK;
	    vlq >>>= VLQ_BASE_SHIFT;
	    if (vlq > 0) {
	      // There are still more digits in this value, so we must make sure the
	      // continuation bit is marked.
	      digit |= VLQ_CONTINUATION_BIT;
	    }
	    encoded += base64.encode(digit);
	  } while (vlq > 0);
	
	  return encoded;
	};
	
	/**
	 * Decodes the next base 64 VLQ value from the given string and returns the
	 * value and the rest of the string via the out parameter.
	 */
	exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
	  var strLen = aStr.length;
	  var result = 0;
	  var shift = 0;
	  var continuation, digit;
	
	  do {
	    if (aIndex >= strLen) {
	      throw new Error("Expected more digits in base 64 VLQ value.");
	    }
	
	    digit = base64.decode(aStr.charCodeAt(aIndex++));
	    if (digit === -1) {
	      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
	    }
	
	    continuation = !!(digit & VLQ_CONTINUATION_BIT);
	    digit &= VLQ_BASE_MASK;
	    result = result + (digit << shift);
	    shift += VLQ_BASE_SHIFT;
	  } while (continuation);
	
	  aOutParam.value = fromVLQSigned(result);
	  aOutParam.rest = aIndex;
	};


/***/ },

/***/ 654:
/*!************************************!*\
  !*** ./~/source-map/lib/base64.js ***!
  \************************************/
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
	
	/**
	 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
	 */
	exports.encode = function (number) {
	  if (0 <= number && number < intToCharMap.length) {
	    return intToCharMap[number];
	  }
	  throw new TypeError("Must be between 0 and 63: " + number);
	};
	
	/**
	 * Decode a single base 64 character code digit to an integer. Returns -1 on
	 * failure.
	 */
	exports.decode = function (charCode) {
	  var bigA = 65;     // 'A'
	  var bigZ = 90;     // 'Z'
	
	  var littleA = 97;  // 'a'
	  var littleZ = 122; // 'z'
	
	  var zero = 48;     // '0'
	  var nine = 57;     // '9'
	
	  var plus = 43;     // '+'
	  var slash = 47;    // '/'
	
	  var littleOffset = 26;
	  var numberOffset = 52;
	
	  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
	  if (bigA <= charCode && charCode <= bigZ) {
	    return (charCode - bigA);
	  }
	
	  // 26 - 51: abcdefghijklmnopqrstuvwxyz
	  if (littleA <= charCode && charCode <= littleZ) {
	    return (charCode - littleA + littleOffset);
	  }
	
	  // 52 - 61: 0123456789
	  if (zero <= charCode && charCode <= nine) {
	    return (charCode - zero + numberOffset);
	  }
	
	  // 62: +
	  if (charCode == plus) {
	    return 62;
	  }
	
	  // 63: /
	  if (charCode == slash) {
	    return 63;
	  }
	
	  // Invalid base64 digit.
	  return -1;
	};


/***/ },

/***/ 655:
/*!*******************************************!*\
  !*** ./~/source-map/lib/binary-search.js ***!
  \*******************************************/
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	exports.GREATEST_LOWER_BOUND = 1;
	exports.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Recursive implementation of binary search.
	 *
	 * @param aLow Indices here and lower do not contain the needle.
	 * @param aHigh Indices here and higher do not contain the needle.
	 * @param aNeedle The element being searched for.
	 * @param aHaystack The non-empty array being searched.
	 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 */
	function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
	  // This function terminates when one of the following is true:
	  //
	  //   1. We find the exact element we are looking for.
	  //
	  //   2. We did not find the exact element, but we can return the index of
	  //      the next-closest element.
	  //
	  //   3. We did not find the exact element, and there is no next-closest
	  //      element than the one we are searching for, so we return -1.
	  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
	  var cmp = aCompare(aNeedle, aHaystack[mid], true);
	  if (cmp === 0) {
	    // Found the element we are looking for.
	    return mid;
	  }
	  else if (cmp > 0) {
	    // Our needle is greater than aHaystack[mid].
	    if (aHigh - mid > 1) {
	      // The element is in the upper half.
	      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // The exact needle element was not found in this haystack. Determine if
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return aHigh < aHaystack.length ? aHigh : -1;
	    } else {
	      return mid;
	    }
	  }
	  else {
	    // Our needle is less than aHaystack[mid].
	    if (mid - aLow > 1) {
	      // The element is in the lower half.
	      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return mid;
	    } else {
	      return aLow < 0 ? -1 : aLow;
	    }
	  }
	}
	
	/**
	 * This is an implementation of binary search which will always try and return
	 * the index of the closest element if there is no exact hit. This is because
	 * mappings between original and generated line/col pairs are single points,
	 * and there is an implicit region between each of them, so a miss just means
	 * that you aren't on the very start of a region.
	 *
	 * @param aNeedle The element you are looking for.
	 * @param aHaystack The array that is being searched.
	 * @param aCompare A function which takes the needle and an element in the
	 *     array and returns -1, 0, or 1 depending on whether the needle is less
	 *     than, equal to, or greater than the element, respectively.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	 */
	exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
	  if (aHaystack.length === 0) {
	    return -1;
	  }
	
	  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
	                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
	  if (index < 0) {
	    return -1;
	  }
	
	  // We have found either the exact element, or the next-closest element than
	  // the one we are searching for. However, there may be more than one such
	  // element. Make sure we always return the smallest of these.
	  while (index - 1 >= 0) {
	    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
	      break;
	    }
	    --index;
	  }
	
	  return index;
	};


/***/ },

/***/ 656:
/*!******************************************!*\
  !*** ./~/source-map/lib/mapping-list.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2014 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(/*! ./util */ 84);
	
	/**
	 * Determine whether mappingB is after mappingA with respect to generated
	 * position.
	 */
	function generatedPositionAfter(mappingA, mappingB) {
	  // Optimized for most common case
	  var lineA = mappingA.generatedLine;
	  var lineB = mappingB.generatedLine;
	  var columnA = mappingA.generatedColumn;
	  var columnB = mappingB.generatedColumn;
	  return lineB > lineA || lineB == lineA && columnB >= columnA ||
	         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
	}
	
	/**
	 * A data structure to provide a sorted view of accumulated mappings in a
	 * performance conscious manner. It trades a neglibable overhead in general
	 * case for a large speedup in case of mappings being added in order.
	 */
	function MappingList() {
	  this._array = [];
	  this._sorted = true;
	  // Serves as infimum
	  this._last = {generatedLine: -1, generatedColumn: 0};
	}
	
	/**
	 * Iterate through internal items. This method takes the same arguments that
	 * `Array.prototype.forEach` takes.
	 *
	 * NOTE: The order of the mappings is NOT guaranteed.
	 */
	MappingList.prototype.unsortedForEach =
	  function MappingList_forEach(aCallback, aThisArg) {
	    this._array.forEach(aCallback, aThisArg);
	  };
	
	/**
	 * Add the given source mapping.
	 *
	 * @param Object aMapping
	 */
	MappingList.prototype.add = function MappingList_add(aMapping) {
	  if (generatedPositionAfter(this._last, aMapping)) {
	    this._last = aMapping;
	    this._array.push(aMapping);
	  } else {
	    this._sorted = false;
	    this._array.push(aMapping);
	  }
	};
	
	/**
	 * Returns the flat, sorted array of mappings. The mappings are sorted by
	 * generated position.
	 *
	 * WARNING: This method returns internal data without copying, for
	 * performance. The return value must NOT be mutated, and should be treated as
	 * an immutable borrow. If you want to take ownership, you must make your own
	 * copy.
	 */
	MappingList.prototype.toArray = function MappingList_toArray() {
	  if (!this._sorted) {
	    this._array.sort(util.compareByGeneratedPositionsInflated);
	    this._sorted = true;
	  }
	  return this._array;
	};
	
	exports.MappingList = MappingList;


/***/ },

/***/ 657:
/*!****************************************!*\
  !*** ./~/source-map/lib/quick-sort.js ***!
  \****************************************/
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	// It turns out that some (most?) JavaScript engines don't self-host
	// `Array.prototype.sort`. This makes sense because C++ will likely remain
	// faster than JS when doing raw CPU-intensive sorting. However, when using a
	// custom comparator function, calling back and forth between the VM's C++ and
	// JIT'd JS is rather slow *and* loses JIT type information, resulting in
	// worse generated code for the comparator function than would be optimal. In
	// fact, when sorting with a comparator, these costs outweigh the benefits of
	// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
	// a ~3500ms mean speed-up in `bench/bench.html`.
	
	/**
	 * Swap the elements indexed by `x` and `y` in the array `ary`.
	 *
	 * @param {Array} ary
	 *        The array.
	 * @param {Number} x
	 *        The index of the first item.
	 * @param {Number} y
	 *        The index of the second item.
	 */
	function swap(ary, x, y) {
	  var temp = ary[x];
	  ary[x] = ary[y];
	  ary[y] = temp;
	}
	
	/**
	 * Returns a random integer within the range `low .. high` inclusive.
	 *
	 * @param {Number} low
	 *        The lower bound on the range.
	 * @param {Number} high
	 *        The upper bound on the range.
	 */
	function randomIntInRange(low, high) {
	  return Math.round(low + (Math.random() * (high - low)));
	}
	
	/**
	 * The Quick Sort algorithm.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 * @param {Number} p
	 *        Start index of the array
	 * @param {Number} r
	 *        End index of the array
	 */
	function doQuickSort(ary, comparator, p, r) {
	  // If our lower bound is less than our upper bound, we (1) partition the
	  // array into two pieces and (2) recurse on each half. If it is not, this is
	  // the empty array and our base case.
	
	  if (p < r) {
	    // (1) Partitioning.
	    //
	    // The partitioning chooses a pivot between `p` and `r` and moves all
	    // elements that are less than or equal to the pivot to the before it, and
	    // all the elements that are greater than it after it. The effect is that
	    // once partition is done, the pivot is in the exact place it will be when
	    // the array is put in sorted order, and it will not need to be moved
	    // again. This runs in O(n) time.
	
	    // Always choose a random pivot so that an input array which is reverse
	    // sorted does not cause O(n^2) running time.
	    var pivotIndex = randomIntInRange(p, r);
	    var i = p - 1;
	
	    swap(ary, pivotIndex, r);
	    var pivot = ary[r];
	
	    // Immediately after `j` is incremented in this loop, the following hold
	    // true:
	    //
	    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
	    //
	    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
	    for (var j = p; j < r; j++) {
	      if (comparator(ary[j], pivot) <= 0) {
	        i += 1;
	        swap(ary, i, j);
	      }
	    }
	
	    swap(ary, i + 1, j);
	    var q = i + 1;
	
	    // (2) Recurse on each half.
	
	    doQuickSort(ary, comparator, p, q - 1);
	    doQuickSort(ary, comparator, q + 1, r);
	  }
	}
	
	/**
	 * Sort the given array in-place with the given comparator function.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 */
	exports.quickSort = function (ary, comparator) {
	  doQuickSort(ary, comparator, 0, ary.length - 1);
	};


/***/ },

/***/ 658:
/*!*************************************************!*\
  !*** ./~/source-map/lib/source-map-consumer.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(/*! ./util */ 84);
	var binarySearch = __webpack_require__(/*! ./binary-search */ 655);
	var ArraySet = __webpack_require__(/*! ./array-set */ 266).ArraySet;
	var base64VLQ = __webpack_require__(/*! ./base64-vlq */ 267);
	var quickSort = __webpack_require__(/*! ./quick-sort */ 657).quickSort;
	
	function SourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  return sourceMap.sections != null
	    ? new IndexedSourceMapConsumer(sourceMap)
	    : new BasicSourceMapConsumer(sourceMap);
	}
	
	SourceMapConsumer.fromSourceMap = function(aSourceMap) {
	  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
	}
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	SourceMapConsumer.prototype._version = 3;
	
	// `__generatedMappings` and `__originalMappings` are arrays that hold the
	// parsed mapping coordinates from the source map's "mappings" attribute. They
	// are lazily instantiated, accessed via the `_generatedMappings` and
	// `_originalMappings` getters respectively, and we only parse the mappings
	// and create these arrays once queried for a source location. We jump through
	// these hoops because there can be many thousands of mappings, and parsing
	// them is expensive, so we only want to do it if we must.
	//
	// Each object in the arrays is of the form:
	//
	//     {
	//       generatedLine: The line number in the generated code,
	//       generatedColumn: The column number in the generated code,
	//       source: The path to the original source file that generated this
	//               chunk of code,
	//       originalLine: The line number in the original source that
	//                     corresponds to this chunk of generated code,
	//       originalColumn: The column number in the original source that
	//                       corresponds to this chunk of generated code,
	//       name: The name of the original symbol which generated this chunk of
	//             code.
	//     }
	//
	// All properties except for `generatedLine` and `generatedColumn` can be
	// `null`.
	//
	// `_generatedMappings` is ordered by the generated positions.
	//
	// `_originalMappings` is ordered by the original positions.
	
	SourceMapConsumer.prototype.__generatedMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
	  get: function () {
	    if (!this.__generatedMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__generatedMappings;
	  }
	});
	
	SourceMapConsumer.prototype.__originalMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
	  get: function () {
	    if (!this.__originalMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__originalMappings;
	  }
	});
	
	SourceMapConsumer.prototype._charIsMappingSeparator =
	  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
	    var c = aStr.charAt(index);
	    return c === ";" || c === ",";
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	SourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    throw new Error("Subclasses must implement _parseMappings");
	  };
	
	SourceMapConsumer.GENERATED_ORDER = 1;
	SourceMapConsumer.ORIGINAL_ORDER = 2;
	
	SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
	SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Iterate over each mapping between an original source/line/column and a
	 * generated line/column in this source map.
	 *
	 * @param Function aCallback
	 *        The function that is called with each mapping.
	 * @param Object aContext
	 *        Optional. If specified, this object will be the value of `this` every
	 *        time that `aCallback` is called.
	 * @param aOrder
	 *        Either `SourceMapConsumer.GENERATED_ORDER` or
	 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	 *        iterate over the mappings sorted by the generated file's line/column
	 *        order or the original's source/line/column order, respectively. Defaults to
	 *        `SourceMapConsumer.GENERATED_ORDER`.
	 */
	SourceMapConsumer.prototype.eachMapping =
	  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
	    var context = aContext || null;
	    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
	
	    var mappings;
	    switch (order) {
	    case SourceMapConsumer.GENERATED_ORDER:
	      mappings = this._generatedMappings;
	      break;
	    case SourceMapConsumer.ORIGINAL_ORDER:
	      mappings = this._originalMappings;
	      break;
	    default:
	      throw new Error("Unknown order of iteration.");
	    }
	
	    var sourceRoot = this.sourceRoot;
	    mappings.map(function (mapping) {
	      var source = mapping.source === null ? null : this._sources.at(mapping.source);
	      if (source != null && sourceRoot != null) {
	        source = util.join(sourceRoot, source);
	      }
	      return {
	        source: source,
	        generatedLine: mapping.generatedLine,
	        generatedColumn: mapping.generatedColumn,
	        originalLine: mapping.originalLine,
	        originalColumn: mapping.originalColumn,
	        name: mapping.name === null ? null : this._names.at(mapping.name)
	      };
	    }, this).forEach(aCallback, context);
	  };
	
	/**
	 * Returns all generated line and column information for the original source,
	 * line, and column provided. If no column is provided, returns all mappings
	 * corresponding to a either the line we are searching for or the next
	 * closest line that has any mappings. Otherwise, returns all mappings
	 * corresponding to the given line and either the column we are searching for
	 * or the next closest column that has any offsets.
	 *
	 * The only argument is an object with the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: Optional. the column number in the original source.
	 *
	 * and an array of objects is returned, each with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	SourceMapConsumer.prototype.allGeneratedPositionsFor =
	  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
	    var line = util.getArg(aArgs, 'line');
	
	    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
	    // returns the index of the closest mapping less than the needle. By
	    // setting needle.originalColumn to 0, we thus find the last mapping for
	    // the given line, provided such a mapping exists.
	    var needle = {
	      source: util.getArg(aArgs, 'source'),
	      originalLine: line,
	      originalColumn: util.getArg(aArgs, 'column', 0)
	    };
	
	    if (this.sourceRoot != null) {
	      needle.source = util.relative(this.sourceRoot, needle.source);
	    }
	    if (!this._sources.has(needle.source)) {
	      return [];
	    }
	    needle.source = this._sources.indexOf(needle.source);
	
	    var mappings = [];
	
	    var index = this._findMapping(needle,
	                                  this._originalMappings,
	                                  "originalLine",
	                                  "originalColumn",
	                                  util.compareByOriginalPositions,
	                                  binarySearch.LEAST_UPPER_BOUND);
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (aArgs.column === undefined) {
	        var originalLine = mapping.originalLine;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we found. Since
	        // mappings are sorted, this is guaranteed to find all mappings for
	        // the line we found.
	        while (mapping && mapping.originalLine === originalLine) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      } else {
	        var originalColumn = mapping.originalColumn;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we were searching for.
	        // Since mappings are sorted, this is guaranteed to find all mappings for
	        // the line we are searching for.
	        while (mapping &&
	               mapping.originalLine === line &&
	               mapping.originalColumn == originalColumn) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      }
	    }
	
	    return mappings;
	  };
	
	exports.SourceMapConsumer = SourceMapConsumer;
	
	/**
	 * A BasicSourceMapConsumer instance represents a parsed source map which we can
	 * query for information about the original file positions by giving it a file
	 * position in the generated source.
	 *
	 * The only parameter is the raw source map (either as a JSON string, or
	 * already parsed to an object). According to the spec, source maps have the
	 * following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - sources: An array of URLs to the original source files.
	 *   - names: An array of identifiers which can be referrenced by individual mappings.
	 *   - sourceRoot: Optional. The URL root from which all sources are relative.
	 *   - sourcesContent: Optional. An array of contents of the original source files.
	 *   - mappings: A string of base64 VLQs which contain the actual mappings.
	 *   - file: Optional. The generated file this source map is associated with.
	 *
	 * Here is an example source map, taken from the source map spec[0]:
	 *
	 *     {
	 *       version : 3,
	 *       file: "out.js",
	 *       sourceRoot : "",
	 *       sources: ["foo.js", "bar.js"],
	 *       names: ["src", "maps", "are", "fun"],
	 *       mappings: "AA,AB;;ABCDE;"
	 *     }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	 */
	function BasicSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sources = util.getArg(sourceMap, 'sources');
	  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
	  // requires the array) to play nice here.
	  var names = util.getArg(sourceMap, 'names', []);
	  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
	  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
	  var mappings = util.getArg(sourceMap, 'mappings');
	  var file = util.getArg(sourceMap, 'file', null);
	
	  // Once again, Sass deviates from the spec and supplies the version as a
	  // string rather than a number, so we use loose equality checking here.
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  sources = sources
	    .map(String)
	    // Some source maps produce relative source paths like "./foo.js" instead of
	    // "foo.js".  Normalize these first so that future comparisons will succeed.
	    // See bugzil.la/1090768.
	    .map(util.normalize)
	    // Always ensure that absolute sources are internally stored relative to
	    // the source root, if the source root is absolute. Not doing this would
	    // be particularly problematic when the source root is a prefix of the
	    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
	    .map(function (source) {
	      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
	        ? util.relative(sourceRoot, source)
	        : source;
	    });
	
	  // Pass `true` below to allow duplicate names and sources. While source maps
	  // are intended to be compressed and deduplicated, the TypeScript compiler
	  // sometimes generates source maps with duplicates in them. See Github issue
	  // #72 and bugzil.la/889492.
	  this._names = ArraySet.fromArray(names.map(String), true);
	  this._sources = ArraySet.fromArray(sources, true);
	
	  this.sourceRoot = sourceRoot;
	  this.sourcesContent = sourcesContent;
	  this._mappings = mappings;
	  this.file = file;
	}
	
	BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	
	/**
	 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
	 *
	 * @param SourceMapGenerator aSourceMap
	 *        The source map that will be consumed.
	 * @returns BasicSourceMapConsumer
	 */
	BasicSourceMapConsumer.fromSourceMap =
	  function SourceMapConsumer_fromSourceMap(aSourceMap) {
	    var smc = Object.create(BasicSourceMapConsumer.prototype);
	
	    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
	    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
	    smc.sourceRoot = aSourceMap._sourceRoot;
	    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
	                                                            smc.sourceRoot);
	    smc.file = aSourceMap._file;
	
	    // Because we are modifying the entries (by converting string sources and
	    // names to indices into the sources and names ArraySets), we have to make
	    // a copy of the entry or else bad things happen. Shared mutable state
	    // strikes again! See github issue #191.
	
	    var generatedMappings = aSourceMap._mappings.toArray().slice();
	    var destGeneratedMappings = smc.__generatedMappings = [];
	    var destOriginalMappings = smc.__originalMappings = [];
	
	    for (var i = 0, length = generatedMappings.length; i < length; i++) {
	      var srcMapping = generatedMappings[i];
	      var destMapping = new Mapping;
	      destMapping.generatedLine = srcMapping.generatedLine;
	      destMapping.generatedColumn = srcMapping.generatedColumn;
	
	      if (srcMapping.source) {
	        destMapping.source = sources.indexOf(srcMapping.source);
	        destMapping.originalLine = srcMapping.originalLine;
	        destMapping.originalColumn = srcMapping.originalColumn;
	
	        if (srcMapping.name) {
	          destMapping.name = names.indexOf(srcMapping.name);
	        }
	
	        destOriginalMappings.push(destMapping);
	      }
	
	      destGeneratedMappings.push(destMapping);
	    }
	
	    quickSort(smc.__originalMappings, util.compareByOriginalPositions);
	
	    return smc;
	  };
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	BasicSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    return this._sources.toArray().map(function (s) {
	      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
	    }, this);
	  }
	});
	
	/**
	 * Provide the JIT with a nice shape / hidden class.
	 */
	function Mapping() {
	  this.generatedLine = 0;
	  this.generatedColumn = 0;
	  this.source = null;
	  this.originalLine = null;
	  this.originalColumn = null;
	  this.name = null;
	}
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	BasicSourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    var generatedLine = 1;
	    var previousGeneratedColumn = 0;
	    var previousOriginalLine = 0;
	    var previousOriginalColumn = 0;
	    var previousSource = 0;
	    var previousName = 0;
	    var length = aStr.length;
	    var index = 0;
	    var cachedSegments = {};
	    var temp = {};
	    var originalMappings = [];
	    var generatedMappings = [];
	    var mapping, str, segment, end, value;
	
	    while (index < length) {
	      if (aStr.charAt(index) === ';') {
	        generatedLine++;
	        index++;
	        previousGeneratedColumn = 0;
	      }
	      else if (aStr.charAt(index) === ',') {
	        index++;
	      }
	      else {
	        mapping = new Mapping();
	        mapping.generatedLine = generatedLine;
	
	        // Because each offset is encoded relative to the previous one,
	        // many segments often have the same encoding. We can exploit this
	        // fact by caching the parsed variable length fields of each segment,
	        // allowing us to avoid a second parse if we encounter the same
	        // segment again.
	        for (end = index; end < length; end++) {
	          if (this._charIsMappingSeparator(aStr, end)) {
	            break;
	          }
	        }
	        str = aStr.slice(index, end);
	
	        segment = cachedSegments[str];
	        if (segment) {
	          index += str.length;
	        } else {
	          segment = [];
	          while (index < end) {
	            base64VLQ.decode(aStr, index, temp);
	            value = temp.value;
	            index = temp.rest;
	            segment.push(value);
	          }
	
	          if (segment.length === 2) {
	            throw new Error('Found a source, but no line and column');
	          }
	
	          if (segment.length === 3) {
	            throw new Error('Found a source and line, but no column');
	          }
	
	          cachedSegments[str] = segment;
	        }
	
	        // Generated column.
	        mapping.generatedColumn = previousGeneratedColumn + segment[0];
	        previousGeneratedColumn = mapping.generatedColumn;
	
	        if (segment.length > 1) {
	          // Original source.
	          mapping.source = previousSource + segment[1];
	          previousSource += segment[1];
	
	          // Original line.
	          mapping.originalLine = previousOriginalLine + segment[2];
	          previousOriginalLine = mapping.originalLine;
	          // Lines are stored 0-based
	          mapping.originalLine += 1;
	
	          // Original column.
	          mapping.originalColumn = previousOriginalColumn + segment[3];
	          previousOriginalColumn = mapping.originalColumn;
	
	          if (segment.length > 4) {
	            // Original name.
	            mapping.name = previousName + segment[4];
	            previousName += segment[4];
	          }
	        }
	
	        generatedMappings.push(mapping);
	        if (typeof mapping.originalLine === 'number') {
	          originalMappings.push(mapping);
	        }
	      }
	    }
	
	    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
	    this.__generatedMappings = generatedMappings;
	
	    quickSort(originalMappings, util.compareByOriginalPositions);
	    this.__originalMappings = originalMappings;
	  };
	
	/**
	 * Find the mapping that best matches the hypothetical "needle" mapping that
	 * we are searching for in the given "haystack" of mappings.
	 */
	BasicSourceMapConsumer.prototype._findMapping =
	  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
	                                         aColumnName, aComparator, aBias) {
	    // To return the position we are searching for, we must first find the
	    // mapping for the given position and then return the opposite position it
	    // points to. Because the mappings are sorted, we can use binary search to
	    // find the best mapping.
	
	    if (aNeedle[aLineName] <= 0) {
	      throw new TypeError('Line must be greater than or equal to 1, got '
	                          + aNeedle[aLineName]);
	    }
	    if (aNeedle[aColumnName] < 0) {
	      throw new TypeError('Column must be greater than or equal to 0, got '
	                          + aNeedle[aColumnName]);
	    }
	
	    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
	  };
	
	/**
	 * Compute the last column for each generated mapping. The last column is
	 * inclusive.
	 */
	BasicSourceMapConsumer.prototype.computeColumnSpans =
	  function SourceMapConsumer_computeColumnSpans() {
	    for (var index = 0; index < this._generatedMappings.length; ++index) {
	      var mapping = this._generatedMappings[index];
	
	      // Mappings do not contain a field for the last generated columnt. We
	      // can come up with an optimistic estimate, however, by assuming that
	      // mappings are contiguous (i.e. given two consecutive mappings, the
	      // first mapping ends where the second one starts).
	      if (index + 1 < this._generatedMappings.length) {
	        var nextMapping = this._generatedMappings[index + 1];
	
	        if (mapping.generatedLine === nextMapping.generatedLine) {
	          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
	          continue;
	        }
	      }
	
	      // The last mapping for each line spans the entire line.
	      mapping.lastGeneratedColumn = Infinity;
	    }
	  };
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	BasicSourceMapConsumer.prototype.originalPositionFor =
	  function SourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._generatedMappings,
	      "generatedLine",
	      "generatedColumn",
	      util.compareByGeneratedPositionsDeflated,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._generatedMappings[index];
	
	      if (mapping.generatedLine === needle.generatedLine) {
	        var source = util.getArg(mapping, 'source', null);
	        if (source !== null) {
	          source = this._sources.at(source);
	          if (this.sourceRoot != null) {
	            source = util.join(this.sourceRoot, source);
	          }
	        }
	        var name = util.getArg(mapping, 'name', null);
	        if (name !== null) {
	          name = this._names.at(name);
	        }
	        return {
	          source: source,
	          line: util.getArg(mapping, 'originalLine', null),
	          column: util.getArg(mapping, 'originalColumn', null),
	          name: name
	        };
	      }
	    }
	
	    return {
	      source: null,
	      line: null,
	      column: null,
	      name: null
	    };
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function BasicSourceMapConsumer_hasContentsOfAllSources() {
	    if (!this.sourcesContent) {
	      return false;
	    }
	    return this.sourcesContent.length >= this._sources.size() &&
	      !this.sourcesContent.some(function (sc) { return sc == null; });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	BasicSourceMapConsumer.prototype.sourceContentFor =
	  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    if (!this.sourcesContent) {
	      return null;
	    }
	
	    if (this.sourceRoot != null) {
	      aSource = util.relative(this.sourceRoot, aSource);
	    }
	
	    if (this._sources.has(aSource)) {
	      return this.sourcesContent[this._sources.indexOf(aSource)];
	    }
	
	    var url;
	    if (this.sourceRoot != null
	        && (url = util.urlParse(this.sourceRoot))) {
	      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
	      // many users. We can help them out when they expect file:// URIs to
	      // behave like it would if they were running a local HTTP server. See
	      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
	      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
	      if (url.scheme == "file"
	          && this._sources.has(fileUriAbsPath)) {
	        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
	      }
	
	      if ((!url.path || url.path == "/")
	          && this._sources.has("/" + aSource)) {
	        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
	      }
	    }
	
	    // This function is used recursively from
	    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
	    // don't want to throw if we can't find the source - we just want to
	    // return null, so we provide a flag to exit gracefully.
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	BasicSourceMapConsumer.prototype.generatedPositionFor =
	  function SourceMapConsumer_generatedPositionFor(aArgs) {
	    var source = util.getArg(aArgs, 'source');
	    if (this.sourceRoot != null) {
	      source = util.relative(this.sourceRoot, source);
	    }
	    if (!this._sources.has(source)) {
	      return {
	        line: null,
	        column: null,
	        lastColumn: null
	      };
	    }
	    source = this._sources.indexOf(source);
	
	    var needle = {
	      source: source,
	      originalLine: util.getArg(aArgs, 'line'),
	      originalColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._originalMappings,
	      "originalLine",
	      "originalColumn",
	      util.compareByOriginalPositions,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (mapping.source === needle.source) {
	        return {
	          line: util.getArg(mapping, 'generatedLine', null),
	          column: util.getArg(mapping, 'generatedColumn', null),
	          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	        };
	      }
	    }
	
	    return {
	      line: null,
	      column: null,
	      lastColumn: null
	    };
	  };
	
	exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	
	/**
	 * An IndexedSourceMapConsumer instance represents a parsed source map which
	 * we can query for information. It differs from BasicSourceMapConsumer in
	 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	 * input.
	 *
	 * The only parameter is a raw source map (either as a JSON string, or already
	 * parsed to an object). According to the spec for indexed source maps, they
	 * have the following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - file: Optional. The generated file this source map is associated with.
	 *   - sections: A list of section definitions.
	 *
	 * Each value under the "sections" field has two fields:
	 *   - offset: The offset into the original specified at which this section
	 *       begins to apply, defined as an object with a "line" and "column"
	 *       field.
	 *   - map: A source map definition. This source map could also be indexed,
	 *       but doesn't have to be.
	 *
	 * Instead of the "map" field, it's also possible to have a "url" field
	 * specifying a URL to retrieve a source map from, but that's currently
	 * unsupported.
	 *
	 * Here's an example source map, taken from the source map spec[0], but
	 * modified to omit a section which uses the "url" field.
	 *
	 *  {
	 *    version : 3,
	 *    file: "app.js",
	 *    sections: [{
	 *      offset: {line:100, column:10},
	 *      map: {
	 *        version : 3,
	 *        file: "section.js",
	 *        sources: ["foo.js", "bar.js"],
	 *        names: ["src", "maps", "are", "fun"],
	 *        mappings: "AAAA,E;;ABCDE;"
	 *      }
	 *    }],
	 *  }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	 */
	function IndexedSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sections = util.getArg(sourceMap, 'sections');
	
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	
	  var lastOffset = {
	    line: -1,
	    column: 0
	  };
	  this._sections = sections.map(function (s) {
	    if (s.url) {
	      // The url field will require support for asynchronicity.
	      // See https://github.com/mozilla/source-map/issues/16
	      throw new Error('Support for url field in sections not implemented.');
	    }
	    var offset = util.getArg(s, 'offset');
	    var offsetLine = util.getArg(offset, 'line');
	    var offsetColumn = util.getArg(offset, 'column');
	
	    if (offsetLine < lastOffset.line ||
	        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
	      throw new Error('Section offsets must be ordered and non-overlapping.');
	    }
	    lastOffset = offset;
	
	    return {
	      generatedOffset: {
	        // The offset fields are 0-based, but we use 1-based indices when
	        // encoding/decoding from VLQ.
	        generatedLine: offsetLine + 1,
	        generatedColumn: offsetColumn + 1
	      },
	      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
	    }
	  });
	}
	
	IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	IndexedSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    var sources = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
	        sources.push(this._sections[i].consumer.sources[j]);
	      }
	    }
	    return sources;
	  }
	});
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	IndexedSourceMapConsumer.prototype.originalPositionFor =
	  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    // Find the section containing the generated position we're trying to map
	    // to an original position.
	    var sectionIndex = binarySearch.search(needle, this._sections,
	      function(needle, section) {
	        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
	        if (cmp) {
	          return cmp;
	        }
	
	        return (needle.generatedColumn -
	                section.generatedOffset.generatedColumn);
	      });
	    var section = this._sections[sectionIndex];
	
	    if (!section) {
	      return {
	        source: null,
	        line: null,
	        column: null,
	        name: null
	      };
	    }
	
	    return section.consumer.originalPositionFor({
	      line: needle.generatedLine -
	        (section.generatedOffset.generatedLine - 1),
	      column: needle.generatedColumn -
	        (section.generatedOffset.generatedLine === needle.generatedLine
	         ? section.generatedOffset.generatedColumn - 1
	         : 0),
	      bias: aArgs.bias
	    });
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
	    return this._sections.every(function (s) {
	      return s.consumer.hasContentsOfAllSources();
	    });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	IndexedSourceMapConsumer.prototype.sourceContentFor =
	  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      var content = section.consumer.sourceContentFor(aSource, true);
	      if (content) {
	        return content;
	      }
	    }
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	IndexedSourceMapConsumer.prototype.generatedPositionFor =
	  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      // Only consider this section if the requested source is in the list of
	      // sources of the consumer.
	      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
	        continue;
	      }
	      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
	      if (generatedPosition) {
	        var ret = {
	          line: generatedPosition.line +
	            (section.generatedOffset.generatedLine - 1),
	          column: generatedPosition.column +
	            (section.generatedOffset.generatedLine === generatedPosition.line
	             ? section.generatedOffset.generatedColumn - 1
	             : 0)
	        };
	        return ret;
	      }
	    }
	
	    return {
	      line: null,
	      column: null
	    };
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	IndexedSourceMapConsumer.prototype._parseMappings =
	  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    this.__generatedMappings = [];
	    this.__originalMappings = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	      var sectionMappings = section.consumer._generatedMappings;
	      for (var j = 0; j < sectionMappings.length; j++) {
	        var mapping = sectionMappings[j];
	
	        var source = section.consumer._sources.at(mapping.source);
	        if (section.consumer.sourceRoot !== null) {
	          source = util.join(section.consumer.sourceRoot, source);
	        }
	        this._sources.add(source);
	        source = this._sources.indexOf(source);
	
	        var name = section.consumer._names.at(mapping.name);
	        this._names.add(name);
	        name = this._names.indexOf(name);
	
	        // The mappings coming from the consumer for the section have
	        // generated positions relative to the start of the section, so we
	        // need to offset them to be relative to the start of the concatenated
	        // generated file.
	        var adjustedMapping = {
	          source: source,
	          generatedLine: mapping.generatedLine +
	            (section.generatedOffset.generatedLine - 1),
	          generatedColumn: mapping.generatedColumn +
	            (section.generatedOffset.generatedLine === mapping.generatedLine
	            ? section.generatedOffset.generatedColumn - 1
	            : 0),
	          originalLine: mapping.originalLine,
	          originalColumn: mapping.originalColumn,
	          name: name
	        };
	
	        this.__generatedMappings.push(adjustedMapping);
	        if (typeof adjustedMapping.originalLine === 'number') {
	          this.__originalMappings.push(adjustedMapping);
	        }
	      }
	    }
	
	    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
	    quickSort(this.__originalMappings, util.compareByOriginalPositions);
	  };
	
	exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;


/***/ },

/***/ 268:
/*!**************************************************!*\
  !*** ./~/source-map/lib/source-map-generator.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var base64VLQ = __webpack_require__(/*! ./base64-vlq */ 267);
	var util = __webpack_require__(/*! ./util */ 84);
	var ArraySet = __webpack_require__(/*! ./array-set */ 266).ArraySet;
	var MappingList = __webpack_require__(/*! ./mapping-list */ 656).MappingList;
	
	/**
	 * An instance of the SourceMapGenerator represents a source map which is
	 * being built incrementally. You may pass an object with the following
	 * properties:
	 *
	 *   - file: The filename of the generated source.
	 *   - sourceRoot: A root for all relative URLs in this source map.
	 */
	function SourceMapGenerator(aArgs) {
	  if (!aArgs) {
	    aArgs = {};
	  }
	  this._file = util.getArg(aArgs, 'file', null);
	  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
	  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	  this._mappings = new MappingList();
	  this._sourcesContents = null;
	}
	
	SourceMapGenerator.prototype._version = 3;
	
	/**
	 * Creates a new SourceMapGenerator based on a SourceMapConsumer
	 *
	 * @param aSourceMapConsumer The SourceMap.
	 */
	SourceMapGenerator.fromSourceMap =
	  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
	    var sourceRoot = aSourceMapConsumer.sourceRoot;
	    var generator = new SourceMapGenerator({
	      file: aSourceMapConsumer.file,
	      sourceRoot: sourceRoot
	    });
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      var newMapping = {
	        generated: {
	          line: mapping.generatedLine,
	          column: mapping.generatedColumn
	        }
	      };
	
	      if (mapping.source != null) {
	        newMapping.source = mapping.source;
	        if (sourceRoot != null) {
	          newMapping.source = util.relative(sourceRoot, newMapping.source);
	        }
	
	        newMapping.original = {
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        };
	
	        if (mapping.name != null) {
	          newMapping.name = mapping.name;
	        }
	      }
	
	      generator.addMapping(newMapping);
	    });
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        generator.setSourceContent(sourceFile, content);
	      }
	    });
	    return generator;
	  };
	
	/**
	 * Add a single mapping from original source line and column to the generated
	 * source's line and column for this source map being created. The mapping
	 * object should have the following properties:
	 *
	 *   - generated: An object with the generated line and column positions.
	 *   - original: An object with the original line and column positions.
	 *   - source: The original source file (relative to the sourceRoot).
	 *   - name: An optional original token name for this mapping.
	 */
	SourceMapGenerator.prototype.addMapping =
	  function SourceMapGenerator_addMapping(aArgs) {
	    var generated = util.getArg(aArgs, 'generated');
	    var original = util.getArg(aArgs, 'original', null);
	    var source = util.getArg(aArgs, 'source', null);
	    var name = util.getArg(aArgs, 'name', null);
	
	    if (!this._skipValidation) {
	      this._validateMapping(generated, original, source, name);
	    }
	
	    if (source != null) {
	      source = String(source);
	      if (!this._sources.has(source)) {
	        this._sources.add(source);
	      }
	    }
	
	    if (name != null) {
	      name = String(name);
	      if (!this._names.has(name)) {
	        this._names.add(name);
	      }
	    }
	
	    this._mappings.add({
	      generatedLine: generated.line,
	      generatedColumn: generated.column,
	      originalLine: original != null && original.line,
	      originalColumn: original != null && original.column,
	      source: source,
	      name: name
	    });
	  };
	
	/**
	 * Set the source content for a source file.
	 */
	SourceMapGenerator.prototype.setSourceContent =
	  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
	    var source = aSourceFile;
	    if (this._sourceRoot != null) {
	      source = util.relative(this._sourceRoot, source);
	    }
	
	    if (aSourceContent != null) {
	      // Add the source content to the _sourcesContents map.
	      // Create a new _sourcesContents map if the property is null.
	      if (!this._sourcesContents) {
	        this._sourcesContents = Object.create(null);
	      }
	      this._sourcesContents[util.toSetString(source)] = aSourceContent;
	    } else if (this._sourcesContents) {
	      // Remove the source file from the _sourcesContents map.
	      // If the _sourcesContents map is empty, set the property to null.
	      delete this._sourcesContents[util.toSetString(source)];
	      if (Object.keys(this._sourcesContents).length === 0) {
	        this._sourcesContents = null;
	      }
	    }
	  };
	
	/**
	 * Applies the mappings of a sub-source-map for a specific source file to the
	 * source map being generated. Each mapping to the supplied source file is
	 * rewritten using the supplied source map. Note: The resolution for the
	 * resulting mappings is the minimium of this map and the supplied map.
	 *
	 * @param aSourceMapConsumer The source map to be applied.
	 * @param aSourceFile Optional. The filename of the source file.
	 *        If omitted, SourceMapConsumer's file property will be used.
	 * @param aSourceMapPath Optional. The dirname of the path to the source map
	 *        to be applied. If relative, it is relative to the SourceMapConsumer.
	 *        This parameter is needed when the two source maps aren't in the same
	 *        directory, and the source map to be applied contains relative source
	 *        paths. If so, those relative source paths need to be rewritten
	 *        relative to the SourceMapGenerator.
	 */
	SourceMapGenerator.prototype.applySourceMap =
	  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
	    var sourceFile = aSourceFile;
	    // If aSourceFile is omitted, we will use the file property of the SourceMap
	    if (aSourceFile == null) {
	      if (aSourceMapConsumer.file == null) {
	        throw new Error(
	          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
	          'or the source map\'s "file" property. Both were omitted.'
	        );
	      }
	      sourceFile = aSourceMapConsumer.file;
	    }
	    var sourceRoot = this._sourceRoot;
	    // Make "sourceFile" relative if an absolute Url is passed.
	    if (sourceRoot != null) {
	      sourceFile = util.relative(sourceRoot, sourceFile);
	    }
	    // Applying the SourceMap can add and remove items from the sources and
	    // the names array.
	    var newSources = new ArraySet();
	    var newNames = new ArraySet();
	
	    // Find mappings for the "sourceFile"
	    this._mappings.unsortedForEach(function (mapping) {
	      if (mapping.source === sourceFile && mapping.originalLine != null) {
	        // Check if it can be mapped by the source map, then update the mapping.
	        var original = aSourceMapConsumer.originalPositionFor({
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        });
	        if (original.source != null) {
	          // Copy mapping
	          mapping.source = original.source;
	          if (aSourceMapPath != null) {
	            mapping.source = util.join(aSourceMapPath, mapping.source)
	          }
	          if (sourceRoot != null) {
	            mapping.source = util.relative(sourceRoot, mapping.source);
	          }
	          mapping.originalLine = original.line;
	          mapping.originalColumn = original.column;
	          if (original.name != null) {
	            mapping.name = original.name;
	          }
	        }
	      }
	
	      var source = mapping.source;
	      if (source != null && !newSources.has(source)) {
	        newSources.add(source);
	      }
	
	      var name = mapping.name;
	      if (name != null && !newNames.has(name)) {
	        newNames.add(name);
	      }
	
	    }, this);
	    this._sources = newSources;
	    this._names = newNames;
	
	    // Copy sourcesContents of applied map.
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aSourceMapPath != null) {
	          sourceFile = util.join(aSourceMapPath, sourceFile);
	        }
	        if (sourceRoot != null) {
	          sourceFile = util.relative(sourceRoot, sourceFile);
	        }
	        this.setSourceContent(sourceFile, content);
	      }
	    }, this);
	  };
	
	/**
	 * A mapping can have one of the three levels of data:
	 *
	 *   1. Just the generated position.
	 *   2. The Generated position, original position, and original source.
	 *   3. Generated and original position, original source, as well as a name
	 *      token.
	 *
	 * To maintain consistency, we validate that any new mapping being added falls
	 * in to one of these categories.
	 */
	SourceMapGenerator.prototype._validateMapping =
	  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
	                                              aName) {
	    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	        && aGenerated.line > 0 && aGenerated.column >= 0
	        && !aOriginal && !aSource && !aName) {
	      // Case 1.
	      return;
	    }
	    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
	             && aGenerated.line > 0 && aGenerated.column >= 0
	             && aOriginal.line > 0 && aOriginal.column >= 0
	             && aSource) {
	      // Cases 2 and 3.
	      return;
	    }
	    else {
	      throw new Error('Invalid mapping: ' + JSON.stringify({
	        generated: aGenerated,
	        source: aSource,
	        original: aOriginal,
	        name: aName
	      }));
	    }
	  };
	
	/**
	 * Serialize the accumulated mappings in to the stream of base 64 VLQs
	 * specified by the source map format.
	 */
	SourceMapGenerator.prototype._serializeMappings =
	  function SourceMapGenerator_serializeMappings() {
	    var previousGeneratedColumn = 0;
	    var previousGeneratedLine = 1;
	    var previousOriginalColumn = 0;
	    var previousOriginalLine = 0;
	    var previousName = 0;
	    var previousSource = 0;
	    var result = '';
	    var next;
	    var mapping;
	    var nameIdx;
	    var sourceIdx;
	
	    var mappings = this._mappings.toArray();
	    for (var i = 0, len = mappings.length; i < len; i++) {
	      mapping = mappings[i];
	      next = ''
	
	      if (mapping.generatedLine !== previousGeneratedLine) {
	        previousGeneratedColumn = 0;
	        while (mapping.generatedLine !== previousGeneratedLine) {
	          next += ';';
	          previousGeneratedLine++;
	        }
	      }
	      else {
	        if (i > 0) {
	          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
	            continue;
	          }
	          next += ',';
	        }
	      }
	
	      next += base64VLQ.encode(mapping.generatedColumn
	                                 - previousGeneratedColumn);
	      previousGeneratedColumn = mapping.generatedColumn;
	
	      if (mapping.source != null) {
	        sourceIdx = this._sources.indexOf(mapping.source);
	        next += base64VLQ.encode(sourceIdx - previousSource);
	        previousSource = sourceIdx;
	
	        // lines are stored 0-based in SourceMap spec version 3
	        next += base64VLQ.encode(mapping.originalLine - 1
	                                   - previousOriginalLine);
	        previousOriginalLine = mapping.originalLine - 1;
	
	        next += base64VLQ.encode(mapping.originalColumn
	                                   - previousOriginalColumn);
	        previousOriginalColumn = mapping.originalColumn;
	
	        if (mapping.name != null) {
	          nameIdx = this._names.indexOf(mapping.name);
	          next += base64VLQ.encode(nameIdx - previousName);
	          previousName = nameIdx;
	        }
	      }
	
	      result += next;
	    }
	
	    return result;
	  };
	
	SourceMapGenerator.prototype._generateSourcesContent =
	  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
	    return aSources.map(function (source) {
	      if (!this._sourcesContents) {
	        return null;
	      }
	      if (aSourceRoot != null) {
	        source = util.relative(aSourceRoot, source);
	      }
	      var key = util.toSetString(source);
	      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
	        ? this._sourcesContents[key]
	        : null;
	    }, this);
	  };
	
	/**
	 * Externalize the source map.
	 */
	SourceMapGenerator.prototype.toJSON =
	  function SourceMapGenerator_toJSON() {
	    var map = {
	      version: this._version,
	      sources: this._sources.toArray(),
	      names: this._names.toArray(),
	      mappings: this._serializeMappings()
	    };
	    if (this._file != null) {
	      map.file = this._file;
	    }
	    if (this._sourceRoot != null) {
	      map.sourceRoot = this._sourceRoot;
	    }
	    if (this._sourcesContents) {
	      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
	    }
	
	    return map;
	  };
	
	/**
	 * Render the source map being generated to a string.
	 */
	SourceMapGenerator.prototype.toString =
	  function SourceMapGenerator_toString() {
	    return JSON.stringify(this.toJSON());
	  };
	
	exports.SourceMapGenerator = SourceMapGenerator;


/***/ },

/***/ 659:
/*!*****************************************!*\
  !*** ./~/source-map/lib/source-node.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var SourceMapGenerator = __webpack_require__(/*! ./source-map-generator */ 268).SourceMapGenerator;
	var util = __webpack_require__(/*! ./util */ 84);
	
	// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
	// operating systems these days (capturing the result).
	var REGEX_NEWLINE = /(\r?\n)/;
	
	// Newline character code for charCodeAt() comparisons
	var NEWLINE_CODE = 10;
	
	// Private symbol for identifying `SourceNode`s when multiple versions of
	// the source-map library are loaded. This MUST NOT CHANGE across
	// versions!
	var isSourceNode = "$$$isSourceNode$$$";
	
	/**
	 * SourceNodes provide a way to abstract over interpolating/concatenating
	 * snippets of generated JavaScript source code while maintaining the line and
	 * column information associated with the original source code.
	 *
	 * @param aLine The original line number.
	 * @param aColumn The original column number.
	 * @param aSource The original source's filename.
	 * @param aChunks Optional. An array of strings which are snippets of
	 *        generated JS, or other SourceNodes.
	 * @param aName The original identifier.
	 */
	function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
	  this.children = [];
	  this.sourceContents = {};
	  this.line = aLine == null ? null : aLine;
	  this.column = aColumn == null ? null : aColumn;
	  this.source = aSource == null ? null : aSource;
	  this.name = aName == null ? null : aName;
	  this[isSourceNode] = true;
	  if (aChunks != null) this.add(aChunks);
	}
	
	/**
	 * Creates a SourceNode from generated code and a SourceMapConsumer.
	 *
	 * @param aGeneratedCode The generated code
	 * @param aSourceMapConsumer The SourceMap for the generated code
	 * @param aRelativePath Optional. The path that relative sources in the
	 *        SourceMapConsumer should be relative to.
	 */
	SourceNode.fromStringWithSourceMap =
	  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
	    // The SourceNode we want to fill with the generated code
	    // and the SourceMap
	    var node = new SourceNode();
	
	    // All even indices of this array are one line of the generated code,
	    // while all odd indices are the newlines between two adjacent lines
	    // (since `REGEX_NEWLINE` captures its match).
	    // Processed fragments are removed from this array, by calling `shiftNextLine`.
	    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
	    var shiftNextLine = function() {
	      var lineContents = remainingLines.shift();
	      // The last line of a file might not have a newline.
	      var newLine = remainingLines.shift() || "";
	      return lineContents + newLine;
	    };
	
	    // We need to remember the position of "remainingLines"
	    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
	
	    // The generate SourceNodes we need a code range.
	    // To extract it current and last mapping is used.
	    // Here we store the last mapping.
	    var lastMapping = null;
	
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      if (lastMapping !== null) {
	        // We add the code from "lastMapping" to "mapping":
	        // First check if there is a new line in between.
	        if (lastGeneratedLine < mapping.generatedLine) {
	          // Associate first line with "lastMapping"
	          addMappingWithCode(lastMapping, shiftNextLine());
	          lastGeneratedLine++;
	          lastGeneratedColumn = 0;
	          // The remaining code is added without mapping
	        } else {
	          // There is no new line in between.
	          // Associate the code between "lastGeneratedColumn" and
	          // "mapping.generatedColumn" with "lastMapping"
	          var nextLine = remainingLines[0];
	          var code = nextLine.substr(0, mapping.generatedColumn -
	                                        lastGeneratedColumn);
	          remainingLines[0] = nextLine.substr(mapping.generatedColumn -
	                                              lastGeneratedColumn);
	          lastGeneratedColumn = mapping.generatedColumn;
	          addMappingWithCode(lastMapping, code);
	          // No more remaining code, continue
	          lastMapping = mapping;
	          return;
	        }
	      }
	      // We add the generated code until the first mapping
	      // to the SourceNode without any mapping.
	      // Each line is added as separate string.
	      while (lastGeneratedLine < mapping.generatedLine) {
	        node.add(shiftNextLine());
	        lastGeneratedLine++;
	      }
	      if (lastGeneratedColumn < mapping.generatedColumn) {
	        var nextLine = remainingLines[0];
	        node.add(nextLine.substr(0, mapping.generatedColumn));
	        remainingLines[0] = nextLine.substr(mapping.generatedColumn);
	        lastGeneratedColumn = mapping.generatedColumn;
	      }
	      lastMapping = mapping;
	    }, this);
	    // We have processed all mappings.
	    if (remainingLines.length > 0) {
	      if (lastMapping) {
	        // Associate the remaining code in the current line with "lastMapping"
	        addMappingWithCode(lastMapping, shiftNextLine());
	      }
	      // and add the remaining lines without any mapping
	      node.add(remainingLines.join(""));
	    }
	
	    // Copy sourcesContent into SourceNode
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aRelativePath != null) {
	          sourceFile = util.join(aRelativePath, sourceFile);
	        }
	        node.setSourceContent(sourceFile, content);
	      }
	    });
	
	    return node;
	
	    function addMappingWithCode(mapping, code) {
	      if (mapping === null || mapping.source === undefined) {
	        node.add(code);
	      } else {
	        var source = aRelativePath
	          ? util.join(aRelativePath, mapping.source)
	          : mapping.source;
	        node.add(new SourceNode(mapping.originalLine,
	                                mapping.originalColumn,
	                                source,
	                                code,
	                                mapping.name));
	      }
	    }
	  };
	
	/**
	 * Add a chunk of generated JS to this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.add = function SourceNode_add(aChunk) {
	  if (Array.isArray(aChunk)) {
	    aChunk.forEach(function (chunk) {
	      this.add(chunk);
	    }, this);
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    if (aChunk) {
	      this.children.push(aChunk);
	    }
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Add a chunk of generated JS to the beginning of this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
	  if (Array.isArray(aChunk)) {
	    for (var i = aChunk.length-1; i >= 0; i--) {
	      this.prepend(aChunk[i]);
	    }
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    this.children.unshift(aChunk);
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Walk over the tree of JS snippets in this node and its children. The
	 * walking function is called once for each snippet of JS and is passed that
	 * snippet and the its original associated source's line/column location.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walk = function SourceNode_walk(aFn) {
	  var chunk;
	  for (var i = 0, len = this.children.length; i < len; i++) {
	    chunk = this.children[i];
	    if (chunk[isSourceNode]) {
	      chunk.walk(aFn);
	    }
	    else {
	      if (chunk !== '') {
	        aFn(chunk, { source: this.source,
	                     line: this.line,
	                     column: this.column,
	                     name: this.name });
	      }
	    }
	  }
	};
	
	/**
	 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
	 * each of `this.children`.
	 *
	 * @param aSep The separator.
	 */
	SourceNode.prototype.join = function SourceNode_join(aSep) {
	  var newChildren;
	  var i;
	  var len = this.children.length;
	  if (len > 0) {
	    newChildren = [];
	    for (i = 0; i < len-1; i++) {
	      newChildren.push(this.children[i]);
	      newChildren.push(aSep);
	    }
	    newChildren.push(this.children[i]);
	    this.children = newChildren;
	  }
	  return this;
	};
	
	/**
	 * Call String.prototype.replace on the very right-most source snippet. Useful
	 * for trimming whitespace from the end of a source node, etc.
	 *
	 * @param aPattern The pattern to replace.
	 * @param aReplacement The thing to replace the pattern with.
	 */
	SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
	  var lastChild = this.children[this.children.length - 1];
	  if (lastChild[isSourceNode]) {
	    lastChild.replaceRight(aPattern, aReplacement);
	  }
	  else if (typeof lastChild === 'string') {
	    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
	  }
	  else {
	    this.children.push(''.replace(aPattern, aReplacement));
	  }
	  return this;
	};
	
	/**
	 * Set the source content for a source file. This will be added to the SourceMapGenerator
	 * in the sourcesContent field.
	 *
	 * @param aSourceFile The filename of the source file
	 * @param aSourceContent The content of the source file
	 */
	SourceNode.prototype.setSourceContent =
	  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
	    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
	  };
	
	/**
	 * Walk over the tree of SourceNodes. The walking function is called for each
	 * source file content and is passed the filename and source content.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walkSourceContents =
	  function SourceNode_walkSourceContents(aFn) {
	    for (var i = 0, len = this.children.length; i < len; i++) {
	      if (this.children[i][isSourceNode]) {
	        this.children[i].walkSourceContents(aFn);
	      }
	    }
	
	    var sources = Object.keys(this.sourceContents);
	    for (var i = 0, len = sources.length; i < len; i++) {
	      aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
	    }
	  };
	
	/**
	 * Return the string representation of this source node. Walks over the tree
	 * and concatenates all the various snippets together to one string.
	 */
	SourceNode.prototype.toString = function SourceNode_toString() {
	  var str = "";
	  this.walk(function (chunk) {
	    str += chunk;
	  });
	  return str;
	};
	
	/**
	 * Returns the string representation of this source node along with a source
	 * map.
	 */
	SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
	  var generated = {
	    code: "",
	    line: 1,
	    column: 0
	  };
	  var map = new SourceMapGenerator(aArgs);
	  var sourceMappingActive = false;
	  var lastOriginalSource = null;
	  var lastOriginalLine = null;
	  var lastOriginalColumn = null;
	  var lastOriginalName = null;
	  this.walk(function (chunk, original) {
	    generated.code += chunk;
	    if (original.source !== null
	        && original.line !== null
	        && original.column !== null) {
	      if(lastOriginalSource !== original.source
	         || lastOriginalLine !== original.line
	         || lastOriginalColumn !== original.column
	         || lastOriginalName !== original.name) {
	        map.addMapping({
	          source: original.source,
	          original: {
	            line: original.line,
	            column: original.column
	          },
	          generated: {
	            line: generated.line,
	            column: generated.column
	          },
	          name: original.name
	        });
	      }
	      lastOriginalSource = original.source;
	      lastOriginalLine = original.line;
	      lastOriginalColumn = original.column;
	      lastOriginalName = original.name;
	      sourceMappingActive = true;
	    } else if (sourceMappingActive) {
	      map.addMapping({
	        generated: {
	          line: generated.line,
	          column: generated.column
	        }
	      });
	      lastOriginalSource = null;
	      sourceMappingActive = false;
	    }
	    for (var idx = 0, length = chunk.length; idx < length; idx++) {
	      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
	        generated.line++;
	        generated.column = 0;
	        // Mappings end at eol
	        if (idx + 1 === length) {
	          lastOriginalSource = null;
	          sourceMappingActive = false;
	        } else if (sourceMappingActive) {
	          map.addMapping({
	            source: original.source,
	            original: {
	              line: original.line,
	              column: original.column
	            },
	            generated: {
	              line: generated.line,
	              column: generated.column
	            },
	            name: original.name
	          });
	        }
	      } else {
	        generated.column++;
	      }
	    }
	  });
	  this.walkSourceContents(function (sourceFile, sourceContent) {
	    map.setSourceContent(sourceFile, sourceContent);
	  });
	
	  return { code: generated.code, map: map };
	};
	
	exports.SourceNode = SourceNode;


/***/ },

/***/ 84:
/*!**********************************!*\
  !*** ./~/source-map/lib/util.js ***!
  \**********************************/
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	/**
	 * This is a helper function for getting values from parameter/options
	 * objects.
	 *
	 * @param args The object we are extracting values from
	 * @param name The name of the property we are getting.
	 * @param defaultValue An optional value to return if the property is missing
	 * from the object. If this is not specified and the property is missing, an
	 * error will be thrown.
	 */
	function getArg(aArgs, aName, aDefaultValue) {
	  if (aName in aArgs) {
	    return aArgs[aName];
	  } else if (arguments.length === 3) {
	    return aDefaultValue;
	  } else {
	    throw new Error('"' + aName + '" is a required argument.');
	  }
	}
	exports.getArg = getArg;
	
	var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
	var dataUrlRegexp = /^data:.+\,.+$/;
	
	function urlParse(aUrl) {
	  var match = aUrl.match(urlRegexp);
	  if (!match) {
	    return null;
	  }
	  return {
	    scheme: match[1],
	    auth: match[2],
	    host: match[3],
	    port: match[4],
	    path: match[5]
	  };
	}
	exports.urlParse = urlParse;
	
	function urlGenerate(aParsedUrl) {
	  var url = '';
	  if (aParsedUrl.scheme) {
	    url += aParsedUrl.scheme + ':';
	  }
	  url += '//';
	  if (aParsedUrl.auth) {
	    url += aParsedUrl.auth + '@';
	  }
	  if (aParsedUrl.host) {
	    url += aParsedUrl.host;
	  }
	  if (aParsedUrl.port) {
	    url += ":" + aParsedUrl.port
	  }
	  if (aParsedUrl.path) {
	    url += aParsedUrl.path;
	  }
	  return url;
	}
	exports.urlGenerate = urlGenerate;
	
	/**
	 * Normalizes a path, or the path portion of a URL:
	 *
	 * - Replaces consecutive slashes with one slash.
	 * - Removes unnecessary '.' parts.
	 * - Removes unnecessary '<dir>/..' parts.
	 *
	 * Based on code in the Node.js 'path' core module.
	 *
	 * @param aPath The path or url to normalize.
	 */
	function normalize(aPath) {
	  var path = aPath;
	  var url = urlParse(aPath);
	  if (url) {
	    if (!url.path) {
	      return aPath;
	    }
	    path = url.path;
	  }
	  var isAbsolute = exports.isAbsolute(path);
	
	  var parts = path.split(/\/+/);
	  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
	    part = parts[i];
	    if (part === '.') {
	      parts.splice(i, 1);
	    } else if (part === '..') {
	      up++;
	    } else if (up > 0) {
	      if (part === '') {
	        // The first part is blank if the path is absolute. Trying to go
	        // above the root is a no-op. Therefore we can remove all '..' parts
	        // directly after the root.
	        parts.splice(i + 1, up);
	        up = 0;
	      } else {
	        parts.splice(i, 2);
	        up--;
	      }
	    }
	  }
	  path = parts.join('/');
	
	  if (path === '') {
	    path = isAbsolute ? '/' : '.';
	  }
	
	  if (url) {
	    url.path = path;
	    return urlGenerate(url);
	  }
	  return path;
	}
	exports.normalize = normalize;
	
	/**
	 * Joins two paths/URLs.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be joined with the root.
	 *
	 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	 *   first.
	 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	 *   is updated with the result and aRoot is returned. Otherwise the result
	 *   is returned.
	 *   - If aPath is absolute, the result is aPath.
	 *   - Otherwise the two paths are joined with a slash.
	 * - Joining for example 'http://' and 'www.example.com' is also supported.
	 */
	function join(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	  if (aPath === "") {
	    aPath = ".";
	  }
	  var aPathUrl = urlParse(aPath);
	  var aRootUrl = urlParse(aRoot);
	  if (aRootUrl) {
	    aRoot = aRootUrl.path || '/';
	  }
	
	  // `join(foo, '//www.example.org')`
	  if (aPathUrl && !aPathUrl.scheme) {
	    if (aRootUrl) {
	      aPathUrl.scheme = aRootUrl.scheme;
	    }
	    return urlGenerate(aPathUrl);
	  }
	
	  if (aPathUrl || aPath.match(dataUrlRegexp)) {
	    return aPath;
	  }
	
	  // `join('http://', 'www.example.com')`
	  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
	    aRootUrl.host = aPath;
	    return urlGenerate(aRootUrl);
	  }
	
	  var joined = aPath.charAt(0) === '/'
	    ? aPath
	    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
	
	  if (aRootUrl) {
	    aRootUrl.path = joined;
	    return urlGenerate(aRootUrl);
	  }
	  return joined;
	}
	exports.join = join;
	
	exports.isAbsolute = function (aPath) {
	  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
	};
	
	/**
	 * Make a path relative to a URL or another path.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be made relative to aRoot.
	 */
	function relative(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	
	  aRoot = aRoot.replace(/\/$/, '');
	
	  // It is possible for the path to be above the root. In this case, simply
	  // checking whether the root is a prefix of the path won't work. Instead, we
	  // need to remove components from the root one by one, until either we find
	  // a prefix that fits, or we run out of components to remove.
	  var level = 0;
	  while (aPath.indexOf(aRoot + '/') !== 0) {
	    var index = aRoot.lastIndexOf("/");
	    if (index < 0) {
	      return aPath;
	    }
	
	    // If the only part of the root that is left is the scheme (i.e. http://,
	    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
	    // have exhausted all components, so the path is not relative to the root.
	    aRoot = aRoot.slice(0, index);
	    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
	      return aPath;
	    }
	
	    ++level;
	  }
	
	  // Make sure we add a "../" for each component we removed from the root.
	  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
	}
	exports.relative = relative;
	
	var supportsNullProto = (function () {
	  var obj = Object.create(null);
	  return !('__proto__' in obj);
	}());
	
	function identity (s) {
	  return s;
	}
	
	/**
	 * Because behavior goes wacky when you set `__proto__` on objects, we
	 * have to prefix all the strings in our set with an arbitrary character.
	 *
	 * See https://github.com/mozilla/source-map/pull/31 and
	 * https://github.com/mozilla/source-map/issues/30
	 *
	 * @param String aStr
	 */
	function toSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return '$' + aStr;
	  }
	
	  return aStr;
	}
	exports.toSetString = supportsNullProto ? identity : toSetString;
	
	function fromSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return aStr.slice(1);
	  }
	
	  return aStr;
	}
	exports.fromSetString = supportsNullProto ? identity : fromSetString;
	
	function isProtoString(s) {
	  if (!s) {
	    return false;
	  }
	
	  var length = s.length;
	
	  if (length < 9 /* "__proto__".length */) {
	    return false;
	  }
	
	  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
	      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
	      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
	      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 9) !== 95  /* '_' */) {
	    return false;
	  }
	
	  for (var i = length - 10; i >= 0; i--) {
	    if (s.charCodeAt(i) !== 36 /* '$' */) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Comparator between two mappings where the original positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same original source/line/column, but different generated
	 * line and column the same. Useful when searching for a mapping with a
	 * stubbed out mapping.
	 */
	function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
	  var cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0 || onlyCompareOriginal) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByOriginalPositions = compareByOriginalPositions;
	
	/**
	 * Comparator between two mappings with deflated source and name indices where
	 * the generated positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same generated line and column, but different
	 * source/name/original line and column the same. Useful when searching for a
	 * mapping with a stubbed out mapping.
	 */
	function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0 || onlyCompareGenerated) {
	    return cmp;
	  }
	
	  cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	
	function strcmp(aStr1, aStr2) {
	  if (aStr1 === aStr2) {
	    return 0;
	  }
	
	  if (aStr1 > aStr2) {
	    return 1;
	  }
	
	  return -1;
	}
	
	/**
	 * Comparator between two mappings with inflated source and name strings where
	 * the generated positions are compared.
	 */
	function compareByGeneratedPositionsInflated(mappingA, mappingB) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = strcmp(mappingA.source, mappingB.source);
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;


/***/ },

/***/ 660:
/*!************************************!*\
  !*** ./~/source-map/source-map.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2009-2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE.txt or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	exports.SourceMapGenerator = __webpack_require__(/*! ./lib/source-map-generator */ 268).SourceMapGenerator;
	exports.SourceMapConsumer = __webpack_require__(/*! ./lib/source-map-consumer */ 658).SourceMapConsumer;
	exports.SourceNode = __webpack_require__(/*! ./lib/source-node */ 659).SourceNode;


/***/ },

/***/ 29:
/*!*************************************!*\
  !*** ./~/style-loader/addStyles.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },

/***/ 269:
/*!*************************************!*\
  !*** ./~/timers-browserify/main.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(/*! setimmediate */ 653);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },

/***/ 179:
/*!**************************!*\
  !*** ./src/apis/base.js ***!
  \**************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchBase = exports.getPretty = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	var pretty = true;
	var getPretty = exports.getPretty = function getPretty() {
	  return pretty;
	};
	var fetchBase = exports.fetchBase = function fetchBase() {
	  if (false) {
	    return Promise.resolve();
	  }
	  return new Promise(function (resolve, reject) {
	    var cleanUp = function cleanUp() {}; // WILL REASSIGN
	    var xmlhttp = new XMLHttpRequest();
	    var handleLoad = function handleLoad() {
	      var status = xmlhttp.status;
	      if (status !== 200) {
	        reject({ message: status.toString() });
	        cleanUp();
	        return;
	      }
	      var link = xmlhttp.getResponseHeader('Link');
	      if (link.indexOf('?') !== -1) {
	        pretty = false;
	      }
	      resolve();
	      cleanUp();
	    };
	    var handleError = function handleError() {
	      reject({ message: '500' });
	      cleanUp();
	    };
	    cleanUp = function cleanUp() {
	      xmlhttp.removeEventListener('load', handleLoad);
	      xmlhttp.removeEventListener('error', handleError);
	      xmlhttp.removeEventListener('abort', handleError);
	    };
	    xmlhttp.addEventListener('load', handleLoad);
	    xmlhttp.addEventListener('error', handleError);
	    xmlhttp.addEventListener('abort', handleError);
	    xmlhttp.open('HEAD', _strings.SITE_URL, true);
	    xmlhttp.send();
	  });
	};

/***/ },

/***/ 270:
/*!******************************!*\
  !*** ./src/apis/endpoint.js ***!
  \******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	var _base = __webpack_require__(/*! ./base */ 179);
	
	var _rest = __webpack_require__(/*! ../util/rest */ 190);
	
	var fromRest = _interopRequireWildcard(_rest);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// eslint-disable-next-line
	var get = exports.get = function get(id) {
	  if ((0, _base.getPretty)()) {
	    return fromRest.get(_strings.SITE_URL + 'fs-endpoint?futusign_screen_id=' + id.toString());
	  }
	  return fromRest.get(_strings.SITE_URL + '?futusign_endpoint=1&futusign_screen_id=' + id.toString());
	};

/***/ },

/***/ 676:
/*!****************************************!*\
  !*** ./src/components/App/Bad/bad.png ***!
  \****************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 472:
/*!*************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Bad/index.css ***!
  \*************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_1OGhqMRiiKp810B-C-VLYh{position:fixed;top:0;left:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;z-index:1;width:100%;height:100%}", ""]);
	
	// exports
	exports.locals = {
		"root": "_1OGhqMRiiKp810B-C-VLYh"
	};

/***/ },

/***/ 661:
/*!******************************************!*\
  !*** ./src/components/App/Bad/index.css ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../~/css-loader?module&-autoprefixer!./../../../../~/postcss-loader!./index.css */ 472);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 271:
/*!******************************************!*\
  !*** ./src/components/App/Bad/index.jsx ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(/*! ./index.css */ 661);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _bad = __webpack_require__(/*! ./bad.png */ 676);
	
	var _bad2 = _interopRequireDefault(_bad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    {
	      id: _index2.default.root
	    },
	    _react2.default.createElement('img', {
	      src: _bad2.default,
	      alt: 'bad',
	      width: '113',
	      height: '150'
	    })
	  );
	};

/***/ },

/***/ 473:
/*!******************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Blocking/index.css ***!
  \******************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_-RRn_IhEMAI1-Nq6yHuDY{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;position:absolute;left:0;top:0;width:100%;height:100%}#_348jqD4F3twh0Cev9zg1Jh{-webkit-animation:z3RqLRaXuFqxQ7MmvkO6y 2s infinite linear;animation:z3RqLRaXuFqxQ7MmvkO6y 2s infinite linear}@-webkit-keyframes z3RqLRaXuFqxQ7MmvkO6y{0%{-webkit-transform:scale(1) rotate(0deg);transform:scale(1) rotate(0deg)}to{-webkit-transform:scale(1) rotate(1turn);transform:scale(1) rotate(1turn)}}@keyframes z3RqLRaXuFqxQ7MmvkO6y{0%{-webkit-transform:scale(1) rotate(0deg);transform:scale(1) rotate(0deg)}to{-webkit-transform:scale(1) rotate(1turn);transform:scale(1) rotate(1turn)}}", ""]);
	
	// exports
	exports.locals = {
		"root": "_-RRn_IhEMAI1-Nq6yHuDY",
		"rootSpinner": "_348jqD4F3twh0Cev9zg1Jh",
		"spin": "z3RqLRaXuFqxQ7MmvkO6y"
	};

/***/ },

/***/ 662:
/*!***********************************************!*\
  !*** ./src/components/App/Blocking/index.css ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../~/css-loader?module&-autoprefixer!./../../../../~/postcss-loader!./index.css */ 473);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 272:
/*!***********************************************!*\
  !*** ./src/components/App/Blocking/index.jsx ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(/*! ./index.css */ 662);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _spinner = __webpack_require__(/*! ./spinner.png */ 677);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    {
	      id: _index2.default.root
	    },
	    _react2.default.createElement('img', {
	      id: _index2.default.rootSpinner,
	      src: _spinner2.default,
	      alt: 'spinner',
	      width: '150',
	      height: '150'
	    })
	  );
	};

/***/ },

/***/ 677:
/*!*************************************************!*\
  !*** ./src/components/App/Blocking/spinner.png ***!
  \*************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAEDUlEQVR42u3dzXHiQBCGYTJwCK7yyUgHh+AQNgSFwBEoHxwCITgEQtgQCMEhOANrxcD+1FLGGCMxrXm66jsCgn6rp6enp5lMGGOMMVaqtfO7m3Z5/9jOqx/tonpOWlbr90X98yvavubP67fvld7z7sYvXARE9UM7n87aZb3awVC3Q2j/Wav02d0z8MRIQBoSoi/BBrRIMKUl7eV9Ub3mBtPHkHXP2j3z9tl5MLfIFAymzyETya6YdNdNlzRvosP0sdJ3a2wChgIq7dzqt/ECdaC33W4TYH1FqFVhQB0ClnaXALsMVLsI1dI/6n4TZHxnh1d2hPo8gtlJfm2Xl2PtKd+d5LYmZhd5PI/aVcYBc45SwVX+dViLGnXpYMAShej1G6oUpeRSF829prPCSwjVGgi9Ra91cUvjHipL3yBLY0FwWfoGL6w2pYDF4cOrARb1VbF/ARaBC1jgAhaNN+fiVHABC1zAonN1/wgs6ul8cQSH1xyZK1zBj384Md+mQWBRX1oBi3rqRg3aS895AfKtp+ktsKiXXi5gUW8XNIBF/SjSkshhShDAojhLImepygOL4gwi4SiJPLAoTkszJ4lawKI4h9Sc4xwRWBRnh8g58aMWsKic2z2covQALDpyhpjZMQ+nWA6BRUfHUQKLxr8ccogbPcCiOLtDDhlT63L1Ciwad8cDZ8izgEVxWmk4whUxYNFJAhaNN4HnCHNMgUVxbktzhHZlYFGcTgdOUHIAFgGLCr+5wwmKpMAiYBGwOAJYwCJgEbAIWMAiYBGwyJEOsAhYBCxyBQxYpIOUChzCxglu6QCL4gxg4wjFUWCR2Q1U8I4QWOZjAYtM9KNr5VdmkFI/+ZWpyTTSijuwFEaBRadMmNlMcjIOMWwNWJR/mQFYBq0Bi+LsBoE1nllY2f1tL7D0twOLYiTtwHKEAyyKFa2AJVoBi+JEK2CJVsCiv3Wr3KMVsFyWABbl1XoMLFfngUWxE3ZgxVsCszxoBlb07tD6YRLNOE7LMbB0hgKLCsyrgBWhKzRgXgUsE2OA5WIEsKiQc0BgqawDC1QTYJHlD1gSdWCBClgEqk/AqjYcPdxwtPAV9ZPBmt/dgGsoqAKf/Z0NV7fl5fz+ygnFQfVfvtWkA1AwXO4wuYR86rToVT9YGuVT/S2N8+kMHOd3fRa99IleotSVAZvOUkcjeI50ewbtTc+jLFGvgHQ4qtGydwnAnqa32yZ/QHW/QYThHDEBKzKCrQA1FGCL6nnk9a+39B0Bdb0C6/bPrseTlKfvosCZWx0sImTpmdWhwuRiTdZnkbtnayx10Yuuqapfra9RG9t9ZrejS1FJMXPkudn94z6qPe+A2y6h36n4V5v9e6z3G4sm1NAyxhhjjDGWvf0C+DtiBQQE6vwAAAAASUVORK5CYII="

/***/ },

/***/ 474:
/*!*******************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Connected/index.css ***!
  \*******************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_1NsI7esKBxIxEcDNvI-E6V{position:fixed;top:0;left:0;z-index:3;border:10px solid transparent;width:100%;height:100%;-webkit-transition:opacity 10s;transition:opacity 10s}", ""]);
	
	// exports
	exports.locals = {
		"root": "_1NsI7esKBxIxEcDNvI-E6V"
	};

/***/ },

/***/ 663:
/*!************************************************!*\
  !*** ./src/components/App/Connected/index.css ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../~/css-loader?module&-autoprefixer!./../../../../~/postcss-loader!./index.css */ 474);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 273:
/*!************************************************!*\
  !*** ./src/components/App/Connected/index.jsx ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(/*! ./index.css */ 663);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Connected = function Connected(_ref) {
	  var connected = _ref.connected;
	  return _react2.default.createElement('div', {
	    id: _index2.default.root,
	    style: {
	      opacity: connected ? 0 : 1,
	      borderColor: connected ? '#5cb85c' : '#d9534f'
	    }
	  });
	};
	Connected.propTypes = {
	  connected: _react.PropTypes.bool.isRequired
	};
	exports.default = Connected;

/***/ },

/***/ 475:
/*!***************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Cover/index.css ***!
  \***************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_2C1VFfdec87bMdI_uDvYvD{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;background-color:#000}#_3pnZo__fSUgz6Jt8FHD01A{-webkit-animation:_2vqnoLGzNgMIELDpFlncpz 2s infinite linear;animation:_2vqnoLGzNgMIELDpFlncpz 2s infinite linear}@-webkit-keyframes _2vqnoLGzNgMIELDpFlncpz{0%{-webkit-transform:scale(1) rotate(0deg);transform:scale(1) rotate(0deg)}to{-webkit-transform:scale(1) rotate(1turn);transform:scale(1) rotate(1turn)}}@keyframes _2vqnoLGzNgMIELDpFlncpz{0%{-webkit-transform:scale(1) rotate(0deg);transform:scale(1) rotate(0deg)}to{-webkit-transform:scale(1) rotate(1turn);transform:scale(1) rotate(1turn)}}", ""]);
	
	// exports
	exports.locals = {
		"root": "_2C1VFfdec87bMdI_uDvYvD",
		"rootSpinner": "_3pnZo__fSUgz6Jt8FHD01A",
		"spin": "_2vqnoLGzNgMIELDpFlncpz"
	};

/***/ },

/***/ 664:
/*!********************************************!*\
  !*** ./src/components/App/Cover/index.css ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../~/css-loader?module&-autoprefixer!./../../../../~/postcss-loader!./index.css */ 475);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 274:
/*!********************************************!*\
  !*** ./src/components/App/Cover/index.jsx ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(/*! ./index.css */ 664);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _loading = __webpack_require__(/*! ./loading.png */ 678);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cover = function Cover() {
	  return _react2.default.createElement(
	    'div',
	    {
	      id: _index2.default.root
	    },
	    _react2.default.createElement('img', {
	      id: _index2.default.rootSpinner,
	      src: _loading2.default,
	      alt: 'spinner',
	      width: '150',
	      height: '150'
	    })
	  );
	};
	exports.default = Cover;

/***/ },

/***/ 678:
/*!**********************************************!*\
  !*** ./src/components/App/Cover/loading.png ***!
  \**********************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 476:
/*!****************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Layers/index.css ***!
  \****************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_2bv72mmzdg7gKyUmefeVrD{position:fixed;top:0;left:0;z-index:5;width:100%;height:100%}._2gSRcxtvNU7pEPBzY7zG12{position:absolute;top:0;left:0;border:none;width:100%;height:100%}", ""]);
	
	// exports
	exports.locals = {
		"root": "_2bv72mmzdg7gKyUmefeVrD",
		"rootLayer": "_2gSRcxtvNU7pEPBzY7zG12"
	};

/***/ },

/***/ 665:
/*!*********************************************!*\
  !*** ./src/components/App/Layers/index.css ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../~/css-loader?module&-autoprefixer!./../../../../~/postcss-loader!./index.css */ 476);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 275:
/*!*********************************************!*\
  !*** ./src/components/App/Layers/index.jsx ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(/*! ./index.css */ 665);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layers = function Layers(_ref) {
	  var layers = _ref.layers;
	  return _react2.default.createElement(
	    'div',
	    { id: _index2.default.root },
	    layers.map(function (o, i) {
	      return _react2.default.createElement('iframe', {
	        key: i.toString(),
	        src: o.url,
	        frameBorder: '0',
	        style: {
	          zIndex: i
	        },
	        className: _index2.default.rootLayer
	      });
	    })
	  );
	};
	Layers.propTypes = {
	  layers: _react.PropTypes.array.isRequired
	};
	exports.default = Layers;

/***/ },

/***/ 477:
/*!*****************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/NoMedia/index.css ***!
  \*****************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_2GT4mhR0OmV5P-cu5RlIua{position:fixed;top:0;left:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;z-index:1;width:100%;height:100%}", ""]);
	
	// exports
	exports.locals = {
		"root": "_2GT4mhR0OmV5P-cu5RlIua"
	};

/***/ },

/***/ 666:
/*!**********************************************!*\
  !*** ./src/components/App/NoMedia/index.css ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../~/css-loader?module&-autoprefixer!./../../../../~/postcss-loader!./index.css */ 477);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 276:
/*!**********************************************!*\
  !*** ./src/components/App/NoMedia/index.jsx ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(/*! ./index.css */ 666);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _noMedia = __webpack_require__(/*! ./noMedia.png */ 679);
	
	var _noMedia2 = _interopRequireDefault(_noMedia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    {
	      id: _index2.default.root
	    },
	    _react2.default.createElement('img', {
	      src: _noMedia2.default,
	      alt: 'no media',
	      width: '150',
	      height: '150'
	    })
	  );
	};

/***/ },

/***/ 679:
/*!************************************************!*\
  !*** ./src/components/App/NoMedia/noMedia.png ***!
  \************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 478:
/*!*****************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Offline/index.css ***!
  \*****************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_1a3WM7rTT_gscW3SlmaRmY{position:fixed;top:0;left:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;z-index:1;width:100%;height:100%}", ""]);
	
	// exports
	exports.locals = {
		"root": "_1a3WM7rTT_gscW3SlmaRmY"
	};

/***/ },

/***/ 667:
/*!**********************************************!*\
  !*** ./src/components/App/Offline/index.css ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../~/css-loader?module&-autoprefixer!./../../../../~/postcss-loader!./index.css */ 478);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 277:
/*!**********************************************!*\
  !*** ./src/components/App/Offline/index.jsx ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(/*! ./index.css */ 667);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _offline = __webpack_require__(/*! ./offline.png */ 680);
	
	var _offline2 = _interopRequireDefault(_offline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    {
	      id: _index2.default.root
	    },
	    _react2.default.createElement('img', {
	      src: _offline2.default,
	      alt: 'offline',
	      width: '150',
	      height: '150'
	    })
	  );
	};

/***/ },

/***/ 680:
/*!************************************************!*\
  !*** ./src/components/App/Offline/offline.png ***!
  \************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 479:
/*!**********************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/OfflineImage/index.css ***!
  \**********************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_1o-Vb8uqtG4SFvTxfLOITf{left:0;top:0;width:100%;height:100%}#_1o-Vb8uqtG4SFvTxfLOITf,#_2j3jBo-uq2mM9xR40uQU_q{position:absolute;background-repeat:no-repeat;background-size:cover;background-position:50%}#_2j3jBo-uq2mM9xR40uQU_q{right:20px;bottom:20px;width:100px;height:100px}", ""]);
	
	// exports
	exports.locals = {
		"root": "_1o-Vb8uqtG4SFvTxfLOITf",
		"rootOffline": "_2j3jBo-uq2mM9xR40uQU_q"
	};

/***/ },

/***/ 668:
/*!***************************************************!*\
  !*** ./src/components/App/OfflineImage/index.css ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../~/css-loader?module&-autoprefixer!./../../../../~/postcss-loader!./index.css */ 479);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 278:
/*!***************************************************!*\
  !*** ./src/components/App/OfflineImage/index.jsx ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(/*! ./index.css */ 668);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _offline = __webpack_require__(/*! ./offline.png */ 681);
	
	var _offline2 = _interopRequireDefault(_offline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerImages = function PlayerImages() {
	  var file = window.localStorage.getItem('futusign_image_file');
	  return _react2.default.createElement(
	    'div',
	    {
	      id: _index2.default.root,
	      style: { backgroundImage: 'url(' + file + ')' }
	    },
	    _react2.default.createElement('div', {
	      id: _index2.default.rootOffline,
	      style: { backgroundImage: 'url(' + _offline2.default + ')' }
	    })
	  );
	};
	exports.default = PlayerImages;

/***/ },

/***/ 681:
/*!*****************************************************!*\
  !*** ./src/components/App/OfflineImage/offline.png ***!
  \*****************************************************/
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADdgAAA3YBfdWCzAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAACAASURBVHic7Z15mBTltYffX/UwMICAJurVEEMMCtMNxAQ1rjGocTe4YfTGaK5GEpO4kBjcYOabGdzNVWPc18R9X2LUmxjcExUxBuluMC4YEZe4omzDdJ37RzWITFWv1bMo7/P4yEx9y5meb6rqO985vyM+p9jRw/sypH440khgIzz/y5i3AdhQsEHIWwtsCMZaQN0qXTsQH2F8CHwMfAAsQHoDnzfAn4fpBZbUvaBzZi3qjp+tJ6DuNqArsMkj1qJ/n7H4uS2QtkR8AzQMs0RNJxavYfZPTM/geTNpZ4ZOm/1WTefsIXwmF5YdPbwvX+izPWhHjHHA5nz6rtOdZJA9hO89RLs3XWc8/353G1QLPjMLy9zwQdBnD0z7InbPP8J6Oh3Ao4i7WW5369Tsq91tUFz06oVlE0iQahwH3qFg+2EM6G6bqkKaie9fi5e7Xu6Fd7rbnGrolQvLTmn8CnX6KXA4sF532xM7YhnYHeS8C9WWfqK7zamEXrWwbGpyexKaBHwv1hdvKYfZW8B8xBsYb4E+QP5HwMfgLV7Z1mcAnj8AGAgaAloP89dH3gZgG2L0jc2ugOcQF4Cuk0u3xzx2zegVC8uaUrvi2SkY21c9WLBTmxE8djQXszkk9K84fmnBo3n0V8DfFPyRmPcNZGNBI6v+QxCv4XM2Hy28QufOX1KtrbWmRy8smzpyBxLemRjfqngQaS4wPf/f43LpN+Oyr1Ts+DEDGJj7FsY4ZOOALTH6VDSYeAs0jQX9LtVlM5fHa2l89MiFZVOTKTw7A7RX2Z2lHPA4+HeB3SU3Z17sBlaJnbDxYPr23Q2P8Zh2B4aUPYh4Cd9OoTV7i8Dit7I6etTCCv6yO36NcRJQX2b3DKY/4PH77rgrVYq5VD0+u+IxATgAs4Yyh3gceT+Xmz2rFvZVSo9ZWNaUnICnczH7UsmdxCLgOvAu6mkfbCWYS62Db/+Dx1EYXyujaweyC1jsN+usuR/VzMAy6PaFZScNX5e+9Rdj7F9GtwUY/4tXf6Xccx/UzLhuwhwefuPuiONB3ymj6zykI+TS02tlW6l068KypsZ9kS6hdF/UPMSZvNt+tS54cVktbesp2NTUtnh2MrBHaR0wxIWo4QS5mYuLd6gN3bKw7OjhfVmn/izgmBK7vIfpLN5fdt7nZUGtjk1NfouEzsRshxK7zEHe97vrFaHLF5ZNadyEOt2M8Y2ijcVyTOeydMlpOvPlD7vAvB6PucZ9QOeU+A62GHG0XOaqmhu2Gl26sMyN2gXzb6aU7bX0CDn7udoy6dpb1rvI7yQnIXNAv+I9dAXi513pue+yhWVNjcfieb8pwQP9Aabj1Jr+fZcY1osxlxqO2ZXAt0to/ijt7Qfo9Bf/U2u7oAsWVnDMkboAs6NKaP1n1OcIuVnza23XZwVzeNB4DKZTgf5Fms8jl9tN0+bOrbVdNV1YQcBd/fUluBLaMZ1Ia/q8nuhF7g3YlFGN1NnNmI0u0vQdpD3l0k/X0p6aLSybPGItGrx7SvDDzMPnILVlnqqVLZ8XbNLQBgYN/i3Yj4s0/Rh5+8vN/nOtbKnJwgpizBP3Y2xbZPaHWOZP0Olz3q2FHZ9XzCUPx7iYQsdiQczXfnLZ+2phgxf3gHb8mAE0ePcUX1R2OQsadl2zqOJHLnMV8sYFkRARGH0x3Wku9b2a2BDnYOaG9YMBDxR04hkGdoJas2fHOfcaOmNu5DDM+z9g08hGYhm+7a3W7F/inDu2O5ZNIIH1v7bgopJyYEeuWVRdg9yceUhbI/09spHRF+kuc6O2iXPu+B6FyeRFwAGR18Uy0D5qzV4Z25xrKIpc+j1gF4JAxyj6g91lU0aMiG3eOAYxlzweo9BdqB1pglz6njjmW0P5BDvGQfcAOxdoNo/29i3jcKJWfceypuTuoDMiG4jlwdZ2zaLqTnTu/CWoYTyF71zD6Ft/s00cW1nY9CpUtbDMjdwUcUPBY5qcfiw3+95q5llDPMjNXIw0HuyZyEbGODZY8ttq56p4YQU7QO8mih0oJ2w/mzS03HDbNdQIufTHKLc7MKdAs5+aazy0mnkqv2NZ//NDQ19WP5AxxjNo0HRzm36x4rnWECtyL7xDLrcHEJ1tbbrQpoxqrHSOihaWueSBwMTQi+Hbga2wukfMpTaqZL41xI+mzX0F2f6IqBSygST8Wyp92pS9KzSX+i+w2RhfqGC218ixe0+KsTK32RBYtjG+91U8NsBsXWA9xBcwG4zUAOqf18oKPi/xIcgH6yAI83kf7APQO5jNx7PXyOlVEnpVLv1xt/6ARTCXmojZpZENZOfKZX9Z7rjlL6zmxttB+4VftFw+r6/QGdX75Bivtsxj5c5dDTZpaAMDB38T+WPw9PUgCkAjgXVqOrH0OuankZ7HJ43pWeakZ+tWcjWdtwzMNV6D6bCIyz7ydpKb/XA5Y5a1sKwpdTCyGwqMdix4s8DuwmxwgXbL8PmhWjO3ljN/OZjbbAj+snHI+zayrYFvVpx9HDeBIuBTwN8wexxvyWNy85Z2lzn5fM6nMFIRTV5mUd2YchQKS15Y5oYPwurnAv8VPpL+hEvvLTBzjaMw3Q8MjZ5ZOXz/aLVmLy7VhqI2Th05loTGY/ou0hY1V+yLC2kJ2MPAA+A/IDfnha42Icg+5xmiQp1lZ8plTyx1vDIWVuo8zI6NuPwBqhu9auRnXmroAWBkYQvsTFz2pEoD/IIzLjsQbB+Mr1QyRo9Deh7fvxmfWzQt+6+umrbICUoH8saWmvVT0sKyqSNH43nPEiW3aHaoWrPXdjY0tQ5Y8RAauAatd6Tcwx0l2eNGb4yf+yHiEGB4KX16Mc9iXEN74rpay0oGYeTJR6J/X/awWrLjShmrtIXVnPwTUQmT0l/k0rtE9nVj+2OLby4q8CH+CA0HRSVZBtnBqT3x7CiMXalBLFkPZynSreTs8lpufGzKiBEkErOI2oDJ9pXL3lVsnKILy1zjtzE9EnG5HSW+Lvd8IS9u8JcQRD+E+74+seYp6NhrVZlEc6mB+P4RSMcBw4rZ+7lA/AN0Dqx7S6l3+XIwl5qG2Snhc2suC/qNLiahVHxhNSf/DmwVcfk0tWTCDVh9HBAu2YzRXLChyIJ2g+WLsT7Hgv2MWrsEeiviVXw7F6//5XGm09ukoQ0MHpzG7KsR8x4ll7mksGmFJnCp3TC7P7yn/sPijq+Vq26Sj8e+lELy2MF2XMDAcsb+3CL9B5/f4C06Py63hbnkgRg3R1yez3vtwwvJHRR5T7GTC1xsrUQyJ4jHtgnBFjtqWtZizaIqHbN1kZ2B9c+aazw0yDWsEpe5FexvEVeHsnb9jwp1jzTApia3j9T8lF4BLivVxk7dXfYu8HdErEmkiJdhmH6PJWdUG2osMMRJBRqcWChuK/JRaM3Ju4HwDA7pJ3LpihfWyjmakrvjcQdWiv5Al7AY+DewADQfeBOzxXgsAi38VEufPuAPQRqCbHCgnsyXkb6cP2/sXgzD4xravZOqKbNiLvkgxk4Rcxyi1sz1YZdCF1Y+CuHlUM+19DrvLvtaNXJCNnFsHzZc+iugqSxpRCOuvKL3kGaCPYOvmXj+XJbWvR6Xnyj/8jsCSIKNAkblBXq7XpNevA92nFz2D5V0NzfqO5j/UPjYmimX3jx82rDBmpOnA+Hue9kkuex5lRgJkD/uuRbYrNIxyka8BNyHz2N4iZlyz7/cZXOvgrnUcHx/a+R9G2wXoAvDiOxe5P9Ebu6Csns2Jx8Dtgu96LNVWBZ7p4VlLlWP2WuE/XWJj6B9qNyLCztdK2acw8NPTkJMoyTpnaroQDwG3AeJe4v52boLc6kksBtm+wLbUGunr3gfXz9Xa/rGcrqZa9wH050Rl69TS+aHnadafZCm5HhEhGdVF6kl/fNyjAKwk0etTx//BmDHcvuWhXgCnyvx6u/sbdqk5sYMheUHYDoY2LK2s+kKFn54TKmFCMzhYcl/ARt3HkpLoM+Gq3/eIXes5C0YE0Jn8P0xapvzfEm2rxhvanJ7PG4CNiynXxl8ANyCvAs/C8rJsEI5JncYpiOA2oR0iyzYgXLZ2SXZVOiAWnakXPaKTw+/aucTNh5Mv35vEvqosmfUkt2iVLsBrCn5K8QZ1K5W4Ae0s5tO/2wq1dikoQ2sNehQxC8plCZfOR8j+2EpZ395devXI2LaHldL5lOuqU8/0xv67U3U+49xXanW2tHD+1pz8mrEOdS2AOUQ6nnQ3KjIQ/DejM6dv0StmUtRphHZvkDcmlYDMd1uTclof9UKW05/8T8Y4acwxrZ2yqgvr/otb7UGe0eM24HnRbn3Pz2E2/SLrFP/IPCjUtrHwEDM/6O5xoO6aL4uRw5fLnsXLZmt8nmBcT7yPcRp1py81o4eXrhymbxw+U4hEvYpn+fKhWUTx/ZB2jWi42OllBEJ/F99Hidqa1oZL2CaSOC4jKIeXzeYSx4f47w9DoHJpe9B2W8g/QCIU1LzENapv88mj4iuTPvu0j8FnoEw42yfVb/85I614dLto+PUrWh6fJCDZo9jFo+whLQE0cJ77WPUmr4c5bZG/DO6PcI425qT51sPqLhRS4I7WPoG1DAC0QLEFS+/Iw1eZA5o4BRXuFCb2MFO2HjwJ1/mKRKDs4lc+sUoa4JdjP9YRSlh4UbeDf5xq1fushNHr02/3N1F6xZK17Kg3xGlll0zt+kXyXmboMSmeGwCDMdsA+CLiC+ABoWcEHxAUNP57bzA2QJMr2P+C5heoKN9TlcpFJsbvTHkLos8eikXkYbcLmHOVGtq/D7STeGGsI9aM3cHQ6w0Lvl4aEiqNFcuHRm3bm7MeljHU8QRhCfewteRak3/MXK+QDD32kiXyCc8yJLcfqtHYNjEsX1Yf9HmJLxt8wt0G2q1pYd/I2bgawae/wjp7IxapX0ZiKbUj/E4u2CGVKlIM3l32barH93lPQfvEL4p+51aMkdDfmEF4cNL3ic8HPUStWQipbStOXkx8NOKf4BPRvoz8g4r6V2uVIlvMQPq9qJ9eYI6b7/8e8A2FJetrg3Sh0E2ju5j2bI7a3FHMzdmKLb8Wsor7hQxmCaqNX15p29HBX+KrFwmCSvfsZZtSXSMc1RYMvl3mQMrMHlVY5ZjNpmW7G6l1hnUreTk0j/DdGIgPRlp4BbY8lfpo/nIfkegDdU9iwrAbDDGeMwupW/fN8wlp5tL/nTVd5NqkZs1n0x2ZwyXTx6uHM/2jZjlwdBv+4xc8X4WLCzfHxs5eDuRCwu32WCqCRsWL5HTtmrNnl1J+pda02fi6XCCd52oVv3oiYkXZgmMcRgX09DwhjUnrzXXWEqFiaLoVnJqzbSQy+1UUOC2+Eidj3AARES0A8Kv2wJWfOCehS8s8ZpOy74ROe/iJbmCd4zCTIf6zdWWnlFhfwDk0tfQwX8DvabCeyeCjcEhmB4xl3rGmlIHm/tO1Y5ltc15hOXeFsCzFdoVfpa4uGNGgbvhlrBiYZnCK3EZ/yg0r86a+1Fw5lQu+gPS7tUeFJtL1VtT8mjq+C3ll/rtmZiNRXYD9va/zCUPr3aB6dTZr6GG7ZFKcnCv1jtUoC3YEFl4xIhscwDPXKoeaZPQRlbCShfRSiXhtNKS/lE1lahsAglzqR+BvYD4LVFp/6GdK521yxmGcSX2dtpc40HV+ObkZi7GpQ9Gdm7JnQzDz0WXozMinjQaBeCBt3GkxoHnFY9kWNBwMaWcYYnlGIerJdNcTb0cmzpyB5LJWZhdXVFKfe9znW6K6UZc8hGbmvp6pYMEXvvsL4tueFbg2UVqm1NIxjsqKmIjO37MAA/fD79bAeQ6iuoG6LKZy5HGB0mUkSwEby+1Zq4uNl4U5jYbYq7xMuQ9BCQrHafXYmxPgpnWnDzfjh8zoNJhVm54ogXXAgcz6x9XZKhMxPc9Bi4f4RGlfWAYiQEvlWSsS7/Jhwu3xWwKq57piWXIbkT+16spCGRNqb2x9ucxHYl64T0nLoInyzEM6JhtLlVx0KRc+hqwrZDuJEggIX8XexLpB7j0YUUzrD2/0Lv1prLm5NlA2OHtArVkvlSJ4eZSG9HRkeDtgfNLPVYJHef4MQMY0HEJcEilY3yG8RHnsqDhpKo+YxAutTbwcTnvvfmo0iWEbZrMJstc8jqMH4R0LTuwL07MjR4JudsKiIGVOSDF36+CkixzCG7zb4LeAXsb7E0gkHz01YeVybQ2KJCX1JeBjRBfAYZ3scDbk3TYQTo1+2oXzgmANSdfIewoTzq/DmP9iH4lecFrgbnGg7Dc5cSZDV3KA9TsXXz/MLXNmVnpNJ9IUrJl8J+NK/AZx8FW1OlZa0oeqNbMX2s4TxjzCT0jtqEeIjy5Ul4VHtvKMJC5xjMw3UjtUuz9AtfWI+E9Yi61W6WD69z5S9SWfkKt6XPVkj4YMhvi+9sgO7Myn19JrIPH/eZShdV84kZ6PeLKeh5oUMTF92plTxg2gQTNySswnRD74NJ/gNPI5TbG11b5ryMMYQBmd5tL/XcsUzt8tc35u1z2RLlMEl+bAZdEBsxVitEHs0utOXVm18WjWbiD22ywh1n41tW3koVMq8XcsH4kk7cBh8c6sDQT6X9g0UZqyZyiaXNfUVt6Bh3aGoiMLwPq8e06c0kXqz2A2tL/VEvmKBbnvoTx0/jvYjaZ5uQlsQiDFJ1KH4Z+XxrsIcIXlkeXLKzAJzPgAWCfoo1LRfo7sh3k0pvLpa9ZXdpH02a/hLR9Qd9bEJHabM3J82vxS9JZcz9Sa+ZS0pnRmB1K4YVeLhOx5O9rvrhk4QvLGOxhRGgnWGxCXgUZkLuoYPHMcpBewewgXHpbueyjBZu69Jugb4MV868dA8lbgtpB8RNEImSvRes1Io5ARB/6l8chkCxb+L8s/EgpqvpuDSexKY2bgMXho1qI2WTeXdao1uzNpR4ZBQWLvL0hItR2paHsj/X/k7nhUe+jVSP3cIdc5iqWLG1EupjCm4xSR51sLlW7w3nPj/qcPY/IH8Cr/aKr82IQqbW/kcttptbs2ZUo4Mil22lJ/zdwTpGmO0Lfx+2UTStyGpdsz5kvfyiX/hm+vx1SWVnnnQjklGoovqKoxe95KCIG2/e7Qny/9KiEznRgaiKT/bamzX2lGiMEppbMrzE7rnBEqo2mT5/HzI2sRVbyp21qm/N3WLRl/u5VzUi1k07yIz4rIY/IADmvK8TQKnNpiJeQtlVrui3O5AS1Zs8HO6zgAa3ZV8F70ppSJemdV2WPm7c0CMG2g4CyFX4AyPm1yxTyIrXNltaBFoJ1TlKU1ex9YiU5HqvgQfgkdOy9qmR3HOQTNEbj2xDgQaRdIsOJjLWRTbfmZDvwNkFRyeeQ/gE8B+k5cnG8IwWoNXuzTWl8ljrvj2XmbX7AB+3PxWVHJ0zhHgVjUR1mHwKd3xsUQwpREdSWnmHNydIzp4sUGSiXIE/RHw+2H8YOmA1C5F/9S3r/ryeoFzQU2BnL91HyLXN2DyTugY8fjEPJWNOy/zK36Xao7t68OmAJneyCapQXSyA8MUUsqgu8pyGOWtPaNTToE3K5Q6lL/L2E87TLSGd+Vu2jb2WFC9lPUe67VR8Yhx1uG+uDjgT/SNR/kbnG24DfymUriz3PI/fCO3b8mJ0Y0HELUZVCVjbWI7zbfmo185VAVCLNxx7o7dBLUk13PyunmTb3FXLsBMyLaOJjOlEtmZ9Us6hs0tAGa0oejSXnIrsH2COWKIRihyfGAEyHYZppzcnHrCk5wSZQ8cZI58xaxBsN+4AuKtDsPmCvGt+tIFrz7M06IoUlLLokXMyoLZO248eMov/yH+Npb4yvBEpx/pPkvAvVlo7WbChCXqJyf8RZdH/JlO0Q25FKZq2RX6k1Ey4LVIR8/NXPbWrqBjx+BDYmuKC54N8klw3XV4ifiF29vSlzqRMxOz3k6lJaMv2riU/vbgKtc/+y2GK64ucupF8X0sXoyZhLvhn+CqOzPHx7LaJfP04Z1WV3rTgxN6yfucYzwB6NdVHF/ye2D2bPW1Pjsb1NIccmj1gr8r1Y9rqHp+iEiUSucBHLHohNGTEC+j+L6YTYK6zW5lffD+k8XOr2oL5jL6FvokCdSL3gwbI5kd5mT401MqsmWFPjntTVPYXRq+wGwGxfzP5hU0dGyx30JBJEZ3fBi57ciwvxFC4qbxpdG6vix5oaj0W6JxYJn+5jIxLeQ13h1a8eGxX6bbEc1p2XT7H30+GNrNuSKcohUGfWefRE8Y9yMdbCs/vNpQ7oblMKYgq/sxpz5R7uyP8ivIhMZo2qJjmyKzDXODmvztyzKefF3+gL3GRNqf1rZU4MfDP0u7KZsEKVTcwI/cHNEgxcPhYoGDTXXdjU1BYRrpJqmR+UEban8b0sxpv4yxfge0vp22cw+B451ifBBmCjMBuLaVtE9GlFuS/+ZgnEVeY2fSTuc9FqMZfaCLMIH5aehU/k/qK1F3yNo4cuLBJ2Chbb428ecAOy24scvayosbjC93QbrDjEHrUT5l9KfI7YQfh1hwG/iWm8ePD9HVDUX0qwsDxYEaYbEXPtxSSYWguMraseQzyBvP3JZIarJXNKped5gcrg7D8jjcCsAsmgSPui6nF3H54XHkoulvHhh6s8CgMeJFzHYStzqYFy6Y/jt7BqqtGOehHZr0sp91EOcul2g4NxyTlFC6uXNGBEsku3Yt8J/76eXFH46ZPHiBSeRRsc1FacwFlj5lXQxwfOQErFvahWEEgGZRxmx1Ft7LqpqujYuLEpoxoxvhZx9eEV/1r1/WR6pPyfRYmcdjPi9jJ7LMC0s1oyJ1Uj/FYqas2ej+lAqhH4F5HS5N1CXS6qLA5g01f8a+XCkku/h/mPhbaX9qxptkfF1F9EqRoTIkuHbaPWdLgwa41Qa/p2pD2pJLRYPIZL/1/8VlWDwuuEw3uw/sqq95/eUSmiimbgze5xj0O55z5A3mEUvSPY30DbdYciC4Bceno+6yZK6yCkEy+BDuxJ0SVBhpIiNhO6d1VNrdW26nV3RJ4bmn9YbBbGSLAT83bP131eHR9xNQs/2lku3aVaFKujtjnP09GxPfBC8dY2D3LfLlX3vstI9Dkk8mB/tUd25wqrzY1PgLYJ6dpOu7+hTp/zbsi1bsdcqh6fvfFsa4y1MPs3prvUlgk/riplzKkjtyaR+C7YVqAx+fo6AC8HBaPsafD+UM4CsJNGfoG+iT9iVsxVchVa7ydFlfW6EHOpWZiFnR9/zKK6/9I5s1bKMoTVhP4J4pLwkfVLtaZLV97tpVhTam9kJxNW1mN1glSxu8CfIjenhLvRSqXCEuLWuZsPFx5cau3mWmJu1OaYH6XJ36ngeGev9bKlNwVhwSHIjqkmXrunY5NHrGXNyWvzMfGlOSaNPhgTMO+f1pQ6oZTPR+fMWoTWG490ZZGxxzNo0HQ7aWQ8VdWqwfzoIvOmTtV3Oy0snfnyhxh3RwwxjMZU4b+yXoq5ERvSv24Gleud9kN2BqnkjaWI/ss93IFLH5mvN1iIraj3Hl29NG5XYi61DtL3Iy4vwFu3kw80/JzN53eRs8ivrYJJN2AutQ6W+L9YingaE+Dtm2zi2KIZQJ84UjmGwo7UJHX+k+ZGjanavsqYGFKvMUBcHvYeGLqw1JZ+IijJFnr1OzY1WbgQZW/D7HogPHCtovHYnw2XhBcVDUGtmQuQN4HCbpMNwX+4qz/7QL7Jjom43MHyjk5l56BQYJyvCyOvJSj5Q+vpmGs8lFr46IxTzI3avNTmcrPvwLRHUNMwcsy1SfCXrg0CbDgcY4PQS+JOnfpCqG8uemF53EhUgW9j1yC1qndjRw/vi+nsGg1fh+XOL6dDcCpQxJG6IgjQJWMoPloYc8P6FdSEzUWH80QuLLl0O6azoqf1/7e3pSx1Yu2++wG1k/lB25hLbVlWD5edDbntguTTCIJahxcHKW61pP8vgI1CL4m/qi3zVFTPwkFy7y+7IvKvx/gWTan9SjeyByKLV0w3FCu7Am2+yPo2wVFUoaF1grnkVXHUNuw0tNtsCHBiZAOfgpG7BReWLnhxWcEBPDvTJg2N0kjq0eSFX7siiK6iqqly6fdY1GcXpD8VbGj8D/b27fH/HpY1YUT5zx4vVqygeFivt+6lkZLRxtcYPCh+XfYuYeRwalekYBVUsfqfzpm1iHR6PLLQndcqfI/Bgx5aUY+5WmxqMgX6RWQDX9F3sjxFF5bcwx34mlqgyYmBSG1vQ9XIVJaO2eBqQo50Kzlc9idFHanGt6DuUXOp8HeiEjEQCS6OVOKR7lRb+oli45SWiNCavgMRHqtl9KVOV3aJYH2c5FRriZ9PWNzRt5runzhS9QsKOVKNRrAnqymYiUsdiRHlK2uno+OkUoYpaTEIjBxHRWpzGttDqljhxB6G3zU69lKO/nNjKcag1vSFmB1AIUeqsQGePWyusex3O3Mjh4FF52iK32ja3Ojd6iqUfJdRWyaNUcgvM81cqvdUPk0s/RdQ+5AUs7kx65HeGcSfFXCkwhDQn80lS96RBvUHvSsxOuvRBvybj+tKVggs7/EltRCVwGDWgNnN5saG61L2MOTmLUWqVTWuVSay2EOh5WY/TM62JVI0j7wjVTdYU+NRpY2amgxEV22VHbtqvFUxylpYQSUH/ZDo5/wobMkF5YzZzdxT8xl8/aUWw6otk6bDtiNQbA7HLIF0kbnGMwo5swMnrrVGT8b15WY0lf3CLZd+HKnQ4jncmhqPKHfcbuKyyMykeHgRb73Cfqgq0KnZV1mW2AZReJdmOgHXeHWYI9XcmPUwu7WAHuubLPOPLde2Cndy/U4muoo5SBf1hggIufS/we8UpBbfBNZW69BinfH8+9CwC9i9BRuaDoO371j1VSVwg3TcRtSxjWHIO7KScPSKFpbczMX4HIgiS8/Vk9DtNmXEVysZv2vpe1xZ2TOlM5109voajNsJfj0vUAAABhhJREFUuZmLyWT3AS4r2NDYG1vykJ00fN381xcWcC2AdL7c7MILNqprJZ1WYE2pg5HdUKDJiyz3ttNps7u8DHA5WFPjd5HuJawieyVIr0Pim3KzwqXOa4g1pU5AVvhwWmTxuQ/xqwIjPYO8bStN7K06OsGak5cChWoRP420Uw/VfliJNaX2x+PmqnVLpddBe8jNnhWTaWVjTY1H4XkXVPyziHchsaXc8y9XakP13vI3Gn6B9EiBFltidmdPP6xWa/p2fNuVUjOrw5kNbNOdiwpArdmLocLUfrEcdGA1iwpiWFi6bOZyluX2p3Dp2Z0ZNOiBnq4OqNbMX1nubYa4vqzdoliE2RS0eItgQ9D9yM2+A9muQHhB8EjsOLn09OLtisxf7QArMDd6JJZ7DIg+YRd/5eO68eU42roLmzJiBHXe0Zh2BzaOaPYc4laWd/w+KkS3u7GpyRQJ7scoIctH56klPSmOeWONALWpqS3wbDqFwlHEDJa176nTX6xdHb2YMTd6Y/A3BNbBt76gd/A65srNDVeb7mFYU+MkPH6DRcrwAboJpX8Q1/FT7KHF1pTaFc/uzsdmR8yquZDbLR8puYYaYi51Ir6dhgr8rqW/AHvFKe1Uk5h1c6ndMLsTiK7SKt4F7wC52Q/XwobPO4GX/a3zMEVnMEMglYT2iHvXXrNkCGtq3BNPtxe8c0E7Zj9Ta7ZwqvkayiI4pum4nWIFRsVD0LBXXIVFPz10Dck/Fm/HiuhoSldCv2Nq8QN+3jCX2g6zGwmqvhZq+WfUf99afeY1T9+yqclv4XEvhXaLAbORvi+Xjj6DXEMkBsKlTsCsjaKiv7oJcVgt5TK7JC/Q3OiR4N8XVIAvZI2WAFMgfV6cwXGfdYLIT+8qjOI1eMQFkDmu1p9vlyWc2knD16W+/jZKS4d6nJwdrmnZ6JJ3awjuUk3JiXicXSDycwUdyI6VyxYq+RsbXZrJHIRp+L/DdGQJzZcCZ7Fw4Rk9QXispxEoz/gXYWxbtLF4Nzimqd6jXirdkiJvLnk4xgVAKWHML2N2vFqz4cK7nzMCySWmgv2C0gooPI3873e1z7DbtBfy7123RGhahvE0vj9ZbXMKHXh/Zgk0Vv2jkBwwpMRulyEd3RWa9qvTraIeQTTjkjPw+UVBz/CqiPtBp8mlH6+xeT2C4DNaPBG84zH7UkmdxBv4dqRaszULiy5uQg/AmlLjkF1FeVWzHsV0Dl76T5/FHWSQLl83EeNYylPEuSF/l+pe+fHunHxVbPKItWhIOOAYyim+JL2C71+Ml7u6p9X1q4RArM3/GcbBFDoSWx3xKj7HqjUTpR/bpfSYhbUCmzJiBInE74Cdy+oo5TB7CNm10P+23uTFt5MbN6COA5EOJapyaRRiOcbFSKf0pCjdHrewYKV/5gA8TsUKVkuPYiHwAKa78PrcL/dcmcFutcdcajjYPhjjkbYuO4zYMDzuAP/kUvXlu5IeubBWYBPH9mHDxUdimgpUqg7TATyDeAjfHmKp/6TOmvtRjGaWhLkxQ/Fz2yN2BNuR6ODB4kiPgH+iXPbJ+CyMlx69sFZgblg//AFH4NmvMb5S5XA+QT2bZzCeA5uD582FdefFkQNoblg/cgNGkLAR+DTiMRbYPFIgthykv5DLndobXC69YmGtIH8HOxi8YzAbG+vgwbvKG0ivY/YW8Day98FbjE9nySNZf2RrYd5ayNbH+BJiA4z1iSNJZVW70B3A/8qlo2t39zB61cJaFXONW+WD2A6gnN1T72EBcAXKXdpbQqBXpdcurBXYCRsPpqHveEw/xNipZEdrz2Qp4o/4uhZv3ft7UuWvcunNv4RO2CmjvkzCvofHeLDvFBC66El8ANyHcRdLcw90x8aiFnymFtaq5O9k4zCNQxqHb6N6xN0sUEV8GuOv+P503hrwN102M1wpsRfT/R90F5EvQLkF+JuDNgc2w2ejmi62YEPwErJ/4HszMHuGJXXP9oa8ymr53CysMGzS0AYGDt6UBJuADcMU7OywDTHWJgjrGZL//ycbhECmsR2zj5DeB1uI8TrSG/j+68C/8f0Mbw98+bN4NyqF/weJwN0ujDsi4AAAAABJRU5ErkJggg=="

/***/ },

/***/ 480:
/*!*****************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Overlay/index.css ***!
  \*****************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_1Duwphv0px3KMYU1SOOYNt{z-index:4}#_1Duwphv0px3KMYU1SOOYNt td{position:relative;width:34%;height:34%}#_27xeATAQLvT4FmQdXbGUDg{z-index:2}#_27xeATAQLvT4FmQdXbGUDg td{position:relative;width:100%;height:34%}#_6MQ3iXvf5RyJBs7bhesSQ{z-index:3}#_6MQ3iXvf5RyJBs7bhesSQ td{position:relative;width:34%;height:100%}._3wOEOiAfgqRXU5hLfb0Sx2{position:fixed;table-layout:fixed;top:0;left:0;border-spacing:0;border-collapse:collapse;width:100%;height:100%}._-ZaP7hGSjUaK3XjNtxunE{position:absolute;top:0;left:0;border:none;width:100%;height:100%}", ""]);
	
	// exports
	exports.locals = {
		"rootFine": "_1Duwphv0px3KMYU1SOOYNt",
		"rootCourseRow": "_27xeATAQLvT4FmQdXbGUDg",
		"rootCourseColumn": "_6MQ3iXvf5RyJBs7bhesSQ",
		"rootGrid": "_3wOEOiAfgqRXU5hLfb0Sx2",
		"rootGridWidget": "_-ZaP7hGSjUaK3XjNtxunE"
	};

/***/ },

/***/ 669:
/*!**********************************************!*\
  !*** ./src/components/App/Overlay/index.css ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../~/css-loader?module&-autoprefixer!./../../../../~/postcss-loader!./index.css */ 480);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 279:
/*!**********************************************!*\
  !*** ./src/components/App/Overlay/index.jsx ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(/*! ./index.css */ 669);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Overlay = function Overlay(_ref) {
	  var overlay = _ref.overlay,
	      ovWidgets = _ref.ovWidgets;
	
	  var upper = null;
	  if (overlay.upper !== null) {
	    var widget = ovWidgets.find(function (o) {
	      return o.id === overlay.upper;
	    });
	    if (widget !== undefined) {
	      upper = widget.url + '?position=upper';
	    }
	  }
	  var middleRow = null;
	  if (overlay.middleRow !== null) {
	    var _widget = ovWidgets.find(function (o) {
	      return o.id === overlay.middleRow;
	    });
	    if (_widget !== undefined) {
	      middleRow = _widget.url + '?position=middle-row';
	    }
	  }
	  var lower = null;
	  if (overlay.lower !== null) {
	    var _widget2 = ovWidgets.find(function (o) {
	      return o.id === overlay.lower;
	    });
	    if (_widget2 !== undefined) {
	      lower = _widget2.url + '?position=lower';
	    }
	  }
	  var left = null;
	  if (overlay.left !== null) {
	    var _widget3 = ovWidgets.find(function (o) {
	      return o.id === overlay.left;
	    });
	    if (_widget3 !== undefined) {
	      left = _widget3.url + '?position=left';
	    }
	  }
	  var middleColumn = null;
	  if (overlay.middleColumn !== null) {
	    var _widget4 = ovWidgets.find(function (o) {
	      return o.id === overlay.middleColumn;
	    });
	    if (_widget4 !== undefined) {
	      middleColumn = _widget4.url + '?position=middle-column';
	    }
	  }
	  var right = null;
	  if (overlay.right !== null) {
	    var _widget5 = ovWidgets.find(function (o) {
	      return o.id === overlay.right;
	    });
	    if (_widget5 !== undefined) {
	      right = _widget5.url + '?position=right';
	    }
	  }
	  var upperLeft = null;
	  if (overlay.upperLeft !== null) {
	    var _widget6 = ovWidgets.find(function (o) {
	      return o.id === overlay.upperLeft;
	    });
	    if (_widget6 !== undefined) {
	      upperLeft = _widget6.url + '?position=upper-left';
	    }
	  }
	  var upperMiddle = null;
	  if (overlay.upperMiddle !== null) {
	    var _widget7 = ovWidgets.find(function (o) {
	      return o.id === overlay.upperMiddle;
	    });
	    if (_widget7 !== undefined) {
	      upperMiddle = _widget7.url + '?position=upper-middle';
	    }
	  }
	  var upperRight = null;
	  if (overlay.upperRight !== null) {
	    var _widget8 = ovWidgets.find(function (o) {
	      return o.id === overlay.upperRight;
	    });
	    if (_widget8 !== undefined) {
	      upperRight = _widget8.url + '?position=upper-right';
	    }
	  }
	  var middleLeft = null;
	  if (overlay.middleLeft !== null) {
	    var _widget9 = ovWidgets.find(function (o) {
	      return o.id === overlay.middleLeft;
	    });
	    if (_widget9 !== undefined) {
	      middleLeft = _widget9.url + '?position=middle-left';
	    }
	  }
	  var middleMiddle = null;
	  if (overlay.middleMiddle !== null) {
	    var _widget10 = ovWidgets.find(function (o) {
	      return o.id === overlay.middleMiddle;
	    });
	    if (_widget10 !== undefined) {
	      middleMiddle = _widget10.url + '?position=middle-middle';
	    }
	  }
	  var middleRight = null;
	  if (overlay.middleRight !== null) {
	    var _widget11 = ovWidgets.find(function (o) {
	      return o.id === overlay.middleRight;
	    });
	    if (_widget11 !== undefined) {
	      middleRight = _widget11.url + '?position=middle-right';
	    }
	  }
	  var lowerLeft = null;
	  if (overlay.lowerLeft !== null) {
	    var _widget12 = ovWidgets.find(function (o) {
	      return o.id === overlay.lowerLeft;
	    });
	    if (_widget12 !== undefined) {
	      lowerLeft = _widget12.url + '?position=lower-left';
	    }
	  }
	  var lowerMiddle = null;
	  if (overlay.lowerMiddle !== null) {
	    var _widget13 = ovWidgets.find(function (o) {
	      return o.id === overlay.lowerMiddle;
	    });
	    if (_widget13 !== undefined) {
	      lowerMiddle = _widget13.url + '?position=lower-middle';
	    }
	  }
	  var lowerRight = null;
	  if (overlay.lowerRight !== null) {
	    var _widget14 = ovWidgets.find(function (o) {
	      return o.id === overlay.lowerRight;
	    });
	    if (_widget14 !== undefined) {
	      lowerRight = _widget14.url + '?position=lower-right';
	    }
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'table',
	      { id: _index2.default.rootCourseRow, className: _index2.default.rootGrid },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            upper !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: upper
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            middleRow !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: middleRow
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            lower !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: lower
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'table',
	      { id: _index2.default.rootCourseColumn, className: _index2.default.rootGrid },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            left !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: left
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            middleColumn !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: middleColumn
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            right !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: right
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'table',
	      { id: _index2.default.rootFine, className: _index2.default.rootGrid },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            upperLeft !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: upperLeft
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            upperMiddle !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: upperMiddle
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            upperRight !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: upperRight
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            middleLeft !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: middleLeft
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            middleMiddle !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: middleMiddle
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            middleRight !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: middleRight
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            lowerLeft !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: lowerLeft
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            lowerMiddle !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: lowerMiddle
	            })
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            lowerRight !== null && _react2.default.createElement('iframe', {
	              frameBorder: '0',
	              scrolling: 'no',
	              className: _index2.default.rootGridWidget,
	              src: lowerRight
	            })
	          )
	        )
	      )
	    )
	  );
	};
	Overlay.propTypes = {
	  overlay: _react.PropTypes.object.isRequired,
	  ovWidgets: _react.PropTypes.array.isRequired
	};
	exports.default = Overlay;

/***/ },

/***/ 481:
/*!*****************************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Player/PlayerImages/index.css ***!
  \*****************************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_3pPJecdcl4iFjoKdPaDZbl{overflow:hidden}#_3pPJecdcl4iFjoKdPaDZbl,.JA0u45-VYYjX5kYQZ1Q8x{position:absolute;left:0;top:0;width:100%;height:100%}.JA0u45-VYYjX5kYQZ1Q8x{background-repeat:no-repeat;background-size:cover;background-position:50%}#_3HIcU8HZFlA1FF6mNeu8RA,#sHBIegPGFS7ytul9Hxdei{background-color:transparent}", ""]);
	
	// exports
	exports.locals = {
		"root": "_3pPJecdcl4iFjoKdPaDZbl",
		"rootDiv": "JA0u45-VYYjX5kYQZ1Q8x",
		"rootEven": "_3HIcU8HZFlA1FF6mNeu8RA",
		"rootOdd": "sHBIegPGFS7ytul9Hxdei"
	};

/***/ },

/***/ 670:
/*!**********************************************************!*\
  !*** ./src/components/App/Player/PlayerImages/index.css ***!
  \**********************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/css-loader?module&-autoprefixer!./../../../../../~/postcss-loader!./index.css */ 481);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 280:
/*!**********************************************************!*\
  !*** ./src/components/App/Player/PlayerImages/index.jsx ***!
  \**********************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rest = __webpack_require__(/*! ../../../../util/rest */ 190);
	
	var _strings = __webpack_require__(/*! ../../../../strings */ 2);
	
	var _index = __webpack_require__(/*! ./index.css */ 670);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayerImages = function (_Component) {
	  _inherits(PlayerImages, _Component);
	
	  function PlayerImages(props) {
	    _classCallCheck(this, PlayerImages);
	
	    var _this = _possibleConstructorReturn(this, (PlayerImages.__proto__ || Object.getPrototypeOf(PlayerImages)).call(this, props));
	
	    _this.even = true;
	    _this.mounted = true;
	    _this.showing = false;
	    _this.handleFile = _this.handleFile.bind(_this);
	    _this.loadImage = _this.loadImage.bind(_this);
	    _this.playImage = _this.playImage.bind(_this);
	    _this.rootEvenEl = null;
	    _this.rootOddEl = null;
	    _this.stopTimeout = null;
	    return _this;
	  }
	
	  _createClass(PlayerImages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.rootEvenEl = document.getElementById(_index2.default.rootEven);
	      this.rootOddEl = document.getElementById(_index2.default.rootOdd);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(upProps) {
	      var _props = this.props,
	          currentlyIsPlaying = _props.currentlyIsPlaying,
	          currentlyPlaying = _props.currentlyPlaying,
	          nextPlaying = _props.nextPlaying;
	
	      var upNextPlaying = upProps.nextPlaying;
	      var upCurrentlyIsPlaying = upProps.currentlyIsPlaying;
	      var upCurrentlyPlaying = upProps.currentlyPlaying;
	      // GETTING READY TO PLAY
	      if (nextPlaying !== _strings.IMAGES && upNextPlaying === _strings.IMAGES) {
	        this.loadImage();
	      }
	      // START PLAYING
	      if (currentlyPlaying === _strings.IMAGES && !currentlyIsPlaying && upCurrentlyIsPlaying) {
	        this.playImage();
	      }
	      // STOP PLAYING
	      if (currentlyPlaying === _strings.IMAGES && upCurrentlyPlaying !== _strings.IMAGES) {}
	      // STOP PLAYING
	
	      // STOP SHOWING
	      if (this.showing && upCurrentlyPlaying !== _strings.IMAGES && upCurrentlyPlaying !== _strings.TRANSITION && upCurrentlyPlaying !== _strings.TRANSITION2) {
	        this.showing = false;
	        this.rootEvenEl.style.display = 'none';
	        this.rootOddEl.style.display = 'none';
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	      window.clearTimeout(this.stopTimeout);
	    }
	  }, {
	    key: 'handleFile',
	    value: function handleFile(image) {
	      var _props2 = this.props,
	          setNextIsReady = _props2.setNextIsReady,
	          storeOffline = _props2.storeOffline;
	
	      if (!this.mounted) {
	        return;
	      }
	      // CACHING OFFLINE
	      if (storeOffline) {
	        var newImageURL = image.file;
	        var lastImageURL = window.localStorage.getItem('futusign_image_url');
	        if (newImageURL !== lastImageURL) {
	          window.localStorage.setItem('futusign_image_url', newImageURL);
	          window.localStorage.setItem('futusign_image_file', image.encoded);
	        }
	      }
	      var renderEl = this.even ? this.rootEvenEl : this.rootOddEl;
	      renderEl.style.backgroundImage = 'url(' + image.encoded + ')';
	      setNextIsReady(true);
	    }
	  }, {
	    key: 'loadImage',
	    value: function loadImage() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          images = _props3.images,
	          setBadPlaying = _props3.setBadPlaying;
	
	      var image = images[0]; // EVENTUALLY GET RID OF ARRAY
	      (0, _rest.getFile)(image.file).then(function (encoded) {
	        _this2.handleFile(_extends({}, image, {
	          encoded: encoded
	        }));
	      }).catch(function () {
	        return setBadPlaying(true);
	      });
	    }
	  }, {
	    key: 'playImage',
	    value: function playImage() {
	      var _props4 = this.props,
	          images = _props4.images,
	          setCurrentlyIsPlaying = _props4.setCurrentlyIsPlaying;
	
	      var image = images[0]; // EVENTUALLY GET RID OF ARRAY
	      this.showing = true;
	      var playEl = this.even ? this.rootEvenEl : this.rootOddEl;
	      var hideEl = !this.even ? this.rootEvenEl : this.rootOddEl;
	      playEl.style.display = 'block';
	      hideEl.style.display = 'none';
	      this.even = !this.even;
	      this.stopTimeout = window.setTimeout(function () {
	        return setCurrentlyIsPlaying(false);
	      }, image.imageDuration * 1000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { id: _index2.default.root },
	        _react2.default.createElement('div', {
	          style: { display: 'none' },
	          id: _index2.default.rootEven,
	          className: _index2.default.rootDiv
	        }),
	        _react2.default.createElement('div', {
	          style: { display: 'none' },
	          id: _index2.default.rootOdd,
	          className: _index2.default.rootDiv
	        })
	      );
	    }
	  }]);
	
	  return PlayerImages;
	}(_react.Component);
	
	PlayerImages.propTypes = {
	  currentlyIsPlaying: _react.PropTypes.bool.isRequired,
	  currentlyPlaying: _react.PropTypes.string,
	  images: _react.PropTypes.array.isRequired,
	  nextPlaying: _react.PropTypes.string,
	  setCurrentlyIsPlaying: _react.PropTypes.func.isRequired,
	  setBadPlaying: _react.PropTypes.func.isRequired,
	  setNextIsReady: _react.PropTypes.func.isRequired,
	  storeOffline: _react.PropTypes.bool.isRequired
	};
	exports.default = PlayerImages;

/***/ },

/***/ 281:
/*!**************************************************************!*\
  !*** ./src/components/App/Player/PlayerTransition/index.jsx ***!
  \**************************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _strings = __webpack_require__(/*! ../../../../strings */ 2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayerTransition = function (_Component) {
	  _inherits(PlayerTransition, _Component);
	
	  function PlayerTransition(props) {
	    _classCallCheck(this, PlayerTransition);
	
	    var _this = _possibleConstructorReturn(this, (PlayerTransition.__proto__ || Object.getPrototypeOf(PlayerTransition)).call(this, props));
	
	    _this.readyTimeout = null;
	    _this.stopTimeout = null;
	    return _this;
	  }
	
	  _createClass(PlayerTransition, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(upProps) {
	      var _props = this.props,
	          currentlyIsPlaying = _props.currentlyIsPlaying,
	          currentlyPlaying = _props.currentlyPlaying,
	          nextPlaying = _props.nextPlaying,
	          setCurrentlyIsPlaying = _props.setCurrentlyIsPlaying,
	          setNextIsReady = _props.setNextIsReady;
	
	      var upNextPlaying = upProps.nextPlaying;
	      var upCurrentlyIsPlaying = upProps.currentlyIsPlaying;
	      // GETTING READY TO PLAY
	      if (nextPlaying !== _strings.TRANSITION && upNextPlaying === _strings.TRANSITION) {
	        this.readyTimeout = window.setTimeout(function () {
	          return setNextIsReady(true);
	        }, 0);
	      }
	      // START PLAYING
	      if (currentlyPlaying === _strings.TRANSITION && !currentlyIsPlaying && upCurrentlyIsPlaying) {
	        this.stopTimeout = window.setTimeout(function () {
	          return setCurrentlyIsPlaying(false);
	        }, 0);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.clearTimeout(this.readyTimeout);
	      window.clearTimeout(this.stopTimeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return PlayerTransition;
	}(_react.Component);
	
	PlayerTransition.propTypes = {
	  currentlyIsPlaying: _react.PropTypes.bool.isRequired,
	  currentlyPlaying: _react.PropTypes.string,
	  nextPlaying: _react.PropTypes.string,
	  setCurrentlyIsPlaying: _react.PropTypes.func.isRequired,
	  setNextIsReady: _react.PropTypes.func.isRequired
	};
	exports.default = PlayerTransition;

/***/ },

/***/ 282:
/*!***************************************************************!*\
  !*** ./src/components/App/Player/PlayerTransition2/index.jsx ***!
  \***************************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _strings = __webpack_require__(/*! ../../../../strings */ 2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayerTransition2 = function (_Component) {
	  _inherits(PlayerTransition2, _Component);
	
	  function PlayerTransition2(props) {
	    _classCallCheck(this, PlayerTransition2);
	
	    var _this = _possibleConstructorReturn(this, (PlayerTransition2.__proto__ || Object.getPrototypeOf(PlayerTransition2)).call(this, props));
	
	    _this.readyTimeout = null;
	    _this.stopTimeout = null;
	    return _this;
	  }
	
	  _createClass(PlayerTransition2, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(upProps) {
	      var _props = this.props,
	          currentlyIsPlaying = _props.currentlyIsPlaying,
	          currentlyPlaying = _props.currentlyPlaying,
	          nextPlaying = _props.nextPlaying,
	          setCurrentlyIsPlaying = _props.setCurrentlyIsPlaying,
	          setNextIsReady = _props.setNextIsReady;
	
	      var upNextPlaying = upProps.nextPlaying;
	      var upCurrentlyIsPlaying = upProps.currentlyIsPlaying;
	      // GETTING READY TO PLAY
	      if (nextPlaying !== _strings.TRANSITION2 && upNextPlaying === _strings.TRANSITION2) {
	        this.readyTimeout = window.setTimeout(function () {
	          return setNextIsReady(true);
	        }, 0);
	      }
	      // START PLAYING
	      if (currentlyPlaying === _strings.TRANSITION2 && !currentlyIsPlaying && upCurrentlyIsPlaying) {
	        this.stopTimeout = window.setTimeout(function () {
	          return setCurrentlyIsPlaying(false);
	        }, 0);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.clearTimeout(this.readyTimeout);
	      window.clearTimeout(this.stopTimeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return PlayerTransition2;
	}(_react.Component);
	
	PlayerTransition2.propTypes = {
	  currentlyIsPlaying: _react.PropTypes.bool.isRequired,
	  currentlyPlaying: _react.PropTypes.string,
	  nextPlaying: _react.PropTypes.string,
	  setCurrentlyIsPlaying: _react.PropTypes.func.isRequired,
	  setNextIsReady: _react.PropTypes.func.isRequired
	};
	exports.default = PlayerTransition2;

/***/ },

/***/ 482:
/*!***************************************************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/components/App/Player/PlayerWebs/index.css ***!
  \***************************************************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../../../../../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "#_23bztrtRS7HlE-Etuspc6B{overflow:hidden}#_23bztrtRS7HlE-Etuspc6B,._2QISzZGhuM_nPy9JbxlNYd{position:absolute;left:0;top:0;width:100%;height:100%}#_1QUvqxZoNT51P-FnFUQcMJ,#_3L-2MVrGoKluSX4Xb9nXq6{background-color:transparent}", ""]);
	
	// exports
	exports.locals = {
		"root": "_23bztrtRS7HlE-Etuspc6B",
		"rootIFrame": "_2QISzZGhuM_nPy9JbxlNYd",
		"rootEven": "_1QUvqxZoNT51P-FnFUQcMJ",
		"rootOdd": "_3L-2MVrGoKluSX4Xb9nXq6"
	};

/***/ },

/***/ 671:
/*!********************************************************!*\
  !*** ./src/components/App/Player/PlayerWebs/index.css ***!
  \********************************************************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../../../../../~/css-loader?module&-autoprefixer!./../../../../../~/postcss-loader!./index.css */ 482);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../../../../../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../../../../../node_modules/css-loader/index.js?module&-autoprefixer!./../../../../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 283:
/*!********************************************************!*\
  !*** ./src/components/App/Player/PlayerWebs/index.jsx ***!
  \********************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _strings = __webpack_require__(/*! ../../../../strings */ 2);
	
	var _index = __webpack_require__(/*! ./index.css */ 671);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WEB_LOAD_TIME = 2;
	
	var PlayerWebs = function (_Component) {
	  _inherits(PlayerWebs, _Component);
	
	  function PlayerWebs(props) {
	    _classCallCheck(this, PlayerWebs);
	
	    var _this = _possibleConstructorReturn(this, (PlayerWebs.__proto__ || Object.getPrototypeOf(PlayerWebs)).call(this, props));
	
	    _this.showing = false;
	    _this.readyTimeout = null;
	    _this.stopTimeout = null;
	    _this.rootEvenEl = null;
	    _this.rootOddEl = null;
	    _this.mounted = true;
	    _this.even = true;
	    _this.playWeb = _this.playWeb.bind(_this);
	    _this.loadWeb = _this.loadWeb.bind(_this);
	    return _this;
	  }
	
	  _createClass(PlayerWebs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.rootEvenEl = document.getElementById(_index2.default.rootEven);
	      this.rootOddEl = document.getElementById(_index2.default.rootOdd);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(upProps) {
	      var _props = this.props,
	          currentlyIsPlaying = _props.currentlyIsPlaying,
	          currentlyPlaying = _props.currentlyPlaying,
	          nextPlaying = _props.nextPlaying,
	          setNextIsReady = _props.setNextIsReady;
	
	      var upNextPlaying = upProps.nextPlaying;
	      var upCurrentlyIsPlaying = upProps.currentlyIsPlaying;
	      var upCurrentlyPlaying = upProps.currentlyPlaying;
	      // GETTING READY TO PLAY
	      if (nextPlaying !== _strings.WEBS && upNextPlaying === _strings.WEBS) {
	        this.loadWeb();
	        this.readyTimeout = window.setTimeout(function () {
	          return setNextIsReady(true);
	        }, WEB_LOAD_TIME * 1000);
	      }
	      // START PLAYING
	      if (currentlyPlaying === _strings.WEBS && !currentlyIsPlaying && upCurrentlyIsPlaying) {
	        this.showing = true;
	        this.playWeb();
	      }
	      // STOP PLAYING
	      if (currentlyPlaying === _strings.WEBS && upCurrentlyPlaying !== _strings.WEBS) {}
	      // STOP PLAYING
	
	      // STOP SHOWING
	      if (this.showing && upCurrentlyPlaying !== _strings.WEBS && upCurrentlyPlaying !== _strings.TRANSITION && upCurrentlyPlaying !== _strings.TRANSITION2) {
	        this.showing = false;
	        this.rootEvenEl.style.display = 'none';
	        this.rootOddEl.style.display = 'none';
	        this.rootEvenEl.src = 'about:blank';
	        this.rootOddEl.src = 'about:blank';
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.clearTimeout(this.readyTimeout);
	      window.clearTimeout(this.stopTimeout);
	    }
	  }, {
	    key: 'loadWeb',
	    value: function loadWeb() {
	      var webs = this.props.webs;
	
	      var web = webs[0];
	      var renderEl = this.even ? this.rootEvenEl : this.rootOddEl;
	      renderEl.src = web.url;
	    }
	  }, {
	    key: 'playWeb',
	    value: function playWeb() {
	      var _props2 = this.props,
	          setCurrentlyIsPlaying = _props2.setCurrentlyIsPlaying,
	          webs = _props2.webs;
	
	      var web = webs[0];
	      var playEl = this.even ? this.rootEvenEl : this.rootOddEl;
	      var hideEl = !this.even ? this.rootEvenEl : this.rootOddEl;
	      playEl.style.display = 'block';
	      hideEl.style.display = 'none';
	      hideEl.src = 'about:blank';
	      this.even = !this.even;
	      this.stopTimeout = window.setTimeout(function () {
	        setCurrentlyIsPlaying(false);
	      }, web.webDuration * 1000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { id: _index2.default.root },
	        _react2.default.createElement('iframe', {
	          frameBorder: '0',
	          scrolling: 'no',
	          style: { display: 'none' },
	          id: _index2.default.rootEven,
	          className: _index2.default.rootIFrame,
	          src: 'about:blank'
	        }),
	        _react2.default.createElement('iframe', {
	          frameBorder: '0',
	          scrolling: 'no',
	          style: { display: 'none' },
	          id: _index2.default.rootOdd,
	          className: _index2.default.rootIFrame,
	          src: 'about:blank'
	        })
	      );
	    }
	  }]);
	
	  return PlayerWebs;
	}(_react.Component);
	
	PlayerWebs.propTypes = {
	  currentlyIsPlaying: _react.PropTypes.bool.isRequired,
	  currentlyPlaying: _react.PropTypes.string,
	  nextPlaying: _react.PropTypes.string,
	  setCurrentlyIsPlaying: _react.PropTypes.func.isRequired,
	  setNextIsReady: _react.PropTypes.func.isRequired,
	  webs: _react.PropTypes.array.isRequired
	};
	exports.default = PlayerWebs;

/***/ },

/***/ 284:
/*!*****************************************************************!*\
  !*** ./src/components/App/Player/PlayerYoutubeVideos/index.jsx ***!
  \*****************************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _strings = __webpack_require__(/*! ../../../../strings */ 2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var URL_REGEX = /^https:\/\/youtu\.be\/(.*)/;
	var PLAYER_DELAY = 5;
	var VIDEO_DELAY = 1;
	
	var PlayerYoutubeVideos = function (_Component) {
	  _inherits(PlayerYoutubeVideos, _Component);
	
	  function PlayerYoutubeVideos(props) {
	    _classCallCheck(this, PlayerYoutubeVideos);
	
	    var _this = _possibleConstructorReturn(this, (PlayerYoutubeVideos.__proto__ || Object.getPrototypeOf(PlayerYoutubeVideos)).call(this, props));
	
	    _this.showing = false;
	    _this.readyTimeout = null;
	    _this.coverTimeout = null;
	    _this.videoId = null;
	    _this.handleYoutubeStateChange = _this.handleYoutubeStateChange.bind(_this);
	    _this.handleYoutubeError = _this.handleYoutubeError.bind(_this);
	    _this.loadYoutubeVideo = _this.loadYoutubeVideo.bind(_this);
	    _this.playYoutubeVideo = _this.playYoutubeVideo.bind(_this);
	    _this.validVideo = _this.validVideo.bind(_this);
	    _this.futusignYoutubeEl = window.document.getElementById('futusign_youtube');
	    window.futusignYoutubeStateChange.addEventListener(_this.handleYoutubeStateChange);
	    window.futusignYoutubeError.addEventListener(_this.handleYoutubeError);
	    return _this;
	  }
	
	  _createClass(PlayerYoutubeVideos, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(upProps) {
	      var _props = this.props,
	          currentlyIsPlaying = _props.currentlyIsPlaying,
	          currentlyPlaying = _props.currentlyPlaying,
	          nextPlaying = _props.nextPlaying,
	          setCover = _props.setCover;
	
	      var upNextPlaying = upProps.nextPlaying;
	      var upCurrentlyIsPlaying = upProps.currentlyIsPlaying;
	      var upCurrentlyPlaying = upProps.currentlyPlaying;
	      // GETTING READY TO PLAY
	      if (nextPlaying !== _strings.YOUTUBE_VIDEOS && upNextPlaying === _strings.YOUTUBE_VIDEOS) {
	        this.loadYoutubeVideo();
	      }
	      // START PLAYING
	      if (currentlyPlaying === _strings.YOUTUBE_VIDEOS && !currentlyIsPlaying && upCurrentlyIsPlaying) {
	        this.playYoutubeVideo();
	      }
	      // STOP PLAYING
	      if (currentlyPlaying === _strings.YOUTUBE_VIDEOS && upCurrentlyPlaying !== _strings.YOUTUBE_VIDEOS) {
	        if (window.futusignYoutubePlayer !== undefined) {
	          window.futusignYoutubePlayer.pauseVideo();
	        }
	        this.futusignYoutubeEl.style.visibility = 'hidden';
	        window.setTimeout(function () {
	          return setCover(true);
	        }, 0);
	      }
	      // STOP SHOWING
	      if (this.showing && upCurrentlyPlaying !== _strings.YOUTUBE_VIDEOS && upCurrentlyPlaying !== _strings.TRANSITION && upCurrentlyPlaying !== _strings.TRANSITION2) {
	        this.showing = false;
	        window.setTimeout(function () {
	          return setCover(false);
	        }, 0);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (window.futusignYoutubePlayer !== undefined) {
	        window.futusignYoutubePlayer.pauseVideo();
	      }
	      this.futusignYoutubeEl.style.visibility = 'hidden';
	      window.clearTimeout(this.readyTimeout);
	      window.clearTimeout(this.coverTimeout);
	      window.futusignYoutubeStateChange.removeEventListener(this.handleYoutubeStateChange);
	      window.futusignYoutubeError.removeEventListener(this.handleYoutubeError);
	    }
	  }, {
	    key: 'handleYoutubeStateChange',
	    value: function handleYoutubeStateChange(event) {
	      var _props2 = this.props,
	          setCover = _props2.setCover,
	          setCurrentlyIsPlaying = _props2.setCurrentlyIsPlaying;
	
	      switch (event.detail) {
	        case window.YT.PlayerState.CUED:
	          window.futusignYoutubePlayer.playVideo();
	          break;
	        case window.YT.PlayerState.ENDED:
	          this.futusignYoutubeEl.style.visibility = 'hidden';
	          setCurrentlyIsPlaying(false);
	          window.setTimeout(function () {
	            return setCover(true);
	          }, 0);
	          break;
	        default:
	      }
	    }
	  }, {
	    key: 'handleYoutubeError',
	    value: function handleYoutubeError() {
	      var setBadPlaying = this.props.setBadPlaying;
	
	      setBadPlaying(true);
	    }
	  }, {
	    key: 'validVideo',
	    value: function validVideo() {
	      var youtubeVideos = this.props.youtubeVideos;
	
	      var url = youtubeVideos[0].url;
	      var match = URL_REGEX.exec(url);
	      if (match === null) {
	        return false;
	      }
	      this.videoId = match[1];
	      return true;
	    }
	  }, {
	    key: 'loadYoutubeVideo',
	    value: function loadYoutubeVideo() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          setBadPlaying = _props3.setBadPlaying,
	          setNextIsReady = _props3.setNextIsReady;
	      // YOUTUBE PLAYING CHECK READY
	
	      if (window.futusignYoutubePlayer === undefined) {
	        this.readyTimeout = window.setTimeout(function () {
	          if (window.futusignYoutubePlayer === undefined) {
	            setBadPlaying(true);
	            return;
	          }
	          if (!_this2.validVideo()) {
	            setBadPlaying(true);
	            return;
	          }
	          setNextIsReady(true);
	        }, PLAYER_DELAY * 1000);
	        return;
	      }
	      // CHECK VIDEOS VALID
	      if (!this.validVideo()) {
	        window.setTimeout(function () {
	          return setBadPlaying(true);
	        }, 0);
	        return;
	      }
	      // READY
	      window.setTimeout(function () {
	        return setNextIsReady(true);
	      }, 0);
	    }
	  }, {
	    key: 'playYoutubeVideo',
	    value: function playYoutubeVideo() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          setCover = _props4.setCover,
	          youtubeVideos = _props4.youtubeVideos;
	
	      this.showing = true;
	      window.futusignYoutubePlayer.cueVideoById(this.videoId, 0, youtubeVideos[0].suggestedQuality);
	      window.setTimeout(function () {
	        setCover(true);
	        _this3.futusignYoutubeEl.style.visibility = 'visible';
	      }, 0);
	      this.coverTimeout = window.setTimeout(function () {
	        return setCover(false);
	      }, VIDEO_DELAY * 1000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return PlayerYoutubeVideos;
	}(_react.Component);
	
	PlayerYoutubeVideos.propTypes = {
	  currentlyIsPlaying: _react.PropTypes.bool.isRequired,
	  currentlyPlaying: _react.PropTypes.string,
	  nextPlaying: _react.PropTypes.string,
	  setBadPlaying: _react.PropTypes.func.isRequired,
	  setCover: _react.PropTypes.func.isRequired,
	  setCurrentlyIsPlaying: _react.PropTypes.func.isRequired,
	  setNextIsReady: _react.PropTypes.func.isRequired,
	  youtubeVideos: _react.PropTypes.array.isRequired
	};
	exports.default = PlayerYoutubeVideos;

/***/ },

/***/ 285:
/*!*********************************************!*\
  !*** ./src/components/App/Player/index.jsx ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(/*! react-redux */ 106);
	
	var _strings = __webpack_require__(/*! ../../../strings */ 2);
	
	var _misc = __webpack_require__(/*! ../../../util/misc */ 189);
	
	var _currentlyPlaying = __webpack_require__(/*! ../../../ducks/currentlyPlaying */ 111);
	
	var fromCurrentlyPlaying = _interopRequireWildcard(_currentlyPlaying);
	
	var _currentlyIsPlaying = __webpack_require__(/*! ../../../ducks/currentlyIsPlaying */ 110);
	
	var fromCurrentlyIsPlaying = _interopRequireWildcard(_currentlyIsPlaying);
	
	var _nextPlaying = __webpack_require__(/*! ../../../ducks/nextPlaying */ 120);
	
	var fromNextPlaying = _interopRequireWildcard(_nextPlaying);
	
	var _nextIsReady = __webpack_require__(/*! ../../../ducks/nextIsReady */ 119);
	
	var fromNextIsReady = _interopRequireWildcard(_nextIsReady);
	
	var _badPlaying = __webpack_require__(/*! ../../../ducks/badPlaying */ 107);
	
	var fromBadPlaying = _interopRequireWildcard(_badPlaying);
	
	var _cover = __webpack_require__(/*! ../../../ducks/cover */ 109);
	
	var fromCover = _interopRequireWildcard(_cover);
	
	var _counter = __webpack_require__(/*! ../../../ducks/counter */ 108);
	
	var fromCounter = _interopRequireWildcard(_counter);
	
	var _priority = __webpack_require__(/*! ../../../ducks/priority */ 123);
	
	var fromPriority = _interopRequireWildcard(_priority);
	
	var _minImagePriority = __webpack_require__(/*! ../../../ducks/minImagePriority */ 117);
	
	var _PlayerTransition = __webpack_require__(/*! ./PlayerTransition */ 281);
	
	var _PlayerTransition2 = _interopRequireDefault(_PlayerTransition);
	
	var _PlayerTransition3 = __webpack_require__(/*! ./PlayerTransition2 */ 282);
	
	var _PlayerTransition4 = _interopRequireDefault(_PlayerTransition3);
	
	var _PlayerImages = __webpack_require__(/*! ./PlayerImages */ 280);
	
	var _PlayerImages2 = _interopRequireDefault(_PlayerImages);
	
	var _PlayerWebs = __webpack_require__(/*! ./PlayerWebs */ 283);
	
	var _PlayerWebs2 = _interopRequireDefault(_PlayerWebs);
	
	var _PlayerYoutubeVideos = __webpack_require__(/*! ./PlayerYoutubeVideos */ 284);
	
	var _PlayerYoutubeVideos2 = _interopRequireDefault(_PlayerYoutubeVideos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Player = function (_Component) {
	  _inherits(Player, _Component);
	
	  function Player(props) {
	    _classCallCheck(this, Player);
	
	    var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));
	
	    _this.media = [];
	    _this.mediaImages = [];
	    _this.filteredImages = [];
	    _this.filteredMediaDecks = [];
	    _this.filteredWebs = [];
	    _this.filteredYoutubeVideos = [];
	    return _this;
	  }
	
	  _createClass(Player, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(upProps) {
	      var _this2 = this;
	
	      var _props = this.props,
	          counter = _props.counter,
	          currentlyIsPlaying = _props.currentlyIsPlaying,
	          currentlyPlaying = _props.currentlyPlaying,
	          nextIsReady = _props.nextIsReady,
	          nextPlaying = _props.nextPlaying,
	          setCounter = _props.setCounter,
	          setCurrentlyIsPlaying = _props.setCurrentlyIsPlaying,
	          setCurrentlyPlaying = _props.setCurrentlyPlaying,
	          setNextIsReady = _props.setNextIsReady,
	          setNextPlaying = _props.setNextPlaying;
	
	      var upCurrentlyIsPlaying = upProps.currentlyIsPlaying;
	      var upNextIsReady = upProps.nextIsReady;
	      // TRIGGER NEXT LOAD
	      if (!currentlyIsPlaying && upCurrentlyIsPlaying) {
	        if (currentlyPlaying === _strings.TRANSITION) {
	          // BEGINNING OF NEW PRIORITY; SET MEDIA
	          if (counter === 0) this.calculateMedia();
	          // STUFF FILTERED
	          var nextMedia = this.media[counter];
	          this.filteredImages = [];
	          this.filteredWebs = [];
	          this.filteredYoutubeVideos = [];
	          switch (nextMedia.type) {
	            case _strings.IMAGES:
	              this.filteredImages = [nextMedia.media];
	              break;
	            case _strings.WEBS:
	              this.filteredWebs = [nextMedia.media];
	              break;
	            case _strings.YOUTUBE_VIDEOS:
	              this.filteredYoutubeVideos = [nextMedia.media];
	              break;
	            default:
	          }
	          // CONTINUE
	          window.setTimeout(function () {
	            setNextIsReady(false);
	            setNextPlaying(_strings.TRANSITION2);
	          }, 0);
	          return;
	        }
	        if (currentlyPlaying === _strings.TRANSITION2) {
	          window.setTimeout(function () {
	            setNextPlaying(_this2.media[counter].type);
	            setNextIsReady(false);
	          }, 0);
	          return;
	        }
	        // PLAYING ACTUAL MEDIA
	        window.setTimeout(function () {
	          setCounter(counter + 1);
	          setNextPlaying('TRANSITION');
	          setNextIsReady(false);
	        }, 0);
	        return;
	      }
	      // TRIGGER PLAYING
	      if (currentlyIsPlaying && !upCurrentlyIsPlaying && nextIsReady || !nextIsReady && upNextIsReady && !currentlyIsPlaying) {
	        window.setTimeout(function () {
	          if (nextPlaying === _strings.TRANSITION && counter === _this2.media.length) _this2.calculatePriority();
	          setCurrentlyPlaying(nextPlaying);
	          setCurrentlyIsPlaying(true);
	        }, 0);
	        return;
	      }
	    }
	  }, {
	    key: 'calculateMedia',
	    value: function calculateMedia() {
	      var _props2 = this.props,
	          images = _props2.images,
	          mediaDecks = _props2.mediaDecks,
	          priority = _props2.priority,
	          webs = _props2.webs,
	          youtubeVideos = _props2.youtubeVideos;
	      // HANDLED DIFFERENT BECAUSE OF OFFLINE
	
	      this.mediaImages = images.filter(function (o) {
	        return o.priority === priority;
	      }).map(function (o) {
	        return {
	          title: o.title,
	          type: _strings.IMAGES,
	          media: o
	        };
	      }).sort(function (a, b) {
	        if (a.title < b.title) {
	          return -1;
	        }
	        if (a.title > b.title) {
	          return 1;
	        }
	        return 0;
	      });
	      var mediaWebs = webs.filter(function (o) {
	        return o.priority === priority;
	      }).map(function (o) {
	        return {
	          title: o.title,
	          type: _strings.WEBS,
	          media: o
	        };
	      });
	      var mediaMediaDecks = mediaDecks.filter(function (o) {
	        return o.priority === priority;
	      }).map(function (o) {
	        return {
	          title: o.title,
	          type: _strings.MEDIA_DECKS,
	          media: o
	        };
	      });
	      var mediaYoutubeVideos = youtubeVideos.filter(function (o) {
	        return o.priority === priority;
	      }).map(function (o) {
	        return {
	          title: o.title,
	          type: _strings.YOUTUBE_VIDEOS,
	          media: o
	        };
	      });
	      this.media = [].concat(_toConsumableArray(this.mediaImages), _toConsumableArray(mediaWebs), _toConsumableArray(mediaYoutubeVideos)).sort(function (a, b) {
	        if (a.title < b.title) {
	          return -1;
	        }
	        if (a.title > b.title) {
	          return 1;
	        }
	        return 0;
	      });
	      // MERGE IN MEDIA DECKS
	      var newMedia = [];
	      for (var i = this.media.length - 1; i >= 0; i -= 1) {
	        var mediaItem = this.media[i];
	        for (var j = mediaMediaDecks.length - 1; j >= 0; j -= 1) {
	          var mediaMediaDecksItem = mediaMediaDecks[j];
	          if (mediaMediaDecksItem.title > mediaItem.title) {
	            mediaMediaDecks.splice(j, 1);
	            for (var k = mediaMediaDecksItem.media.media.length - 1; k >= 0; k -= 1) {
	              var mediaMediaDecksItemItem = mediaMediaDecksItem.media.media[k];
	              newMedia.unshift({
	                media: mediaMediaDecksItemItem,
	                title: mediaMediaDecksItem.title,
	                type: mediaMediaDecksItemItem.type
	              });
	            }
	          }
	        }
	        newMedia.unshift(mediaItem);
	      }
	      for (var _i = mediaMediaDecks.length - 1; _i >= 0; _i -= 1) {
	        var _mediaMediaDecksItem = mediaMediaDecks[_i];
	        for (var _j = _mediaMediaDecksItem.media.media.length - 1; _j >= 0; _j -= 1) {
	          var _mediaMediaDecksItemItem = _mediaMediaDecksItem.media.media[_j];
	          newMedia.unshift({
	            media: _mediaMediaDecksItemItem,
	            title: _mediaMediaDecksItem.title,
	            type: _mediaMediaDecksItemItem.type
	          });
	        }
	      }
	      this.media = newMedia;
	    }
	  }, {
	    key: 'calculatePriority',
	    value: function calculatePriority() {
	      var _props3 = this.props,
	          images = _props3.images,
	          mediaDecks = _props3.mediaDecks,
	          priority = _props3.priority,
	          setCounter = _props3.setCounter,
	          setPriority = _props3.setPriority,
	          webs = _props3.webs,
	          youtubeVideos = _props3.youtubeVideos;
	
	      var nextPriority = (0, _misc.minLargerPriority)(priority, [].concat(_toConsumableArray(images), _toConsumableArray(mediaDecks), _toConsumableArray(webs), _toConsumableArray(youtubeVideos)));
	      if (nextPriority === Infinity) {
	        nextPriority = (0, _misc.minLargerPriority)(0, [].concat(_toConsumableArray(images), _toConsumableArray(mediaDecks), _toConsumableArray(webs), _toConsumableArray(youtubeVideos)));
	      }
	      setPriority(nextPriority);
	      setCounter(0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          currentlyIsPlaying = _props4.currentlyIsPlaying,
	          currentlyPlaying = _props4.currentlyPlaying,
	          minImagePriority = _props4.minImagePriority,
	          nextPlaying = _props4.nextPlaying,
	          priority = _props4.priority,
	          setBadPlaying = _props4.setBadPlaying,
	          setCover = _props4.setCover,
	          setCurrentlyIsPlaying = _props4.setCurrentlyIsPlaying,
	          setNextIsReady = _props4.setNextIsReady;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_PlayerTransition2.default, {
	          currentlyIsPlaying: currentlyIsPlaying,
	          currentlyPlaying: currentlyPlaying,
	          nextPlaying: nextPlaying,
	          setCover: setCover,
	          setCurrentlyIsPlaying: setCurrentlyIsPlaying,
	          setNextIsReady: setNextIsReady
	        }),
	        _react2.default.createElement(_PlayerTransition4.default, {
	          currentlyIsPlaying: currentlyIsPlaying,
	          currentlyPlaying: currentlyPlaying,
	          nextPlaying: nextPlaying,
	          setCover: setCover,
	          setCurrentlyIsPlaying: setCurrentlyIsPlaying,
	          setNextIsReady: setNextIsReady
	        }),
	        _react2.default.createElement(_PlayerImages2.default, {
	          currentlyIsPlaying: currentlyIsPlaying,
	          currentlyPlaying: currentlyPlaying,
	          images: this.filteredImages,
	          nextPlaying: nextPlaying,
	          setBadPlaying: setBadPlaying,
	          setCurrentlyIsPlaying: setCurrentlyIsPlaying,
	          setNextIsReady: setNextIsReady,
	          storeOffline: this.filteredImages.length !== 0 && priority === minImagePriority && this.filteredImages[0].id !== undefined && this.filteredImages[0].id === this.mediaImages[0].media.id
	        }),
	        _react2.default.createElement(_PlayerWebs2.default, {
	          currentlyIsPlaying: currentlyIsPlaying,
	          currentlyPlaying: currentlyPlaying,
	          nextPlaying: nextPlaying,
	          setCurrentlyIsPlaying: setCurrentlyIsPlaying,
	          setNextIsReady: setNextIsReady,
	          webs: this.filteredWebs
	        }),
	        _react2.default.createElement(_PlayerYoutubeVideos2.default, {
	          currentlyIsPlaying: currentlyIsPlaying,
	          currentlyPlaying: currentlyPlaying,
	          nextPlaying: nextPlaying,
	          setBadPlaying: setBadPlaying,
	          setCover: setCover,
	          setCurrentlyIsPlaying: setCurrentlyIsPlaying,
	          setNextIsReady: setNextIsReady,
	          youtubeVideos: this.filteredYoutubeVideos
	        })
	      );
	    }
	  }]);
	
	  return Player;
	}(_react.Component);
	
	Player.propTypes = {
	  counter: _react.PropTypes.number.isRequired,
	  currentlyIsPlaying: _react.PropTypes.bool.isRequired,
	  currentlyPlaying: _react.PropTypes.string,
	  minImagePriority: _react.PropTypes.number.isRequired,
	  images: _react.PropTypes.array.isRequired,
	  mediaDecks: _react.PropTypes.array.isRequired,
	  nextIsReady: _react.PropTypes.bool.isRequired,
	  nextPlaying: _react.PropTypes.string,
	  priority: _react.PropTypes.number.isRequired,
	  setBadPlaying: _react.PropTypes.func.isRequired,
	  setCover: _react.PropTypes.func.isRequired,
	  setCounter: _react.PropTypes.func.isRequired,
	  setCurrentlyPlaying: _react.PropTypes.func.isRequired,
	  setCurrentlyIsPlaying: _react.PropTypes.func.isRequired,
	  setNextIsReady: _react.PropTypes.func.isRequired,
	  setNextPlaying: _react.PropTypes.func.isRequired,
	  setPriority: _react.PropTypes.func.isRequired,
	  webs: _react.PropTypes.array.isRequired,
	  youtubeVideos: _react.PropTypes.array.isRequired
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    counter: fromCounter.getCounter(state),
	    currentlyIsPlaying: fromCurrentlyIsPlaying.getCurrentlyIsPlaying(state),
	    currentlyPlaying: fromCurrentlyPlaying.getCurrentlyPlaying(state),
	    minImagePriority: (0, _minImagePriority.getMinImagePriority)(state),
	    nextIsReady: fromNextIsReady.getNextIsReady(state),
	    nextPlaying: fromNextPlaying.getNextPlaying(state),
	    priority: fromPriority.getPriority(state)
	  };
	}, {
	  setBadPlaying: fromBadPlaying.setBadPlaying,
	  setCover: fromCover.setCover,
	  setCounter: fromCounter.setCounter,
	  setCurrentlyPlaying: fromCurrentlyPlaying.setCurrentlyPlaying,
	  setCurrentlyIsPlaying: fromCurrentlyIsPlaying.setCurrentlyIsPlaying,
	  setNextIsReady: fromNextIsReady.setNextIsReady,
	  setNextPlaying: fromNextPlaying.setNextPlaying,
	  setPriority: fromPriority.setPriority
	})(Player);

/***/ },

/***/ 286:
/*!**************************************!*\
  !*** ./src/components/App/index.jsx ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(/*! react-redux */ 106);
	
	var _app = __webpack_require__(/*! firebase/app */ 155);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(/*! firebase/auth */ 496);
	
	__webpack_require__(/*! firebase/database */ 497);
	
	var _strings = __webpack_require__(/*! ../../strings */ 2);
	
	var _misc = __webpack_require__(/*! ../../util/misc */ 189);
	
	var _base = __webpack_require__(/*! ../../apis/base */ 179);
	
	var _appBlocking = __webpack_require__(/*! ../../ducks/appBlocking */ 180);
	
	var fromAppBlocking = _interopRequireWildcard(_appBlocking);
	
	var _monitor = __webpack_require__(/*! ../../ducks/monitor */ 118);
	
	var fromMonitor = _interopRequireWildcard(_monitor);
	
	var _screen = __webpack_require__(/*! ../../ducks/screen */ 186);
	
	var fromScreen = _interopRequireWildcard(_screen);
	
	var _youtubeVideos = __webpack_require__(/*! ../../ducks/youtubeVideos */ 126);
	
	var fromYoutubeVideos = _interopRequireWildcard(_youtubeVideos);
	
	var _youtubeVideosOverride = __webpack_require__(/*! ../../ducks/youtubeVideosOverride */ 127);
	
	var fromYoutubeVideosOverride = _interopRequireWildcard(_youtubeVideosOverride);
	
	var _cover = __webpack_require__(/*! ../../ducks/cover */ 109);
	
	var fromCover = _interopRequireWildcard(_cover);
	
	var _counter = __webpack_require__(/*! ../../ducks/counter */ 108);
	
	var fromCounter = _interopRequireWildcard(_counter);
	
	var _images = __webpack_require__(/*! ../../ducks/images */ 112);
	
	var fromImages = _interopRequireWildcard(_images);
	
	var _imagesOverride = __webpack_require__(/*! ../../ducks/imagesOverride */ 113);
	
	var fromImagesOverride = _interopRequireWildcard(_imagesOverride);
	
	var _layers = __webpack_require__(/*! ../../ducks/layers */ 114);
	
	var fromLayers = _interopRequireWildcard(_layers);
	
	var _webs = __webpack_require__(/*! ../../ducks/webs */ 124);
	
	var fromWebs = _interopRequireWildcard(_webs);
	
	var _websOverride = __webpack_require__(/*! ../../ducks/websOverride */ 125);
	
	var fromWebsOverride = _interopRequireWildcard(_websOverride);
	
	var _offlinePlaying = __webpack_require__(/*! ../../ducks/offlinePlaying */ 184);
	
	var fromOfflinePlaying = _interopRequireWildcard(_offlinePlaying);
	
	var _badPlaying = __webpack_require__(/*! ../../ducks/badPlaying */ 107);
	
	var fromBadPlaying = _interopRequireWildcard(_badPlaying);
	
	var _currentlyPlaying = __webpack_require__(/*! ../../ducks/currentlyPlaying */ 111);
	
	var fromCurrentlyPlaying = _interopRequireWildcard(_currentlyPlaying);
	
	var _currentlyIsPlaying = __webpack_require__(/*! ../../ducks/currentlyIsPlaying */ 110);
	
	var fromCurrentlyIsPlaying = _interopRequireWildcard(_currentlyIsPlaying);
	
	var _nextPlaying = __webpack_require__(/*! ../../ducks/nextPlaying */ 120);
	
	var fromNextPlaying = _interopRequireWildcard(_nextPlaying);
	
	var _nextIsReady = __webpack_require__(/*! ../../ducks/nextIsReady */ 119);
	
	var fromNextIsReady = _interopRequireWildcard(_nextIsReady);
	
	var _connected = __webpack_require__(/*! ../../ducks/connected */ 181);
	
	var fromConnected = _interopRequireWildcard(_connected);
	
	var _overlay = __webpack_require__(/*! ../../ducks/overlay */ 122);
	
	var fromOverlay = _interopRequireWildcard(_overlay);
	
	var _ovWidgets = __webpack_require__(/*! ../../ducks/ovWidgets */ 121);
	
	var fromOvWidgets = _interopRequireWildcard(_ovWidgets);
	
	var _layerBlocking = __webpack_require__(/*! ../../ducks/layerBlocking */ 182);
	
	var fromLayerBlocking = _interopRequireWildcard(_layerBlocking);
	
	var _priority = __webpack_require__(/*! ../../ducks/priority */ 123);
	
	var fromPriority = _interopRequireWildcard(_priority);
	
	var _minImagePriority = __webpack_require__(/*! ../../ducks/minImagePriority */ 117);
	
	var fromMinImagePriority = _interopRequireWildcard(_minImagePriority);
	
	var _override = __webpack_require__(/*! ../../ducks/override */ 185);
	
	var fromOverride = _interopRequireWildcard(_override);
	
	var _mediaDecks = __webpack_require__(/*! ../../ducks/mediaDecks */ 115);
	
	var fromMediaDecks = _interopRequireWildcard(_mediaDecks);
	
	var _mediaDecksOverride = __webpack_require__(/*! ../../ducks/mediaDecksOverride */ 116);
	
	var fromMediaDecksOverride = _interopRequireWildcard(_mediaDecksOverride);
	
	var _time = __webpack_require__(/*! ../../ducks/time */ 187);
	
	var fromTime = _interopRequireWildcard(_time);
	
	var _version = __webpack_require__(/*! ../../ducks/version */ 188);
	
	var fromVersion = _interopRequireWildcard(_version);
	
	var _noPlayer = __webpack_require__(/*! ../../ducks/noPlayer */ 183);
	
	var fromNoPlayer = _interopRequireWildcard(_noPlayer);
	
	var _Blocking = __webpack_require__(/*! ./Blocking */ 272);
	
	var _Blocking2 = _interopRequireDefault(_Blocking);
	
	var _Offline = __webpack_require__(/*! ./Offline */ 277);
	
	var _Offline2 = _interopRequireDefault(_Offline);
	
	var _Connected = __webpack_require__(/*! ./Connected */ 273);
	
	var _Connected2 = _interopRequireDefault(_Connected);
	
	var _OfflineImage = __webpack_require__(/*! ./OfflineImage */ 278);
	
	var _OfflineImage2 = _interopRequireDefault(_OfflineImage);
	
	var _Bad = __webpack_require__(/*! ./Bad */ 271);
	
	var _Bad2 = _interopRequireDefault(_Bad);
	
	var _NoMedia = __webpack_require__(/*! ./NoMedia */ 276);
	
	var _NoMedia2 = _interopRequireDefault(_NoMedia);
	
	var _Player = __webpack_require__(/*! ./Player */ 285);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _Overlay = __webpack_require__(/*! ./Overlay */ 279);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Layers = __webpack_require__(/*! ./Layers */ 275);
	
	var _Layers2 = _interopRequireDefault(_Layers);
	
	var _Cover = __webpack_require__(/*! ./Cover */ 274);
	
	var _Cover2 = _interopRequireDefault(_Cover);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
	
	    _this.fetch = _this.fetch.bind(_this);
	    _this.restartPlayingLoop = _this.restartPlayingLoop.bind(_this);
	    _this.handleMessage = _this.handleMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetch();
	      window.addEventListener('message', this.handleMessage);
	    }
	  }, {
	    key: 'handleMessage',
	    value: function handleMessage(message) {
	      var _props = this.props,
	          setLayerBlocking = _props.setLayerBlocking,
	          time = _props.time;
	
	      switch (message.data.type) {
	        case _strings.MSG_BLOCK:
	          setLayerBlocking(true);
	          break;
	        case _strings.MSG_UNBLOCK:
	          setLayerBlocking(false);
	          this.restartPlayingLoop();
	          break;
	        case _strings.MSG_TIME:
	          message.source.postMessage({
	            type: _strings.MSG_TIME,
	            value: time
	          }, message.origin);
	          break;
	        default:
	      }
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          badPlaying = _props2.badPlaying,
	          fetchScreen = _props2.fetchScreen,
	          images = _props2.images,
	          imagesOverride = _props2.imagesOverride,
	          offlinePlaying = _props2.offlinePlaying,
	          override = _props2.override,
	          layers = _props2.layers,
	          monitor = _props2.monitor,
	          mediaDecks = _props2.mediaDecks,
	          mediaDecksOverride = _props2.mediaDecksOverride,
	          webs = _props2.webs,
	          websOverride = _props2.websOverride,
	          youtubeVideos = _props2.youtubeVideos,
	          youtubeVideosOverride = _props2.youtubeVideosOverride,
	          setConnected = _props2.setConnected,
	          setAppBlocking = _props2.setAppBlocking,
	          setBadPlaying = _props2.setBadPlaying,
	          setOverride = _props2.setOverride,
	          setOfflinePlaying = _props2.setOfflinePlaying,
	          setTime = _props2.setTime,
	          version = _props2.version,
	          setVersion = _props2.setVersion;
	
	      (0, _base.fetchBase)().then(function () {
	        // DETECT COMING BACK ONLINE
	        if (offlinePlaying) {
	          window.location.reload();
	        }
	        return fetchScreen();
	      }).then(function (response) {
	        var screen = response.screen;
	        if (version !== null && version !== response.version) {
	          window.location.reload();
	        }
	        var nextOverride = false;
	        var nextImages = response.images;
	        var nextMediaDecks = response.mediaDecks;
	        var nextWebs = response.webs;
	        var nextYoutubeVideos = response.youtubeVideos;
	        var nextLayers = response.layers;
	        var nextMonitor = response.monitor;
	        if (response.imagesOverride.length !== 0 || response.mediaDecksOverride.length !== 0 || response.websOverride.length !== 0 || response.youtubeVideosOverride.length !== 0) {
	          nextOverride = true;
	          setOverride(true);
	          nextImages = response.imagesOverride;
	          nextMediaDecks = response.mediaDecksOverride;
	          nextWebs = response.websOverride;
	          nextYoutubeVideos = response.youtubeVideosOverride;
	        } else {
	          setOverride(false);
	        }
	        // MONITORING - RELOAD
	        if (monitor !== null && JSON.stringify(nextMonitor) !== JSON.stringify(monitor)) {
	          window.location.reload();
	          return;
	        }
	        // MONITORING - LOGIN AND CHECK-IN
	        if (monitor === null && nextMonitor !== null) {
	          try {
	            _app2.default.initializeApp(nextMonitor);
	            _app2.default.auth().signOut().then(function () {
	              _app2.default.auth().onAuthStateChanged(function (user) {
	                if (user) {
	                  (function () {
	                    var presenceRef = _app2.default.database().ref('presence');
	                    var logRef = _app2.default.database().ref('log');
	                    var connectedRef = _app2.default.database().ref('.info/connected');
	                    connectedRef.on('value', function (snap) {
	                      if (snap.val() === true) {
	                        var myPresenceRef = presenceRef.push(screen.id);
	                        logRef.push({
	                          id: screen.id,
	                          title: screen.title,
	                          status: 'up',
	                          timestamp: _app2.default.database.ServerValue.TIMESTAMP
	                        });
	                        var disconnectRef = logRef.push();
	                        myPresenceRef.onDisconnect().remove();
	                        disconnectRef.onDisconnect().set({
	                          id: screen.id,
	                          title: screen.title,
	                          status: 'down',
	                          timestamp: _app2.default.database.ServerValue.TIMESTAMP
	                        });
	                        setConnected(true);
	                      } else {
	                        setConnected(false);
	                      }
	                    });
	                  })();
	                }
	              });
	              _app2.default.auth().signInWithEmailAndPassword(nextMonitor.email, nextMonitor.password);
	            });
	          } catch (err) {
	            // DO NOTHING
	          }
	        }
	        // CONDITIONALLY CLEAR LOCAL STORAGE
	        if (nextImages.length === 0) {
	          window.localStorage.removeItem('futusign_image_url');
	          window.localStorage.removeItem('futusign_image_file');
	        }
	        // SET DRIFT TIME
	        var serverTime = response.time * 1000;
	        var localTime = Date.now();
	        setTime(localTime - serverTime);
	        // MISC
	        setVersion(response.version);
	        setOfflinePlaying(false);
	        setBadPlaying(false);
	        setAppBlocking(false);
	        // CONDITIONALLY RESTART PLAYING LOOP
	        var usedImages = images;
	        var usedMediaDecks = mediaDecks;
	        var usedWebs = webs;
	        var usedYoutubeVideos = youtubeVideos;
	        if (nextOverride) {
	          usedImages = imagesOverride;
	          usedMediaDecks = mediaDecksOverride;
	          usedWebs = websOverride;
	          usedYoutubeVideos = youtubeVideosOverride;
	        }
	        if (badPlaying || offlinePlaying || override !== nextOverride || JSON.stringify(usedImages) !== JSON.stringify(nextImages) || JSON.stringify(usedMediaDecks) !== JSON.stringify(nextMediaDecks) || JSON.stringify(usedWebs) !== JSON.stringify(nextWebs) || JSON.stringify(usedYoutubeVideos) !== JSON.stringify(nextYoutubeVideos) || JSON.stringify(layers) !== JSON.stringify(nextLayers)) {
	          _this2.restartPlayingLoop();
	        }
	        window.setTimeout(_this2.fetch, screen.polling * 60 * 1000);
	      }).catch(function (error) {
	        setOfflinePlaying(true);
	        setBadPlaying(false);
	        setAppBlocking(false);
	        if (false) {
	          window.console.log(error);
	          return;
	        }
	        window.setTimeout(_this2.fetch, _strings.ERROR_POLLING_INTERVAL * 1000);
	      });
	    }
	  }, {
	    key: 'restartPlayingLoop',
	    value: function restartPlayingLoop() {
	      var _props3 = this.props,
	          images = _props3.images,
	          imagesOverride = _props3.imagesOverride,
	          override = _props3.override,
	          mediaDecks = _props3.mediaDecks,
	          mediaDecksOverride = _props3.mediaDecksOverride,
	          resetCurrentlyPlaying = _props3.resetCurrentlyPlaying,
	          resetNextPlaying = _props3.resetNextPlaying,
	          setCounter = _props3.setCounter,
	          setCover = _props3.setCover,
	          setCurrentlyIsPlaying = _props3.setCurrentlyIsPlaying,
	          setCurrentlyPlaying = _props3.setCurrentlyPlaying,
	          setMinImagePriority = _props3.setMinImagePriority,
	          setNextIsReady = _props3.setNextIsReady,
	          setNoPlayer = _props3.setNoPlayer,
	          setPriority = _props3.setPriority,
	          webs = _props3.webs,
	          websOverride = _props3.websOverride,
	          youtubeVideos = _props3.youtubeVideos,
	          youtubeVideosOverride = _props3.youtubeVideosOverride;
	
	      setNoPlayer(true);
	      setCover(true);
	      var usedImages = images;
	      var usedMediaDecks = mediaDecks;
	      var usedWebs = webs;
	      var usedYoutubeVideos = youtubeVideos;
	      if (override) {
	        usedMediaDecks = mediaDecksOverride;
	        usedImages = imagesOverride;
	        usedWebs = websOverride;
	        usedYoutubeVideos = youtubeVideosOverride;
	      }
	      setNextIsReady(false);
	      setCurrentlyIsPlaying(false);
	      resetCurrentlyPlaying();
	      resetNextPlaying();
	      setMinImagePriority((0, _misc.minLargerPriority)(0, usedImages));
	      setPriority((0, _misc.minLargerPriority)(0, [].concat(_toConsumableArray(usedImages), _toConsumableArray(usedMediaDecks), _toConsumableArray(usedWebs), _toConsumableArray(usedYoutubeVideos))));
	      setCounter(0);
	      setCurrentlyPlaying(_strings.TRANSITION);
	      window.setTimeout(function () {
	        setNoPlayer(false);
	        setCover(false);
	        setCurrentlyIsPlaying(true);
	      }, _strings.RESTART_DELAY * 1000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          appBlocking = _props4.appBlocking,
	          badPlaying = _props4.badPlaying,
	          connected = _props4.connected,
	          cover = _props4.cover,
	          images = _props4.images,
	          imagesOverride = _props4.imagesOverride,
	          mediaDecks = _props4.mediaDecks,
	          mediaDecksOverride = _props4.mediaDecksOverride,
	          noPlayer = _props4.noPlayer,
	          layers = _props4.layers,
	          layerBlocking = _props4.layerBlocking,
	          monitor = _props4.monitor,
	          offlinePlaying = _props4.offlinePlaying,
	          overlay = _props4.overlay,
	          override = _props4.override,
	          ovWidgets = _props4.ovWidgets,
	          webs = _props4.webs,
	          websOverride = _props4.websOverride,
	          youtubeVideos = _props4.youtubeVideos,
	          youtubeVideosOverride = _props4.youtubeVideosOverride;
	
	      var lastImageURL = window.localStorage.getItem('futusign_image_url');
	      var usedImages = images;
	      var usedMediaDecks = mediaDecks;
	      var usedWebs = webs;
	      var usedYoutubeVideos = youtubeVideos;
	      if (override) {
	        usedImages = imagesOverride;
	        usedMediaDecks = mediaDecksOverride;
	        usedWebs = websOverride;
	        usedYoutubeVideos = youtubeVideosOverride;
	      }
	      if (appBlocking) return _react2.default.createElement(_Blocking2.default, null);
	      if (offlinePlaying && lastImageURL !== null) return _react2.default.createElement(_OfflineImage2.default, null);
	      if (offlinePlaying) return _react2.default.createElement(_Offline2.default, null);
	      if (badPlaying) return _react2.default.createElement(_Bad2.default, null);
	      var noMedia = usedImages.length === 0 && usedMediaDecks.length === 0 && usedWebs.length === 0 && usedYoutubeVideos.length === 0;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Layers2.default, { layers: layers }),
	        !layerBlocking && cover && _react2.default.createElement(_Cover2.default, null),
	        !layerBlocking && monitor !== null && _react2.default.createElement(_Connected2.default, { connected: connected }),
	        !layerBlocking && overlay !== null && _react2.default.createElement(_Overlay2.default, { overlay: overlay, ovWidgets: ovWidgets }),
	        !layerBlocking && noMedia && _react2.default.createElement(_NoMedia2.default, null),
	        !layerBlocking && !noMedia && !noPlayer && _react2.default.createElement(_Player2.default, {
	          images: usedImages,
	          mediaDecks: usedMediaDecks,
	          webs: usedWebs,
	          youtubeVideos: usedYoutubeVideos
	        })
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.propTypes = {
	  appBlocking: _react.PropTypes.bool.isRequired,
	  badPlaying: _react.PropTypes.bool.isRequired,
	  connected: _react.PropTypes.bool.isRequired,
	  cover: _react.PropTypes.bool.isRequired,
	  images: _react.PropTypes.array.isRequired,
	  imagesOverride: _react.PropTypes.array.isRequired,
	  fetchScreen: _react.PropTypes.func.isRequired,
	  layers: _react.PropTypes.array.isRequired,
	  layerBlocking: _react.PropTypes.bool.isRequired,
	  mediaDecks: _react.PropTypes.array.isRequired,
	  mediaDecksOverride: _react.PropTypes.array.isRequired,
	  monitor: _react.PropTypes.object,
	  noPlayer: _react.PropTypes.bool.isRequired,
	  offlinePlaying: _react.PropTypes.bool.isRequired,
	  overlay: _react.PropTypes.object,
	  override: _react.PropTypes.bool.isRequired,
	  ovWidgets: _react.PropTypes.array.isRequired,
	  resetCurrentlyPlaying: _react.PropTypes.func.isRequired,
	  resetNextPlaying: _react.PropTypes.func.isRequired,
	  setAppBlocking: _react.PropTypes.func.isRequired,
	  setBadPlaying: _react.PropTypes.func.isRequired,
	  setConnected: _react.PropTypes.func.isRequired,
	  setCover: _react.PropTypes.func.isRequired,
	  setCounter: _react.PropTypes.func.isRequired,
	  setCurrentlyPlaying: _react.PropTypes.func.isRequired,
	  setCurrentlyIsPlaying: _react.PropTypes.func.isRequired,
	  setLayerBlocking: _react.PropTypes.func.isRequired,
	  setMinImagePriority: _react.PropTypes.func.isRequired,
	  setNextIsReady: _react.PropTypes.func.isRequired,
	  setOfflinePlaying: _react.PropTypes.func.isRequired,
	  setOverride: _react.PropTypes.func.isRequired,
	  setPriority: _react.PropTypes.func.isRequired,
	  setNoPlayer: _react.PropTypes.func.isRequired,
	  setTime: _react.PropTypes.func.isRequired,
	  setVersion: _react.PropTypes.func.isRequired,
	  time: _react.PropTypes.number.isRequired,
	  version: _react.PropTypes.string,
	  webs: _react.PropTypes.array.isRequired,
	  websOverride: _react.PropTypes.array.isRequired,
	  youtubeVideos: _react.PropTypes.array.isRequired,
	  youtubeVideosOverride: _react.PropTypes.array.isRequired
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    appBlocking: fromAppBlocking.getAppBlocking(state),
	    badPlaying: fromBadPlaying.getBadPlaying(state),
	    connected: fromConnected.getConnected(state),
	    cover: fromCover.getCover(state),
	    images: fromImages.getImages(state),
	    imagesOverride: fromImagesOverride.getImagesOverride(state),
	    layers: fromLayers.getLayers(state),
	    layerBlocking: fromLayerBlocking.getLayerBlocking(state),
	    mediaDecks: fromMediaDecks.getMediaDecks(state),
	    mediaDecksOverride: fromMediaDecksOverride.getMediaDecksOverride(state),
	    monitor: fromMonitor.getMonitor(state),
	    noPlayer: fromNoPlayer.getNoPlayer(state),
	    offlinePlaying: fromOfflinePlaying.getOfflinePlaying(state),
	    overlay: fromOverlay.getOverlay(state),
	    override: fromOverride.getOverride(state),
	    ovWidgets: fromOvWidgets.getOvWidgets(state),
	    time: fromTime.getTime(state),
	    version: fromVersion.getVersion(state),
	    webs: fromWebs.getWebs(state),
	    websOverride: fromWebsOverride.getWebsOverride(state),
	    youtubeVideos: fromYoutubeVideos.getYoutubeVideos(state),
	    youtubeVideosOverride: fromYoutubeVideosOverride.getYoutubeVideosOverride(state)
	  };
	}, {
	  fetchScreen: fromScreen.fetchScreen,
	  resetCurrentlyPlaying: fromCurrentlyPlaying.resetCurrentlyPlaying,
	  resetNextPlaying: fromNextPlaying.resetNextPlaying,
	  setAppBlocking: fromAppBlocking.setAppBlocking,
	  setBadPlaying: fromBadPlaying.setBadPlaying,
	  setCover: fromCover.setCover,
	  setCounter: fromCounter.setCounter,
	  setConnected: fromConnected.setConnected,
	  setCurrentlyIsPlaying: fromCurrentlyIsPlaying.setCurrentlyIsPlaying,
	  setCurrentlyPlaying: fromCurrentlyPlaying.setCurrentlyPlaying,
	  setLayerBlocking: fromLayerBlocking.setLayerBlocking,
	  setMinImagePriority: fromMinImagePriority.setMinImagePriority,
	  setNextIsReady: fromNextIsReady.setNextIsReady,
	  setNoPlayer: fromNoPlayer.setNoPlayer,
	  setOfflinePlaying: fromOfflinePlaying.setOfflinePlaying,
	  setOverride: fromOverride.setOverride,
	  setPriority: fromPriority.setPriority,
	  setTime: fromTime.setTime,
	  setVersion: fromVersion.setVersion
	})(App);

/***/ },

/***/ 287:
/*!*************************************!*\
  !*** ./src/configureStore/index.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _reduxThunk = __webpack_require__(/*! redux-thunk */ 262);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(/*! ./reducers */ 288);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var middlewares = [_reduxThunk2.default];
	  return (0, _redux.createStore)(_reducers2.default, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares),  false ? window.devToolsExtension() : function (f) {
	    return f;
	  }));
	};

/***/ },

/***/ 288:
/*!****************************************!*\
  !*** ./src/configureStore/reducers.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _appBlocking = __webpack_require__(/*! ../ducks/appBlocking */ 180);
	
	var _appBlocking2 = _interopRequireDefault(_appBlocking);
	
	var _offlinePlaying = __webpack_require__(/*! ../ducks/offlinePlaying */ 184);
	
	var _offlinePlaying2 = _interopRequireDefault(_offlinePlaying);
	
	var _badPlaying = __webpack_require__(/*! ../ducks/badPlaying */ 107);
	
	var _badPlaying2 = _interopRequireDefault(_badPlaying);
	
	var _screen = __webpack_require__(/*! ../ducks/screen */ 186);
	
	var _screen2 = _interopRequireDefault(_screen);
	
	var _layers = __webpack_require__(/*! ../ducks/layers */ 114);
	
	var _layers2 = _interopRequireDefault(_layers);
	
	var _youtubeVideos = __webpack_require__(/*! ../ducks/youtubeVideos */ 126);
	
	var _youtubeVideos2 = _interopRequireDefault(_youtubeVideos);
	
	var _youtubeVideosOverride = __webpack_require__(/*! ../ducks/youtubeVideosOverride */ 127);
	
	var _youtubeVideosOverride2 = _interopRequireDefault(_youtubeVideosOverride);
	
	var _currentlyPlaying = __webpack_require__(/*! ../ducks/currentlyPlaying */ 111);
	
	var _currentlyPlaying2 = _interopRequireDefault(_currentlyPlaying);
	
	var _currentlyIsPlaying = __webpack_require__(/*! ../ducks/currentlyIsPlaying */ 110);
	
	var _currentlyIsPlaying2 = _interopRequireDefault(_currentlyIsPlaying);
	
	var _nextPlaying = __webpack_require__(/*! ../ducks/nextPlaying */ 120);
	
	var _nextPlaying2 = _interopRequireDefault(_nextPlaying);
	
	var _nextIsReady = __webpack_require__(/*! ../ducks/nextIsReady */ 119);
	
	var _nextIsReady2 = _interopRequireDefault(_nextIsReady);
	
	var _images = __webpack_require__(/*! ../ducks/images */ 112);
	
	var _images2 = _interopRequireDefault(_images);
	
	var _monitor = __webpack_require__(/*! ../ducks/monitor */ 118);
	
	var _monitor2 = _interopRequireDefault(_monitor);
	
	var _connected = __webpack_require__(/*! ../ducks/connected */ 181);
	
	var _connected2 = _interopRequireDefault(_connected);
	
	var _overlay = __webpack_require__(/*! ../ducks/overlay */ 122);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _ovWidgets = __webpack_require__(/*! ../ducks/ovWidgets */ 121);
	
	var _ovWidgets2 = _interopRequireDefault(_ovWidgets);
	
	var _layerBlocking = __webpack_require__(/*! ../ducks/layerBlocking */ 182);
	
	var _layerBlocking2 = _interopRequireDefault(_layerBlocking);
	
	var _cover = __webpack_require__(/*! ../ducks/cover */ 109);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	var _priority = __webpack_require__(/*! ../ducks/priority */ 123);
	
	var _priority2 = _interopRequireDefault(_priority);
	
	var _minImagePriority = __webpack_require__(/*! ../ducks/minImagePriority */ 117);
	
	var _minImagePriority2 = _interopRequireDefault(_minImagePriority);
	
	var _webs = __webpack_require__(/*! ../ducks/webs */ 124);
	
	var _webs2 = _interopRequireDefault(_webs);
	
	var _websOverride = __webpack_require__(/*! ../ducks/websOverride */ 125);
	
	var _websOverride2 = _interopRequireDefault(_websOverride);
	
	var _imagesOverride = __webpack_require__(/*! ../ducks/imagesOverride */ 113);
	
	var _imagesOverride2 = _interopRequireDefault(_imagesOverride);
	
	var _override = __webpack_require__(/*! ../ducks/override */ 185);
	
	var _override2 = _interopRequireDefault(_override);
	
	var _counter = __webpack_require__(/*! ../ducks/counter */ 108);
	
	var _counter2 = _interopRequireDefault(_counter);
	
	var _mediaDecks = __webpack_require__(/*! ../ducks/mediaDecks */ 115);
	
	var _mediaDecks2 = _interopRequireDefault(_mediaDecks);
	
	var _mediaDecksOverride = __webpack_require__(/*! ../ducks/mediaDecksOverride */ 116);
	
	var _mediaDecksOverride2 = _interopRequireDefault(_mediaDecksOverride);
	
	var _time = __webpack_require__(/*! ../ducks/time */ 187);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _version = __webpack_require__(/*! ../ducks/version */ 188);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _noPlayer = __webpack_require__(/*! ../ducks/noPlayer */ 183);
	
	var _noPlayer2 = _interopRequireDefault(_noPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  appBlocking: _appBlocking2.default,
	  offlinePlaying: _offlinePlaying2.default,
	  badPlaying: _badPlaying2.default,
	  screen: _screen2.default,
	  currentlyPlaying: _currentlyPlaying2.default,
	  currentlyIsPlaying: _currentlyIsPlaying2.default,
	  nextPlaying: _nextPlaying2.default,
	  nextIsReady: _nextIsReady2.default,
	  images: _images2.default,
	  layers: _layers2.default,
	  monitor: _monitor2.default,
	  connected: _connected2.default,
	  overlay: _overlay2.default,
	  ovWidgets: _ovWidgets2.default,
	  layerBlocking: _layerBlocking2.default,
	  cover: _cover2.default,
	  priority: _priority2.default,
	  minImagePriority: _minImagePriority2.default,
	  webs: _webs2.default,
	  websOverride: _websOverride2.default,
	  imagesOverride: _imagesOverride2.default,
	  override: _override2.default,
	  counter: _counter2.default,
	  mediaDecks: _mediaDecks2.default,
	  mediaDecksOverride: _mediaDecksOverride2.default,
	  youtubeVideos: _youtubeVideos2.default,
	  youtubeVideosOverride: _youtubeVideosOverride2.default,
	  time: _time2.default,
	  version: _version2.default,
	  noPlayer: _noPlayer2.default
	});

/***/ },

/***/ 180:
/*!**********************************!*\
  !*** ./src/ducks/appBlocking.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setAppBlocking = exports.getAppBlocking = exports.SET_APP_BLOCKING = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'appBlocking';
	// ACTIONS
	var SET_APP_BLOCKING = exports.SET_APP_BLOCKING = _strings.ACTION_PREFIX + 'SET_APP_BLOCKING';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_APP_BLOCKING:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getAppBlocking = exports.getAppBlocking = function getAppBlocking(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validAppBlocking = function validAppBlocking(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setAppBlocking = exports.setAppBlocking = function setAppBlocking(value) {
	  if (!validAppBlocking(value)) throw new Error();
	  return {
	    type: SET_APP_BLOCKING,
	    value: value
	  };
	};

/***/ },

/***/ 107:
/*!*********************************!*\
  !*** ./src/ducks/badPlaying.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setBadPlaying = exports.getBadPlaying = exports.SET_BAD_PLAYING = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'badPlaying';
	// ACTIONS
	var SET_BAD_PLAYING = exports.SET_BAD_PLAYING = _strings.ACTION_PREFIX + 'SET_BAD_PLAYING';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_BAD_PLAYING:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS
	
	
	var getBadPlaying = exports.getBadPlaying = function getBadPlaying(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validBadPlaying = function validBadPlaying(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setBadPlaying = exports.setBadPlaying = function setBadPlaying(value) {
	  if (!validBadPlaying(value)) throw new Error();
	  if (value) {
	    window.setTimeout(function () {
	      window.location.reload();
	    }, _strings.ERROR_POLLING_INTERVAL * 1000);
	  }
	  return {
	    type: SET_BAD_PLAYING,
	    value: value
	  };
	};

/***/ },

/***/ 181:
/*!********************************!*\
  !*** ./src/ducks/connected.js ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setConnected = exports.getConnected = exports.SET_CONNECTED = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'connected';
	// ACTIONS
	var SET_CONNECTED = exports.SET_CONNECTED = _strings.ACTION_PREFIX + 'SET_CONNECTED';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_CONNECTED:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS
	
	
	var getConnected = exports.getConnected = function getConnected(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validConnected = function validConnected(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setConnected = exports.setConnected = function setConnected(value) {
	  if (!validConnected(value)) throw new Error();
	  return {
	    type: SET_CONNECTED,
	    value: value
	  };
	};

/***/ },

/***/ 108:
/*!******************************!*\
  !*** ./src/ducks/counter.js ***!
  \******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setCounter = exports.getCounter = exports.SET_COUNTER = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'counter';
	// ACTIONS
	var SET_COUNTER = exports.SET_COUNTER = _strings.ACTION_PREFIX + 'SET_COUNTER';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_COUNTER:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getCounter = exports.getCounter = function getCounter(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validCounter = function validCounter(value) {
	  return !(value === undefined || typeof value !== 'number');
	};
	// ACTION CREATORS
	var setCounter = exports.setCounter = function setCounter(value) {
	  if (!validCounter(value)) throw new Error();
	  return {
	    type: SET_COUNTER,
	    value: value
	  };
	};

/***/ },

/***/ 109:
/*!****************************!*\
  !*** ./src/ducks/cover.js ***!
  \****************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setCover = exports.getCover = exports.SET_COVER = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'cover';
	// ACTIONS
	var SET_COVER = exports.SET_COVER = _strings.ACTION_PREFIX + 'SET_COVER';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_COVER:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getCover = exports.getCover = function getCover(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validCover = function validCover(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setCover = exports.setCover = function setCover(value) {
	  if (!validCover(value)) throw new Error();
	  return {
	    type: SET_COVER,
	    value: value
	  };
	};

/***/ },

/***/ 110:
/*!*****************************************!*\
  !*** ./src/ducks/currentlyIsPlaying.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setCurrentlyIsPlaying = exports.getCurrentlyIsPlaying = exports.SET_CURRENTLY_IS_PLAYING = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'currentlyIsPlaying';
	// ACTIONS
	var SET_CURRENTLY_IS_PLAYING = exports.SET_CURRENTLY_IS_PLAYING = _strings.ACTION_PREFIX + 'SET_CURRENTLY_IS_PLAYING';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_CURRENTLY_IS_PLAYING:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getCurrentlyIsPlaying = exports.getCurrentlyIsPlaying = function getCurrentlyIsPlaying(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validCurrentlyIsPlaying = function validCurrentlyIsPlaying(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setCurrentlyIsPlaying = exports.setCurrentlyIsPlaying = function setCurrentlyIsPlaying(value) {
	  if (!validCurrentlyIsPlaying(value)) throw new Error();
	  return {
	    type: SET_CURRENTLY_IS_PLAYING,
	    value: value
	  };
	};

/***/ },

/***/ 111:
/*!***************************************!*\
  !*** ./src/ducks/currentlyPlaying.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetCurrentlyPlaying = exports.setCurrentlyPlaying = exports.getCurrentlyPlaying = exports.SET_CURRENTLY_PLAYING = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'currentlyPlaying';
	// ACTIONS
	var SET_CURRENTLY_PLAYING = exports.SET_CURRENTLY_PLAYING = _strings.ACTION_PREFIX + 'SET_CURRENTLY_PLAYING';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_CURRENTLY_PLAYING:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getCurrentlyPlaying = exports.getCurrentlyPlaying = function getCurrentlyPlaying(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validCurrentlyPlaying = function validCurrentlyPlaying(value) {
	  return !(value === undefined || typeof value !== 'string');
	};
	// ACTION CREATORS
	var setCurrentlyPlaying = exports.setCurrentlyPlaying = function setCurrentlyPlaying(value) {
	  if (!validCurrentlyPlaying(value)) throw new Error();
	  return {
	    type: SET_CURRENTLY_PLAYING,
	    value: value
	  };
	};
	var resetCurrentlyPlaying = exports.resetCurrentlyPlaying = function resetCurrentlyPlaying() {
	  return {
	    type: SET_CURRENTLY_PLAYING,
	    value: null
	  };
	};

/***/ },

/***/ 112:
/*!*****************************!*\
  !*** ./src/ducks/images.js ***!
  \*****************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setImages = exports.getImages = exports.FETCH_IMAGES_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'images';
	// ACTIONS
	var FETCH_IMAGES_SUCCESS = exports.FETCH_IMAGES_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_IMAGES_SUCCESS';
	// SCHEMA
	var imageSchema = new _normalizr.Schema('images');
	var imagesSchema = (0, _normalizr.arrayOf)(imageSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_IMAGES_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.images);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_IMAGES_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getImagesIds = function getImagesIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getImagesById = function getImagesById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getImages = exports.getImages = (0, _reselect.createSelector)([getImagesIds, getImagesById], function (imagesIds, imagesById) {
	  return imagesIds.map(function (id) {
	    return imagesById[id];
	  });
	});
	var setImages = exports.setImages = function setImages(response) {
	  return {
	    type: FETCH_IMAGES_SUCCESS,
	    response: (0, _normalizr.normalize)(response, imagesSchema)
	  };
	};

/***/ },

/***/ 113:
/*!*************************************!*\
  !*** ./src/ducks/imagesOverride.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setImagesOverride = exports.getImagesOverride = exports.FETCH_IMAGES_OVERRIDE_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'imagesOverride';
	// ACTIONS
	var FETCH_IMAGES_OVERRIDE_SUCCESS = exports.FETCH_IMAGES_OVERRIDE_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_IMAGES_OVERRIDE_SUCCESS';
	// SCHEMA
	var imageOverrideSchema = new _normalizr.Schema('imagesOverride');
	var imagesOverrideSchema = (0, _normalizr.arrayOf)(imageOverrideSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_IMAGES_OVERRIDE_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.imagesOverride);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_IMAGES_OVERRIDE_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getImagesOverrideIds = function getImagesOverrideIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getImagesOverrideById = function getImagesOverrideById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getImagesOverride = exports.getImagesOverride = (0, _reselect.createSelector)([getImagesOverrideIds, getImagesOverrideById], function (imagesOverrideIds, imagesOverrideById) {
	  return imagesOverrideIds.map(function (id) {
	    return imagesOverrideById[id];
	  });
	});
	var setImagesOverride = exports.setImagesOverride = function setImagesOverride(response) {
	  return {
	    type: FETCH_IMAGES_OVERRIDE_SUCCESS,
	    response: (0, _normalizr.normalize)(response, imagesOverrideSchema)
	  };
	};

/***/ },

/***/ 182:
/*!************************************!*\
  !*** ./src/ducks/layerBlocking.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setLayerBlocking = exports.getLayerBlocking = exports.SET_LAYER_BLOCKING = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'layerBlocking';
	// ACTIONS
	var SET_LAYER_BLOCKING = exports.SET_LAYER_BLOCKING = _strings.ACTION_PREFIX + 'SET_LAYER_BLOCKING';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_LAYER_BLOCKING:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getLayerBlocking = exports.getLayerBlocking = function getLayerBlocking(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validLayerBlocking = function validLayerBlocking(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setLayerBlocking = exports.setLayerBlocking = function setLayerBlocking(value) {
	  if (!validLayerBlocking(value)) throw new Error();
	  return {
	    type: SET_LAYER_BLOCKING,
	    value: value
	  };
	};

/***/ },

/***/ 114:
/*!*****************************!*\
  !*** ./src/ducks/layers.js ***!
  \*****************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setLayers = exports.getLayers = exports.FETCH_LAYERS_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'layers';
	// ACTIONS
	var FETCH_LAYERS_SUCCESS = exports.FETCH_LAYERS_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_LAYERS_SUCCESS';
	// SCHEMA
	var layerSchema = new _normalizr.Schema('layers');
	var layersSchema = (0, _normalizr.arrayOf)(layerSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_LAYERS_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.layers);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_LAYERS_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getLayersIds = function getLayersIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getLayersById = function getLayersById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getLayers = exports.getLayers = (0, _reselect.createSelector)([getLayersIds, getLayersById], function (layersIds, layersById) {
	  return layersIds.map(function (id) {
	    return layersById[id];
	  });
	});
	var setLayers = exports.setLayers = function setLayers(response) {
	  return {
	    type: FETCH_LAYERS_SUCCESS,
	    response: (0, _normalizr.normalize)(response, layersSchema)
	  };
	};

/***/ },

/***/ 115:
/*!*********************************!*\
  !*** ./src/ducks/mediaDecks.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setMediaDecks = exports.getMediaDecks = exports.FETCH_MEDIA_DECKS_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'mediaDecks';
	// ACTIONS
	var FETCH_MEDIA_DECKS_SUCCESS = exports.FETCH_MEDIA_DECKS_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_MEDIA_DECKS_SUCCESS';
	// SCHEMA
	var mediaDeckSchema = new _normalizr.Schema('mediaDecks');
	var mediaDecksSchema = (0, _normalizr.arrayOf)(mediaDeckSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_MEDIA_DECKS_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.mediaDecks);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_MEDIA_DECKS_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getMediaDecksIds = function getMediaDecksIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getMediaDecksById = function getMediaDecksById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getMediaDecks = exports.getMediaDecks = (0, _reselect.createSelector)([getMediaDecksIds, getMediaDecksById], function (mediaDecksIds, mediaDecksById) {
	  return mediaDecksIds.map(function (id) {
	    return mediaDecksById[id];
	  });
	});
	var setMediaDecks = exports.setMediaDecks = function setMediaDecks(response) {
	  return {
	    type: FETCH_MEDIA_DECKS_SUCCESS,
	    response: (0, _normalizr.normalize)(response, mediaDecksSchema)
	  };
	};

/***/ },

/***/ 116:
/*!*****************************************!*\
  !*** ./src/ducks/mediaDecksOverride.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setMediaDecksOverride = exports.getMediaDecksOverride = exports.FETCH_MEDIA_DECKS_OVERRIDE_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'mediaDecksOverride';
	// ACTIONS
	var FETCH_MEDIA_DECKS_OVERRIDE_SUCCESS = exports.FETCH_MEDIA_DECKS_OVERRIDE_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_MEDIA_DECKS_OVERRIDE_SUCCESS';
	// SCHEMA
	var mediaDeckOverrideSchema = new _normalizr.Schema('mediaDecksOverride');
	var mediaDecksOverrideSchema = (0, _normalizr.arrayOf)(mediaDeckOverrideSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_MEDIA_DECKS_OVERRIDE_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.mediaDecksOverride);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_MEDIA_DECKS_OVERRIDE_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getMediaDecksOverrideIds = function getMediaDecksOverrideIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getMediaDecksOverrideById = function getMediaDecksOverrideById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getMediaDecksOverride = exports.getMediaDecksOverride = (0, _reselect.createSelector)([getMediaDecksOverrideIds, getMediaDecksOverrideById], function (mediaDecksOverrideIds, mediaDecksOverrideById) {
	  return mediaDecksOverrideIds.map(function (id) {
	    return mediaDecksOverrideById[id];
	  });
	});
	var setMediaDecksOverride = exports.setMediaDecksOverride = function setMediaDecksOverride(response) {
	  return {
	    type: FETCH_MEDIA_DECKS_OVERRIDE_SUCCESS,
	    response: (0, _normalizr.normalize)(response, mediaDecksOverrideSchema)
	  };
	};

/***/ },

/***/ 117:
/*!***************************************!*\
  !*** ./src/ducks/minImagePriority.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setMinImagePriority = exports.getMinImagePriority = exports.SET_MIN_IMAGE_PRIORITY = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'minImagePriority';
	// ACTIONS
	var SET_MIN_IMAGE_PRIORITY = exports.SET_MIN_IMAGE_PRIORITY = _strings.ACTION_PREFIX + 'SET_MIN_IMAGE_PRIORITY';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_MIN_IMAGE_PRIORITY:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getMinImagePriority = exports.getMinImagePriority = function getMinImagePriority(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validMinImagePriority = function validMinImagePriority(value) {
	  return !(value === undefined || typeof value !== 'number');
	};
	// ACTION CREATORS
	var setMinImagePriority = exports.setMinImagePriority = function setMinImagePriority(value) {
	  if (!validMinImagePriority(value)) throw new Error();
	  return {
	    type: SET_MIN_IMAGE_PRIORITY,
	    value: value
	  };
	};

/***/ },

/***/ 118:
/*!******************************!*\
  !*** ./src/ducks/monitor.js ***!
  \******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setMonitor = exports.getMonitor = exports.FETCH_MONITOR_SUCCESS = undefined;
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'monitor';
	// ACTIONS
	var FETCH_MONITOR_SUCCESS = exports.FETCH_MONITOR_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_MONITOR_SUCCESS';
	// SCHEMA
	// REDUCERS
	var value = function value() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_MONITOR_SUCCESS:
	      return action.response;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  value: value
	});
	// ACCESSORS AKA SELECTORS
	
	var getMonitor = exports.getMonitor = function getMonitor(state) {
	  return state[reducerMountPoint].value;
	};
	// ACTION CREATOR VALIDATORS
	// ACTION CREATORS
	var setMonitor = exports.setMonitor = function setMonitor(response) {
	  return {
	    type: FETCH_MONITOR_SUCCESS,
	    response: response
	  };
	};

/***/ },

/***/ 119:
/*!**********************************!*\
  !*** ./src/ducks/nextIsReady.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setNextIsReady = exports.getNextIsReady = exports.SET_NEXT_IS_READY = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'nextIsReady';
	// ACTIONS
	var SET_NEXT_IS_READY = exports.SET_NEXT_IS_READY = _strings.ACTION_PREFIX + 'SET_NEXT_IS_READY';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_NEXT_IS_READY:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getNextIsReady = exports.getNextIsReady = function getNextIsReady(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validNextIsReady = function validNextIsReady(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setNextIsReady = exports.setNextIsReady = function setNextIsReady(value) {
	  if (!validNextIsReady(value)) throw new Error();
	  return {
	    type: SET_NEXT_IS_READY,
	    value: value
	  };
	};

/***/ },

/***/ 120:
/*!**********************************!*\
  !*** ./src/ducks/nextPlaying.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetNextPlaying = exports.setNextPlaying = exports.getNextPlaying = exports.SET_NEXT_PLAYING = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'nextPlaying';
	// ACTIONS
	var SET_NEXT_PLAYING = exports.SET_NEXT_PLAYING = _strings.ACTION_PREFIX + 'SET_NEXT_PLAYING';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_NEXT_PLAYING:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getNextPlaying = exports.getNextPlaying = function getNextPlaying(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validNextPlaying = function validNextPlaying(value) {
	  return !(value === undefined || typeof value !== 'string');
	};
	// ACTION CREATORS
	var setNextPlaying = exports.setNextPlaying = function setNextPlaying(value) {
	  if (!validNextPlaying(value)) throw new Error();
	  return {
	    type: SET_NEXT_PLAYING,
	    value: value
	  };
	};
	var resetNextPlaying = exports.resetNextPlaying = function resetNextPlaying() {
	  return {
	    type: SET_NEXT_PLAYING,
	    value: null
	  };
	};

/***/ },

/***/ 183:
/*!*******************************!*\
  !*** ./src/ducks/noPlayer.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setNoPlayer = exports.getNoPlayer = exports.SET_NO_PLAYER = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'noPlayer';
	// ACTIONS
	var SET_NO_PLAYER = exports.SET_NO_PLAYER = _strings.ACTION_PREFIX + 'SET_NO_PLAYER';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_NO_PLAYER:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getNoPlayer = exports.getNoPlayer = function getNoPlayer(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validNoPlayer = function validNoPlayer(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setNoPlayer = exports.setNoPlayer = function setNoPlayer(value) {
	  if (!validNoPlayer(value)) throw new Error();
	  return {
	    type: SET_NO_PLAYER,
	    value: value
	  };
	};

/***/ },

/***/ 184:
/*!*************************************!*\
  !*** ./src/ducks/offlinePlaying.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOfflinePlaying = exports.getOfflinePlaying = exports.SET_OFFLINE_PLAYING = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'offlinePlaying';
	// ACTIONS
	var SET_OFFLINE_PLAYING = exports.SET_OFFLINE_PLAYING = _strings.ACTION_PREFIX + 'SET_OFFLINE_PLAYING';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_OFFLINE_PLAYING:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS
	
	
	var getOfflinePlaying = exports.getOfflinePlaying = function getOfflinePlaying(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validOfflinePlaying = function validOfflinePlaying(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setOfflinePlaying = exports.setOfflinePlaying = function setOfflinePlaying(value) {
	  if (!validOfflinePlaying(value)) throw new Error();
	  return {
	    type: SET_OFFLINE_PLAYING,
	    value: value
	  };
	};

/***/ },

/***/ 121:
/*!********************************!*\
  !*** ./src/ducks/ovWidgets.js ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOvWidgets = exports.getOvWidgets = exports.FETCH_OV_WIDGETS_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'ovWidgets';
	// ACTIONS
	var FETCH_OV_WIDGETS_SUCCESS = exports.FETCH_OV_WIDGETS_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_OV_WIDGETS_SUCCESS';
	// SCHEMA
	var ovWidgetSchema = new _normalizr.Schema('ovWidgets');
	var ovWidgetsSchema = (0, _normalizr.arrayOf)(ovWidgetSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_OV_WIDGETS_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.ovWidgets);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_OV_WIDGETS_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getOvWidgetsIds = function getOvWidgetsIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getOvWidgetsById = function getOvWidgetsById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getOvWidgets = exports.getOvWidgets = (0, _reselect.createSelector)([getOvWidgetsIds, getOvWidgetsById], function (ovWidgetsIds, ovWidgetsById) {
	  return ovWidgetsIds.map(function (id) {
	    return ovWidgetsById[id];
	  });
	});
	var setOvWidgets = exports.setOvWidgets = function setOvWidgets(response) {
	  return {
	    type: FETCH_OV_WIDGETS_SUCCESS,
	    response: (0, _normalizr.normalize)(response, ovWidgetsSchema)
	  };
	};

/***/ },

/***/ 122:
/*!******************************!*\
  !*** ./src/ducks/overlay.js ***!
  \******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOverlay = exports.getOverlay = exports.FETCH_OVERLAY_SUCCESS = undefined;
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'overlay';
	// ACTIONS
	var FETCH_OVERLAY_SUCCESS = exports.FETCH_OVERLAY_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_OVERLAY_SUCCESS';
	// SCHEMA
	// REDUCERS
	var value = function value() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_OVERLAY_SUCCESS:
	      return action.response;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  value: value
	});
	// ACCESSORS AKA SELECTORS
	
	var getOverlay = exports.getOverlay = function getOverlay(state) {
	  return state[reducerMountPoint].value;
	};
	// ACTION CREATOR VALIDATORS
	// ACTION CREATORS
	var setOverlay = exports.setOverlay = function setOverlay(response) {
	  return {
	    type: FETCH_OVERLAY_SUCCESS,
	    response: response
	  };
	};

/***/ },

/***/ 185:
/*!*******************************!*\
  !*** ./src/ducks/override.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOverride = exports.getOverride = exports.SET_OVERRIDE = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'override';
	// ACTIONS
	var SET_OVERRIDE = exports.SET_OVERRIDE = _strings.ACTION_PREFIX + 'SET_OVERRIDE';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_OVERRIDE:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getOverride = exports.getOverride = function getOverride(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validOverride = function validOverride(value) {
	  return !(value === undefined || typeof value !== 'boolean');
	};
	// ACTION CREATORS
	var setOverride = exports.setOverride = function setOverride(value) {
	  if (!validOverride(value)) throw new Error();
	  return {
	    type: SET_OVERRIDE,
	    value: value
	  };
	};

/***/ },

/***/ 123:
/*!*******************************!*\
  !*** ./src/ducks/priority.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setPriority = exports.getPriority = exports.SET_PRIORITY = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'priority';
	// ACTIONS
	var SET_PRIORITY = exports.SET_PRIORITY = _strings.ACTION_PREFIX + 'SET_PRIORITY';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_PRIORITY:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getPriority = exports.getPriority = function getPriority(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validPriority = function validPriority(value) {
	  return !(value === undefined || typeof value !== 'number');
	};
	// ACTION CREATORS
	var setPriority = exports.setPriority = function setPriority(value) {
	  if (!validPriority(value)) throw new Error();
	  return {
	    type: SET_PRIORITY,
	    value: value
	  };
	};

/***/ },

/***/ 186:
/*!*****************************!*\
  !*** ./src/ducks/screen.js ***!
  \*****************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetFetchScreenError = exports.fetchScreen = exports.getFetchScreenErrorMessage = exports.getIsFetchingScreen = exports.getScreen = exports.RESET_FETCH_SCREEN_ERROR = exports.FETCH_SCREEN_ERROR = exports.FETCH_SCREEN_SUCCESS = exports.FETCH_SCREEN_REQUEST = undefined;
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	var _exceptions = __webpack_require__(/*! ../util/exceptions */ 290);
	
	var _images = __webpack_require__(/*! ./images */ 112);
	
	var _imagesOverride = __webpack_require__(/*! ./imagesOverride */ 113);
	
	var _webs = __webpack_require__(/*! ./webs */ 124);
	
	var _websOverride = __webpack_require__(/*! ./websOverride */ 125);
	
	var _youtubeVideos = __webpack_require__(/*! ./youtubeVideos */ 126);
	
	var _youtubeVideosOverride = __webpack_require__(/*! ./youtubeVideosOverride */ 127);
	
	var _layers = __webpack_require__(/*! ./layers */ 114);
	
	var _mediaDecks = __webpack_require__(/*! ./mediaDecks */ 115);
	
	var _mediaDecksOverride = __webpack_require__(/*! ./mediaDecksOverride */ 116);
	
	var _overlay = __webpack_require__(/*! ./overlay */ 122);
	
	var _ovWidgets = __webpack_require__(/*! ./ovWidgets */ 121);
	
	var _monitor = __webpack_require__(/*! ./monitor */ 118);
	
	var _endpoint = __webpack_require__(/*! ../apis/endpoint */ 270);
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'screen';
	// ACTIONS
	
	// API
	var FETCH_SCREEN_REQUEST = exports.FETCH_SCREEN_REQUEST = _strings.ACTION_PREFIX + 'FETCH_SCREEN_REQUEST';
	var FETCH_SCREEN_SUCCESS = exports.FETCH_SCREEN_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_SCREEN_SUCCESS';
	var FETCH_SCREEN_ERROR = exports.FETCH_SCREEN_ERROR = _strings.ACTION_PREFIX + 'FETCH_SCREEN_ERROR';
	var RESET_FETCH_SCREEN_ERROR = exports.RESET_FETCH_SCREEN_ERROR = _strings.ACTION_PREFIX + 'RESET_FETCH_SCREEN_ERROR';
	// SCHEMA
	// REDUCERS
	var value = function value() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    id: _strings.SCREEN_ID
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_SCREEN_SUCCESS:
	      return action.response;
	    default:
	      return state;
	  }
	};
	var isFetching = function isFetching() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_SCREEN_REQUEST:
	      return true;
	    case FETCH_SCREEN_SUCCESS:
	    case FETCH_SCREEN_ERROR:
	      return false;
	    default:
	      return state;
	  }
	};
	var fetchErrorMessage = function fetchErrorMessage() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_SCREEN_ERROR:
	      return action.message;
	    case FETCH_SCREEN_REQUEST:
	    case FETCH_SCREEN_SUCCESS:
	    case RESET_FETCH_SCREEN_ERROR:
	      return null;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  value: value,
	  isFetching: isFetching,
	  fetchErrorMessage: fetchErrorMessage
	});
	// ACCESSORS AKA SELECTORS
	
	var getScreen = exports.getScreen = function getScreen(state) {
	  return state[reducerMountPoint].value;
	};
	var getIsFetchingScreen = exports.getIsFetchingScreen = function getIsFetchingScreen(state) {
	  return state[reducerMountPoint].isFetching;
	};
	var getFetchScreenErrorMessage = exports.getFetchScreenErrorMessage = function getFetchScreenErrorMessage(state) {
	  return state[reducerMountPoint].fetchErrorMessage;
	};
	// ACTION CREATOR VALIDATORS
	// ACTION CREATORS
	var fetchScreen = exports.fetchScreen = function fetchScreen() {
	  return function (dispatch, getState) {
	    var state = getState();
	    if (getIsFetchingScreen(state)) throw new Error();
	    var screen = getScreen(state);
	    dispatch({
	      type: FETCH_SCREEN_REQUEST
	    });
	    return (0, _endpoint.get)(screen.id).then(function (response) {
	      dispatch({
	        type: FETCH_SCREEN_SUCCESS,
	        response: response.screen
	      });
	      dispatch((0, _images.setImages)(response.images));
	      dispatch((0, _imagesOverride.setImagesOverride)(response.imagesOverride));
	      dispatch((0, _mediaDecks.setMediaDecks)(response.mediaDecks));
	      dispatch((0, _mediaDecksOverride.setMediaDecksOverride)(response.mediaDecksOverride));
	      dispatch((0, _webs.setWebs)(response.webs));
	      dispatch((0, _websOverride.setWebsOverride)(response.websOverride));
	      dispatch((0, _youtubeVideos.setYoutubeVideos)(response.youtubeVideos));
	      dispatch((0, _youtubeVideosOverride.setYoutubeVideosOverride)(response.youtubeVideosOverride));
	      dispatch((0, _layers.setLayers)(response.layers));
	      dispatch((0, _overlay.setOverlay)(response.overlay));
	      dispatch((0, _ovWidgets.setOvWidgets)(response.ovWidgets));
	      dispatch((0, _monitor.setMonitor)(response.monitor));
	      return response;
	    }, function (error) {
	      dispatch({
	        type: FETCH_SCREEN_ERROR,
	        message: error.message
	      });
	      throw new _exceptions.ServerException(error.message);
	    });
	  };
	};
	var resetFetchScreenError = exports.resetFetchScreenError = function resetFetchScreenError() {
	  return {
	    type: RESET_FETCH_SCREEN_ERROR
	  };
	};

/***/ },

/***/ 187:
/*!***************************!*\
  !*** ./src/ducks/time.js ***!
  \***************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTime = exports.getTime = exports.SET_TIME = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'time';
	// ACTIONS
	var SET_TIME = exports.SET_TIME = _strings.ACTION_PREFIX + 'SET_TIME';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_TIME:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getTime = exports.getTime = function getTime(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validTime = function validTime(value) {
	  return !(value === undefined || typeof value !== 'number');
	};
	// ACTION CREATORS
	var setTime = exports.setTime = function setTime(value) {
	  if (!validTime(value)) throw new Error();
	  return {
	    type: SET_TIME,
	    value: value
	  };
	};

/***/ },

/***/ 188:
/*!******************************!*\
  !*** ./src/ducks/version.js ***!
  \******************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setVersion = exports.getVersion = exports.SET_VERSION = undefined;
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'version';
	// ACTIONS
	var SET_VERSION = exports.SET_VERSION = _strings.ACTION_PREFIX + 'SET_VERSION';
	// SCHEMA
	// REDUCERS
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_VERSION:
	      return action.value;
	    default:
	      return state;
	  }
	};
	// ACCESSORS AKA SELECTORS
	
	
	var getVersion = exports.getVersion = function getVersion(state) {
	  return state[reducerMountPoint];
	};
	// ACTION CREATOR VALIDATORS
	var validVersion = function validVersion(value) {
	  return !(value === undefined || typeof value !== 'string');
	};
	// ACTION CREATORS
	var setVersion = exports.setVersion = function setVersion(value) {
	  if (!validVersion(value)) throw new Error();
	  return {
	    type: SET_VERSION,
	    value: value
	  };
	};

/***/ },

/***/ 124:
/*!***************************!*\
  !*** ./src/ducks/webs.js ***!
  \***************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setWebs = exports.getWebs = exports.FETCH_WEBS_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'webs';
	// ACTIONS
	var FETCH_WEBS_SUCCESS = exports.FETCH_WEBS_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_WEBS_SUCCESS';
	// SCHEMA
	var webSchema = new _normalizr.Schema('webs');
	var websSchema = (0, _normalizr.arrayOf)(webSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_WEBS_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.webs);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_WEBS_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getWebsIds = function getWebsIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getWebsById = function getWebsById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getWebs = exports.getWebs = (0, _reselect.createSelector)([getWebsIds, getWebsById], function (websIds, websById) {
	  return websIds.map(function (id) {
	    return websById[id];
	  });
	});
	var setWebs = exports.setWebs = function setWebs(response) {
	  return {
	    type: FETCH_WEBS_SUCCESS,
	    response: (0, _normalizr.normalize)(response, websSchema)
	  };
	};

/***/ },

/***/ 125:
/*!***********************************!*\
  !*** ./src/ducks/websOverride.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setWebsOverride = exports.getWebsOverride = exports.FETCH_WEBS_OVERRIDE_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'websOverride';
	// ACTIONS
	var FETCH_WEBS_OVERRIDE_SUCCESS = exports.FETCH_WEBS_OVERRIDE_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_WEBS_OVERRIDE_SUCCESS';
	// SCHEMA
	var webOverrideSchema = new _normalizr.Schema('websOverride');
	var websOverrideSchema = (0, _normalizr.arrayOf)(webOverrideSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_WEBS_OVERRIDE_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.websOverride);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_WEBS_OVERRIDE_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getWebsOverrideIds = function getWebsOverrideIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getWebsOverrideById = function getWebsOverrideById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getWebsOverride = exports.getWebsOverride = (0, _reselect.createSelector)([getWebsOverrideIds, getWebsOverrideById], function (websOverrideIds, websOverrideById) {
	  return websOverrideIds.map(function (id) {
	    return websOverrideById[id];
	  });
	});
	var setWebsOverride = exports.setWebsOverride = function setWebsOverride(response) {
	  return {
	    type: FETCH_WEBS_OVERRIDE_SUCCESS,
	    response: (0, _normalizr.normalize)(response, websOverrideSchema)
	  };
	};

/***/ },

/***/ 126:
/*!************************************!*\
  !*** ./src/ducks/youtubeVideos.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setYoutubeVideos = exports.getYoutubeVideos = exports.FETCH_YOUTUBE_VIDEOS_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'youtubeVideos';
	// ACTIONS
	var FETCH_YOUTUBE_VIDEOS_SUCCESS = exports.FETCH_YOUTUBE_VIDEOS_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_YOUTUBE_VIDEOS_SUCCESS';
	// SCHEMA
	var youtubeVideoSchema = new _normalizr.Schema('youtubeVideos');
	var youtubeVideosSchema = (0, _normalizr.arrayOf)(youtubeVideoSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_YOUTUBE_VIDEOS_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.youtubeVideos);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_YOUTUBE_VIDEOS_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getYoutubeVideosIds = function getYoutubeVideosIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getYoutubeVideosById = function getYoutubeVideosById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getYoutubeVideos = exports.getYoutubeVideos = (0, _reselect.createSelector)([getYoutubeVideosIds, getYoutubeVideosById], function (youtubeVideosIds, youtubeVideosById) {
	  return youtubeVideosIds.map(function (id) {
	    return youtubeVideosById[id];
	  });
	});
	var setYoutubeVideos = exports.setYoutubeVideos = function setYoutubeVideos(response) {
	  return {
	    type: FETCH_YOUTUBE_VIDEOS_SUCCESS,
	    response: (0, _normalizr.normalize)(response, youtubeVideosSchema)
	  };
	};

/***/ },

/***/ 127:
/*!********************************************!*\
  !*** ./src/ducks/youtubeVideosOverride.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setYoutubeVideosOverride = exports.getYoutubeVideosOverride = exports.FETCH_YOUTUBE_VIDEOS_OVERRIDE_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(/*! redux */ 17);
	
	var _normalizr = __webpack_require__(/*! normalizr */ 34);
	
	var _reselect = __webpack_require__(/*! reselect */ 36);
	
	var _strings = __webpack_require__(/*! ../strings */ 2);
	
	// API
	
	// REDUCER MOUNT POINT
	var reducerMountPoint = 'youtubeVideosOverride';
	// ACTIONS
	var FETCH_YOUTUBE_VIDEOS_OVERRIDE_SUCCESS = exports.FETCH_YOUTUBE_VIDEOS_OVERRIDE_SUCCESS = _strings.ACTION_PREFIX + 'FETCH_YOUTUBE_VIDEOS_OVERRIDE_SUCCESS';
	// SCHEMA
	var youtubeVideoOverrideSchema = new _normalizr.Schema('youtubeVideosOverride');
	var youtubeVideosOverrideSchema = (0, _normalizr.arrayOf)(youtubeVideoOverrideSchema);
	// REDUCERS
	var byId = function byId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_YOUTUBE_VIDEOS_OVERRIDE_SUCCESS:
	      {
	        return _extends({}, state, action.response.entities.youtubeVideosOverride);
	      }
	    default:
	      return state;
	  }
	};
	var ids = function ids() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FETCH_YOUTUBE_VIDEOS_OVERRIDE_SUCCESS:
	      return action.response.result;
	    default:
	      return state;
	  }
	};
	exports.default = (0, _redux.combineReducers)({
	  byId: byId,
	  ids: ids
	});
	// ACCESSORS AKA SELECTORS
	
	var getYoutubeVideosOverrideIds = function getYoutubeVideosOverrideIds(state) {
	  return state[reducerMountPoint].ids;
	};
	var getYoutubeVideosOverrideById = function getYoutubeVideosOverrideById(state) {
	  return state[reducerMountPoint].byId;
	};
	var getYoutubeVideosOverride = exports.getYoutubeVideosOverride = (0, _reselect.createSelector)([getYoutubeVideosOverrideIds, getYoutubeVideosOverrideById], function (youtubeVideosOverrideIds, youtubeVideosOverrideById) {
	  return youtubeVideosOverrideIds.map(function (id) {
	    return youtubeVideosOverrideById[id];
	  });
	});
	var setYoutubeVideosOverride = exports.setYoutubeVideosOverride = function setYoutubeVideosOverride(response) {
	  return {
	    type: FETCH_YOUTUBE_VIDEOS_OVERRIDE_SUCCESS,
	    response: (0, _normalizr.normalize)(response, youtubeVideosOverrideSchema)
	  };
	};

/***/ },

/***/ 483:
/*!******************************************************************************!*\
  !*** ./~/css-loader?module&-autoprefixer!./~/postcss-loader!./src/index.css ***!
  \******************************************************************************/
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(/*! ./../~/css-loader/lib/css-base.js */ 28)();
	// imports
	
	
	// module
	exports.push([module.id, "body{margin:0;padding:0;font-family:sans-serif;background-color:#000;overflow:hidden}div{box-sizing:border-box}#futusign_youtube{position:absolute;top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);-ms-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}", ""]);
	
	// exports


/***/ },

/***/ 672:
/*!***********************!*\
  !*** ./src/index.css ***!
  \***********************/
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(/*! !./../~/css-loader?module&-autoprefixer!./../~/postcss-loader!./index.css */ 483);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(/*! ./../~/style-loader/addStyles.js */ 29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js?module&-autoprefixer!./../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js?module&-autoprefixer!./../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 289:
/*!***********************!*\
  !*** ./src/index.jsx ***!
  \***********************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(/*! babel-polyfill */ 191);
	
	var _react = __webpack_require__(/*! react */ 14);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(/*! react-dom */ 234);
	
	var _reactRedux = __webpack_require__(/*! react-redux */ 106);
	
	var _configureStore = __webpack_require__(/*! ./configureStore */ 287);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _App = __webpack_require__(/*! ./components/App */ 286);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(/*! ./index.css */ 672);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line
	__webpack_require__.p = window.publicPath;
	var store = (0, _configureStore2.default)();
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));

/***/ },

/***/ 2:
/*!************************!*\
  !*** ./src/strings.js ***!
  \************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// eslint-disable-next-line
	var ACTION_PREFIX = exports.ACTION_PREFIX = 'app/';
	var SITE_URL = exports.SITE_URL = window.siteUrl;
	var SCREEN_ID = exports.SCREEN_ID = window.screenId;
	var ERROR_POLLING_INTERVAL = exports.ERROR_POLLING_INTERVAL = 60;
	// MESSAGES
	var MSG_BLOCK = exports.MSG_BLOCK = 'MSG_BLOCK';
	var MSG_TIME = exports.MSG_TIME = 'MSG_TIME';
	var MSG_UNBLOCK = exports.MSG_UNBLOCK = 'MSG_UNBLOCK';
	// PLAYERS
	var TRANSITION = exports.TRANSITION = 'TRANSITION';
	var TRANSITION2 = exports.TRANSITION2 = 'TRANSITION2';
	var IMAGES = exports.IMAGES = 'IMAGES';
	var MEDIA_DECKS = exports.MEDIA_DECKS = 'MEDIA_DECKS';
	var RESTART_DELAY = exports.RESTART_DELAY = 2;
	var WEBS = exports.WEBS = 'WEBS';
	var YOUTUBE_VIDEOS = exports.YOUTUBE_VIDEOS = 'YOUTUBE_VIDEOS';

/***/ },

/***/ 290:
/*!********************************!*\
  !*** ./src/util/exceptions.js ***!
  \********************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ServerException = ServerException;
	// eslint-disable-next-line
	function ServerException(message) {
	  this.name = 'ServerException';
	  this.message = message;
	}

/***/ },

/***/ 189:
/*!**************************!*\
  !*** ./src/util/misc.js ***!
  \**************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BASE64_MARKER = ';base64,';
	
	var convertDataURIToBinary = exports.convertDataURIToBinary = function convertDataURIToBinary(dataUri) {
	  var base64Index = dataUri.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
	  var base64 = dataUri.substring(base64Index);
	  var raw = window.atob(base64);
	  var rawLength = raw.length;
	  var array = new Uint8Array(new ArrayBuffer(rawLength));
	  for (var i = 0; i < rawLength; i += 1) {
	    array[i] = raw.charCodeAt(i);
	  }
	  return array;
	};
	var minLargerPriority = exports.minLargerPriority = function minLargerPriority(start, media) {
	  var priority = Infinity;
	  for (var i = 0; i < media.length; i += 1) {
	    var iPriority = media[i].priority;
	    priority = iPriority > start && iPriority < priority ? iPriority : priority;
	  }
	  return priority;
	};

/***/ },

/***/ 190:
/*!**************************!*\
  !*** ./src/util/rest.js ***!
  \**************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var get = exports.get = function get(endpoint) {
	  return new Promise(function (resolve, reject) {
	    var result = void 0;
	    var cleanUp = function cleanUp() {}; // WILL REASSIGN
	    var xmlhttp = new XMLHttpRequest();
	    var handleLoad = function handleLoad() {
	      var status = xmlhttp.status;
	      if (status !== 200) {
	        reject({ message: status.toString() });
	        cleanUp();
	        return;
	      }
	      try {
	        result = JSON.parse(xmlhttp.responseText);
	      } catch (error) {
	        reject({ message: '500' });
	        cleanUp();
	        return;
	      }
	      resolve(result);
	      cleanUp();
	    };
	    var handleError = function handleError() {
	      reject({ message: '500' });
	      cleanUp();
	    };
	    cleanUp = function cleanUp() {
	      xmlhttp.removeEventListener('load', handleLoad);
	      xmlhttp.removeEventListener('error', handleError);
	      xmlhttp.removeEventListener('abort', handleError);
	    };
	    xmlhttp.addEventListener('load', handleLoad);
	    xmlhttp.addEventListener('error', handleError);
	    xmlhttp.addEventListener('abort', handleError);
	    xmlhttp.open('GET', endpoint, true);
	    xmlhttp.send();
	  });
	};
	var getFile = exports.getFile = function getFile(url) {
	  return new Promise(function (resolve, reject) {
	    var cleanUp = function cleanUp() {}; // WILL REASSIGN
	    var xmlhttp = new XMLHttpRequest();
	    var handleLoad = function handleLoad() {
	      var status = xmlhttp.status;
	      if (status !== 200) {
	        reject({ message: status.toString() });
	        cleanUp();
	        return;
	      }
	      var fileReader = new FileReader();
	      fileReader.onload = function (_ref) {
	        var result = _ref.target.result;
	
	        resolve(result);
	        cleanUp();
	      };
	      fileReader.readAsDataURL(xmlhttp.response);
	    };
	    var handleError = function handleError() {
	      reject({ message: '500' });
	      cleanUp();
	    };
	    cleanUp = function cleanUp() {
	      xmlhttp.removeEventListener('load', handleLoad);
	      xmlhttp.removeEventListener('error', handleError);
	      xmlhttp.removeEventListener('abort', handleError);
	    };
	    xmlhttp.addEventListener('load', handleLoad);
	    xmlhttp.addEventListener('error', handleError);
	    xmlhttp.addEventListener('abort', handleError);
	    xmlhttp.open('GET', url, true);
	    xmlhttp.responseType = 'blob';
	    xmlhttp.send();
	  });
	};

/***/ }

});


// WEBPACK FOOTER //
// main.126327f2910dc05aa49c.bundle.js